import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { SajuCalculationResult, SajuCalculator, SajuInput } from '../../model/struct/saju';
import type { ReportChapter, ReportChapterTheme } from '../../model/struct/saju';

interface ManseReadingContext {
    [key: string]: any;
}

interface ManseReportData {
    calculation: SajuCalculationResult;
    targetYear: number;
    ownerName: string;
    calendarLabel: string;
    chart: any;
    pillars: any[];
    displayPillars: any[];
    rawElements: any[];
    elements: any[];
    tenGods: any[];
    elementRelations: any;
    personality: any;
    nobleStars: any[];
    specialStars: any[];
    emptyBranches: string[];
    luckInfo: any;
    luckFlow: any[];
    annualLuck: any[];
    monthlyLuck: any[];
    interactionSections: any[];
    interpretationSignals: any[];
    validation: any;
    reading: ManseReadingContext;
    precision: any;
}

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.simsim-shell {
  min-height: 100vh;
  background: #fbf8f5;
  transition: background 0.3s ease;
}

.simsim-shell.is-tarot-screen {
  background: radial-gradient(circle at 19% 17%, rgba(255, 255, 255, 0.82) 0 1px, transparent 1.9px), radial-gradient(circle at 60% 12%, rgba(255, 255, 255, 0.68) 0 1px, transparent 2px), radial-gradient(circle at 82% 26%, rgba(225, 248, 255, 0.54) 0 1px, transparent 2px), radial-gradient(circle at 31% 68%, rgba(255, 255, 255, 0.54) 0 1px, transparent 2px), radial-gradient(circle at 74% 78%, rgba(255, 255, 255, 0.5) 0 1px, transparent 2px), radial-gradient(ellipse at 22% 80%, rgba(92, 210, 205, 0.18), transparent 34%), radial-gradient(ellipse at 78% 30%, rgba(215, 164, 222, 0.24), transparent 36%), linear-gradient(180deg, #f8f5ff 0%, #ecebfb 34%, #dcdff4 68%, #cfd3ee 100%);
  background-attachment: fixed;
}

.simsim-header {
  background: rgba(255, 255, 255, 0.9);
}

.simsim-shell.is-tarot-screen .simsim-header {
  border-color: rgba(158, 151, 205, 0.24);
  background: rgba(250, 248, 255, 0.76);
}

.simsim-card {
  min-width: 0;
}

.simsim-hide-scrollbar {
  scrollbar-width: none;
}

.simsim-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.result-loading-panel {
  position: relative;
}

.result-loading-panel::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(196, 111, 130, 0.12) 45%, transparent 70%);
  transform: translateX(-100%);
  animation: result-sheen 1.8s ease-in-out infinite;
  pointer-events: none;
}

.result-loading-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #c46f82;
  animation: result-dot 0.9s ease-in-out infinite;
}

.result-loading-dot:nth-child(2) {
  animation-delay: 0.14s;
  background: #d8b5c4;
}

.result-loading-dot:nth-child(3) {
  animation-delay: 0.28s;
  background: #c6b8ad;
}

.tarot-screen-shell {
  min-height: calc(100vh - 64px);
  max-width: 1180px;
  margin: 0 auto;
}

.tarot-stage {
  position: relative;
  background: transparent;
  color: #242236;
}

.tarot-kicker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(82, 78, 121, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.58);
  color: #736c9b;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.16em;
  padding: 8px 14px;
  box-shadow: 0 10px 28px rgba(72, 67, 111, 0.08);
}

.tarot-title {
  margin-top: 22px;
  color: #27223a;
  font-size: 48px;
  font-weight: 900;
  line-height: 1.02;
  letter-spacing: 0;
}

.tarot-subtitle {
  margin: 14px auto 0;
  max-width: 560px;
  color: #67627f;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.75;
}

.tarot-fan-wrap {
  overflow: visible;
}

.tarot-table {
  position: absolute;
  left: 50%;
  bottom: -14px;
  width: min(760px, 98%);
  height: 170px;
  transform: translateX(-50%);
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.52) 0%, rgba(172, 171, 210, 0.28) 45%, transparent 72%);
  border-radius: 50%;
  filter: blur(1px);
  opacity: 0.95;
}

.tarot-fan {
  position: absolute;
  inset: 0;
}

.tarot-fan-card {
  --tx: 0px;
  --ty: 0px;
  --rot: 0deg;
  --shuffle-x: 0px;
  --shuffle-y: 0px;
  --shuffle-rot: 0deg;
  --shuffle-start-x: 0px;
  --shuffle-start-y: 0px;
  --shuffle-start-rot: 0deg;
  --stack-x: 0px;
  --stack-y: 0px;
  --stack-rot: 0deg;
  --shuffle-delay: 0ms;
  --fan-open-delay: 0ms;
  position: absolute;
  left: 50%;
  bottom: 46px;
  width: 112px;
  height: 192px;
  padding: 0;
  border: 0;
  border-radius: 13px;
  background: transparent;
  cursor: pointer;
  transform: translateX(-50%) translateX(var(--tx)) translateY(var(--ty)) rotate(var(--rot));
  transform-origin: 50% 100%;
  transition: transform 0.28s ease, opacity 0.2s ease, filter 0.2s ease;
  filter: drop-shadow(0 16px 20px rgba(40, 37, 67, 0.22));
}

.tarot-fan-card:disabled {
  cursor: wait;
}

.tarot-fan-card:not(:disabled):hover,
.tarot-fan-card:not(:disabled):focus-visible {
  transform: translateX(-50%) translateX(var(--tx)) translateY(calc(var(--ty) - 26px)) rotate(var(--rot)) scale(1.04);
  filter: drop-shadow(0 22px 26px rgba(40, 37, 67, 0.28));
}

.tarot-fan-card:focus-visible {
  outline: 3px solid #f5f0ff;
  outline-offset: 5px;
}

.tarot-fan-card.is-picked {
  z-index: 60 !important;
  transform: translateX(-50%) translateX(var(--tx)) translateY(calc(var(--ty) - 42px)) rotate(var(--rot)) scale(1.08);
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.32));
}

.tarot-fan-card.is-muted {
  opacity: 0.45;
}

.tarot-fan.is-shuffling .tarot-fan-card {
  cursor: wait;
  pointer-events: none;
  transform-origin: 50% 50%;
  animation: tarotGatherStack 1.08s cubic-bezier(0.22, 0.72, 0.2, 1) var(--shuffle-delay) both;
}

.tarot-fan.is-shuffling .tarot-card-face {
  animation: tarotShuffleGlow 1.08s ease var(--shuffle-delay) both;
}

.tarot-fan.is-opening .tarot-fan-card {
  cursor: wait;
  pointer-events: none;
  transform-origin: 50% 100%;
  animation: tarotFanOpen 1.72s cubic-bezier(0.12, 0.78, 0.18, 1) var(--fan-open-delay) both;
  filter: drop-shadow(0 20px 26px rgba(40, 37, 67, 0.24));
}

@keyframes tarotGatherStack {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateX(var(--shuffle-start-x)) translateY(var(--shuffle-start-y)) rotate(var(--shuffle-start-rot)) scale(0.96);
  }
  14% {
    opacity: 1;
  }
  44% {
    transform: translateX(-50%) translateX(var(--shuffle-x)) translateY(var(--shuffle-y)) rotate(var(--shuffle-rot)) scale(1);
  }
  72% {
    transform: translateX(-50%) translateX(var(--stack-x)) translateY(calc(var(--stack-y) - 3px)) rotate(var(--stack-rot)) scale(0.99);
  }
  100% {
    opacity: 0.98;
    transform: translateX(-50%) translateX(var(--stack-x)) translateY(var(--stack-y)) rotate(var(--stack-rot)) scale(0.99);
  }
}
@keyframes tarotFanOpen {
  0% {
    opacity: 0.98;
    transform: translateX(-50%) translateX(var(--stack-x)) translateY(var(--stack-y)) rotate(var(--stack-rot)) scale(0.99);
  }
  18% {
    transform: translateX(-50%) translateX(var(--stack-x)) translateY(calc(var(--stack-y) - 8px)) rotate(var(--stack-rot)) scale(1);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateX(var(--tx)) translateY(var(--ty)) rotate(var(--rot)) scale(1);
  }
}
@keyframes tarotShuffleGlow {
  0% {
    filter: brightness(0.92);
  }
  46% {
    filter: brightness(1.12);
  }
  100% {
    filter: brightness(1);
  }
}
.tarot-fan-card:nth-child(1) {
  --shuffle-start-x: -124px;
  --shuffle-start-y: 18px;
  --shuffle-start-rot: -18deg;
  --shuffle-x: -22px;
  --shuffle-y: 8px;
  --shuffle-rot: -5deg;
  --stack-x: -6px;
  --stack-y: 3px;
  --stack-rot: -2deg;
  --shuffle-delay: 0ms;
  --fan-open-delay: 0ms;
}

.tarot-fan-card:nth-child(2) {
  --shuffle-start-x: 108px;
  --shuffle-start-y: -2px;
  --shuffle-start-rot: 16deg;
  --shuffle-x: 18px;
  --shuffle-y: 3px;
  --shuffle-rot: 4deg;
  --stack-x: -5px;
  --stack-y: 2px;
  --stack-rot: 1deg;
  --shuffle-delay: 12ms;
  --fan-open-delay: 42ms;
}

.tarot-fan-card:nth-child(3) {
  --shuffle-start-x: -88px;
  --shuffle-start-y: -8px;
  --shuffle-start-rot: -14deg;
  --shuffle-x: -15px;
  --shuffle-y: 0px;
  --shuffle-rot: -3deg;
  --stack-x: -4px;
  --stack-y: 1px;
  --stack-rot: -1deg;
  --shuffle-delay: 24ms;
  --fan-open-delay: 84ms;
}

.tarot-fan-card:nth-child(4) {
  --shuffle-start-x: 122px;
  --shuffle-start-y: 14px;
  --shuffle-start-rot: 18deg;
  --shuffle-x: 20px;
  --shuffle-y: 7px;
  --shuffle-rot: 5deg;
  --stack-x: -3px;
  --stack-y: 1px;
  --stack-rot: 1deg;
  --shuffle-delay: 36ms;
  --fan-open-delay: 126ms;
}

.tarot-fan-card:nth-child(5) {
  --shuffle-start-x: -104px;
  --shuffle-start-y: 6px;
  --shuffle-start-rot: -16deg;
  --shuffle-x: -18px;
  --shuffle-y: 5px;
  --shuffle-rot: -4deg;
  --stack-x: -2px;
  --stack-y: 0px;
  --stack-rot: -1deg;
  --shuffle-delay: 48ms;
  --fan-open-delay: 168ms;
}

.tarot-fan-card:nth-child(6) {
  --shuffle-start-x: 76px;
  --shuffle-start-y: -13px;
  --shuffle-start-rot: 12deg;
  --shuffle-x: 13px;
  --shuffle-y: -2px;
  --shuffle-rot: 3deg;
  --stack-x: -1px;
  --stack-y: 0px;
  --stack-rot: 0deg;
  --shuffle-delay: 60ms;
  --fan-open-delay: 210ms;
}

.tarot-fan-card:nth-child(7) {
  --shuffle-start-x: -44px;
  --shuffle-start-y: 19px;
  --shuffle-start-rot: -8deg;
  --shuffle-x: -6px;
  --shuffle-y: 3px;
  --shuffle-rot: 0deg;
  --stack-x: 0px;
  --stack-y: 0px;
  --stack-rot: 0deg;
  --shuffle-delay: 72ms;
  --fan-open-delay: 252ms;
}

.tarot-fan-card:nth-child(8) {
  --shuffle-start-x: 42px;
  --shuffle-start-y: 18px;
  --shuffle-start-rot: 8deg;
  --shuffle-x: 8px;
  --shuffle-y: 2px;
  --shuffle-rot: 1deg;
  --stack-x: 1px;
  --stack-y: -1px;
  --stack-rot: 0deg;
  --shuffle-delay: 84ms;
  --fan-open-delay: 294ms;
}

.tarot-fan-card:nth-child(9) {
  --shuffle-start-x: -72px;
  --shuffle-start-y: -14px;
  --shuffle-start-rot: -12deg;
  --shuffle-x: -12px;
  --shuffle-y: -2px;
  --shuffle-rot: -2deg;
  --stack-x: 2px;
  --stack-y: -1px;
  --stack-rot: 1deg;
  --shuffle-delay: 96ms;
  --fan-open-delay: 336ms;
}

.tarot-fan-card:nth-child(10) {
  --shuffle-start-x: 96px;
  --shuffle-start-y: 9px;
  --shuffle-start-rot: 14deg;
  --shuffle-x: 16px;
  --shuffle-y: 6px;
  --shuffle-rot: 4deg;
  --stack-x: 3px;
  --stack-y: -2px;
  --stack-rot: -1deg;
  --shuffle-delay: 108ms;
  --fan-open-delay: 378ms;
}

.tarot-fan-card:nth-child(11) {
  --shuffle-start-x: -98px;
  --shuffle-start-y: 12px;
  --shuffle-start-rot: -15deg;
  --shuffle-x: -17px;
  --shuffle-y: 7px;
  --shuffle-rot: -4deg;
  --stack-x: 4px;
  --stack-y: -2px;
  --stack-rot: 1deg;
  --shuffle-delay: 120ms;
  --fan-open-delay: 420ms;
}

.tarot-fan-card:nth-child(12) {
  --shuffle-start-x: 64px;
  --shuffle-start-y: -9px;
  --shuffle-start-rot: 10deg;
  --shuffle-x: 11px;
  --shuffle-y: -3px;
  --shuffle-rot: 2deg;
  --stack-x: 5px;
  --stack-y: -3px;
  --stack-rot: -1deg;
  --shuffle-delay: 132ms;
  --fan-open-delay: 462ms;
}

.tarot-fan-card:nth-child(13) {
  --shuffle-start-x: -16px;
  --shuffle-start-y: -18px;
  --shuffle-start-rot: -4deg;
  --shuffle-x: -4px;
  --shuffle-y: -4px;
  --shuffle-rot: -1deg;
  --stack-x: 6px;
  --stack-y: -3px;
  --stack-rot: 2deg;
  --shuffle-delay: 144ms;
  --fan-open-delay: 504ms;
}

.tarot-fan-card:nth-child(1) {
  --tx: -330px;
  --ty: 62px;
  --rot: -34deg;
  z-index: 1;
}

.tarot-fan-card:nth-child(2) {
  --tx: -274px;
  --ty: 40px;
  --rot: -27deg;
  z-index: 2;
}

.tarot-fan-card:nth-child(3) {
  --tx: -218px;
  --ty: 23px;
  --rot: -20deg;
  z-index: 3;
}

.tarot-fan-card:nth-child(4) {
  --tx: -162px;
  --ty: 10px;
  --rot: -13deg;
  z-index: 4;
}

.tarot-fan-card:nth-child(5) {
  --tx: -106px;
  --ty: 3px;
  --rot: -7deg;
  z-index: 5;
}

.tarot-fan-card:nth-child(6) {
  --tx: -52px;
  --ty: 0px;
  --rot: -3deg;
  z-index: 6;
}

.tarot-fan-card:nth-child(7) {
  --tx: 0px;
  --ty: -1px;
  --rot: 0deg;
  z-index: 7;
}

.tarot-fan-card:nth-child(8) {
  --tx: 52px;
  --ty: 0px;
  --rot: 3deg;
  z-index: 8;
}

.tarot-fan-card:nth-child(9) {
  --tx: 106px;
  --ty: 3px;
  --rot: 7deg;
  z-index: 9;
}

.tarot-fan-card:nth-child(10) {
  --tx: 162px;
  --ty: 10px;
  --rot: 13deg;
  z-index: 10;
}

.tarot-fan-card:nth-child(11) {
  --tx: 218px;
  --ty: 23px;
  --rot: 20deg;
  z-index: 11;
}

.tarot-fan-card:nth-child(12) {
  --tx: 274px;
  --ty: 40px;
  --rot: 27deg;
  z-index: 12;
}

.tarot-fan-card:nth-child(13) {
  --tx: 330px;
  --ty: 62px;
  --rot: 34deg;
  z-index: 13;
}

.tarot-card-face {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 5px solid #24242c;
  border-radius: 14px;
  background: radial-gradient(circle at 15% 12%, #ffffff 0 1px, transparent 1.8px), radial-gradient(circle at 28% 23%, rgba(255, 255, 255, 0.86) 0 1.2px, transparent 2px), radial-gradient(circle at 78% 16%, rgba(255, 255, 255, 0.9) 0 1.3px, transparent 2.2px), radial-gradient(circle at 86% 72%, rgba(255, 255, 255, 0.78) 0 1px, transparent 2px), radial-gradient(circle at 24% 82%, rgba(255, 255, 255, 0.72) 0 1px, transparent 1.9px), radial-gradient(circle at 68% 42%, rgba(144, 112, 194, 0.32), transparent 38%), linear-gradient(180deg, #202129 0%, #15161c 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 4px 0 rgba(35, 35, 43, 0.38);
}

.tarot-card-face::before,
.tarot-card-face::after {
  content: "";
  position: absolute;
  pointer-events: none;
}

.tarot-card-face::before {
  inset: 10px;
  border: 1px solid rgba(239, 242, 255, 0.7);
  border-radius: 9px;
  box-shadow: inset 0 0 0 1px rgba(239, 242, 255, 0.16);
  z-index: 5;
}

.tarot-card-face::after {
  left: -8%;
  right: -8%;
  bottom: 18%;
  height: 36%;
  background: radial-gradient(ellipse at 30% 60%, rgba(242, 246, 255, 0.9) 0 18%, transparent 20%), radial-gradient(ellipse at 48% 52%, rgba(242, 246, 255, 0.88) 0 20%, transparent 23%), radial-gradient(ellipse at 67% 64%, rgba(242, 246, 255, 0.72) 0 17%, transparent 20%), radial-gradient(ellipse at 52% 88%, rgba(242, 246, 255, 0.54) 0 18%, transparent 22%);
  opacity: 0.72;
  transform: rotate(-8deg);
  z-index: 1;
}

.tarot-card-star {
  position: absolute;
  left: 50%;
  top: 48%;
  width: 76px;
  height: 76px;
  color: transparent;
  font-size: 0;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.26));
  z-index: 4;
}

.tarot-card-star::before,
.tarot-card-star::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(92deg, #f7f9ff 0 46%, #9298a6 47% 54%, #f7f9ff 55% 100%);
  clip-path: polygon(50% 0%, 60% 39%, 100% 50%, 60% 61%, 50% 100%, 40% 61%, 0% 50%, 40% 39%);
}

.tarot-card-star::after {
  transform: rotate(45deg) scale(0.58);
  opacity: 0.88;
}

.tarot-card-moon {
  position: absolute;
  left: 19px;
  top: 17px;
  color: #f7f9ff;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  z-index: 4;
}

.tarot-card-moon::after {
  content: "☾";
  position: absolute;
  left: 66px;
  top: 124px;
  color: rgba(247, 249, 255, 0.88);
  font-size: 18px;
}

.tarot-card-line {
  position: absolute;
  left: 50%;
  top: 42%;
  width: 86px;
  height: 52px;
  border: 1px solid rgba(239, 242, 255, 0.34);
  border-left-color: transparent;
  border-right-color: transparent;
  border-radius: 50%;
  background: transparent;
  transform: translateX(-50%) rotate(-13deg);
  z-index: 3;
}

.tarot-card-line::before,
.tarot-card-line::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  background: rgba(247, 249, 255, 0.78);
}

.tarot-card-line::before {
  left: 14px;
  top: 6px;
  width: 3px;
  height: 3px;
  box-shadow: 22px -8px 0 rgba(247, 249, 255, 0.55), 54px 9px 0 rgba(247, 249, 255, 0.62);
}

.tarot-card-line::after {
  right: 9px;
  bottom: 8px;
  width: 4px;
  height: 4px;
  box-shadow: -38px 8px 0 rgba(247, 249, 255, 0.46);
}

.tarot-guide-card {
  position: relative;
  z-index: 10;
  margin: 14px auto 0;
  max-width: 620px;
  padding: 12px 18px;
  text-align: center;
}

.tarot-guide-title {
  color: #2d2940;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.35;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.72);
}

.tarot-guide-copy {
  margin-top: 8px;
  color: #746f8c;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.tarot-reshuffle-button {
  display: flex;
  min-width: 176px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(47, 43, 68, 0.12);
  border-radius: 999px;
  background: #242331;
  color: #f7f4ff;
  font-size: 14px;
  font-weight: 900;
  box-shadow: 0 14px 26px rgba(53, 49, 82, 0.18);
  transition: transform 0.2s ease, background 0.2s ease;
}

.tarot-reshuffle-button:not(:disabled):hover {
  background: #34314a;
  transform: translateY(-2px);
}

.tarot-reshuffle-button:disabled {
  cursor: wait;
  opacity: 0.62;
}

.tarot-result-panel {
  position: relative;
  z-index: 10;
  margin: 34px auto 0;
  max-width: 920px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 8px;
  background: rgba(255, 250, 247, 0.88);
  color: #1f2937;
  box-shadow: 0 24px 54px rgba(58, 54, 92, 0.16);
}

.tarot-result-visual {
  display: flex;
  min-height: 540px;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 24% 20%, rgba(255, 255, 255, 0.68) 0 1px, transparent 1.8px), radial-gradient(circle at 70% 18%, rgba(255, 255, 255, 0.56) 0 1px, transparent 2px), radial-gradient(circle at 82% 76%, rgba(247, 249, 255, 0.48) 0 1px, transparent 2px), radial-gradient(ellipse at 50% 62%, rgba(116, 102, 178, 0.28), transparent 46%), linear-gradient(180deg, #e7e4f6 0%, #d7d8f0 52%, #c7c9e7 100%);
  padding: 32px;
  color: #ffffff;
}

.tarot-result-image-shell {
  position: relative;
  display: flex;
  width: 70mm;
  height: 120mm;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 16px;
  background: rgba(28, 29, 38, 0.18);
  box-shadow: 0 26px 42px rgba(28, 27, 46, 0.26), 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.tarot-result-image {
  display: block;
  width: 70mm;
  height: 120mm;
  object-fit: cover;
  border-radius: 16px;
  transition: transform 0.24s ease;
}

.tarot-result-image.is-reversed {
  transform: rotate(180deg);
}

.tarot-orientation-pill {
  position: absolute;
  left: 50%;
  bottom: 14px;
  z-index: 2;
  transform: translateX(-50%);
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: #2b2840;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  padding: 8px 12px;
  box-shadow: 0 10px 22px rgba(30, 29, 48, 0.18);
}

.tarot-orientation-pill.is-reversed {
  background: rgba(36, 35, 49, 0.92);
  color: #f7f4ff;
}

.tarot-orientation-badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(129, 117, 173, 0.24);
  border-radius: 999px;
  background: rgba(129, 117, 173, 0.1);
  color: #6f64a1;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  padding: 7px 10px;
}

.tarot-orientation-badge.is-reversed {
  background: rgba(36, 35, 49, 0.1);
  color: #3b3659;
}

.tarot-reading-label {
  color: #8175ad;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.tarot-result-card {
  display: flex;
  width: min(220px, 80%);
  min-height: 300px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 6px solid rgba(255, 255, 255, 0.84);
  border-radius: 16px;
  background: radial-gradient(circle at 70% 18%, rgba(255, 255, 255, 0.62), transparent 18%), linear-gradient(150deg, rgba(255, 255, 255, 0.22), transparent 42%), #242331;
  padding: 22px 16px;
  text-align: center;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.28);
}

.tarot-result-card-title,
.tarot-result-card-name {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 900;
  line-height: 1.4;
  text-transform: uppercase;
}

.tarot-result-card-symbol {
  color: #ffffff;
  font-size: 58px;
  font-weight: 900;
  line-height: 1;
}

@media (max-width: 640px) {
  .tarot-title {
    font-size: 36px;
  }
  .tarot-subtitle {
    font-size: 14px;
  }
  .tarot-table {
    bottom: 2px;
    height: 112px;
  }
  .tarot-fan-card {
    bottom: 42px;
    width: 72px;
    height: 123px;
    border-radius: 10px;
  }
  .tarot-result-visual {
    min-height: 500px;
    padding: 24px 18px;
  }
  .tarot-result-image-shell,
  .tarot-result-image {
    width: 70mm;
    height: 120mm;
  }
  .tarot-card-face {
    border-width: 4px;
    border-radius: 10px;
  }
  .tarot-card-face::before {
    inset: 9px;
  }
  .tarot-card-face::after {
    inset: 14px;
  }
  .tarot-card-star {
    width: 48px;
    height: 48px;
  }
  .tarot-card-moon {
    left: 13px;
    top: 12px;
    font-size: 12px;
  }
  .tarot-card-moon::after {
    left: 42px;
    top: 82px;
    font-size: 12px;
  }
  .tarot-card-line {
    width: 54px;
    height: 34px;
  }
  .tarot-guide-card {
    padding: 16px;
  }
  .tarot-guide-title {
    font-size: 21px;
  }
  .tarot-guide-copy {
    font-size: 13px;
  }
  .tarot-fan-card:nth-child(1) {
    --tx: -172px;
    --ty: 44px;
    --rot: -35deg;
  }
  .tarot-fan-card:nth-child(2) {
    --tx: -143px;
    --ty: 30px;
    --rot: -28deg;
  }
  .tarot-fan-card:nth-child(3) {
    --tx: -114px;
    --ty: 19px;
    --rot: -21deg;
  }
  .tarot-fan-card:nth-child(4) {
    --tx: -85px;
    --ty: 10px;
    --rot: -14deg;
  }
  .tarot-fan-card:nth-child(5) {
    --tx: -56px;
    --ty: 4px;
    --rot: -8deg;
  }
  .tarot-fan-card:nth-child(6) {
    --tx: -28px;
    --ty: 1px;
    --rot: -3deg;
  }
  .tarot-fan-card:nth-child(7) {
    --tx: 0px;
    --ty: 0px;
    --rot: 0deg;
  }
  .tarot-fan-card:nth-child(8) {
    --tx: 28px;
    --ty: 1px;
    --rot: 3deg;
  }
  .tarot-fan-card:nth-child(9) {
    --tx: 56px;
    --ty: 4px;
    --rot: 8deg;
  }
  .tarot-fan-card:nth-child(10) {
    --tx: 85px;
    --ty: 10px;
    --rot: 14deg;
  }
  .tarot-fan-card:nth-child(11) {
    --tx: 114px;
    --ty: 19px;
    --rot: 21deg;
  }
  .tarot-fan-card:nth-child(12) {
    --tx: 143px;
    --ty: 30px;
    --rot: 28deg;
  }
  .tarot-fan-card:nth-child(13) {
    --tx: 172px;
    --ty: 44px;
    --rot: 35deg;
  }
}
.pinball-arena {
  position: relative;
  min-height: 620px;
  overflow: hidden;
  border-radius: 8px;
  color: #3e3638;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);
}

.pinball-arena::before {
  content: "";
  position: absolute;
  inset: 12px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  pointer-events: none;
}

.pinball-arena::after {
  content: "";
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 76px;
  height: 2px;
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.78) 0 12px, rgba(62, 54, 56, 0.22) 12px 22px);
  border-radius: 999px;
}

.pinball-arena-top {
  position: relative;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
}

.pinball-kicker,
.pinball-status {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: #3e3638;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
  padding: 8px 12px;
  box-shadow: 0 10px 22px rgba(62, 54, 56, 0.08);
}

.pinball-kicker {
  letter-spacing: 0.16em;
}

.pinball-drop-slot {
  position: absolute;
  left: 50%;
  top: 58px;
  z-index: 4;
  width: 96px;
  height: 20px;
  transform: translateX(-50%);
  border-radius: 0 0 20px 20px;
  background: rgba(62, 54, 56, 0.76);
  box-shadow: inset 0 -5px 0 rgba(255, 255, 255, 0.16);
}

.pinball-side-rail {
  position: absolute;
  top: 86px;
  bottom: 74px;
  z-index: 3;
  width: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.58);
  box-shadow: inset 0 0 0 1px rgba(62, 54, 56, 0.08);
}

.pinball-side-rail.is-left {
  left: 24px;
}

.pinball-side-rail.is-right {
  right: 24px;
}

.pinball-peg {
  position: absolute;
  z-index: 4;
  width: 14px;
  height: 14px;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  background: #fffaf7;
  box-shadow: inset 0 -2px 0 rgba(62, 54, 56, 0.14), 0 6px 12px rgba(62, 54, 56, 0.14);
}

.pinball-wheel-core {
  position: absolute;
  left: 50%;
  top: 45%;
  z-index: 2;
  width: 210px;
  height: 210px;
  transform: translate(-50%, -50%);
  border: 18px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  animation: pinball-wheel-spin 9s linear infinite;
}

.pinball-wheel-core span {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 84px;
  transform-origin: 50% 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.35);
}

.pinball-wheel-core span:nth-child(1) {
  transform: rotate(0deg);
}

.pinball-wheel-core span:nth-child(2) {
  transform: rotate(45deg);
}

.pinball-wheel-core span:nth-child(3) {
  transform: rotate(90deg);
}

.pinball-wheel-core span:nth-child(4) {
  transform: rotate(135deg);
}

.pinball-bubble {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

.pinball-bubble span {
  position: absolute;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);
}

.pinball-bubble span:nth-child(1) {
  left: 13%;
  top: 25%;
  width: 132px;
  height: 132px;
}

.pinball-bubble span:nth-child(2) {
  right: 15%;
  top: 38%;
  width: 164px;
  height: 164px;
}

.pinball-bubble span:nth-child(3) {
  left: 34%;
  bottom: 18%;
  width: 104px;
  height: 104px;
}

.pinball-jar {
  position: absolute;
  left: 50%;
  bottom: 86px;
  z-index: 1;
  width: 300px;
  height: 250px;
  transform: translateX(-50%);
  border: 18px solid rgba(255, 255, 255, 0.3);
  border-top-width: 34px;
  border-radius: 70px 70px 44px 44px;
}

.pinball-jar span {
  position: absolute;
  left: 50%;
  top: -62px;
  width: 128px;
  height: 42px;
  transform: translateX(-50%);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.34);
}

.pinball-finish-line {
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 38px;
  z-index: 5;
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(62, 54, 56, 0.78);
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.28em;
  box-shadow: 0 16px 32px rgba(62, 54, 56, 0.16);
}

.pinball-ball {
  --pinball-start: 50%;
  --pinball-mid-a: 42%;
  --pinball-mid-b: 58%;
  --pinball-mid-c: 45%;
  --pinball-end: 50%;
  --pinball-color: #ffb3c7;
  --pinball-duration: 2800ms;
  --pinball-delay: 0ms;
  position: absolute;
  left: var(--pinball-start);
  top: 72px;
  z-index: 7;
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: var(--pinball-color);
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.26);
  transform: translateX(-50%);
  box-shadow: 0 12px 22px rgba(62, 54, 56, 0.18);
  animation: pinball-drop var(--pinball-duration) cubic-bezier(0.2, 0.72, 0.26, 1) var(--pinball-delay) forwards;
}

.pinball-ball.is-winner {
  z-index: 9;
  box-shadow: 0 18px 30px rgba(62, 54, 56, 0.24);
}

.pinball-ball span {
  max-width: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pinball-empty-state {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 6;
  width: min(320px, 100% - 48px);
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: rgba(255, 250, 247, 0.84);
  padding: 22px;
  text-align: center;
  box-shadow: 0 16px 32px rgba(62, 54, 56, 0.12);
}

.pinball-ranking-row.is-winner {
  background: #fff1f2;
}

@keyframes pinball-drop {
  0% {
    left: var(--pinball-start);
    top: 72px;
    transform: translateX(-50%) rotate(0deg) scale(0.96);
  }
  16% {
    left: var(--pinball-mid-a);
    top: 21%;
    transform: translateX(-50%) rotate(90deg) scale(1);
  }
  34% {
    left: var(--pinball-mid-b);
    top: 38%;
    transform: translateX(-50%) rotate(190deg) scale(0.98);
  }
  54% {
    left: var(--pinball-mid-c);
    top: 56%;
    transform: translateX(-50%) rotate(310deg) scale(1.02);
  }
  76% {
    left: var(--pinball-end);
    top: 73%;
    transform: translateX(-50%) rotate(450deg) scale(1);
  }
  100% {
    left: var(--pinball-end);
    top: calc(100% - 88px);
    transform: translateX(-50%) rotate(620deg) scale(1);
  }
}
@keyframes pinball-wheel-spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@media (max-width: 640px) {
  .pinball-arena {
    min-height: 540px;
  }
  .pinball-arena-top {
    align-items: flex-start;
    flex-direction: column;
  }
  .pinball-side-rail.is-left {
    left: 14px;
  }
  .pinball-side-rail.is-right {
    right: 14px;
  }
  .pinball-peg {
    width: 11px;
    height: 11px;
  }
  .pinball-ball {
    width: 36px;
    height: 36px;
    font-size: 11px;
  }
  .pinball-wheel-core {
    width: 160px;
    height: 160px;
  }
  .pinball-jar {
    width: 220px;
    height: 210px;
  }
}
.gift-draw-reel {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.gift-draw-reel.is-drawing {
  animation: gift-reel 0.46s ease-in-out infinite;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
}

.gift-result-shell {
  animation: gift-pop 0.42s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.gift-burst {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.gift-burst span {
  position: absolute;
  color: #c46f82;
  font-weight: 900;
  opacity: 0;
  animation: gift-burst 1.25s ease-out forwards;
}

.gift-burst span:nth-child(1) {
  left: 12%;
  top: 18%;
}

.gift-burst span:nth-child(2) {
  right: 16%;
  top: 14%;
  animation-delay: 0.08s;
}

.gift-burst span:nth-child(3) {
  left: 18%;
  bottom: 18%;
  animation-delay: 0.16s;
}

.gift-burst span:nth-child(4) {
  right: 20%;
  bottom: 22%;
  animation-delay: 0.24s;
}

.gift-burst span:nth-child(5) {
  left: 50%;
  top: 8%;
  animation-delay: 0.32s;
}

@keyframes result-sheen {
  0% {
    transform: translateX(-100%);
  }
  48%, 100% {
    transform: translateX(100%);
  }
}
@keyframes result-dot {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
}
@keyframes gift-reel {
  0%, 100% {
    transform: rotate(-3deg) scale(1);
  }
  50% {
    transform: rotate(4deg) scale(1.06);
  }
}
@keyframes gift-pop {
  0% {
    transform: translateY(10px) scale(0.98);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
@keyframes gift-burst {
  0% {
    transform: translateY(8px) scale(0.6) rotate(0deg);
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  100% {
    transform: translateY(-22px) scale(1.4) rotate(18deg);
    opacity: 0;
  }
}
.simsim-shell.is-pinball-screen {
  width: 100%;
  min-height: 100vh;
  color: #f8fafc;
  background: #0a0d12;
}

.pinball-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 22px 8px 36px;
  color: #f8fafc;
  background: radial-gradient(circle at 50% 0%, rgba(25, 247, 255, 0.12), transparent 34%), linear-gradient(180deg, #11151d 0%, #07080c 100%);
}

.pinball-stage {
  --pinball-board-width: 760px;
  position: relative;
  display: grid;
  grid-template-columns: 184px minmax(640px, var(--pinball-board-width)) 148px;
  align-items: start;
  column-gap: 8px;
  width: min(100%, 1108px);
  margin: 0 auto;
}

.pinball-left-panel {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  width: 184px;
  min-width: 0;
  justify-self: end;
}

.pinball-right-panel {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  justify-self: start;
}

.pinball-machine-card {
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  isolation: isolate;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: #020205;
  box-shadow: 0 22px 64px rgba(0, 0, 0, 0.38);
}

.pinball-machine-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.24), transparent 18%, transparent 76%, rgba(0, 0, 0, 0.3)), linear-gradient(180deg, rgba(255, 255, 255, 0.05), transparent 22%, rgba(0, 0, 0, 0.16));
}

.pinball-canvas-wrap {
  position: relative;
  z-index: 1;
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
  background: #020205;
}

.pinball-canvas {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  aspect-ratio: 4/3;
  object-fit: contain;
}

.pinball-controls-overlay,
.pinball-status-overlay,
.pinball-setup-overlay,
.pinball-rank-overlay {
  position: relative;
  z-index: 4;
}

.pinball-controls-overlay {
  width: 100%;
  padding: 6px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(4, 7, 12, 0.72);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(12px);
}

.pinball-controls-overlay:not([open]) {
  width: 100%;
}

.pinball-controls-summary,
.pinball-setup-summary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  list-style: none;
  cursor: pointer;
  user-select: none;
  color: rgba(229, 246, 255, 0.78);
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.pinball-controls-summary::-webkit-details-marker,
.pinball-setup-summary::-webkit-details-marker {
  display: none;
}

.pinball-controls-summary {
  min-width: 42px;
  padding: 0 9px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.09);
}

.pinball-controls-body {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.pinball-controls-overlay:not([open]) .pinball-controls-body {
  display: none;
}

.pinball-control-button {
  min-width: 54px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  color: #e5f6ff;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.1);
  transition: transform 0.16s ease, border-color 0.16s ease, background 0.16s ease;
}

.pinball-control-button:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: rgba(255, 255, 255, 0.38);
  background: rgba(255, 255, 255, 0.16);
}

.pinball-control-button:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.pinball-control-button.is-primary {
  color: #051014;
  border-color: rgba(92, 255, 239, 0.7);
  background: #5cffef;
  box-shadow: 0 0 18px rgba(92, 255, 239, 0.28);
}

.pinball-control-button.is-stop {
  color: #fff;
  border-color: rgba(255, 111, 148, 0.72);
  background: #ef476f;
}

.pinball-control-button.is-muted {
  color: rgba(229, 246, 255, 0.76);
}

.pinball-status-overlay {
  width: 100%;
  max-width: none;
  padding: 8px 10px;
  border-left: 3px solid #5cffef;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.06));
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.65);
}

.pinball-status-kicker {
  margin: 0;
  color: rgba(229, 246, 255, 0.62);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0;
}

.pinball-status-message {
  margin: 3px 0 0;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
}

.pinball-setup-overlay {
  width: 100%;
  max-height: calc(100vh - 206px);
  padding: 8px;
  overflow: auto;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(3, 8, 15, 0.72);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(12px);
  transition: opacity 0.18s ease, transform 0.18s ease, width 0.18s ease;
}

.pinball-setup-overlay:not([open]) {
  max-height: none;
  overflow: hidden;
}

.pinball-setup-summary {
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  padding: 0 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.pinball-setup-summary strong {
  color: #5cffef;
  font-size: 11px;
}

.pinball-setup-body {
  margin-top: 8px;
}

.pinball-setup-overlay.is-running {
  width: 100%;
  opacity: 0.88;
  transform: none;
}

.pinball-setup-overlay.is-running .pinball-setup-body {
  display: none;
}

.pinball-setup-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.pinball-input-block,
.pinball-option-block,
.pinball-inline-options label {
  min-width: 0;
}

.pinball-input-block > span,
.pinball-option-block > span,
.pinball-inline-options label > span {
  display: block;
  margin-bottom: 5px;
  color: rgba(229, 246, 255, 0.7);
  font-size: 10px;
  font-weight: 900;
}

.pinball-input-block textarea,
.pinball-inline-options select {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  color: #f8fafc;
  font-size: 11px;
  font-weight: 800;
  outline: none;
  background: rgba(255, 255, 255, 0.08);
}

.pinball-input-block textarea {
  min-height: 74px;
  max-height: 92px;
  padding: 8px 9px;
  resize: vertical;
  line-height: 1.45;
}

.pinball-inline-options select {
  height: 30px;
  padding: 0 8px;
}

.pinball-input-block textarea:focus,
.pinball-inline-options select:focus {
  border-color: rgba(92, 255, 239, 0.58);
  background: rgba(255, 255, 255, 0.12);
}

.pinball-map-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.pinball-map-button {
  height: 27px;
  padding: 0 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  color: rgba(229, 246, 255, 0.78);
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  background: rgba(255, 255, 255, 0.08);
}

.pinball-map-button.is-active {
  color: #041014;
  border-color: rgba(92, 255, 239, 0.7);
  background: #5cffef;
}

.pinball-map-button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.pinball-inline-options {
  display: grid;
  grid-template-columns: 1fr;
  align-items: end;
  gap: 6px;
  margin-top: 8px;
}

.pinball-toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 7px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  color: rgba(229, 246, 255, 0.78);
  font-size: 10px;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.07);
}

.pinball-toggle input {
  width: 13px;
  height: 13px;
  accent-color: #5cffef;
}

.pinball-setup-help,
.pinball-download-link {
  margin: 7px 0 0;
  color: rgba(229, 246, 255, 0.64);
  font-size: 10px;
  font-weight: 800;
  line-height: 1.45;
}

.pinball-setup-help.is-error {
  color: #ff7a96;
}

.pinball-download-link {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 9px;
  border-radius: 8px;
  color: #041014;
  background: #5cffef;
}

.pinball-minimap-panel {
  justify-self: center;
  width: 132px;
  height: 220px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 8px;
  background: rgba(2, 6, 12, 0.68);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.3);
}

.pinball-minimap-canvas {
  display: block;
  width: 132px;
  height: 220px;
}

.pinball-rank-overlay {
  width: 148px;
  max-height: 220px;
  padding: 8px 6px 8px 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 8px;
  color: #f8fafc;
  text-align: left;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.88);
  background: rgba(2, 6, 12, 0.68);
  backdrop-filter: blur(10px);
}

.pinball-rank-overlay.has-winner {
  max-height: 220px;
}

.pinball-rank-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  color: rgba(229, 246, 255, 0.58);
}

.pinball-rank-head p,
.pinball-rank-head span {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.pinball-rank-list {
  display: grid;
  gap: 4px;
  max-height: 176px;
  overflow-y: auto;
  padding-right: 4px;
}

.pinball-rank-overlay.has-winner .pinball-rank-list {
  max-height: 176px;
}

.pinball-rank-row {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 5px;
  min-height: 22px;
  padding: 1px 0;
  font-weight: 900;
}

.pinball-rank-row.is-winner {
  filter: drop-shadow(0 0 8px rgba(92, 255, 239, 0.45));
}

.pinball-rank-ball {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255, 255, 255, 0.78);
  border-radius: 999px;
  box-shadow: 0 0 10px currentColor;
}

.pinball-rank-name {
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pinball-rank-number {
  color: rgba(229, 246, 255, 0.72);
  font-size: 11px;
  line-height: 1;
}

.pinball-rank-empty {
  margin-top: 6px;
  color: rgba(229, 246, 255, 0.58);
  font-size: 10px;
  font-weight: 900;
  line-height: 1.35;
}

@media (max-width: 1120px) {
  .pinball-page {
    padding: 12px 8px 28px;
    align-items: flex-start;
  }
  .pinball-stage {
    grid-template-columns: 1fr;
    gap: 10px;
    width: min(100%, 880px);
  }
  .pinball-left-panel {
    order: 2;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    justify-self: stretch;
  }
  .pinball-machine-card {
    order: 1;
    width: 100%;
  }
  .pinball-right-panel {
    order: 3;
    justify-self: center;
    width: 100%;
    justify-content: center;
  }
}
@media (max-width: 700px) {
  .pinball-left-panel {
    grid-template-columns: 1fr;
  }
  .pinball-control-button {
    min-width: 48px;
    height: 27px;
    padding: 0 7px;
    font-size: 10px;
  }
  .pinball-setup-overlay {
    width: auto;
    max-height: 260px;
    overflow-y: auto;
  }
  .pinball-setup-overlay.is-running {
    width: 100%;
    max-height: none;
    overflow: hidden;
  }
  .pinball-inline-options {
    grid-template-columns: 1fr;
  }
  .pinball-rank-overlay {
    width: min(158px, 100% - 146px);
    max-height: 158px;
  }
  .pinball-rank-list {
    max-height: 114px;
  }
  .pinball-rank-overlay.has-winner {
    max-height: 140px;
  }
  .pinball-rank-overlay.has-winner .pinball-rank-list {
    max-height: 96px;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public screen: string = 'home';
    public activeCategory: string = 'all';
    public query: string = '';
    public selectedTest: any = null;
    public questionIndex: number = 0;
    public answers: any[] = [];
    public result: any = null;
    public notice: string = '';
    public shareParamName: string = 'share';
    public uploadedImage: string = '';
    public uploadedFileName: string = '';
    public uploadedFileMeta: any = null;
    public photoAnalyzing: boolean = false;
    public attachmentFiles: any[] = [];
    public attachmentUploading: boolean = false;
    public attachmentProgress: number = 0;
    public attachmentMessage: string = '파일을 선택하거나 끌어다 놓으세요';
    public attachmentMaxSize: number = 25 * 1024 * 1024;
    public resultTransitionToken: number = 0;
    public giftResult: any = null;
    public giftDrawing: boolean = false;
    public giftDeck: any[] = [];
    public tarotChoices: any[] = [];
    public tarotReading: boolean = false;
    public tarotShuffling: boolean = false;
    public tarotOpening: boolean = false;
    public pickedTarotIndex: number | null = null;
    public pinballParticipantsInput: string = '1\n2\n3\n4\n5\n6\n7\n8\n9\n10\n11\n12\n13\n14\n15\n16\n17\n18\n19\n20\n21\n22\n23\n24';
    public pinballMap: string = 'fixed';
    public pinballWinningRank: any = 1;
    public pinballSkillEnabled: boolean = true;
    public pinballRunning: boolean = false;
    public pinballShuffling: boolean = false;
    public pinballBalls: any[] = [];
    public pinballResults: any[] = [];
    public pinballWinner: any = null;
    public pinballError: string = '';
    public pinballMessage: string = '이름을 입력하고 셔플한 뒤 시작하세요';
    public pinballRecordEnabled: boolean = false;
    public pinballDownloadUrl: string = '';
    public pinballDownloadName: string = 'facet-pinball-draw.webm';
    public pinballTotalBalls: number = 24;
    public pinballCanvasWidth: number = 640;
    public pinballCanvasHeight: number = 480;
    public pinballWorldHeight: number = 2380;
    public pinballRankOptions: any[] = [
        { value: 1, label: '첫번째' },
        { value: 2, label: '두번째' },
        { value: 3, label: '세번째' },
        { value: 4, label: '네번째' },
        { value: 5, label: '다섯번째' },
        { value: 'last', label: '마지막' }
    ];
    public pinballMaps: any[] = [
        { id: 'fixed', label: '고정 네온 맵', accent: '#19f7ff', background: '#020205' }
    ];
    public pinballTrackRows: any[] = [
        { top: 18, pegs: [16, 32, 48, 64, 80] },
        { top: 30, pegs: [10, 24, 38, 52, 66, 80, 94] },
        { top: 42, pegs: [16, 32, 48, 64, 80] },
        { top: 54, pegs: [10, 24, 38, 52, 66, 80, 94] },
        { top: 66, pegs: [16, 32, 48, 64, 80] }
    ];
    public resultLoadingDelayMs: number = 3200;
    public photoAnalyzeDelayMs: number = 600;
    public giftDrawDelayMs: number = 2400;
    public tarotShuffleDelayMs: number = 1320;
    public tarotOpenDelayMs: number = 2380;
    public pinballDrawDelayMs: number = 4300;
    private pinballFrameRequest: any = null;
    private pinballLastFrameTime: number = 0;
    private pinballStartedAt: number = 0;
    private pinballMotionElapsed: number = 0;
    private pinballCurrentMotionScale: number = 1;
    private pinballWorld: any = null;
    private pinballCameraX: number = 0;
    private pinballCameraTargetX: number = 0;
    private pinballCameraVelocityX: number = 0;
    private pinballCameraY: number = 0;
    private pinballCameraTargetY: number = 0;
    private pinballCameraVelocityY: number = 0;
    private pinballCameraScale: number = 1;
    private pinballCameraTargetScale: number = 1;
    private pinballCameraBounceX: number = 0;
    private pinballCameraBounceVelocityX: number = 0;
    private pinballCameraBounce: number = 0;
    private pinballCameraBounceVelocity: number = 0;
    private pinballCameraFocusX: number = 0;
    private pinballCameraFocusY: number = 0;
    private pinballCameraFocusReady: boolean = false;
    private pinballFocusBallId: string = '';
    private pinballWinnerAnnouncedAt: number = 0;
    private pinballWinnerBurstSeed: number = 0;
    private pinballLastCameraImpactAt: number = 0;
    private pinballRenderQueued: boolean = false;
    private pinballLastPanelRenderAt: number = 0;
    private pinballRecorder: any = null;
    private pinballRecordedChunks: any[] = [];
    private sajuCalculator: SajuCalculator = new SajuCalculator();
    public expandedManseSection: number = 0;
    public expandedManseSectionId: string = 'manse-chapter-core';
    public manseValidationOpen: boolean = false;
    public fortuneProfile: any = { name: '', birthDate: '', birthTime: '12:00', timeUnknown: false, gender: 'none', calendarType: 'solar', birthPlace: 'none' };
    public compatibilityForm: any = { aName: '나', aBirthDate: '', aBirthTime: '12:00', bName: '상대', bBirthDate: '', bBirthTime: '12:00' };
    public dailyForm: any = { birthDate: '', focus: 'overall' };
    public manseForm: any = { name: '', birthDate: '', birthTime: '12:00', timeUnknown: false, gender: 'none', calendarType: 'solar', birthPlace: 'none', targetYear: new Date().getFullYear() };
    public categories: any[] = [
        { id: 'all', label: '전체', icon: 'spark' },
        { id: 'pick', label: '추천', icon: 'star' },
        { id: 'personality', label: '성격', icon: 'face' },
        { id: 'photo', label: '사진', icon: 'image' },
        { id: 'fortune', label: '운세', icon: 'moon' },
        { id: 'astrology', label: '점성술', icon: 'zodiac' },
        { id: 'love', label: '연애', icon: 'heart' },
        { id: 'style', label: '취향', icon: 'swatch' },
        { id: 'attachment', label: '파일 첨부', icon: 'clip' },
        { id: 'mini', label: '미니게임', icon: 'play' }
    ];

    public tests: any[] = [
        {
            id: 'mood-weather',
            title: '내 마음 날씨 테스트',
            subtitle: '오늘의 감정 기압 알아보기',
            category: 'personality',
            section: 'new',
            badge: 'NEW',
            plays: '82.4K',
            duration: '4분',
            creator: '패싯 연구팀',
            icon: '☁',
            coverLabel: 'MOOD',
            cover: {
                background: 'linear-gradient(135deg, #f4d8cf 0%, #dccabf 44%, #c6b8ad 100%)',
                color: '#3e3638'
            },
            tags: ['감정', '일상', '힐링'],
            description: '하루를 대하는 방식으로 지금 마음의 하늘을 찾아봐요.',
            questions: [
                {
                    text: '아침에 눈을 떴을 때 가장 먼저 드는 생각은?',
                    options: [
                        { label: '오늘 할 일을 빠르게 정리한다', detail: '머릿속 달력이 먼저 켜져요', result: 'clear', score: 2 },
                        { label: '조금 더 누워서 기분을 살핀다', detail: '컨디션 체크가 먼저예요', result: 'cloud', score: 2 },
                        { label: '좋아하는 음악부터 튼다', detail: '분위기가 하루를 만든다고 믿어요', result: 'sunny', score: 2 },
                        { label: '메신저와 알림을 훑는다', detail: '세상 흐름에 바로 접속해요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '갑자기 일정이 바뀌면 나는?',
                    options: [
                        { label: '새 계획을 바로 세운다', detail: '변수도 표로 잡아두면 편해요', result: 'clear', score: 2 },
                        { label: '잠깐 멈추고 마음을 가라앉힌다', detail: '속도를 늦춰야 정확해져요', result: 'cloud', score: 2 },
                        { label: '오히려 새로운 재미를 찾는다', detail: '뜻밖의 루트도 좋아요', result: 'sunny', score: 2 },
                        { label: '사람들에게 상황을 물어본다', detail: '함께 움직이면 금방 풀려요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '친구가 고민을 털어놓을 때 나는?',
                    options: [
                        { label: '문제를 쪼개서 해결책을 찾는다', detail: '정리가 곧 위로예요', result: 'clear', score: 2 },
                        { label: '끝까지 듣고 감정을 받아준다', detail: '먼저 기대도 되는 사람이 되고 싶어요', result: 'cloud', score: 2 },
                        { label: '기분 전환할 일을 제안한다', detail: '공기가 바뀌면 마음도 움직여요', result: 'sunny', score: 2 },
                        { label: '비슷한 경험을 꺼내며 공감한다', detail: '같이 웃고 같이 투덜대요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '하루가 끝났을 때 가장 만족스러운 순간은?',
                    options: [
                        { label: '해야 할 일을 깔끔히 끝냈을 때', detail: '체크 표시가 주는 평화가 있어요', result: 'clear', score: 2 },
                        { label: '무리하지 않고 나를 지켰을 때', detail: '속도를 잘 고른 날이 좋아요', result: 'cloud', score: 2 },
                        { label: '작은 즐거움이 많이 쌓였을 때', detail: '간식, 노래, 햇빛 같은 것들', result: 'sunny', score: 2 },
                        { label: '누군가와 재미있는 이야기를 나눴을 때', detail: '하루의 하이라이트는 대화예요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '생각이 많아지는 오후, 리듬을 되찾는 방법은?',
                    options: [
                        { label: '할 일을 세 덩어리로 다시 나눈다', detail: '작게 쪼개면 길이 보여요', result: 'clear', score: 2 },
                        { label: '창밖을 보며 잠깐 쉬어간다', detail: '마음을 먼저 진정시켜요', result: 'cloud', score: 2 },
                        { label: '달콤한 간식이나 산책을 곁들인다', detail: '기분을 살짝 올려요', result: 'sunny', score: 2 },
                        { label: '믿는 사람에게 짧게 털어놓는다', detail: '말하다 보면 흐름이 풀려요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '좋은 소식을 들었을 때 가장 먼저 하고 싶은 일은?',
                    options: [
                        { label: '앞으로 할 일을 바로 적어둔다', detail: '기회를 계획으로 바꿔요', result: 'clear', score: 2 },
                        { label: '혼자 조용히 기쁨을 음미한다', detail: '감정이 오래 머물게 해요', result: 'cloud', score: 2 },
                        { label: '기분 좋은 음악을 크게 튼다', detail: '좋은 에너지는 표현해야 해요', result: 'sunny', score: 2 },
                        { label: '가까운 사람에게 바로 공유한다', detail: '함께 기뻐하면 더 커져요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '컨디션이 애매한 날 약속이 있다면?',
                    options: [
                        { label: '시간과 동선을 줄여 부담을 낮춘다', detail: '현실적인 조정이 먼저예요', result: 'clear', score: 2 },
                        { label: '솔직히 상태를 말하고 속도를 늦춘다', detail: '나를 무리시키지 않아요', result: 'cloud', score: 2 },
                        { label: '가면 나아질 거라 믿고 가볍게 나선다', detail: '분위기가 컨디션을 바꿔요', result: 'sunny', score: 2 },
                        { label: '상대와 통화하며 기분을 끌어올린다', detail: '연결되면 힘이 생겨요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '새로운 계절이 시작될 때 먼저 바꾸는 것은?',
                    options: [
                        { label: '일정표와 목표 목록', detail: '새 출발에는 구조가 필요해요', result: 'clear', score: 2 },
                        { label: '침구나 향처럼 쉬는 공간', detail: '내가 머무는 온도를 바꿔요', result: 'cloud', score: 2 },
                        { label: '옷차림이나 플레이리스트', detail: '기분부터 산뜻하게 바꿔요', result: 'sunny', score: 2 },
                        { label: '만나고 싶은 사람들과의 약속', detail: '계절은 함께 지나야 선명해요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '하루가 꼬였다고 느껴질 때 나는?',
                    options: [
                        { label: '가장 급한 하나만 남기고 정리한다', detail: '우선순위를 다시 잡아요', result: 'clear', score: 2 },
                        { label: '무리한 기대를 내려놓고 쉬어간다', detail: '회복이 먼저인 날도 있어요', result: 'cloud', score: 2 },
                        { label: '작은 재미로 분위기를 환기한다', detail: '웃을 틈을 일부러 만들어요', result: 'sunny', score: 2 },
                        { label: '누군가와 이야기하며 털어낸다', detail: '혼자 끌어안지 않아요', result: 'spark', score: 2 }
                    ]
                },
                {
                    text: '잠들기 전 마음이 가장 편해지는 장면은?',
                    options: [
                        { label: '내일 할 일이 가지런히 정리된 상태', detail: '예측 가능하면 잠이 잘 와요', result: 'clear', score: 2 },
                        { label: '조용한 조명 아래 몸이 풀리는 시간', detail: '부드러운 마무리가 필요해요', result: 'cloud', score: 2 },
                        { label: '오늘 좋았던 일을 떠올리며 웃는 순간', detail: '작은 행복을 챙겨요', result: 'sunny', score: 2 },
                        { label: '재미있는 대화를 마지막으로 확인하는 순간', detail: '연결감이 하루를 닫아줘요', result: 'spark', score: 2 }
                    ]
                }
            ],
            results: {
                clear: {
                    title: '맑고 또렷한 계획형 하늘',
                    subtitle: '차분한 판단으로 하루를 정돈하는 사람',
                    summary: '당신은 복잡한 일도 순서대로 펼쳐놓으면 금방 길을 찾는 타입이에요. 주변 사람들은 당신의 침착함에서 안정감을 얻습니다.',
                    tags: ['정리력', '책임감', '집중'],
                    guide: '가끔은 계획표 밖의 작은 우연도 남겨두면 마음이 더 가벼워져요.',
                    match: '잘 맞는 테스트: 연애 신호등 테스트'
                },
                cloud: {
                    title: '포근한 구름형 마음',
                    subtitle: '감정의 결을 섬세하게 읽는 사람',
                    summary: '당신은 빠르게 답을 내리기보다 분위기와 마음의 온도를 먼저 살피는 타입이에요. 그래서 함께 있으면 말하지 않은 부분까지 배려받는 느낌이 납니다.',
                    tags: ['공감', '섬세함', '회복'],
                    guide: '생각이 많아질 땐 몸을 먼저 움직여보세요. 작은 산책이 마음의 문을 열어줍니다.',
                    match: '잘 맞는 테스트: 비밀 서랍 테스트'
                },
                sunny: {
                    title: '반짝이는 햇살형 에너지',
                    subtitle: '작은 재미로 분위기를 바꾸는 사람',
                    summary: '당신은 일상의 틈에서 즐거움을 발견하는 능력이 좋아요. 무거운 상황도 당신이 들어오면 조금 밝아지는 편입니다.',
                    tags: ['낙관', '센스', '활력'],
                    guide: '계속 밝아야 한다는 부담은 내려놓아도 괜찮아요. 쉬는 날의 당신도 충분히 매력적입니다.',
                    match: '잘 맞는 테스트: 취향 컬러 팔레트'
                },
                spark: {
                    title: '번쩍이는 소나기형 순간파',
                    subtitle: '대화와 연결에서 힘을 얻는 사람',
                    summary: '당신은 사람과 사건 사이에서 빠르게 재미를 포착하는 타입이에요. 즉흥적인 선택도 당신에게는 좋은 이야깃거리가 됩니다.',
                    tags: ['순발력', '친화력', '호기심'],
                    guide: '속도가 빠른 만큼 쉬어가는 신호도 챙겨주세요. 에너지를 아끼면 오래 빛나요.',
                    match: '잘 맞는 테스트: 주말 모험력 테스트'
                }
            }
        },
        {
            id: 'love-signal',
            title: '연애 신호등 테스트',
            subtitle: '내 플러팅 색깔은 몇 번 신호?',
            category: 'love',
            section: 'must',
            badge: 'HOT',
            plays: '314.8K',
            duration: '4분',
            creator: '연심 실험실',
            icon: '♡',
            coverLabel: 'LOVE',
            cover: {
                background: 'linear-gradient(135deg, #f7d2d8 0%, #d99aa8 48%, #b98aa6 100%)',
                color: '#3e3638'
            },
            tags: ['연애', '관계', '플러팅'],
            description: '좋아하는 사람 앞에서 내가 보내는 신호를 색깔로 확인해요.',
            questions: [
                {
                    text: '관심 있는 사람이 생기면 나는?',
                    options: [
                        { label: '천천히 관찰하며 타이밍을 본다', detail: '신중하게 가까워져요', result: 'green', score: 2 },
                        { label: '장난 섞인 말을 자주 건다', detail: '웃음으로 거리를 좁혀요', result: 'yellow', score: 2 },
                        { label: '먼저 약속을 제안한다', detail: '마음은 행동으로 보여줘요', result: 'red', score: 2 },
                        { label: '혼자 상상하다가 티가 난다', detail: '숨긴다고 숨겼는데 들켜요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '답장이 늦게 오면 드는 생각은?',
                    options: [
                        { label: '바쁘겠지 하고 내 일을 한다', detail: '내 리듬을 유지해요', result: 'green', score: 2 },
                        { label: '농담 섞인 추가 메시지를 고민한다', detail: '분위기를 살리고 싶어요', result: 'yellow', score: 2 },
                        { label: '솔직히 조금 신경 쓰인다', detail: '좋아하면 티가 나는 편이에요', result: 'pink', score: 2 },
                        { label: '다음 만남에서 직접 확인한다', detail: '애매한 건 오래 두지 않아요', result: 'red', score: 2 }
                    ]
                },
                {
                    text: '데이트 코스를 고른다면?',
                    options: [
                        { label: '대화하기 좋은 조용한 곳', detail: '서로를 알아가는 시간이 좋아요', result: 'green', score: 2 },
                        { label: '사진 찍고 놀 수 있는 핫플', detail: '추억은 선명해야 해요', result: 'yellow', score: 2 },
                        { label: '상대 취향을 반영한 맞춤 코스', detail: '준비한 마음을 보여줘요', result: 'red', score: 2 },
                        { label: '날씨와 기분에 맞춘 즉흥 코스', detail: '설렘은 변수가 만들어요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '고백에 가까운 말을 들어도 애매하다면?',
                    options: [
                        { label: '조심스럽게 의미를 물어본다', detail: '서두르지 않지만 놓치지도 않아요', result: 'green', score: 2 },
                        { label: '웃으며 비슷한 농담으로 받아친다', detail: '가볍게 온도를 올려요', result: 'yellow', score: 2 },
                        { label: '내 마음도 분명하게 말한다', detail: '진심에는 진심으로 답해요', result: 'red', score: 2 },
                        { label: '집에 와서 계속 곱씹는다', detail: '그 한 문장이 하루를 장악해요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '상대가 나를 헷갈리게 할 때 나는?',
                    options: [
                        { label: '속도를 늦추고 행동을 더 지켜본다', detail: '확신은 천천히 쌓아도 돼요', result: 'green', score: 2 },
                        { label: '가볍게 떠보는 말을 던진다', detail: '분위기를 무겁게 만들고 싶진 않아요', result: 'yellow', score: 2 },
                        { label: '애매한 부분을 직접 물어본다', detail: '불확실한 신호는 오래 두지 않아요', result: 'red', score: 2 },
                        { label: '작은 말투까지 의미를 찾아본다', detail: '마음이 이미 깊이 들어갔어요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '썸 초반에 가장 중요하게 보는 것은?',
                    options: [
                        { label: '편하게 대화가 이어지는지', detail: '긴장보다 안정감이 먼저예요', result: 'green', score: 2 },
                        { label: '서로 장난을 받아주는지', detail: '티키타카가 설렘을 만들어요', result: 'yellow', score: 2 },
                        { label: '만날 의지가 분명한지', detail: '마음은 시간으로도 보여요', result: 'red', score: 2 },
                        { label: '나를 떠올리게 하는 작은 신호가 있는지', detail: '사소한 배려에 흔들려요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '좋아하는 사람에게 선물을 고른다면?',
                    options: [
                        { label: '오래 쓸 수 있는 실용적인 것', detail: '부담 없이 곁에 남았으면 해요', result: 'green', score: 2 },
                        { label: '웃음이 나는 작은 장난템', detail: '받는 순간 분위기가 풀렸으면 해요', result: 'yellow', score: 2 },
                        { label: '상대가 예전에 말했던 바로 그 물건', detail: '내가 기억했다는 걸 보여줘요', result: 'red', score: 2 },
                        { label: '의미를 담은 편지나 작은 소품', detail: '말하지 못한 마음을 담아요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '데이트 뒤 집에 와서 나는?',
                    options: [
                        { label: '오늘 좋았던 점을 차분히 돌아본다', detail: '관계의 속도를 확인해요', result: 'green', score: 2 },
                        { label: '웃겼던 장면을 다시 보내며 놀린다', detail: '대화를 계속 이어가고 싶어요', result: 'yellow', score: 2 },
                        { label: '다음에 또 보자는 말을 먼저 한다', detail: '좋았다면 바로 표현해요', result: 'red', score: 2 },
                        { label: '대화 내용을 오래 곱씹는다', detail: '한 문장 한 문장이 크게 남아요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '관계가 조금 어색해졌을 때 나는?',
                    options: [
                        { label: '괜찮은 타이밍을 기다리며 자연스럽게 푼다', detail: '억지로 밀어붙이지 않아요', result: 'green', score: 2 },
                        { label: '가벼운 농담으로 분위기를 바꾼다', detail: '웃음으로 얼음을 녹여요', result: 'yellow', score: 2 },
                        { label: '서운했던 지점을 솔직히 말한다', detail: '정리해야 다시 가까워져요', result: 'red', score: 2 },
                        { label: '혼자 걱정하다가 조심스럽게 말을 꺼낸다', detail: '상처 주고 싶지 않아서 오래 생각해요', result: 'pink', score: 2 }
                    ]
                },
                {
                    text: '마음이 커졌다는 걸 느끼는 순간은?',
                    options: [
                        { label: '상대 앞에서 편안한 내가 나올 때', detail: '안정감이 호감의 증거예요', result: 'green', score: 2 },
                        { label: '별것 아닌 농담에도 계속 웃을 때', detail: '같이 있으면 공기가 가벼워져요', result: 'yellow', score: 2 },
                        { label: '내 시간을 기꺼이 내고 싶을 때', detail: '우선순위가 달라져요', result: 'red', score: 2 },
                        { label: '혼자 있는 시간에도 자꾸 떠오를 때', detail: '이미 마음속 장면이 많아졌어요', result: 'pink', score: 2 }
                    ]
                }
            ],
            results: {
                green: {
                    title: '초록불 안정 신호형',
                    subtitle: '편안함으로 마음을 여는 타입',
                    summary: '당신의 연애 신호는 부담 없이 다가오는 초록불이에요. 천천히 쌓이는 신뢰가 강점이라 오래 볼수록 매력이 깊어집니다.',
                    tags: ['신뢰', '배려', '롱런'],
                    guide: '너무 안전한 표현만 고르면 마음이 늦게 닿을 수 있어요. 작은 칭찬 하나는 바로 보내도 좋아요.',
                    match: '궁합 좋은 유형: 핑크빛 상상형'
                },
                yellow: {
                    title: '노란불 장난꾸러기형',
                    subtitle: '농담과 센스로 거리를 좁히는 타입',
                    summary: '당신은 분위기를 어색하지 않게 만드는 재능이 있어요. 상대는 당신과 이야기하다가 어느새 마음의 문을 열게 됩니다.',
                    tags: ['센스', '장난', '밀당'],
                    guide: '가끔은 농담 뒤에 숨긴 진심을 한 문장으로 꺼내보세요. 효과가 꽤 강합니다.',
                    match: '궁합 좋은 유형: 빨간불 직진형'
                },
                red: {
                    title: '빨간불 직진 고백형',
                    subtitle: '좋아하는 마음을 행동으로 증명하는 타입',
                    summary: '당신은 확실한 마음 앞에서 오래 망설이지 않는 편이에요. 선명한 표현이 상대에게 큰 안정감을 줄 수 있습니다.',
                    tags: ['솔직함', '추진력', '표현'],
                    guide: '속도가 빠를수록 상대의 보폭을 확인해 주세요. 같이 걷는 느낌이 설렘을 더 오래 지킵니다.',
                    match: '궁합 좋은 유형: 초록불 안정 신호형'
                },
                pink: {
                    title: '핑크빛 상상형',
                    subtitle: '혼자 설레다 어느새 티 나는 타입',
                    summary: '당신의 마음은 섬세한 장면을 많이 만들어요. 말보다 표정과 작은 행동에서 호감이 먼저 새어 나오는 편입니다.',
                    tags: ['설렘', '상상', '순정'],
                    guide: '머릿속 시나리오가 길어질 땐 현실의 작은 질문 하나를 던져보세요. 관계가 훨씬 선명해져요.',
                    match: '궁합 좋은 유형: 노란불 장난꾸러기형'
                }
            }
        },
        {
            id: 'color-palette',
            title: '취향 컬러 팔레트',
            subtitle: '내 분위기를 색으로 조합하면?',
            category: 'style',
            section: 'must',
            badge: 'PICK',
            plays: '156.2K',
            duration: '4분',
            creator: '팔레트 클럽',
            icon: '◐',
            coverLabel: 'TONE',
            cover: {
                background: 'linear-gradient(135deg, #f5e8d6 0%, #dfc0ae 42%, #c5b6a6 100%)',
                color: '#3e3638'
            },
            tags: ['취향', '스타일', '컬러'],
            description: '고르는 장면마다 쌓이는 나만의 분위기 색을 찾아봐요.',
            questions: [
                {
                    text: '가장 끌리는 방의 분위기는?',
                    options: [
                        { label: '햇빛이 드는 산뜻한 방', detail: '밝고 깨끗한 느낌', result: 'lime', score: 2 },
                        { label: '조용한 음악이 흐르는 방', detail: '차분하고 깊은 느낌', result: 'navy', score: 2 },
                        { label: '오브제가 많은 개성 있는 방', detail: '보는 재미가 많은 느낌', result: 'coral', score: 2 },
                        { label: '나무와 패브릭이 많은 방', detail: '따뜻하고 편한 느낌', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '사진을 찍을 때 더 좋아하는 컷은?',
                    options: [
                        { label: '선명하고 깨끗한 정면 컷', detail: '군더더기 없는 구도', result: 'lime', score: 2 },
                        { label: '그림자가 예쁜 무드 컷', detail: '여백과 분위기', result: 'navy', score: 2 },
                        { label: '컬러가 튀는 순간 컷', detail: '눈에 확 들어오는 장면', result: 'coral', score: 2 },
                        { label: '자연스러운 일상 컷', detail: '꾸미지 않은 편안함', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '새 물건을 살 때 기준은?',
                    options: [
                        { label: '오래 봐도 질리지 않는지', detail: '기본기가 중요해요', result: 'lime', score: 2 },
                        { label: '내 세계관과 맞는지', detail: '분위기 합이 중요해요', result: 'navy', score: 2 },
                        { label: '처음 봤을 때 설레는지', detail: '첫인상이 강해야 해요', result: 'coral', score: 2 },
                        { label: '손이 자주 갈 만큼 편한지', detail: '실사용 감각이 중요해요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '옷장을 정리할 때 끝까지 남기는 것은?',
                    options: [
                        { label: '기본 색 셔츠와 단정한 팬츠', detail: '언제 입어도 깔끔해요', result: 'lime', score: 2 },
                        { label: '톤이 깊은 재킷이나 니트', detail: '분위기를 오래 잡아줘요', result: 'navy', score: 2 },
                        { label: '색이 선명한 포인트 아이템', detail: '하나만 입어도 기분이 살아나요', result: 'coral', score: 2 },
                        { label: '편하고 질감 좋은 데일리웨어', detail: '손이 자주 가는 게 진짜 취향이에요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '새 프로필 사진을 고른다면?',
                    options: [
                        { label: '표정이 밝고 배경이 깨끗한 사진', detail: '첫인상이 산뜻했으면 해요', result: 'lime', score: 2 },
                        { label: '빛과 그림자가 분위기 있는 사진', detail: '한 번 더 보게 되는 여운이 좋아요', result: 'navy', score: 2 },
                        { label: '컬러와 포즈가 눈에 띄는 사진', detail: '나다운 개성이 보여야 해요', result: 'coral', score: 2 },
                        { label: '자연스럽게 웃는 일상 사진', detail: '꾸민 듯 안 꾸민 편안함이 좋아요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '작업 공간에 꼭 두고 싶은 것은?',
                    options: [
                        { label: '정리함과 밝은 조명', detail: '시야가 맑아야 집중돼요', result: 'lime', score: 2 },
                        { label: '묵직한 스피커나 어두운 컵', detail: '차분한 몰입감이 필요해요', result: 'navy', score: 2 },
                        { label: '컬러 포스터나 작은 피규어', detail: '보는 재미가 있어야 손이 움직여요', result: 'coral', score: 2 },
                        { label: '식물과 부드러운 패브릭', detail: '편한 온도가 오래 가요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '친구에게 내 취향을 보여준다면?',
                    options: [
                        { label: '깔끔하게 정리된 플레이리스트', detail: '선명하고 부담 없는 취향', result: 'lime', score: 2 },
                        { label: '밤에 보면 좋은 영화 목록', detail: '조용히 깊어지는 취향', result: 'navy', score: 2 },
                        { label: '요즘 꽂힌 강렬한 아이템 모음', detail: '첫눈에 기억나는 취향', result: 'coral', score: 2 },
                        { label: '자주 가는 편한 장소 지도', detail: '머물수록 좋은 취향', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '하루의 분위기를 바꾸는 작은 물건은?',
                    options: [
                        { label: '깨끗한 텀블러와 새 메모지', detail: '시작이 산뜻해져요', result: 'lime', score: 2 },
                        { label: '짙은 향의 핸드크림', detail: '공기가 차분하게 내려앉아요', result: 'navy', score: 2 },
                        { label: '색이 예쁜 키링이나 스티커', detail: '작은 포인트가 하루를 살려요', result: 'coral', score: 2 },
                        { label: '부드러운 양말이나 담요', detail: '몸이 편해야 기분도 편해요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '가장 오래 기억되는 장소의 조건은?',
                    options: [
                        { label: '동선이 편하고 빛이 좋은 곳', detail: '머무는 방식이 깔끔해요', result: 'lime', score: 2 },
                        { label: '조용하고 이야기가 깊은 곳', detail: '분위기가 오래 남아요', result: 'navy', score: 2 },
                        { label: '색과 소품이 독특한 곳', detail: '한 장면으로 기억돼요', result: 'coral', score: 2 },
                        { label: '편한 의자와 따뜻한 공기가 있는 곳', detail: '다시 가고 싶어져요', result: 'moss', score: 2 }
                    ]
                },
                {
                    text: '선물 포장을 고를 때 나는?',
                    options: [
                        { label: '흰 종이에 얇은 리본', detail: '깨끗한 완성도가 좋아요', result: 'lime', score: 2 },
                        { label: '짙은 색 포장지와 금속 태그', detail: '조용히 고급스러운 느낌', result: 'navy', score: 2 },
                        { label: '선명한 패턴과 색 조합', detail: '받기 전부터 즐거워야 해요', result: 'coral', score: 2 },
                        { label: '크라프트지와 손글씨 카드', detail: '따뜻하고 자연스러운 마음', result: 'moss', score: 2 }
                    ]
                }
            ],
            results: {
                lime: {
                    title: '라임 클리어 팔레트',
                    subtitle: '맑고 산뜻한 인상을 남기는 취향',
                    summary: '당신은 복잡함보다 선명한 균형을 좋아해요. 밝은 컬러와 깨끗한 형태가 잘 어울립니다.',
                    tags: ['산뜻함', '균형', '미니멀'],
                    guide: '포인트 컬러 하나만 더해도 취향이 훨씬 생생해져요.',
                    match: '어울리는 무드: 낮 산책, 유리컵, 흰 셔츠'
                },
                navy: {
                    title: '딥 네이비 팔레트',
                    subtitle: '조용하지만 오래 남는 취향',
                    summary: '당신은 한 번에 튀기보다 볼수록 깊어지는 분위기를 좋아해요. 낮은 채도와 선명한 소재감이 잘 맞습니다.',
                    tags: ['깊이', '여백', '몰입'],
                    guide: '무거워 보일 때는 작은 금속 포인트나 밝은 텍스처를 섞어보세요.',
                    match: '어울리는 무드: 밤 산책, 재즈, 진한 커피'
                },
                coral: {
                    title: '코랄 팝 팔레트',
                    subtitle: '기분을 한 칸 올리는 취향',
                    summary: '당신은 장면에 활기를 불어넣는 색을 잘 골라요. 예상 밖의 조합도 당신에게는 자연스럽습니다.',
                    tags: ['개성', '리듬', '포인트'],
                    guide: '강한 색끼리 만날 때는 넓은 여백을 확보하면 더 세련돼 보여요.',
                    match: '어울리는 무드: 스티커, 팝업스토어, 컬러 양말'
                },
                moss: {
                    title: '모스 그린 팔레트',
                    subtitle: '편안함이 멋이 되는 취향',
                    summary: '당신은 오래 머물고 싶은 분위기를 좋아해요. 자연스러운 소재와 부드러운 색이 매력을 살립니다.',
                    tags: ['편안함', '자연스러움', '온기'],
                    guide: '너무 무난해 보일 땐 패턴 하나를 작게 섞으면 생기가 살아나요.',
                    match: '어울리는 무드: 식물, 린넨, 느린 오후'
                }
            }
        },
        {
            id: 'secret-drawer',
            title: '비밀 서랍 테스트',
            subtitle: '내가 숨겨둔 진짜 욕구는?',
            category: 'personality',
            section: 'self',
            badge: 'DEEP',
            plays: '91.7K',
            duration: '4분',
            creator: '내면 관찰소',
            icon: '▣',
            coverLabel: 'ROOM',
            cover: {
                background: 'linear-gradient(135deg, #eee2e8 0%, #d8b5c4 45%, #b9c6d8 100%)',
                color: '#312244'
            },
            tags: ['자아', '습관', '내면'],
            description: '무심코 고른 물건으로 마음속 서랍의 이름을 확인해요.',
            questions: [
                {
                    text: '가방 안에 꼭 넣고 다니고 싶은 것은?',
                    options: [
                        { label: '작은 노트', detail: '생각을 붙잡아두고 싶어요', result: 'archive', score: 2 },
                        { label: '향이 좋은 핸드크림', detail: '감각을 챙기고 싶어요', result: 'comfort', score: 2 },
                        { label: '이어폰', detail: '내 세계로 잠깐 들어가요', result: 'dream', score: 2 },
                        { label: '보조배터리', detail: '변수에 대비해야 마음이 편해요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '혼자 시간이 생기면 가장 먼저 하고 싶은 일은?',
                    options: [
                        { label: '밀린 생각 정리하기', detail: '흩어진 마음을 분류해요', result: 'archive', score: 2 },
                        { label: '맛있는 걸 천천히 먹기', detail: '나를 대접하고 싶어요', result: 'comfort', score: 2 },
                        { label: '아무 목적 없이 걷기', detail: '우연한 장면이 필요해요', result: 'dream', score: 2 },
                        { label: '할 일 목록 재정비하기', detail: '다시 주도권을 잡아요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '요즘 가장 듣고 싶은 말은?',
                    options: [
                        { label: '네 생각은 충분히 가치 있어', detail: '내 안의 말을 믿고 싶어요', result: 'archive', score: 2 },
                        { label: '그만큼 해낸 것도 많아', detail: '따뜻한 인정이 필요해요', result: 'comfort', score: 2 },
                        { label: '원하는 대로 가도 괜찮아', detail: '가능성을 열어두고 싶어요', result: 'dream', score: 2 },
                        { label: '이제 네가 선택하면 돼', detail: '확신의 한마디가 필요해요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '마음이 복잡할 때 가장 먼저 필요한 것은?',
                    options: [
                        { label: '생각을 적을 빈 페이지', detail: '문장으로 꺼내야 보여요', result: 'archive', score: 2 },
                        { label: '따뜻한 음식과 조용한 자리', detail: '몸이 풀리면 마음도 풀려요', result: 'comfort', score: 2 },
                        { label: '정처 없이 걸을 수 있는 시간', detail: '길이 열리면 생각도 열려요', result: 'dream', score: 2 },
                        { label: '당장 정할 수 있는 작은 선택지', detail: '주도권을 되찾고 싶어요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '혼자만의 방에 숨겨두고 싶은 것은?',
                    options: [
                        { label: '아직 보여주지 않은 메모 더미', detail: '내 생각의 원석이에요', result: 'archive', score: 2 },
                        { label: '좋아하는 향과 부드러운 이불', detail: '나를 달래는 도구예요', result: 'comfort', score: 2 },
                        { label: '언젠가 떠날 여행 지도', detail: '가능성을 접어두고 싶지 않아요', result: 'dream', score: 2 },
                        { label: '계획표와 체크리스트', detail: '방향을 잃지 않게 해줘요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '오래 간직한 물건을 꺼내보는 이유는?',
                    options: [
                        { label: '그때의 생각을 잊고 싶지 않아서', detail: '기록은 나를 이어줘요', result: 'archive', score: 2 },
                        { label: '힘들 때 안정감을 주어서', detail: '익숙한 감각이 필요해요', result: 'comfort', score: 2 },
                        { label: '다시 새로운 꿈을 떠올리게 해서', detail: '가능성의 문을 열어줘요', result: 'dream', score: 2 },
                        { label: '내가 해온 선택을 확인하고 싶어서', detail: '쌓인 흔적이 확신이 돼요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '갑자기 자유 시간이 주어진다면?',
                    options: [
                        { label: '미뤄둔 생각과 사진을 정리한다', detail: '흩어진 것을 모으고 싶어요', result: 'archive', score: 2 },
                        { label: '좋아하는 곳에서 천천히 쉰다', detail: '나를 대접하는 시간이 좋아요', result: 'comfort', score: 2 },
                        { label: '목적지를 정하지 않고 나간다', detail: '우연한 장면을 만나고 싶어요', result: 'dream', score: 2 },
                        { label: '할 일과 쉬는 일을 다시 배치한다', detail: '내 시간을 내가 잡고 싶어요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '나를 가장 잘 설명하는 문장은?',
                    options: [
                        { label: '내 안의 말을 오래 붙잡는 사람', detail: '생각이 곧 나의 지도예요', result: 'archive', score: 2 },
                        { label: '작은 온기로 다시 살아나는 사람', detail: '다정함이 에너지가 돼요', result: 'comfort', score: 2 },
                        { label: '다른 가능성을 계속 열어두는 사람', detail: '상상할 때 숨이 트여요', result: 'dream', score: 2 },
                        { label: '흔들려도 방향을 다시 잡는 사람', detail: '선택할 힘을 믿고 싶어요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '최근의 나에게 필요한 버튼은?',
                    options: [
                        { label: '저장 버튼', detail: '놓치기 전에 남기고 싶어요', result: 'archive', score: 2 },
                        { label: '일시정지 버튼', detail: '숨을 고를 시간이 필요해요', result: 'comfort', score: 2 },
                        { label: '새 창 열기 버튼', detail: '다른 장면을 보고 싶어요', result: 'dream', score: 2 },
                        { label: '선택 완료 버튼', detail: '망설임을 끝내고 싶어요', result: 'control', score: 2 }
                    ]
                },
                {
                    text: '비 오는 날 마음이 향하는 곳은?',
                    options: [
                        { label: '조용히 글을 쓸 수 있는 책상', detail: '빗소리가 생각을 정리해줘요', result: 'archive', score: 2 },
                        { label: '따뜻한 조명 아래의 소파', detail: '몸을 편히 기대고 싶어요', result: 'comfort', score: 2 },
                        { label: '창밖을 보며 상상할 수 있는 자리', detail: '비는 다른 세계를 떠올리게 해요', result: 'dream', score: 2 },
                        { label: '내일 준비물을 미리 챙기는 공간', detail: '정리가 되면 마음이 놓여요', result: 'control', score: 2 }
                    ]
                }
            ],
            results: {
                archive: {
                    title: '기록의 서랍',
                    subtitle: '생각을 잃어버리고 싶지 않은 마음',
                    summary: '당신은 스쳐 지나가는 감정과 아이디어를 소중히 여기는 사람입니다. 정리된 문장 속에서 스스로를 더 잘 이해해요.',
                    tags: ['기록', '분석', '진심'],
                    guide: '완벽한 정리보다 짧은 메모가 더 오래 도움이 될 때가 많아요.',
                    match: '추천 루틴: 자기 전 세 줄 기록'
                },
                comfort: {
                    title: '온기의 서랍',
                    subtitle: '나를 다정하게 돌보고 싶은 마음',
                    summary: '당신은 마음이 지칠수록 감각적인 안정이 필요한 타입이에요. 좋은 향, 좋은 식사, 편한 옷이 생각보다 큰 힘을 줍니다.',
                    tags: ['돌봄', '안정', '감각'],
                    guide: '남을 챙기듯 나를 챙기는 시간을 일정에 먼저 넣어보세요.',
                    match: '추천 루틴: 좋아하는 향으로 하루 닫기'
                },
                dream: {
                    title: '상상의 서랍',
                    subtitle: '다른 가능성을 열어두고 싶은 마음',
                    summary: '당신은 익숙한 길에서도 새로운 장면을 찾는 사람입니다. 목적 없는 시간이 오히려 창의력을 회복시켜줘요.',
                    tags: ['상상', '자유', '호기심'],
                    guide: '생각만 하던 일을 아주 작은 버전으로 실행해 보세요.',
                    match: '추천 루틴: 지도 없이 동네 산책'
                },
                control: {
                    title: '주도권의 서랍',
                    subtitle: '내 삶의 핸들을 다시 잡고 싶은 마음',
                    summary: '당신은 불확실함 속에서도 방향을 만들고 싶은 타입이에요. 계획과 준비는 당신에게 중요한 안정 장치입니다.',
                    tags: ['계획', '확신', '실행'],
                    guide: '모든 변수를 통제하려 하기보다 선택 가능한 세 가지만 남겨보세요.',
                    match: '추천 루틴: 내일의 우선순위 3개'
                }
            }
        },
        {
            id: 'weekend-adventure',
            title: '주말 모험력 테스트',
            subtitle: '내 쉬는 날 장르는 무엇?',
            category: 'mini',
            section: 'new',
            badge: 'PLAY',
            plays: '44.1K',
            duration: '4분',
            creator: '주말 제작소',
            icon: '▶',
            coverLabel: 'WEEK',
            cover: {
                background: 'linear-gradient(135deg, #f1d4c2 0%, #e4c3cd 48%, #c7bfd0 100%)',
                color: '#3e3638'
            },
            tags: ['주말', '미니', '취미'],
            description: '쉬는 날 선택지로 나의 주말 장르를 뽑아봐요.',
            questions: [
                {
                    text: '토요일 오전, 가장 먼저 하고 싶은 일은?',
                    options: [
                        { label: '새 카페 찾아가기', detail: '동네도 새롭게 보는 편', result: 'explorer', score: 2 },
                        { label: '집에서 느긋하게 브런치', detail: '쉬는 날은 속도가 중요해요', result: 'nest', score: 2 },
                        { label: '친구들과 바로 약속 잡기', detail: '사람이 있어야 주말이죠', result: 'party', score: 2 },
                        { label: '전시나 팝업 검색하기', detail: '새로운 자극이 필요해요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '예상보다 시간이 많이 남았다면?',
                    options: [
                        { label: '안 가본 골목으로 걷는다', detail: '길 위에서 충전해요', result: 'explorer', score: 2 },
                        { label: '밀린 콘텐츠를 몰아본다', detail: '완벽한 회복 코스', result: 'nest', score: 2 },
                        { label: '누구든 불러서 만난다', detail: '즉흥 약속 환영', result: 'party', score: 2 },
                        { label: '저장해둔 장소 리스트를 연다', detail: '수집한 취향을 실행해요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '일요일 밤 가장 듣고 싶은 말은?',
                    options: [
                        { label: '이번 주말 진짜 알찼다', detail: '발견이 많았던 하루', result: 'explorer', score: 2 },
                        { label: '제대로 쉬었다', detail: '몸과 마음이 가벼워요', result: 'nest', score: 2 },
                        { label: '우리 다음에도 또 보자', detail: '관계가 충전됐어요', result: 'party', score: 2 },
                        { label: '좋은 취향 하나 찾았다', detail: '내 리스트가 더 풍성해져요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '금요일 밤 주말 계획을 세운다면?',
                    options: [
                        { label: '안 가본 동네를 지도에 찍어둔다', detail: '새 길이 있어야 설레요', result: 'explorer', score: 2 },
                        { label: '집에서 볼 콘텐츠와 먹을 걸 준비한다', detail: '회복 루트를 먼저 깔아둬요', result: 'nest', score: 2 },
                        { label: '누가 시간이 되는지 단톡방에 묻는다', detail: '주말은 같이 놀 때 살아나요', result: 'party', score: 2 },
                        { label: '전시, 팝업, 맛집 후보를 저장한다', detail: '좋은 장면을 골라두고 싶어요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '갑자기 친구가 나오라고 부르면?',
                    options: [
                        { label: '장소가 새로우면 바로 혹한다', detail: '낯선 루트가 끌려요', result: 'explorer', score: 2 },
                        { label: '오늘은 쉬는 날인지 먼저 확인한다', detail: '내 에너지 잔량이 중요해요', result: 'nest', score: 2 },
                        { label: '준비 시간을 묻고 합류한다', detail: '즉흥 약속도 재미있어요', result: 'party', score: 2 },
                        { label: '가볼 만한 곳을 내가 제안한다', detail: '저장한 리스트를 꺼낼 때예요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '주말 사진첩에 남기고 싶은 장면은?',
                    options: [
                        { label: '처음 본 골목의 간판과 풍경', detail: '발견의 흔적이 좋아요', result: 'explorer', score: 2 },
                        { label: '느긋한 식탁과 편한 방', detail: '쉼의 장면을 남기고 싶어요', result: 'nest', score: 2 },
                        { label: '친구들과 웃는 단체 사진', detail: '사람이 있는 기억이 오래가요', result: 'party', score: 2 },
                        { label: '전시 티켓과 마음에 든 오브제', detail: '취향의 증거를 모아요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '일요일 오후에 가장 아쉬운 것은?',
                    options: [
                        { label: '가보려던 길을 아직 못 걸은 것', detail: '발견을 더 하고 싶어요', result: 'explorer', score: 2 },
                        { label: '충분히 쉬지 못한 것', detail: '주말의 핵심은 회복이에요', result: 'nest', score: 2 },
                        { label: '사람들을 더 못 만난 것', detail: '웃을 시간이 조금 더 필요해요', result: 'party', score: 2 },
                        { label: '저장한 곳을 실행하지 못한 것', detail: '취향 리스트가 기다리고 있어요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '처음 가는 동네에서 나는?',
                    options: [
                        { label: '발길 가는 대로 골목을 돈다', detail: '계획 밖에서 재미를 찾아요', result: 'explorer', score: 2 },
                        { label: '편히 앉을 카페부터 찾는다', detail: '기지가 있어야 마음이 놓여요', result: 'nest', score: 2 },
                        { label: '근처 친구에게 추천을 묻는다', detail: '사람의 힌트가 제일 빨라요', result: 'party', score: 2 },
                        { label: '저장해둔 장소를 순서대로 돈다', detail: '취향 코스를 실행해요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '주말 예산을 어디에 쓰고 싶을까?',
                    options: [
                        { label: '교통비와 작은 길거리 간식', detail: '이동하는 맛이 있어요', result: 'explorer', score: 2 },
                        { label: '집에서 즐길 맛있는 음식', detail: '나만의 회복식을 차려요', result: 'nest', score: 2 },
                        { label: '친구들과 나눌 한 끼', detail: '같이 먹어야 더 맛있어요', result: 'party', score: 2 },
                        { label: '전시, 굿즈, 소품 같은 경험', detail: '남는 장면에 쓰고 싶어요', result: 'collector', score: 2 }
                    ]
                },
                {
                    text: '월요일을 덜 무겁게 만드는 일은?',
                    options: [
                        { label: '일요일 밤 짧은 산책으로 마무리하기', detail: '몸이 움직이면 마음도 가벼워져요', result: 'explorer', score: 2 },
                        { label: '집을 조금 정리하고 일찍 눕기', detail: '회복감을 이어가고 싶어요', result: 'nest', score: 2 },
                        { label: '좋았던 약속 이야기를 한 번 더 나누기', detail: '기억을 같이 붙잡아요', result: 'party', score: 2 },
                        { label: '다음 주말 후보를 하나 저장하기', detail: '기대가 있으면 버틸 힘이 생겨요', result: 'collector', score: 2 }
                    ]
                }
            ],
            results: {
                explorer: {
                    title: '골목 탐험가형 주말',
                    subtitle: '목적지보다 이동 중 발견을 사랑하는 타입',
                    summary: '당신의 주말은 지도 밖에서 더 재밌어집니다. 낯선 길, 작은 가게, 우연한 풍경이 에너지를 채워줘요.',
                    tags: ['탐험', '산책', '발견'],
                    guide: '다음 주말에는 한 정거장 먼저 내려 걸어보세요.',
                    match: '추천 장소: 시장 골목, 작은 서점'
                },
                nest: {
                    title: '포근한 홈시네마형 주말',
                    subtitle: '밖보다 안에서 깊게 회복하는 타입',
                    summary: '당신에게 좋은 주말은 에너지를 새로 채우는 시간이에요. 편한 공간을 잘 꾸릴수록 일주일의 밸런스가 좋아집니다.',
                    tags: ['회복', '집콕', '느긋함'],
                    guide: '작은 조명 하나만 바꿔도 쉬는 느낌이 선명해져요.',
                    match: '추천 장소: 내 방, 조용한 베이커리'
                },
                party: {
                    title: '즉흥 합류형 주말',
                    subtitle: '사람을 만나며 주말이 살아나는 타입',
                    summary: '당신은 약속이 생기는 순간 에너지가 올라가는 사람입니다. 좋은 대화와 웃음이 최고의 휴식이에요.',
                    tags: ['사교', '즉흥', '대화'],
                    guide: '완전히 비워두는 시간도 한 칸 남기면 월요일이 덜 무거워요.',
                    match: '추천 장소: 보드게임 카페, 루프탑'
                },
                collector: {
                    title: '취향 수집가형 주말',
                    subtitle: '좋은 장면을 저장하며 살아나는 타입',
                    summary: '당신은 주말마다 나만의 취향 아카이브를 업데이트해요. 전시, 팝업, 굿즈처럼 만질 수 있는 경험이 잘 맞습니다.',
                    tags: ['취향', '전시', '수집'],
                    guide: '저장만 하지 말고 이번 달 안에 하나는 꼭 실행해 보세요.',
                    match: '추천 장소: 팝업스토어, 편집숍'
                }
            }
        },
        {
            id: 'desk-animal',
            title: '책상 위 동물 테스트',
            subtitle: '일할 때 나는 어떤 동물 모드?',
            category: 'personality',
            section: 'self',
            badge: 'FUN',
            plays: '128.9K',
            duration: '4분',
            creator: '오피스 관찰단',
            icon: '◆',
            coverLabel: 'WORK',
            cover: {
                background: 'linear-gradient(135deg, #eadbd2 0%, #cfc3bb 48%, #b6aaa2 100%)',
                color: '#1f2937'
            },
            tags: ['업무', '습관', '성격'],
            description: '집중 방식과 협업 습관으로 나의 작업 모드를 찾아요.',
            questions: [
                {
                    text: '업무를 시작할 때 나는?',
                    options: [
                        { label: '먼저 목록을 만들고 우선순위를 정한다', detail: '정리 후 출발', result: 'owl', score: 2 },
                        { label: '쉬운 것부터 빠르게 처리한다', detail: '가속도를 먼저 만들어요', result: 'squirrel', score: 2 },
                        { label: '조용히 몰입할 환경을 만든다', detail: '방해 요소를 줄여요', result: 'cat', score: 2 },
                        { label: '팀 상황을 먼저 확인한다', detail: '흐름을 맞추는 게 중요해요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '회의에서 내 역할은?',
                    options: [
                        { label: '핵심 쟁점을 정리한다', detail: '방향을 잡는 편', result: 'owl', score: 2 },
                        { label: '아이디어를 많이 던진다', detail: '가능성을 열어요', result: 'squirrel', score: 2 },
                        { label: '듣다가 결정적일 때 말한다', detail: '말의 밀도를 챙겨요', result: 'cat', score: 2 },
                        { label: '사람들 의견을 연결한다', detail: '협업 온도를 봐요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '마감이 다가오면?',
                    options: [
                        { label: '남은 일을 다시 계산한다', detail: '리스크를 줄여요', result: 'owl', score: 2 },
                        { label: '순간 집중력으로 몰아친다', detail: '속도가 붙으면 강해요', result: 'squirrel', score: 2 },
                        { label: '혼자 조용히 끝까지 파고든다', detail: '깊은 집중이 무기', result: 'cat', score: 2 },
                        { label: '도움이 필요한 부분을 공유한다', detail: '같이 끝내는 쪽', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '일이 잘 풀리지 않을 때 나는?',
                    options: [
                        { label: '문제를 다시 정의하고 원인을 찾는다', detail: '구조가 보여야 해결돼요', result: 'owl', score: 2 },
                        { label: '작게 시도하며 막힌 곳을 뚫는다', detail: '손을 움직이면 답이 나와요', result: 'squirrel', score: 2 },
                        { label: '방해를 줄이고 혼자 깊게 본다', detail: '조용해야 실마리가 보여요', result: 'cat', score: 2 },
                        { label: '관련된 사람과 상황을 맞춰본다', detail: '흐름을 같이 보면 빨라요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '새로운 툴을 배워야 한다면?',
                    options: [
                        { label: '공식 문서와 핵심 개념부터 본다', detail: '원리를 알아야 오래 써요', result: 'owl', score: 2 },
                        { label: '일단 눌러보며 기능을 익힌다', detail: '직접 해보는 게 제일 빨라요', result: 'squirrel', score: 2 },
                        { label: '튜토리얼을 조용히 따라 해본다', detail: '혼자 익힐 시간이 필요해요', result: 'cat', score: 2 },
                        { label: '잘 쓰는 사람에게 팁을 묻는다', detail: '노하우를 나누면 속도가 붙어요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '동료가 도움을 요청할 때 나는?',
                    options: [
                        { label: '상황을 듣고 필요한 단계를 정리한다', detail: '문제가 어디인지 먼저 봐요', result: 'owl', score: 2 },
                        { label: '바로 같이 해보며 손을 보탠다', detail: '움직이면서 해결해요', result: 'squirrel', score: 2 },
                        { label: '집중할 시간을 확보해 꼼꼼히 봐준다', detail: '대충 넘기고 싶지 않아요', result: 'cat', score: 2 },
                        { label: '연결할 사람이나 자료를 찾아준다', detail: '팀 안의 길을 만들어줘요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '집중력이 떨어지는 오후의 나는?',
                    options: [
                        { label: '남은 업무를 다시 우선순위로 묶는다', detail: '해야 할 길을 짧게 만들어요', result: 'owl', score: 2 },
                        { label: '쉬운 업무 하나를 빠르게 끝낸다', detail: '작은 완료가 다시 시동을 걸어요', result: 'squirrel', score: 2 },
                        { label: '알림을 끄고 조용한 모드로 들어간다', detail: '자극을 줄여야 살아나요', result: 'cat', score: 2 },
                        { label: '팀 채널을 보며 흐름을 다시 잡는다', detail: '사람들과 맞추면 리듬이 돌아와요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '피드백을 받았을 때 먼저 하는 일은?',
                    options: [
                        { label: '기준과 영향도를 분류한다', detail: '수정의 우선순위를 잡아요', result: 'owl', score: 2 },
                        { label: '바로 고칠 수 있는 것부터 반영한다', detail: '빠른 개선이 마음을 편하게 해요', result: 'squirrel', score: 2 },
                        { label: '혼자 읽어보고 의도를 곱씹는다', detail: '정확히 이해하고 움직여요', result: 'cat', score: 2 },
                        { label: '피드백 준 사람과 맥락을 맞춘다', detail: '오해를 줄이는 대화가 중요해요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '회의가 길어질 때 내가 찾는 돌파구는?',
                    options: [
                        { label: '논점을 세 개로 정리해 결론을 묻는다', detail: '흩어진 말을 묶어요', result: 'owl', score: 2 },
                        { label: '실행 가능한 다음 액션을 제안한다', detail: '움직일 일이 생기면 풀려요', result: 'squirrel', score: 2 },
                        { label: '잠깐 침묵하며 핵심 문장을 고른다', detail: '말을 아껴도 정확히 말해요', result: 'cat', score: 2 },
                        { label: '서로 다른 의견의 공통점을 찾는다', detail: '사람 사이의 접점을 봐요', result: 'dolphin', score: 2 }
                    ]
                },
                {
                    text: '성과를 보여줘야 할 때 나는?',
                    options: [
                        { label: '목표와 결과를 한눈에 보이게 만든다', detail: '근거가 설득력을 줘요', result: 'owl', score: 2 },
                        { label: '먼저 데모나 샘플을 보여준다', detail: '보이면 설명이 빨라요', result: 'squirrel', score: 2 },
                        { label: '디테일과 완성도를 끝까지 다듬는다', detail: '작은 차이가 결과를 말해요', result: 'cat', score: 2 },
                        { label: '함께 만든 사람들의 기여도 챙긴다', detail: '성과는 팀의 흐름으로 보여요', result: 'dolphin', score: 2 }
                    ]
                }
            ],
            results: {
                owl: {
                    title: '밤눈 밝은 부엉이형',
                    subtitle: '맥락과 구조를 보는 작업자',
                    summary: '당신은 일을 시작하기 전에 전체 그림을 잡는 타입이에요. 복잡한 프로젝트에서 특히 안정적인 기준점이 됩니다.',
                    tags: ['분석', '구조화', '책임'],
                    guide: '완벽한 구조를 기다리기보다 초안을 빠르게 공유하면 속도가 더 좋아져요.',
                    match: '잘 맞는 역할: 기획, PM, 리뷰어'
                },
                squirrel: {
                    title: '재빠른 다람쥐형',
                    subtitle: '작게 시작해 추진력을 만드는 작업자',
                    summary: '당신은 머뭇거리기보다 움직이면서 답을 찾는 타입이에요. 빠른 시도와 전환이 강점입니다.',
                    tags: ['실행', '속도', '아이디어'],
                    guide: '마지막 정리 시간을 미리 확보하면 결과물이 더 단단해져요.',
                    match: '잘 맞는 역할: 콘텐츠, 운영, 프로토타입'
                },
                cat: {
                    title: '조용한 고양이형',
                    subtitle: '깊은 집중으로 완성도를 높이는 작업자',
                    summary: '당신은 소음이 줄어들수록 실력이 잘 드러나는 타입이에요. 혼자 파고드는 시간에서 좋은 결과를 만듭니다.',
                    tags: ['몰입', '섬세함', '완성도'],
                    guide: '중간 공유를 조금만 늘리면 당신의 깊이가 더 잘 전달돼요.',
                    match: '잘 맞는 역할: 디자인, 리서치, 개발'
                },
                dolphin: {
                    title: '협업 돌고래형',
                    subtitle: '사람과 흐름을 함께 읽는 작업자',
                    summary: '당신은 팀 안에서 막힌 지점을 부드럽게 풀어내는 타입이에요. 의견 사이의 다리를 놓는 데 강합니다.',
                    tags: ['협업', '조율', '커뮤니케이션'],
                    guide: '모두를 챙기다 내 할 일이 밀리지 않도록 경계선을 분명히 해주세요.',
                    match: '잘 맞는 역할: 커뮤니티, CX, 리드'
                }
            }
        },
        {
            id: 'snack-fate',
            title: '간식 운세 테스트',
            subtitle: '오늘 나를 살리는 당충전은?',
            category: 'mini',
            section: 'new',
            badge: 'LUCK',
            plays: '65.5K',
            duration: '3분',
            creator: '스낵 점성술사',
            icon: '✦',
            coverLabel: 'LUCK',
            cover: {
                background: 'linear-gradient(135deg, #f1d2bd 0%, #d8a4a8 52%, #bca9a2 100%)',
                color: '#3e3638'
            },
            tags: ['운세', '간식', '가벼움'],
            description: '별일 아닌 선택으로 오늘의 간식 기운을 뽑아봐요.',
            questions: [
                {
                    text: '오늘 가장 필요한 기운은?',
                    options: [
                        { label: '부드러운 위로', detail: '마음이 말랑해지고 싶어요', result: 'cake', score: 2 },
                        { label: '또렷한 집중', detail: '정신이 번쩍해야 해요', result: 'coffee', score: 2 },
                        { label: '가벼운 재미', detail: '입이 심심한 날', result: 'chip', score: 2 },
                        { label: '상큼한 전환', detail: '분위기를 바꾸고 싶어요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '지금 내 하루의 리듬은?',
                    options: [
                        { label: '천천히 풀리는 중', detail: '급하지 않게', result: 'cake', score: 2 },
                        { label: '빡빡하게 돌아가는 중', detail: '각성이 필요해요', result: 'coffee', score: 2 },
                        { label: '왔다 갔다 산만한 중', detail: '작은 자극이 필요해요', result: 'chip', score: 2 },
                        { label: '새로고침이 필요한 중', detail: '공기를 바꾸고 싶어요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '오후 3시에 입이 심심하다면?',
                    options: [
                        { label: '부드러운 디저트로 쉬어간다', detail: '달콤한 휴식이 필요해요', result: 'cake', score: 2 },
                        { label: '진한 커피로 집중을 다시 켠다', detail: '한 번 더 몰입하고 싶어요', result: 'coffee', score: 2 },
                        { label: '바삭한 걸 조금씩 집어먹는다', detail: '작은 소리가 기분을 깨워요', result: 'chip', score: 2 },
                        { label: '상큼한 과일로 입맛을 바꾼다', detail: '무거운 흐름을 가볍게 해요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '기분이 살짝 가라앉은 날 고르는 맛은?',
                    options: [
                        { label: '크림처럼 포근한 맛', detail: '위로받는 느낌이 좋아요', result: 'cake', score: 2 },
                        { label: '쌉싸름하고 진한 맛', detail: '정신이 또렷해져요', result: 'coffee', score: 2 },
                        { label: '짭짤하고 경쾌한 맛', detail: '생각을 잠깐 끊어줘요', result: 'chip', score: 2 },
                        { label: '새콤달콤한 맛', detail: '기분을 환기해줘요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '오늘의 행운 포장을 고른다면?',
                    options: [
                        { label: '파스텔 리본이 묶인 작은 상자', detail: '다정한 보상 같아요', result: 'cake', score: 2 },
                        { label: '검은 라벨의 깔끔한 컵', detail: '집중하는 분위기가 나요', result: 'coffee', score: 2 },
                        { label: '톡톡 튀는 컬러의 봉지', detail: '열기 전부터 가벼워요', result: 'chip', score: 2 },
                        { label: '투명하고 산뜻한 컵', detail: '신선한 기운이 보여요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '집중 전 책상 위에 두고 싶은 간식은?',
                    options: [
                        { label: '한 입 케이크나 마들렌', detail: '시작 전에 마음을 달래요', result: 'cake', score: 2 },
                        { label: '얼음 가득한 커피', detail: '정신을 빠르게 깨워요', result: 'coffee', score: 2 },
                        { label: '조금씩 먹는 스낵', detail: '리듬을 끊지 않고 먹기 좋아요', result: 'chip', score: 2 },
                        { label: '잘라둔 과일 한 컵', detail: '가볍게 새로고침돼요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '친구와 나눠 먹고 싶은 것은?',
                    options: [
                        { label: '서로 다른 조각 케이크', detail: '고르는 재미까지 나누고 싶어요', result: 'cake', score: 2 },
                        { label: '각자 취향대로 고른 커피', detail: '대화가 또렷해져요', result: 'coffee', score: 2 },
                        { label: '큰 봉지 과자 하나', detail: '가볍게 집어먹으며 웃기 좋아요', result: 'chip', score: 2 },
                        { label: '컵과일이나 생과일 주스', detail: '상큼하게 같이 쉬고 싶어요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '퇴근길 편의점에서 눈에 들어오는 것은?',
                    options: [
                        { label: '오늘만 할인하는 디저트', detail: '나에게 주는 작은 상이에요', result: 'cake', score: 2 },
                        { label: '새로 나온 캔커피', detail: '내일의 집중까지 챙겨요', result: 'coffee', score: 2 },
                        { label: '처음 보는 과자 맛', detail: '가벼운 모험이 필요해요', result: 'chip', score: 2 },
                        { label: '잘 익은 과일 컵', detail: '하루를 산뜻하게 닫고 싶어요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '밤 산책 뒤 떠오르는 한 입은?',
                    options: [
                        { label: '작고 달콤한 빵 한 조각', detail: '하루의 끝을 부드럽게 만들어요', result: 'cake', score: 2 },
                        { label: '따뜻한 라테 한 모금', detail: '몸을 천천히 풀어줘요', result: 'coffee', score: 2 },
                        { label: '바삭한 스낵 몇 개', detail: '심심한 밤에 작은 재미예요', result: 'chip', score: 2 },
                        { label: '차가운 과일 한 입', detail: '입안이 맑아지는 느낌이에요', result: 'fruit', score: 2 }
                    ]
                },
                {
                    text: '내일의 나에게 남겨두고 싶은 간식은?',
                    options: [
                        { label: '힘든 순간 꺼낼 달콤한 보상', detail: '미리 다정함을 준비해요', result: 'cake', score: 2 },
                        { label: '바쁜 아침을 깨울 카페인', detail: '시동 걸 준비를 해둬요', result: 'coffee', score: 2 },
                        { label: '잠깐 웃을 수 있는 가벼운 스낵', detail: '심심함을 막아줘요', result: 'chip', score: 2 },
                        { label: '상큼하게 시작할 과일', detail: '몸과 기분을 같이 깨워요', result: 'fruit', score: 2 }
                    ]
                }
            ],
            results: {
                cake: {
                    title: '폭신한 조각 케이크 운',
                    subtitle: '오늘은 나에게 다정할수록 좋아지는 날',
                    summary: '달콤하고 부드러운 것이 마음의 모서리를 둥글게 만들어줘요. 무리한 목표보다 작은 보상이 잘 맞습니다.',
                    tags: ['위로', '보상', '느긋함'],
                    guide: '오늘의 행운 시간: 오후 3시 20분',
                    match: '행운의 짝꿍: 따뜻한 차'
                },
                coffee: {
                    title: '진한 콜드브루 운',
                    subtitle: '집중력이 필요한 일을 끝내기 좋은 날',
                    summary: '흐릿했던 생각이 한 번에 정리되는 기운이에요. 짧고 굵게 몰입하면 성과가 납니다.',
                    tags: ['집중', '속도', '정리'],
                    guide: '오늘의 행운 시간: 오전 10시 40분',
                    match: '행운의 짝꿍: 담백한 쿠키'
                },
                chip: {
                    title: '바삭한 감자칩 운',
                    subtitle: '작은 재미가 연달아 터지는 날',
                    summary: '계획보다 즉흥적인 선택에서 웃음이 생길 수 있어요. 너무 큰 의미를 찾지 않아도 충분히 즐거운 날입니다.',
                    tags: ['재미', '즉흥', '가벼움'],
                    guide: '오늘의 행운 시간: 저녁 7시 10분',
                    match: '행운의 짝꿍: 탄산수'
                },
                fruit: {
                    title: '상큼한 과일컵 운',
                    subtitle: '분위기 전환에 강한 날',
                    summary: '답답한 흐름이 있다면 색다른 선택 하나가 리듬을 바꿔줄 거예요. 짧은 외출이나 자리 이동이 좋습니다.',
                    tags: ['전환', '상쾌함', '리셋'],
                    guide: '오늘의 행운 시간: 오후 1시 30분',
                    match: '행운의 짝꿍: 산책'
                }
            }
        },
        {
            id: 'idol-stage',
            title: '아이돌 무대 포지션 테스트',
            subtitle: '내가 팀에 들어간다면 맡을 포지션은?',
            category: 'style',
            section: 'self',
            badge: 'POP',
            plays: '203.6K',
            duration: '4분',
            creator: '스테이지 랩',
            icon: '★',
            coverLabel: 'STAGE',
            cover: {
                background: 'linear-gradient(135deg, #ddcbe4 0%, #c3b9d8 48%, #f0dcc4 100%)',
                color: '#3e3638'
            },
            tags: ['K팝', '무대', '캐릭터'],
            description: '무대 위 선택으로 나의 존재감 타입을 찾아봐요.',
            questions: [
                {
                    text: '무대 시작 직전 나는?',
                    options: [
                        { label: '동선을 마지막으로 확인한다', detail: '실수 없는 완성도', result: 'leader', score: 2 },
                        { label: '카메라 포인트를 떠올린다', detail: '시선을 잡고 싶어요', result: 'center', score: 2 },
                        { label: '멤버들과 장난치며 긴장을 푼다', detail: '팀 분위기 담당', result: 'mood', score: 2 },
                        { label: '혼자 숨을 고르며 몰입한다', detail: '한 방을 준비해요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '팬들이 나를 기억했으면 하는 장면은?',
                    options: [
                        { label: '팀을 안정적으로 이끄는 모습', detail: '믿음직한 존재감', result: 'leader', score: 2 },
                        { label: '킬링파트에서 눈 마주치는 순간', detail: '강한 인상', result: 'center', score: 2 },
                        { label: '비하인드에서 웃기는 모습', detail: '친근한 매력', result: 'mood', score: 2 },
                        { label: '라이브로 분위기를 바꾸는 순간', detail: '실력의 설득력', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '연습실에서 나는?',
                    options: [
                        { label: '전체 합을 체크한다', detail: '팀 밸런스가 보여요', result: 'leader', score: 2 },
                        { label: '표정과 제스처를 연구한다', detail: '디테일이 중요해요', result: 'center', score: 2 },
                        { label: '지친 멤버를 웃긴다', detail: '분위기가 살아야 해요', result: 'mood', score: 2 },
                        { label: '어려운 파트를 반복한다', detail: '납득될 때까지 파요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '무대 의상을 처음 봤을 때 나는?',
                    options: [
                        { label: '팀 전체 콘셉트와 균형을 본다', detail: '합이 맞아야 무대가 살아나요', result: 'leader', score: 2 },
                        { label: '내가 돋보일 포인트를 찾는다', detail: '한 컷을 남기고 싶어요', result: 'center', score: 2 },
                        { label: '멤버별 반응을 보며 분위기를 띄운다', detail: '준비 과정도 즐거워야 해요', result: 'mood', score: 2 },
                        { label: '움직이고 노래하기 편한지 확인한다', detail: '실력 발휘가 먼저예요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '파트 분배 회의에서 내가 보는 것은?',
                    options: [
                        { label: '각자 강점이 잘 배치됐는지', detail: '팀 전체 완성도를 챙겨요', result: 'leader', score: 2 },
                        { label: '킬링파트를 어떻게 살릴지', detail: '짧은 순간이 무대를 좌우해요', result: 'center', score: 2 },
                        { label: '멤버들이 부담 없이 말하는지', detail: '분위기가 좋아야 의견도 나와요', result: 'mood', score: 2 },
                        { label: '라이브가 안정적으로 들릴지', detail: '무대의 설득력은 소리에서 나와요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '팬 사인회에서 내 매력 포인트는?',
                    options: [
                        { label: '차분하게 기억하고 챙겨주는 모습', detail: '믿음직한 인상을 남겨요', result: 'leader', score: 2 },
                        { label: '눈을 맞추는 선명한 리액션', detail: '한 사람에게 집중해요', result: 'center', score: 2 },
                        { label: '편하게 웃게 만드는 말솜씨', detail: '어색함을 풀어줘요', result: 'mood', score: 2 },
                        { label: '진심이 느껴지는 짧은 한마디', detail: '목소리와 태도로 오래 남아요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '새 콘셉트 사진을 찍는다면?',
                    options: [
                        { label: '팀 스토리가 잘 보이는 컷을 고른다', detail: '전체 메시지가 중요해요', result: 'leader', score: 2 },
                        { label: '시선을 잡는 표정과 포즈를 시도한다', detail: '한 장으로 기억되고 싶어요', result: 'center', score: 2 },
                        { label: '현장 분위기를 살리며 자연스럽게 찍는다', detail: '편안한 에너지가 매력이에요', result: 'mood', score: 2 },
                        { label: '노래 분위기와 맞는 감정을 잡는다', detail: '사진에도 서사가 필요해요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '연습이 길어지는 날 나는?',
                    options: [
                        { label: '쉬는 타이밍과 남은 분량을 조율한다', detail: '버틸 수 있는 구조를 만들어요', result: 'leader', score: 2 },
                        { label: '마지막까지 표정과 엔딩을 다듬는다', detail: '디테일이 기억을 만들어요', result: 'center', score: 2 },
                        { label: '지친 분위기를 장난으로 풀어준다', detail: '웃어야 다시 움직여요', result: 'mood', score: 2 },
                        { label: '컨디션을 관리하며 어려운 구간을 반복한다', detail: '목소리를 끝까지 지켜요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '컴백 직전 가장 신경 쓰는 것은?',
                    options: [
                        { label: '무대 동선과 팀 합', detail: '흔들림 없는 기준이 필요해요', result: 'leader', score: 2 },
                        { label: '첫 등장과 엔딩 포즈', detail: '시작과 끝이 기억돼요', result: 'center', score: 2 },
                        { label: '멤버들의 긴장과 현장 분위기', detail: '팀 텐션이 무대를 좌우해요', result: 'mood', score: 2 },
                        { label: '라이브 컨디션과 호흡', detail: '결정적인 순간을 준비해요', result: 'vocal', score: 2 }
                    ]
                },
                {
                    text: '무대가 끝난 뒤 내가 확인하는 것은?',
                    options: [
                        { label: '전체 흐름에서 아쉬운 지점', detail: '다음 무대를 더 좋게 만들어요', result: 'leader', score: 2 },
                        { label: '내 표정과 카메라 반응', detail: '화면 속 존재감을 체크해요', result: 'center', score: 2 },
                        { label: '멤버들과 팬들의 분위기', detail: '함께 즐겼는지가 중요해요', result: 'mood', score: 2 },
                        { label: '라이브가 안정적으로 들렸는지', detail: '실력으로 남고 싶어요', result: 'vocal', score: 2 }
                    ]
                }
            ],
            results: {
                leader: {
                    title: '믿고 보는 리더 포지션',
                    subtitle: '무대의 중심을 뒤에서 단단히 잡는 사람',
                    summary: '당신은 자신의 파트뿐 아니라 전체 흐름을 보는 타입이에요. 팀이 흔들릴 때 기준점이 되어줍니다.',
                    tags: ['리더십', '균형', '책임'],
                    guide: '혼자 짊어지기보다 잘 나눌수록 더 멋진 리더가 됩니다.',
                    match: '팬들이 부르는 별명: 무대의 기둥'
                },
                center: {
                    title: '시선 강탈 센터 포지션',
                    subtitle: '짧은 순간에도 장면을 만드는 사람',
                    summary: '당신은 표정과 타이밍으로 분위기를 바꾸는 힘이 있어요. 등장하는 순간 시선이 자연스럽게 모입니다.',
                    tags: ['존재감', '센스', '표현'],
                    guide: '강한 포인트 사이에 힘을 빼는 구간을 만들면 더 오래 기억돼요.',
                    match: '팬들이 부르는 별명: 엔딩요정'
                },
                mood: {
                    title: '팀 텐션 메이커 포지션',
                    subtitle: '무대 밖에서도 팀을 빛나게 하는 사람',
                    summary: '당신은 사람들의 긴장을 풀고 분위기를 살리는 능력이 좋아요. 편안함이 곧 당신의 매력입니다.',
                    tags: ['친화력', '유머', '에너지'],
                    guide: '웃음을 주는 만큼 당신의 진지한 매력도 가끔 보여주세요.',
                    match: '팬들이 부르는 별명: 입덕 문'
                },
                vocal: {
                    title: '한 방 있는 메인 보컬 포지션',
                    subtitle: '결정적인 순간에 설득하는 사람',
                    summary: '당신은 조용히 준비하다가 중요한 장면에서 실력으로 답하는 타입이에요. 깊은 몰입이 강점입니다.',
                    tags: ['실력', '몰입', '진정성'],
                    guide: '완벽히 준비된 뒤에만 나서려 하지 않아도 괜찮아요. 과정도 충분히 매력적입니다.',
                    match: '팬들이 부르는 별명: 라이브 장인'
                }
            }
        }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.enrichTests();
        await this.service.init();
        let restored = await this.restoreSharedResultFromUrl();
        if (!restored) {
            this.selectedTest = this.heroTest;
        }
    }

    public async restoreSharedResultFromUrl() {
        let payload = this.readSharePayload();
        if (!payload?.t) return false;

        let test = this.tests.find((item: any) => item.id === payload.t);
        if (!test) return false;

        this.selectedTest = test;
        this.questionIndex = 0;
        this.answers = [];
        this.result = null;
        this.resultTransitionToken++;
        this.resetPhotoState();
        this.resetGiftState();
        this.resetPinballState();
        this.resetFortuneState();

        let restored = this.resultFromSharePayload(test, payload);
        if (!restored?.result) return false;

        this.result = restored.result;
        this.screen = restored.screen;
        if (this.screen === 'gift') {
            this.giftResult = this.result;
        }
        if (this.screen === 'pinball' && Array.isArray(restored.result?.ranking)) {
            this.restorePinballResultState(restored.result.ranking);
        }

        await this.service.render();
        if (this.screen === 'pinball') {
            this.queuePinballBoardDraw();
        }
        this.scrollPageToTop('auto');
        return true;
    }

    public readSharePayload() {
        let value = new URLSearchParams(window.location.search).get(this.shareParamName);
        if (!value) return null;

        try {
            let payload = JSON.parse(value);
            return payload && typeof payload === 'object' ? payload : null;
        } catch (error) {
            return null;
        }
    }

    public resultFromSharePayload(test: any, payload: any) {
        let scoring = test.scoring || 'quiz';

        if (scoring === 'photo') {
            let index = this.normalizedResultIndex(payload.i, test.results || []);
            if (index < 0) return null;
            return { screen: 'photoResult', result: this.buildPhotoResultFromIndex(test, index, payload.pt) };
        }

        if (scoring === 'gift') {
            let index = this.normalizedResultIndex(payload.i, test.results || []);
            if (index < 0) return null;
            return { screen: 'gift', result: this.buildGiftResultFromIndex(test, index) };
        }

        if (scoring === 'tarot') {
            let index = this.normalizedResultIndex(payload.i, test.results || []);
            if (index < 0) return null;
            let fanIndex = Number.isFinite(Number(payload.fi)) ? Number(payload.fi) : index;
            let card = { ...(test.results[index] || {}), fanIndex: fanIndex, shareResultIndex: index };
            let orientation = payload.o === 'reversed' ? 'reversed' : 'upright';
            return { screen: 'tarot', result: this.createTarotDrawResult(card, orientation) };
        }

        if (scoring === 'pinball') {
            let ranking = Array.isArray(payload.ranking) ? payload.ranking.slice(0, 40) : [];
            if (!ranking.length) return null;
            this.restorePinballWinningRank(payload.pr, payload.wr);
            return { screen: 'pinball', result: this.createPinballSharedResult(test, ranking, payload.w, payload.wr) };
        }

        if (scoring === 'saju') {
            this.fortuneProfile = this.mergeSharedForm(this.fortuneProfile, payload.f);
            if (!this.parseBirthDate(this.fortuneProfile.birthDate, this.fortuneProfile.calendarType)) return null;
            return { screen: 'saju', result: this.buildSajuResult(this.fortuneProfile) };
        }

        if (scoring === 'compatibility') {
            this.compatibilityForm = this.mergeSharedForm(this.compatibilityForm, payload.f);
            if (!this.parseBirthDate(this.compatibilityForm.aBirthDate) || !this.parseBirthDate(this.compatibilityForm.bBirthDate)) return null;
            return { screen: 'compatibility', result: this.buildCompatibilityResult(this.compatibilityForm) };
        }

        if (scoring === 'daily') {
            this.dailyForm = this.mergeSharedForm(this.dailyForm, payload.f);
            let targetDate = this.parseBirthDate(payload.d) || new Date();
            if (!this.parseBirthDate(this.dailyForm.birthDate)) return null;
            return { screen: 'daily', result: this.buildDailyFortuneResult(this.dailyForm, targetDate) };
        }

        if (scoring === 'manse') {
            this.manseForm = this.mergeSharedForm(this.manseForm, payload.f);
            let targetYear = Number(payload.y);
            if (!Number.isFinite(targetYear)) targetYear = new Date().getFullYear();
            targetYear = this.normalTargetYear(targetYear);
            this.manseForm.targetYear = targetYear;
            if (!this.parseBirthDate(this.manseForm.birthDate, this.manseForm.calendarType)) return null;
            this.resetManseAccordion();
            let calculation = this.calculateSaju({ ...this.manseForm, targetYear: targetYear });
            return { screen: 'manse', result: this.buildManseResult(calculation) };
        }

        if (scoring === 'axes') {
            let code = this.normalizedAxisCode(payload.r);
            if (!code) return null;
            let result = this.axisProfile(code, {});
            result.shareResultKey = code;
            return { screen: 'result', result: result };
        }

        let key = `${payload.r || ''}`;
        let result = test.results?.[key];
        if (!result) return null;
        return { screen: 'result', result: { ...result, shareResultKey: key } };
    }

    public mergeSharedForm(base: any, form: any) {
        if (!form || typeof form !== 'object') return { ...base };
        return { ...base, ...form };
    }

    public normalizedResultIndex(value: any, results: any[]) {
        let index = Number(value);
        if (!Number.isInteger(index) || index < 0 || index >= results.length) return -1;
        return index;
    }

    public buildPhotoResultFromIndex(test: any, index: number, toneValue: any = 0) {
        let base = (test.results || [])[index] || {};
        let tones = this.photoResultTones();
        let toneIndex = Number(toneValue);
        if (!Number.isInteger(toneIndex) || toneIndex < 0) toneIndex = 0;
        toneIndex = tones.length ? toneIndex % tones.length : 0;

        return {
            ...base,
            summary: `${base.summary || ''} ${tones[toneIndex] || ''}`.trim(),
            tags: base.tags || ['전생', '인물상'],
            guide: base.guide || '오늘의 선택에 전생 캐릭터의 장점을 살짝 빌려보세요.',
            match: base.match || '추천 테스트: 생활 MBTI 성향 테스트',
            shareResultIndex: index,
            sharePhotoToneIndex: toneIndex
        };
    }

    public buildGiftResultFromIndex(test: any, index: number) {
        return {
            ...((test.results || [])[index] || {}),
            drawNumber: index + 1,
            shareResultIndex: index
        };
    }

    public restorePinballWinningRank(sharedRank: any, fallbackRank: any = '') {
        if (sharedRank === 'last') {
            this.pinballWinningRank = 'last';
            return;
        }
        let rank = Number(sharedRank || fallbackRank);
        if (Number.isFinite(rank) && rank >= 1) {
            this.pinballWinningRank = Math.floor(rank);
        }
    }

    public createPinballSharedResult(test: any, ranking: any[], winnerLabel: string = '', winnerRankValue: any = '') {
        let colors = this.pinballPastelPalette();
        let normalized = (ranking || []).map((item: any, index: number) => ({
            label: item?.label || `공 ${index + 1}`,
            rank: Number.isFinite(Number(item?.rank)) ? Number(item.rank) : index + 1,
            color: item?.color || colors[index % colors.length],
            weight: item?.weight || 1
        })).sort((a: any, b: any) => a.rank - b.rank);
        let winnerRank = Number(winnerRankValue);
        let winner = (Number.isFinite(winnerRank) ? normalized.find((item: any) => item.rank === winnerRank) : null)
            || normalized.find((item: any) => item.label === winnerLabel)
            || normalized[0]
            || {};
        return {
            title: `${winner.rank || 1}위 ${winner.label || winnerLabel || '당첨공'}`,
            subtitle: '핀볼 랜덤 숫자 뽑기 결과',
            summary: `${winner.label || winnerLabel || '당첨공'} 공이 지정한 당첨 순위로 골인했어요.`,
            tags: ['핀볼', '랜덤', '룰렛'],
            guide: '같은 명단이라도 셔플과 충돌에 따라 순서가 달라질 수 있어요.',
            match: `${test?.title || '핀볼 뽑기'} 다시 하기`,
            winnerLabel: winner.label || winnerLabel,
            winnerRank: winner.rank || 1,
            ranking: normalized
        };
    }

    public restorePinballResultState(ranking: any[]) {
        let colors = this.pinballPastelPalette();
        let normalized = (ranking || []).map((item: any, index: number) => ({
            label: item?.label || `공 ${index + 1}`,
            displayLabel: item?.displayLabel || item?.shortLabel || this.pinballDisplayLabel(item?.label || `${index + 1}`),
            rank: Number.isFinite(Number(item?.rank)) ? Number(item.rank) : index + 1,
            color: item?.color || colors[index % colors.length],
            weight: item?.weight || 1
        })).sort((a: any, b: any) => a.rank - b.rank);

        this.pinballResults = normalized;
        this.pinballTotalBalls = normalized.length || this.pinballTotalBalls;
        this.pinballWorld = this.createPinballWorld();
        this.pinballWinner = normalized.find((item: any) => item.rank === this.result?.winnerRank)
            || normalized.find((item: any) => item.label === this.result?.winnerLabel)
            || normalized[0]
            || null;
        this.pinballWinnerAnnouncedAt = this.pinballWinner ? performance.now() - 1800 : 0;
        this.pinballWinnerBurstSeed = this.pinballWinner ? this.randomInt(100000) : 0;
        this.pinballBalls = this.createPinballSnapshotBalls(normalized);
        this.pinballRunning = false;
        this.pinballShuffling = false;
        let focusBall = this.pinballBalls.find((ball: any) => ball.label === this.pinballWinner?.label || ball.rank === this.pinballWinner?.rank)
            || this.pinballBalls[0]
            || null;
        this.pinballFocusBallId = focusBall?.id || '';
        this.pinballCameraFocusX = focusBall?.x || 0;
        this.pinballCameraFocusY = focusBall?.y || 0;
        this.pinballCameraFocusReady = !!focusBall;
        this.pinballCameraScale = this.pinballWinner ? 1.24 : 1;
        this.pinballCameraTargetScale = this.pinballCameraScale;
        let visibleW = this.pinballCanvasWidth / this.pinballCameraScale;
        let visibleH = this.pinballCanvasHeight / this.pinballCameraScale;
        this.pinballCameraTargetX = focusBall
            ? this.clamp(focusBall.x - visibleW * 0.5, 0, Math.max(0, this.pinballWorld.width - visibleW))
            : 0;
        this.pinballCameraX = this.pinballCameraTargetX;
        this.pinballCameraTargetY = this.pinballWinner
            ? this.clamp(this.pinballWorld.goalY - visibleH * 0.64, 0, Math.max(0, this.pinballWorld.height - visibleH))
            : 0;
        this.pinballCameraY = this.pinballCameraTargetY;
        this.pinballMessage = this.pinballWinner ? `${this.pinballWinner.label} 당첨 결과` : '공유된 결과';
    }

    public createPinballSnapshotBalls(ranking: any[]) {
        let total = Math.max((ranking || []).length, 1);
        let radius = total > 86 ? 10 : total > 54 ? 12 : total > 28 ? 15 : 18;
        let world = this.pinballWorld || this.createPinballWorld();
        let columns = Math.min(9, Math.max(4, Math.ceil(Math.sqrt(total) + 1)));
        let left = 132;
        let right = this.pinballCanvasWidth - 132;
        let gap = columns > 1 ? (right - left) / (columns - 1) : 0;
        return (ranking || []).map((item: any, index: number) => {
            let rankIndex = Math.max(0, (Number(item.rank) || index + 1) - 1);
            let column = rankIndex % columns;
            let row = Math.floor(rankIndex / columns);
            let isWinner = this.result?.winnerLabel === item.label || this.result?.winnerRank === item.rank;
            return {
                ...item,
                id: item?.id || `pinball-snapshot-${rankIndex}-${index}`,
                x: left + gap * column,
                y: world.goalY + 220 + row * (radius * 2.2),
                vx: 0,
                vy: 0,
                r: radius,
                finished: true,
                skillTimer: 0,
                skillGlow: isWinner ? 1 : 0
            };
        });
    }

    public queuePinballBoardDraw() {
        requestAnimationFrame(() => this.drawPinballBoard());
    }

    public normalizedAxisCode(value: any) {
        let code = `${value || ''}`.toUpperCase();
        return /^[EI][SN][TF][JP]$/.test(code) ? code : '';
    }

    public createResultSharePayload() {
        if (!this.selectedTest || !this.result) return null;

        let scoring = this.selectedTest.scoring || 'quiz';
        let payload: any = { t: this.selectedTest.id };
        if (scoring !== 'quiz') payload.s = scoring;

        if (scoring === 'photo') {
            let index = this.currentResultIndex();
            if (index < 0) return null;
            payload.i = index;
            payload.pt = Number.isInteger(this.result.sharePhotoToneIndex) ? this.result.sharePhotoToneIndex : 0;
            return payload;
        }

        if (scoring === 'gift') {
            let index = this.currentResultIndex();
            if (index < 0) return null;
            payload.i = index;
            return payload;
        }

        if (scoring === 'tarot') {
            let index = this.currentResultIndex();
            if (index < 0) return null;
            payload.i = index;
            payload.fi = Number.isInteger(this.result.shareFanIndex) ? this.result.shareFanIndex : index;
            payload.o = this.result.orientation === 'reversed' ? 'reversed' : 'upright';
            return payload;
        }

        if (scoring === 'pinball') {
            let ranking = (this.pinballResults || []).slice(0, 40).map((item: any) => ({
                label: item.label,
                rank: item.rank,
                color: item.color,
                weight: item.weight
            }));
            if (!ranking.length || !this.result?.winnerLabel) return null;
            payload.ranking = ranking;
            payload.w = this.result.winnerLabel;
            payload.wr = this.result.winnerRank || this.pinballWinner?.rank || '';
            payload.pr = this.pinballWinningRank;
            return payload;
        }

        if (scoring === 'saju') {
            payload.f = this.sharedFortuneForm(this.fortuneProfile);
            return payload;
        }

        if (scoring === 'compatibility') {
            payload.f = { ...this.compatibilityForm };
            return payload;
        }

        if (scoring === 'daily') {
            payload.f = { ...this.dailyForm };
            payload.d = this.result.shareDate || this.formatInputDate(new Date());
            return payload;
        }

        if (scoring === 'manse') {
            payload.f = this.sharedFortuneForm(this.manseForm);
            payload.y = this.result.shareYear || new Date().getFullYear();
            return payload;
        }

        if (scoring === 'axes') {
            let code = this.normalizedAxisCode(this.result.shareResultKey || this.axisCodeFromResult(this.result));
            if (!code) return null;
            payload.r = code;
            return payload;
        }

        let key = this.result.shareResultKey || this.resultKeyForResult(this.selectedTest, this.result);
        if (!key) return null;
        payload.r = key;
        return payload;
    }

    public sharedFortuneForm(form: any) {
        let payload: any = {
            name: form.name || '',
            birthDate: form.birthDate || '',
            birthTime: form.birthTime || '12:00',
            timeUnknown: !!form.timeUnknown,
            gender: form.gender || 'none',
            calendarType: form.calendarType || 'solar',
            birthPlace: form.birthPlace || 'none'
        };
        if (typeof form.targetYear !== 'undefined') {
            payload.targetYear = this.normalTargetYear(form.targetYear);
        }
        return payload;
    }

    public createResultShareUrl() {
        let payload = this.createResultSharePayload();
        if (!payload) return '';

        let url = new URL(window.location.href);
        url.pathname = '/dashboard';
        url.search = '';
        url.hash = '';
        url.searchParams.set(this.shareParamName, JSON.stringify(payload));
        return url.toString();
    }

    public replaceCurrentUrlWithShareLink() {
        let url = this.createResultShareUrl();
        if (!url || !window.history?.replaceState) return;
        window.history.replaceState({}, '', url);
    }

    public clearSharedResultUrl() {
        let url = new URL(window.location.href);
        if (!url.searchParams.has(this.shareParamName)) return;
        url.searchParams.delete(this.shareParamName);
        window.history?.replaceState({}, '', url.toString());
    }

    public currentResultIndex() {
        let sharedIndex = Number(this.result?.shareResultIndex);
        if (Number.isInteger(sharedIndex) && sharedIndex >= 0) return sharedIndex;
        return this.resultIndexForResult(this.selectedTest, this.result);
    }

    public resultIndexForResult(test: any, result: any) {
        let results = test?.results || [];
        if (!Array.isArray(results)) return -1;

        for (let i = 0; i < results.length; i++) {
            let item = results[i];
            if (item === result) return i;
            if (item?.title === result?.title && (!item?.subtitle || `${result?.subtitle || ''}`.indexOf(item.subtitle) >= 0)) {
                return i;
            }
        }

        return -1;
    }

    public resultKeyForResult(test: any, result: any) {
        let results = test?.results || {};
        if (!results || Array.isArray(results)) return '';

        for (let key of Object.keys(results)) {
            let item = results[key];
            if (item === result) return key;
            if (item?.title === result?.title && item?.subtitle === result?.subtitle) return key;
        }

        return '';
    }

    public axisCodeFromResult(result: any) {
        let fromTags = (result?.tags || []).find((tag: string) => this.normalizedAxisCode(tag));
        if (fromTags) return fromTags;

        let match = `${result?.title || ''}`.match(/[EI][SN][TF][JP]/);
        return match ? match[0] : '';
    }

    public enrichTests() {
        if (!this.tests.find((test: any) => test.id === 'daily-type')) {
            this.tests.splice(1, 0, this.createDailyTypeTest());
        }
        if (!this.tests.find((test: any) => test.id === 'past-life-face')) {
            this.tests.splice(2, 0, this.createPastLifePhotoTest());
        }
        if (!this.tests.find((test: any) => test.id === 'parents-day-gift')) {
            this.tests.splice(3, 0, this.createParentsDayGiftTest());
        }
        if (!this.tests.find((test: any) => test.id === 'pinball-random-draw')) {
            this.tests.splice(4, 0, this.createPinballDrawTest());
        }
        if (!this.tests.find((test: any) => test.id === 'zodiac-mood')) {
            this.tests.splice(5, 0, this.createAstrologyTest());
        }
        let fortuneTests = [
            this.createTarotTest(),
            this.createSajuTest(),
            this.createCompatibilityTest(),
            this.createDailyFortuneTest(),
            this.createManseTest(),
            this.createPrecisionManseTest()
        ].filter((candidate: any) => !this.tests.find((test: any) => test.id === candidate.id));
        if (fortuneTests.length) {
            this.tests.splice(6, 0, ...fortuneTests);
        }

        this.validateQuestionTests();
    }

    public createDailyTypeTest() {
        return {
            id: 'daily-type',
            title: '생활 MBTI 성향 테스트',
            subtitle: '내 일상 선택으로 보는 4축 성향',
            category: 'personality',
            section: 'must',
            badge: 'MBTI',
            plays: '402.1K',
            duration: '5분',
            creator: '패싯 타입 연구소',
            icon: 'BTI',
            coverLabel: 'TYPE',
            scoring: 'axes',
            cover: {
                background: 'linear-gradient(135deg, #d8c7e8 0%, #c4c4d8 46%, #d6b5c3 100%)',
                color: '#3e3638'
            },
            tags: ['MBTI', '성향', '자기이해'],
            description: '에너지, 정보 수집, 결정 방식, 생활 리듬을 12문항으로 가볍게 확인해요.',
            questions: [
                {
                    text: '갑자기 빈 저녁 시간이 생겼을 때 나는?',
                    options: [
                        { label: '누구 만날 사람 없나 연락한다', detail: '사람을 만나면 에너지가 살아나요', scores: { E: 2 } },
                        { label: '혼자 조용히 보내며 충전한다', detail: '내 리듬을 회복하는 시간이 필요해요', scores: { I: 2 } }
                    ]
                },
                {
                    text: '새로운 취미를 시작한다면 더 끌리는 쪽은?',
                    options: [
                        { label: '직접 해보며 감을 잡는다', detail: '실제로 만지고 경험해야 이해돼요', scores: { S: 2 } },
                        { label: '가능성과 의미부터 상상한다', detail: '이 취미가 열어줄 세계가 궁금해요', scores: { N: 2 } }
                    ]
                },
                {
                    text: '친구가 선택을 고민할 때 나는?',
                    options: [
                        { label: '장단점을 정리해준다', detail: '판단 기준을 분명히 잡아줘요', scores: { T: 2 } },
                        { label: '친구의 마음을 먼저 물어본다', detail: '후회하지 않을 감정이 중요해요', scores: { F: 2 } }
                    ]
                },
                {
                    text: '여행 전날 밤의 나는?',
                    options: [
                        { label: '동선과 준비물을 다시 확인한다', detail: '준비가 되어야 마음이 편해요', scores: { J: 2 } },
                        { label: '대략 챙기고 현지에서 맞춘다', detail: '여행은 변수까지 재미예요', scores: { P: 2 } }
                    ]
                },
                {
                    text: '처음 보는 모임에 들어가면 나는?',
                    options: [
                        { label: '가벼운 말부터 걸어본다', detail: '분위기를 빨리 파악하고 싶어요', scores: { E: 2 } },
                        { label: '잠깐 관찰하다 자연스럽게 낀다', detail: '사람들의 흐름을 먼저 봐요', scores: { I: 2 } }
                    ]
                },
                {
                    text: '설명서를 읽을 때 더 편한 방식은?',
                    options: [
                        { label: '구체적인 예시와 순서가 좋다', detail: '확실한 단계가 있으면 빨라요', scores: { S: 2 } },
                        { label: '전체 원리와 구조가 먼저다', detail: '큰 그림을 알아야 응용돼요', scores: { N: 2 } }
                    ]
                },
                {
                    text: '팀에서 의견이 갈릴 때 나는?',
                    options: [
                        { label: '가장 합리적인 기준을 세운다', detail: '결정에는 근거가 필요해요', scores: { T: 2 } },
                        { label: '각자 중요하게 여기는 것을 듣는다', detail: '관계와 납득이 오래 가요', scores: { F: 2 } }
                    ]
                },
                {
                    text: '마감이 있는 일을 맡으면?',
                    options: [
                        { label: '초반에 계획을 세우고 나눠 한다', detail: '미리 해두면 마음이 안정돼요', scores: { J: 2 } },
                        { label: '흐름을 보며 막판 집중력을 쓴다', detail: '압박이 있어야 속도가 붙어요', scores: { P: 2 } }
                    ]
                },
                {
                    text: '기분 전환이 필요할 때 나는?',
                    options: [
                        { label: '누군가와 이야기하며 풀어낸다', detail: '말하다 보면 생각이 정리돼요', scores: { E: 2 } },
                        { label: '혼자 있는 시간을 확보한다', detail: '조용해야 감정이 가라앉아요', scores: { I: 2 } }
                    ]
                },
                {
                    text: '새 프로젝트를 볼 때 먼저 보이는 것은?',
                    options: [
                        { label: '지금 당장 해야 할 현실적인 일', detail: '실행 조건을 먼저 확인해요', scores: { S: 2 } },
                        { label: '앞으로 확장될 가능성과 방향', detail: '이 일이 어디까지 갈지 상상해요', scores: { N: 2 } }
                    ]
                },
                {
                    text: '내가 더 듣기 좋은 칭찬은?',
                    options: [
                        { label: '판단이 정확하고 일 처리가 깔끔해', detail: '능력과 결과를 인정받고 싶어요', scores: { T: 2 } },
                        { label: '네가 있어서 분위기가 편해졌어', detail: '마음 씀씀이를 알아주면 좋아요', scores: { F: 2 } }
                    ]
                },
                {
                    text: '주말 약속을 잡는 방식은?',
                    options: [
                        { label: '며칠 전 시간과 장소를 정한다', detail: '예정된 즐거움이 더 편해요', scores: { J: 2 } },
                        { label: '당일 기분에 맞춰 정한다', detail: '그때의 컨디션이 제일 중요해요', scores: { P: 2 } }
                    ]
                }
            ]
        };
    }

    public createPastLifePhotoTest() {
        return {
            id: 'past-life-face',
            title: '전생 인물상 테스트',
            subtitle: '사진 한 장으로 보는 나의 전생 캐릭터',
            category: 'photo',
            section: 'must',
            badge: 'PHOTO',
            plays: '276.3K',
            duration: '1분',
            creator: '패싯 관상 기록실',
            icon: '相',
            coverLabel: 'PAST',
            scoring: 'photo',
            cover: {
                background: 'linear-gradient(135deg, #ead2bd 0%, #d9a89f 45%, #bfb1a7 100%)',
                color: '#3e3638'
            },
            tags: ['사진', '전생', '인물상'],
            description: '올린 사진의 분위기와 파일 리듬을 바탕으로 조선 어딘가의 전생 캐릭터를 뽑아봐요.',
            questions: [],
            results: [
                {
                    title: '조선의 밤길 기록관',
                    subtitle: '조용히 보고 오래 기억하던 사람',
                    summary: '당신의 전생은 붓과 등불을 들고 사람들의 이야기를 차곡차곡 남기던 기록관에 가까워요. 말수는 적어도 장면을 놓치지 않는 눈이 있었고, 중요한 순간에는 누구보다 정확했습니다.',
                    tags: ['관찰력', '기록', '침착함'],
                    guide: '지금도 생각을 적어두면 감정과 판단이 훨씬 선명해지는 편이에요.',
                    match: '잘 맞는 테스트: 비밀 서랍 테스트'
                },
                {
                    title: '달빛 아래 궁중 악사',
                    subtitle: '분위기를 한 박자 바꾸던 사람',
                    summary: '당신의 전생은 잔치와 의식 사이에서 사람들의 마음을 음악으로 움직이던 악사 같아요. 과하게 나서지 않아도 공기의 흐름을 읽고, 필요한 순간에 딱 맞는 온도를 만들 줄 알았습니다.',
                    tags: ['감각', '무드', '섬세함'],
                    guide: '좋아하는 음악이나 향처럼 작은 감각을 챙길수록 컨디션이 빨리 살아나요.',
                    match: '잘 맞는 테스트: 취향 컬러 팔레트'
                },
                {
                    title: '저잣거리 소문 해결사',
                    subtitle: '사람 사이의 실마리를 잘 찾던 사람',
                    summary: '당신의 전생은 복잡한 소문과 부탁이 모이는 시장 한복판에서 묘하게 답을 찾아내던 해결사예요. 낯선 사람과도 금방 말을 트고, 흩어진 단서를 연결하는 재치가 강했습니다.',
                    tags: ['순발력', '대화', '센스'],
                    guide: '머릿속으로만 고민하기보다 누군가와 말하면서 풀 때 답이 빨리 나와요.',
                    match: '잘 맞는 테스트: 연애 신호등 테스트'
                },
                {
                    title: '북촌의 약재상',
                    subtitle: '필요한 것을 조용히 건네던 사람',
                    summary: '당신의 전생은 사람들의 몸과 마음 상태를 살피고 꼭 맞는 약재를 골라주던 약재상입니다. 화려하진 않아도 꾸준히 곁을 지키는 힘이 있었고, 작은 변화에도 민감했어요.',
                    tags: ['돌봄', '균형', '안정감'],
                    guide: '타인을 챙기는 만큼 내 회복 루틴도 같은 무게로 챙겨주세요.',
                    match: '잘 맞는 테스트: 내 마음 날씨 테스트'
                },
                {
                    title: '바다를 건너던 역관',
                    subtitle: '낯선 세계를 빠르게 읽던 사람',
                    summary: '당신의 전생은 새로운 말과 문화를 오가며 길을 만들던 역관에 가까워요. 익숙한 곳에만 머물기보다 다른 관점을 배울 때 눈빛이 살아났고, 변화 앞에서 꽤 대담했습니다.',
                    tags: ['호기심', '언어', '모험'],
                    guide: '처음 가는 장소나 새로운 공부가 답답한 마음을 환기해줄 수 있어요.',
                    match: '잘 맞는 테스트: 주말 모험력 테스트'
                },
                {
                    title: '왕실 초상화가',
                    subtitle: '사람의 인상을 오래 들여다보던 사람',
                    summary: '당신의 전생은 한 사람의 표정과 자세에서 성격을 읽어내던 초상화가 같아요. 겉으로 보이는 것보다 미묘한 결을 더 중요하게 봤고, 아름다움 안의 이야기를 잡아내는 감각이 있었습니다.',
                    tags: ['미감', '집중', '해석'],
                    guide: '좋아하는 이미지를 모아두면 내가 원하는 방향이 자연스럽게 드러나요.',
                    match: '잘 맞는 테스트: 아이돌 무대 포지션 테스트'
                },
                {
                    title: '산중의 책사',
                    subtitle: '멀리 보고 조용히 판을 짜던 사람',
                    summary: '당신의 전생은 사람들보다 한 발 뒤에서 전체 흐름을 읽던 책사에 가까워요. 빨리 움직이기보다 구조를 파악한 뒤 정확한 수를 두는 타입이었고, 결정적인 한마디가 강했습니다.',
                    tags: ['전략', '분석', '차분함'],
                    guide: '생각이 복잡할수록 우선순위 세 개만 적어보면 길이 또렷해져요.',
                    match: '잘 맞는 테스트: 생활 MBTI 성향 테스트'
                },
                {
                    title: '비단길 상인',
                    subtitle: '취향과 사람을 함께 모으던 사람',
                    summary: '당신의 전생은 좋은 물건과 좋은 사람을 알아보고 연결하던 상인입니다. 손해와 이익만 보는 사람이 아니라 분위기, 취향, 타이밍까지 함께 읽는 감각이 있었어요.',
                    tags: ['취향', '연결', '감각'],
                    guide: '작은 선택에도 내 취향을 반영하면 일상이 훨씬 선명해지는 편이에요.',
                    match: '잘 맞는 테스트: 간식 운세 테스트'
                },
                {
                    title: '궁궐의 숨은 왕족',
                    subtitle: '품격을 지키며 자기 자리를 알아가던 사람',
                    summary: '당신의 전생은 궁궐의 화려함 안에서도 쉽게 들뜨지 않던 왕족에 가까워요. 타고난 품위와 책임감을 함께 지녔고, 사람들 앞에서는 차분하게 웃어도 속으로는 나만의 기준을 단단히 세우는 사람이었습니다.',
                    tags: ['품격', '자존감', '기준'],
                    guide: '지금도 주변의 기대에 휩쓸리기보다 내가 지키고 싶은 원칙을 먼저 정하면 중심이 잡혀요.',
                    match: '잘 맞는 테스트: 생활 MBTI 성향 테스트'
                },
                {
                    title: '붉은 곤룡포의 왕',
                    subtitle: '큰 결정을 홀로 감당하던 사람',
                    summary: '당신의 전생은 수많은 시선과 책임을 등에 지고 나라의 방향을 고민하던 왕에 가까워요. 말 한마디의 무게를 알았고, 흔들리는 순간에도 전체를 먼저 보는 넓은 시야와 결단력이 강했습니다.',
                    tags: ['리더십', '결단력', '책임감'],
                    guide: '중요한 선택 앞에서는 모두를 만족시키려 하기보다 가장 오래 지킬 수 있는 기준을 고르세요.',
                    match: '잘 맞는 테스트: 아이돌 무대 포지션 테스트',
                    photoWeight: 1
                },
                {
                    title: '한양의 고아한 선비',
                    subtitle: '말과 글로 자기 세계를 단정히 세우던 사람',
                    summary: '당신의 전생은 책과 붓을 가까이 두고 생각의 결을 가다듬던 선비에 가까워요. 겉으로는 조용하고 반듯했지만, 옳다고 믿는 일 앞에서는 쉽게 물러서지 않는 기개와 깊은 집중력이 있었습니다.',
                    tags: ['학문', '기개', '절제'],
                    guide: '지금도 생각을 글로 정리하면 마음속 기준과 진짜 바람이 훨씬 또렷해져요.',
                    match: '잘 맞는 테스트: 비밀 서랍 테스트'
                },
                {
                    title: '비단 저고리의 귀족',
                    subtitle: '우아한 안목으로 사람과 분위기를 읽던 사람',
                    summary: '당신의 전생은 말투와 걸음, 옷깃의 작은 결까지 신경 쓰던 귀족에 가까워요. 겉으로는 여유롭고 고상했지만, 사람 사이의 흐름을 빠르게 읽고 내 편과 내 취향을 정확히 알아보는 감각이 있었습니다.',
                    tags: ['우아함', '안목', '사회성'],
                    guide: '좋아하는 것과 싫어하는 것을 분명히 구분할수록 당신의 매력이 더 선명해져요.',
                    match: '잘 맞는 테스트: 취향 컬러 팔레트'
                },
                {
                    title: '비단 장막 속 왕비',
                    subtitle: '부드럽지만 단단하게 궁의 균형을 잡던 사람',
                    summary: '당신의 전생은 조용한 미소 뒤로 사람들의 마음과 궁궐의 균형을 살피던 왕비에 가까워요. 드러나는 권력보다 섬세한 영향력이 강했고, 필요한 순간에는 누구보다 단호하게 소중한 것을 지켜냈습니다.',
                    tags: ['품위', '통찰', '보호'],
                    guide: '부드럽게 배려하되 내 경계까지 흐리지 않으면 관계가 훨씬 건강해져요.',
                    match: '잘 맞는 테스트: 내 마음 날씨 테스트',
                    photoWeight: 1
                },
                {
                    title: '꽃가마 안의 공주',
                    subtitle: '사랑받는 자리에서도 자기 마음을 지키던 사람',
                    summary: '당신의 전생은 궁궐의 시선과 기대 속에서 자라난 공주에 가까워요. 곱고 화려한 것만 누린 사람이 아니라, 정해진 예법 안에서도 나만의 취향과 마음을 잃지 않으려 애쓰던 섬세한 사람이었습니다.',
                    tags: ['섬세함', '자기표현', '품위'],
                    guide: '다정한 기대에 맞추느라 내 취향을 미루고 있다면, 오늘은 작은 선택 하나만큼은 내 마음대로 골라보세요.',
                    match: '잘 맞는 테스트: 취향 컬러 팔레트',
                    photoWeight: 1
                },
                {
                    title: '궁궐의 당당한 대군',
                    subtitle: '큰 그릇과 자유로운 기개를 함께 지닌 사람',
                    summary: '당신의 전생은 왕실의 피를 이어받았지만 한 자리에만 머물지 않던 대군에 가까워요. 책임의 무게를 알면서도 답답한 틀을 그대로 따르기보다, 넓은 세상과 새로운 가능성을 향해 시선을 돌리는 기개가 있었습니다.',
                    tags: ['기개', '자유로움', '큰그림'],
                    guide: '주어진 역할이 답답하게 느껴질수록 내가 넓히고 싶은 방향을 한 문장으로 정리해보세요.',
                    match: '잘 맞는 테스트: 주말 모험력 테스트',
                    photoWeight: 1
                },
                {
                    title: '연지빛 궁궐 후궁',
                    subtitle: '조용한 긴장 속에서 마음의 패를 읽던 사람',
                    summary: '당신의 전생은 화려한 장막 뒤에서 사람들의 말과 표정을 세심하게 읽던 후궁에 가까워요. 드러내지 않아도 분위기의 온도를 빨리 알아차렸고, 불리한 상황에서도 나를 지키는 방법을 조용히 찾아내는 감각이 강했습니다.',
                    tags: ['눈치', '생존감각', '매력'],
                    guide: '상황을 너무 많이 읽느라 지칠 때는 내가 정말 원하는 것과 단순한 불안을 구분해보세요.',
                    match: '잘 맞는 테스트: 연애 신호등 테스트'
                },
                {
                    title: '장터 골목의 돌쇠',
                    subtitle: '몸으로 부딪치며 하루를 밀고 가던 사람',
                    summary: '당신의 전생은 말보다 행동이 먼저였던 돌쇠에 가까워요. 투박해 보여도 맡은 일은 끝까지 해내는 힘이 있었고, 복잡한 계산보다 사람을 향한 의리와 현실적인 감각으로 길을 찾는 사람이었습니다.',
                    tags: ['성실함', '의리', '생활력'],
                    guide: '생각이 너무 많아질수록 몸을 움직여 작은 일을 하나 끝내면 마음의 속도도 같이 정리돼요.',
                    match: '잘 맞는 테스트: 간식 운세 테스트'
                },
                {
                    title: '새벽을 버티던 노비',
                    subtitle: '고된 시간 속에서도 끝내 살아남던 사람',
                    summary: '당신의 전생은 이름보다 일이 먼저 불리던 노비에 가까워요. 쉽지 않은 환경에서도 하루를 견디는 끈기가 강했고, 작은 틈의 자유와 다정함을 소중히 여기며 자기 안의 온기를 잃지 않으려 했습니다.',
                    tags: ['끈기', '회복력', '생활감'],
                    guide: '지금도 나를 몰아붙이기보다 쉬어갈 권리를 인정할 때 버티는 힘이 더 오래 갑니다.',
                    match: '잘 맞는 테스트: 내 마음 날씨 테스트'
                },
                {
                    title: '먼지 길의 추노꾼',
                    subtitle: '흔적을 따라 끝까지 파고들던 사람',
                    summary: '당신의 전생은 사라진 발자국과 작은 단서까지 놓치지 않던 추노꾼에 가까워요. 한번 목표가 생기면 쉽게 흐트러지지 않았고, 낯선 길에서도 상황을 읽어내는 감각과 집요한 집중력이 강했습니다.',
                    tags: ['추적', '집중력', '승부근성'],
                    guide: '목표를 좇을 때는 속도만 올리기보다 왜 그 방향으로 가는지 중간중간 확인해보세요.',
                    match: '잘 맞는 테스트: 아이돌 무대 포지션 테스트'
                },
                {
                    title: '밤을 밝히던 전기수',
                    subtitle: '이야기로 사람들의 마음을 움직이던 사람',
                    summary: '당신의 전생은 등불 아래에서 소설을 읽어주며 사람들을 울리고 웃기던 전기수에 가까워요. 목소리와 호흡만으로 장면을 살려냈고, 사람들이 어떤 대목에서 마음을 여는지 아는 뛰어난 이야기 감각이 있었습니다.',
                    tags: ['이야기', '표현력', '공감'],
                    guide: '머릿속에만 담아둔 감정은 말이나 글로 꺼낼 때 가장 선명한 힘이 됩니다.',
                    match: '잘 맞는 테스트: 비밀 서랍 테스트'
                },
                {
                    title: '전장을 가르던 장군',
                    subtitle: '위기 앞에서 방향을 잃지 않던 사람',
                    summary: '당신의 전생은 먼지와 함성 속에서도 사람들을 이끌던 장군에 가까워요. 두려움이 없어서가 아니라 두려운 순간에도 먼저 판단하고 움직였고, 흩어진 마음을 하나의 방향으로 모으는 힘이 강했습니다.',
                    tags: ['용기', '통솔력', '판단력'],
                    guide: '중요한 순간에는 모든 가능성을 다 붙잡기보다 지금 지켜야 할 하나를 먼저 정해보세요.',
                    match: '잘 맞는 테스트: 아이돌 무대 포지션 테스트'
                },
                {
                    title: '조정의 깊은 재상',
                    subtitle: '말 한마디로 큰 판을 조율하던 사람',
                    summary: '당신의 전생은 임금과 신하들 사이에서 나라의 흐름을 조율하던 재상에 가까워요. 겉으로는 조용히 듣는 시간이 길었지만, 결정적인 순간에는 복잡한 이해관계를 꿰뚫고 현실적인 답을 내는 지혜가 있었습니다.',
                    tags: ['지혜', '조율', '책임감'],
                    guide: '복잡한 문제일수록 감정과 사실을 나누어 적어보면 가장 현실적인 선택지가 보입니다.',
                    match: '잘 맞는 테스트: 생활 MBTI 성향 테스트'
                },
                {
                    title: '불꽃 옆의 대장장이',
                    subtitle: '뜨거운 손끝으로 쓸모를 만들어내던 사람',
                    summary: '당신의 전생은 쇠를 달구고 두드려 필요한 도구를 만들던 대장장이에 가까워요. 말보다 결과로 보여주는 타입이었고, 같은 동작을 반복하면서도 더 단단하고 정확한 형태를 찾아내는 집중력이 강했습니다.',
                    tags: ['장인정신', '끈기', '실용감각'],
                    guide: '완벽한 계획보다 손을 움직여 첫 형태를 만들어볼 때 생각이 훨씬 빨리 정리돼요.',
                    match: '잘 맞는 테스트: 간식 운세 테스트'
                },
                {
                    title: '산사에 머물던 스님',
                    subtitle: '고요 속에서 마음의 소리를 듣던 사람',
                    summary: '당신의 전생은 산사에서 계절의 흐름을 바라보며 마음을 닦던 스님에 가까워요. 바깥의 소란보다 내면의 움직임을 섬세하게 살폈고, 욕심을 덜어낼수록 더 분명해지는 평온을 아는 사람이었습니다.',
                    tags: ['평온', '성찰', '절제'],
                    guide: '답이 급하게 필요할수록 잠깐 멈춰 숨을 고르면 진짜 중요한 마음이 올라옵니다.',
                    match: '잘 맞는 테스트: 내 마음 날씨 테스트'
                },
                {
                    title: '달빛 아래 무당',
                    subtitle: '보이지 않는 기척과 마음의 결을 읽던 사람',
                    summary: '당신의 전생은 사람들의 불안과 바람을 듣고 보이지 않는 흐름을 풀어내던 무당에 가까워요. 직감이 예민했고, 말로 설명하기 어려운 분위기까지 빠르게 감지하며 막힌 마음에 출구를 열어주는 힘이 있었습니다.',
                    tags: ['직감', '치유', '감응'],
                    guide: '느낌이 강하게 오는 날에는 그냥 넘기지 말고 기록해두세요. 반복되는 감각 안에 단서가 있어요.',
                    match: '잘 맞는 테스트: 오늘의 타로'
                }
            ]
        };
    }

    public createParentsDayGiftTest() {
        return {
            id: 'parents-day-gift',
            title: '어버이날 선물뽑기',
            subtitle: '버튼 한 번으로 정하는 오늘의 효도템',
            category: 'mini',
            section: 'new',
            badge: 'EVENT',
            plays: '118.9K',
            duration: '10초',
            creator: '패싯 효도위원회',
            icon: '禮',
            coverLabel: 'GIFT',
            scoring: 'gift',
            cover: {
                background: 'linear-gradient(135deg, #ecd0c7 0%, #c99aaa 45%, #bca9a2 100%)',
                color: '#3e3638'
            },
            tags: ['어버이날', '선물', '랜덤뽑기'],
            description: '문항 없이 선물뽑기 버튼만 누르면 부모님께 드릴 오늘의 선물이 랜덤으로 나와요.',
            questions: [],
            results: [
                {
                    title: '용돈 10만원',
                    subtitle: '오늘의 효도 상한가를 찍었습니다',
                    summary: '이건 봉투가 아니라 작은 시상식입니다. 부모님 표정이 흔들릴 수 있으니 건넬 때는 덤덤한 척하지만, 속으로는 충분히 뿌듯해도 됩니다.',
                    tags: ['대박', '현금', '효도상한가'],
                    guide: '새 지폐나 깔끔한 봉투에 넣고 “맛있는 거 드세요” 한마디를 얹으면 완성도 최고예요.',
                    match: '추가 미션: 손편지와 같이 드리기',
                    accent: '#b76e79',
                    effect: 'jackpot'
                },
                {
                    title: '용돈 5만원',
                    subtitle: '지갑이 바로 효도 모드로 전환됩니다',
                    summary: '오늘은 깔끔하게 봉투 한 장으로 승부하는 날이에요. 금액보다 중요한 건 건네는 표정인데, 그래도 5만원은 표정 관리가 꽤 쉬워집니다.',
                    tags: ['현금', '확실함', '든든함'],
                    guide: '짧은 손편지 한 줄을 같이 넣으면 체감 금액이 올라가요.',
                    match: '추가 미션: 봉투에 이름 직접 쓰기',
                    accent: '#c98291',
                    effect: 'gold'
                },
                {
                    title: '용돈 만원',
                    subtitle: '부담은 낮추고 마음은 선명하게',
                    summary: '만원 한 장도 그냥 드리면 용돈이고, 말 한마디를 얹으면 이벤트가 됩니다. 오늘의 포인트는 “작지만 제가 직접 뽑았습니다”예요.',
                    tags: ['소소함', '현금', '귀여운효도'],
                    guide: '좋아하시는 간식 하나와 같이 드리면 밸런스가 좋아요.',
                    match: '추가 미션: 편의점 간식 심부름',
                    accent: '#7f9fb0',
                    effect: 'blue'
                },
                {
                    title: '용돈 5천원',
                    subtitle: '효도 예산 긴축 운영안',
                    summary: '예산은 작지만 당당함은 크게 가는 결과예요. 대신 오늘은 애교와 심부름으로 나머지 금액을 채워야 합니다.',
                    tags: ['긴축', '재치', '심부름'],
                    guide: '“커피값 보태세요”라고 말하면 자연스럽게 살아납니다.',
                    match: '추가 미션: 커피 사다드리기',
                    accent: '#d7b56d',
                    effect: 'yellow'
                },
                {
                    title: '용돈 천원',
                    subtitle: '상징성으로 밀어붙이는 효도',
                    summary: '이건 금액보다 이벤트성에 기대야 하는 선물이에요. 천원만 드리면 위험하지만, 쿠폰과 함께라면 갑자기 귀여운 이벤트가 됩니다.',
                    tags: ['상징성', '이벤트', '쿠폰필수'],
                    guide: '천원 옆에 안마 10분권을 붙이면 분위기가 살아나요.',
                    match: '추가 미션: 어깨 안마 10분',
                    accent: '#d49a72',
                    effect: 'yellow'
                },
                {
                    title: '꽝',
                    subtitle: '하지만 빈손으로 끝내면 집안 공기가 달라집니다',
                    summary: '뽑기는 꽝이지만 현실은 아직 수정 가능해요. 지금 바로 “오늘 설거지는 제가 할게요”를 외치면 꽝이 이벤트로 바뀝니다.',
                    tags: ['위기', '반전', '행동필요'],
                    guide: '꽝 결과를 보여드리고 3초 안에 심부름을 제안하세요.',
                    match: '추가 미션: 설거지와 분리수거',
                    accent: '#8d95a3',
                    effect: 'gray'
                },
                {
                    title: '가족여행권',
                    subtitle: '일정 조율이라는 진짜 보스가 등장했습니다',
                    summary: '큰 선물이 나왔어요. 실제 여행이 아니어도 근교 드라이브, 당일치기, 맛집 코스처럼 실행 가능한 버전으로 줄이면 성공률이 올라갑니다.',
                    tags: ['여행', '추억', '일정조율'],
                    guide: '날짜 후보 3개를 먼저 제시하면 말만 꺼낸 사람이 되지 않아요.',
                    match: '추가 미션: 여행 후보지 3곳 찾기',
                    accent: '#b8aaa1',
                    effect: 'green'
                },
                {
                    title: '점심 식사권',
                    subtitle: '맛있는 한 끼로 분위기를 회복하는 카드',
                    summary: '부모님 취향을 가장 안정적으로 맞출 수 있는 결과예요. 메뉴 선정권까지 드리면 실패 확률이 크게 내려갑니다.',
                    tags: ['외식', '대화', '안정픽'],
                    guide: '예약 가능한 곳으로 고르면 당일 우왕좌왕을 줄일 수 있어요.',
                    match: '추가 미션: 메뉴판 링크 보내기',
                    accent: '#c98f7a',
                    effect: 'red'
                },
                {
                    title: '마사지 예약권',
                    subtitle: '피로 회복 쪽으로 정확히 꽂힌 선물',
                    summary: '오늘의 뽑기는 실용성이 강합니다. 부모님이 시간을 내기 어려워하신다면 예약부터 결제까지 대신 처리하는 게 핵심이에요.',
                    tags: ['휴식', '실용', '회복'],
                    guide: '위치와 시간을 먼저 확인하고 예약권처럼 예쁘게 말해보세요.',
                    match: '추가 미션: 예약 가능한 시간 물어보기',
                    accent: '#a995bf',
                    effect: 'purple'
                },
                {
                    title: '드라이빙 데이트권',
                    subtitle: '차 안 대화가 오늘의 선물입니다',
                    summary: '멀리 가지 않아도 좋아요. 좋아하는 음악, 창밖 풍경, 편한 대화가 있으면 짧은 드라이브도 꽤 오래 기억됩니다.',
                    tags: ['드라이브', '대화', '분위기'],
                    guide: '목적지는 카페나 산책로처럼 가볍게 잡는 편이 좋아요.',
                    match: '추가 미션: 플레이리스트 준비하기',
                    accent: '#879dbc',
                    effect: 'blue'
                },
                {
                    title: '꽃다발 예약권',
                    subtitle: '사진 한 장 남기기 좋은 선물',
                    summary: '조금 클래식하지만 여전히 강한 카드예요. 꽃만 건네기보다 “오늘 생각나서 준비했어요”라는 문장이 같이 가야 완성됩니다.',
                    tags: ['꽃', '기념일', '사진'],
                    guide: '너무 큰 꽃다발보다 들고 다니기 편한 크기가 실전형이에요.',
                    match: '추가 미션: 사진 찍어드리기',
                    accent: '#c986a0',
                    effect: 'pink'
                },
                {
                    title: '하루 자유이용권',
                    subtitle: '부모님은 쉬고 내가 움직이는 날',
                    summary: '오늘 하루 집안일, 장보기, 심부름 중 하나를 책임지는 결과예요. 말보다 바로 움직이는 쪽이 훨씬 강합니다.',
                    tags: ['심부름', '집안일', '실행력'],
                    guide: '할 일을 직접 골라달라고 하면 선물의 체감이 올라가요.',
                    match: '추가 미션: 장보기 리스트 받기',
                    accent: '#b2a69f',
                    effect: 'green'
                }
            ]
        };
    }

    public createPinballDrawTest() {
        return {
            id: 'pinball-random-draw',
            title: '핀볼 랜덤 숫자 뽑기',
            subtitle: '공이 먼저 들어오는 순서로 정하는 사다리 룰렛',
            category: 'mini',
            section: 'new',
            badge: 'PINBALL',
            plays: '64.2K',
            duration: '30초',
            creator: '패싯 미니게임랩',
            icon: '●',
            coverLabel: 'DRAW',
            scoring: 'pinball',
            cover: {
                background: 'linear-gradient(135deg, #e7d2c0 0%, #c98f9f 46%, #7f9fb0 100%)',
                color: '#3e3638'
            },
            tags: ['핀볼', '숫자뽑기', '룰렛', '사다리'],
            description: '이름이나 숫자를 넣고 셔플한 뒤 핀볼 보드에서 가장 먼저 또는 지정한 순서로 골인한 공을 뽑아요.',
            questions: [],
            results: []
        };
    }

    public createAstrologyTest() {
        return {
            id: 'zodiac-mood',
            title: '점성술 무드 테스트',
            subtitle: '내 안의 별자리 원소는 무엇일까?',
            category: 'astrology',
            section: 'new',
            badge: 'ZODIAC',
            plays: '143.6K',
            duration: '4분',
            creator: '패싯 별자리 연구소',
            icon: '☾',
            coverLabel: 'STARS',
            cover: {
                background: 'linear-gradient(135deg, #d8c7ea 0%, #a9b6d8 47%, #d8b49c 100%)',
                color: '#2d2638'
            },
            tags: ['점성술', '별자리', '성향', '원소'],
            description: '일상 선택 속에서 불, 흙, 바람, 물 중 지금 나와 가장 가까운 별자리 원소를 찾아요.',
            questions: [
                {
                    text: '새로운 일이 시작될 때 가장 먼저 올라오는 마음은?',
                    options: [
                        { label: '바로 뛰어들고 싶다', detail: '시작의 열기가 나를 움직여요', result: 'fire', score: 2 },
                        { label: '필요한 조건부터 확인한다', detail: '기반이 단단해야 편해요', result: 'earth', score: 2 },
                        { label: '가능한 선택지를 떠올린다', detail: '생각이 먼저 여러 갈래로 퍼져요', result: 'air', score: 2 },
                        { label: '그 일이 내 마음에 맞는지 본다', detail: '감정의 물결이 중요해요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '친구들이 나에게 자주 기대하는 역할은?',
                    options: [
                        { label: '분위기를 확 끌어올리는 사람', detail: '에너지를 켜는 쪽이에요', result: 'fire', score: 2 },
                        { label: '현실적인 답을 챙기는 사람', detail: '가능한 방법을 찾아줘요', result: 'earth', score: 2 },
                        { label: '대화를 가볍게 풀어주는 사람', detail: '생각과 말의 흐름을 연결해요', result: 'air', score: 2 },
                        { label: '마음을 깊게 들어주는 사람', detail: '말 너머의 감정을 살펴요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '휴식이 필요할 때 가장 끌리는 장면은?',
                    options: [
                        { label: '햇빛 아래 활기찬 산책', detail: '움직여야 다시 살아나요', result: 'fire', score: 2 },
                        { label: '잘 정돈된 방과 따뜻한 식사', detail: '안정된 감각이 회복이에요', result: 'earth', score: 2 },
                        { label: '가벼운 수다와 새로운 콘텐츠', detail: '새 자극이 숨통을 틔워요', result: 'air', score: 2 },
                        { label: '조용한 음악과 긴 목욕', detail: '감정을 천천히 풀어내요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '결정해야 하는 순간, 내가 믿는 것은?',
                    options: [
                        { label: '지금 당기는 방향', detail: '강한 끌림을 놓치지 않아요', result: 'fire', score: 2 },
                        { label: '쌓아온 경험과 근거', detail: '검증된 길이 마음을 놓이게 해요', result: 'earth', score: 2 },
                        { label: '정보와 사람들의 관점', detail: '여러 시야를 비교해요', result: 'air', score: 2 },
                        { label: '직감과 마음의 온도', detail: '내면의 신호를 믿는 편이에요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '좋아하는 사람 앞에서 나는?',
                    options: [
                        { label: '마음이 표정과 행동에 바로 드러난다', detail: '숨기기보다 보여주는 편이에요', result: 'fire', score: 2 },
                        { label: '꾸준히 챙기며 신뢰를 쌓는다', detail: '오래 가는 안정감을 줘요', result: 'earth', score: 2 },
                        { label: '장난과 대화로 거리를 좁힌다', detail: '말이 통하면 마음도 열려요', result: 'air', score: 2 },
                        { label: '혼자 오래 느끼고 천천히 표현한다', detail: '마음이 깊어질 시간이 필요해요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '계획이 틀어졌을 때 나의 반응은?',
                    options: [
                        { label: '새 판을 빠르게 연다', detail: '변수도 추진력으로 바꿔요', result: 'fire', score: 2 },
                        { label: '손실을 줄이는 쪽으로 다시 짠다', detail: '현실적인 복구가 먼저예요', result: 'earth', score: 2 },
                        { label: '다른 방법을 여러 개 찾는다', detail: '길은 하나가 아니라고 봐요', result: 'air', score: 2 },
                        { label: '잠깐 멈춰 마음을 정리한다', detail: '내 리듬을 회복해야 움직여요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '내 공간에 꼭 필요한 분위기는?',
                    options: [
                        { label: '활기와 포인트가 있는 공간', detail: '보는 순간 힘이 나야 해요', result: 'fire', score: 2 },
                        { label: '튼튼하고 편안한 공간', detail: '오래 머물수록 좋아야 해요', result: 'earth', score: 2 },
                        { label: '가볍게 바꿀 수 있는 공간', detail: '기분 따라 재배치하고 싶어요', result: 'air', score: 2 },
                        { label: '감성적인 온도가 있는 공간', detail: '빛과 소리의 결이 중요해요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '칭찬을 들을 때 가장 기분 좋은 말은?',
                    options: [
                        { label: '너랑 있으면 에너지가 생겨', detail: '나의 불꽃을 알아봐줘서 좋아요', result: 'fire', score: 2 },
                        { label: '너는 믿고 맡길 수 있어', detail: '나의 안정감을 인정받고 싶어요', result: 'earth', score: 2 },
                        { label: '너는 말이 잘 통하고 재밌어', detail: '나의 감각과 아이디어가 보여요', result: 'air', score: 2 },
                        { label: '너는 마음을 잘 알아줘', detail: '나의 깊이를 알아주는 말이에요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '요즘 나에게 가장 필요한 별의 메시지는?',
                    options: [
                        { label: '망설이지 말고 시작해도 돼', detail: '첫 불씨를 살리고 싶어요', result: 'fire', score: 2 },
                        { label: '천천히 쌓으면 충분해', detail: '흔들리지 않는 기반이 필요해요', result: 'earth', score: 2 },
                        { label: '다른 관점에서 보면 풀려', detail: '생각의 창문을 열고 싶어요', result: 'air', score: 2 },
                        { label: '느끼는 것을 믿어도 돼', detail: '마음의 파도를 받아들이고 싶어요', result: 'water', score: 2 }
                    ]
                },
                {
                    text: '하루가 끝날 때 가장 만족스러운 순간은?',
                    options: [
                        { label: '하고 싶은 걸 용기 내서 해낸 순간', detail: '오늘의 불꽃이 남아요', result: 'fire', score: 2 },
                        { label: '해야 할 일을 차분히 끝낸 순간', detail: '쌓아둔 결과가 편안해요', result: 'earth', score: 2 },
                        { label: '좋은 대화와 아이디어가 남은 순간', detail: '생각이 살아 움직여요', result: 'air', score: 2 },
                        { label: '내 마음을 잘 돌본 순간', detail: '감정이 정돈되면 충분해요', result: 'water', score: 2 }
                    ]
                }
            ],
            results: {
                fire: {
                    title: '불의 별자리 무드',
                    subtitle: '양자리·사자자리·사수자리처럼 먼저 빛나는 사람',
                    summary: '당신은 마음이 움직이면 빠르게 행동으로 옮기는 타입이에요. 뜨거운 추진력과 솔직한 표현이 주변의 공기를 바꿉니다.',
                    tags: ['열정', '용기', '직진'],
                    guide: '불꽃이 오래 가려면 중간중간 숨을 고르는 시간이 필요해요.',
                    match: '잘 맞는 테스트: 오늘의 타로'
                },
                earth: {
                    title: '흙의 별자리 무드',
                    subtitle: '황소자리·처녀자리·염소자리처럼 단단히 쌓는 사람',
                    summary: '당신은 감각과 현실 조건을 꼼꼼히 살피며 신뢰를 만드는 타입이에요. 꾸준함이 쌓일수록 존재감이 더 선명해집니다.',
                    tags: ['안정', '현실감', '꾸준함'],
                    guide: '완벽히 준비된 순간만 기다리기보다 작은 시작을 허락해보세요.',
                    match: '잘 맞는 테스트: 간편 사주 풀이'
                },
                air: {
                    title: '바람의 별자리 무드',
                    subtitle: '쌍둥이자리·천칭자리·물병자리처럼 흐름을 잇는 사람',
                    summary: '당신은 생각과 대화 사이에서 길을 찾는 타입이에요. 가벼운 호기심과 넓은 관점이 막힌 분위기를 풀어줍니다.',
                    tags: ['대화', '아이디어', '유연함'],
                    guide: '가능성이 많을수록 오늘 고를 한 가지 기준을 세우면 더 편해져요.',
                    match: '잘 맞는 테스트: 생활 MBTI 성향 테스트'
                },
                water: {
                    title: '물의 별자리 무드',
                    subtitle: '게자리·전갈자리·물고기자리처럼 깊게 느끼는 사람',
                    summary: '당신은 말보다 분위기와 감정의 흐름을 먼저 읽는 타입이에요. 섬세한 직감과 공감력이 관계를 깊게 만듭니다.',
                    tags: ['직감', '공감', '감수성'],
                    guide: '모든 감정을 혼자 품기보다 믿는 사람에게 조금씩 흘려보내도 좋아요.',
                    match: '잘 맞는 테스트: 비밀 서랍 테스트'
                }
            }
        };
    }

    public createTarotTest() {
        return {
            id: 'daily-tarot',
            title: '오늘의 타로',
            subtitle: '카드 한 장으로 보는 지금의 흐름',
            category: 'fortune',
            section: 'must',
            badge: 'TAROT',
            plays: '221.7K',
            duration: '30초',
            creator: '패싯 카드룸',
            icon: '☾',
            coverLabel: 'TAROT',
            scoring: 'tarot',
            cover: {
                background: 'linear-gradient(135deg, #d8bcc8 0%, #aa91ad 50%, #d9b39b 100%)',
                color: '#3e3638'
            },
            tags: ['타로', '오늘', '카드'],
            description: '질문을 하나 떠올리고 펼쳐진 카드 중 마음이 가는 한 장을 골라 오늘의 힌트를 받아요.',
            questions: [],
            results: this.createTarotDeck()
        };
    }

    public createSajuTest() {
        return {
            id: 'saju-basic',
            title: '간편 사주 풀이',
            subtitle: '생년월일시로 보는 나의 기본 기운',
            category: 'fortune',
            section: 'must',
            badge: 'SAJU',
            plays: '356.4K',
            duration: '1분',
            creator: '패싯 명리노트',
            icon: '命',
            coverLabel: 'SAJU',
            scoring: 'saju',
            cover: {
                background: 'linear-gradient(135deg, #d8b8ad 0%, #c6b8a5 48%, #d7bd8d 100%)',
                color: '#3e3638'
            },
            tags: ['사주', '성향', '오행'],
            description: '이름과 생년월일시를 입력하면 사주의 큰 분위기와 오행 밸런스를 정리해요.',
            questions: [],
            results: []
        };
    }

    public createCompatibilityTest() {
        return {
            id: 'saju-compatibility',
            title: '우리 궁합 보기',
            subtitle: '두 사람의 생일 리듬으로 보는 관계 점수',
            category: 'fortune',
            section: 'must',
            badge: 'MATCH',
            plays: '289.2K',
            duration: '1분',
            creator: '패싯 궁합실',
            icon: '合',
            coverLabel: 'MATCH',
            scoring: 'compatibility',
            cover: {
                background: 'linear-gradient(135deg, #d6a1aa 0%, #e2b795 48%, #b9b4c3 100%)',
                color: '#3e3638'
            },
            tags: ['궁합', '연애', '관계'],
            description: '나와 상대의 생년월일시를 넣고 관계의 온도, 대화 리듬, 보완 포인트를 확인해요.',
            questions: [],
            results: []
        };
    }

    public createDailyFortuneTest() {
        return {
            id: 'daily-fortune',
            title: '일일운세',
            subtitle: '오늘 하루의 총운과 행운 포인트',
            category: 'fortune',
            section: 'new',
            badge: 'TODAY',
            plays: '512.8K',
            duration: '20초',
            creator: '패싯 오늘운',
            icon: '日',
            coverLabel: 'TODAY',
            scoring: 'daily',
            cover: {
                background: 'linear-gradient(135deg, #d8c5b1 0%, #cfc0aa 48%, #d8b18e 100%)',
                color: '#3e3638'
            },
            tags: ['일일운세', '행운', '오늘'],
            description: '생일과 오늘 날짜의 리듬을 섞어 총운, 애정운, 재물운, 일운을 가볍게 뽑아요.',
            questions: [],
            results: []
        };
    }

    public createManseTest() {
        return {
            id: 'manse-calendar',
            title: '간편 만세력',
            subtitle: '원국·십신·신살·대운 리포트',
            category: 'fortune',
            section: 'self',
            badge: 'PILLAR',
            plays: '174.5K',
            duration: '1분',
            creator: '패싯 만세력',
            icon: '曆',
            coverLabel: 'MANSE',
            scoring: 'manse',
            cover: {
                background: 'linear-gradient(135deg, #c58a92 0%, #d8b1a8 46%, #bfb4a3 100%)',
                color: '#3e3638'
            },
            tags: ['만세력', '사주팔자', '십신', '신살'],
            description: '생년월일시를 입력해 시주·일주·월주·년주, 지장간, 십신, 귀인, 신살, 대운과 세운 흐름을 확인해요.',
            questions: [],
            results: []
        };
    }

    public createPrecisionManseTest() {
        return {
            id: 'manse-precision',
            title: '정밀 만세력',
            subtitle: '절입·시차 보정·대운 시작까지 보는 명식',
            category: 'fortune',
            section: 'new',
            badge: 'PRECISION',
            plays: '98.6K',
            duration: '2분',
            creator: '패싯 정밀만세력',
            icon: '精',
            coverLabel: 'PRECISION',
            scoring: 'manse',
            precision: true,
            cover: {
                background: 'linear-gradient(135deg, #9f6f7b 0%, #c09a86 48%, #879987 100%)',
                color: '#fffaf7'
            },
            tags: ['정밀 만세력', '절기', '대운', '세운'],
            description: '출생지·서머타임 보정, 절입 경계, 24절기표, 월운·세운 흐름과 정확도 체크 기준까지 한 번에 확인해요.',
            questions: [],
            results: []
        };
    }

    public createTarotDeck() {
        let major = [
            {
                image: 'major-00-fool.jpg',
                title: 'The Fool · 바보',
                subtitle: '새로운 길이 열리는 카드',
                summary: '오늘은 완벽한 계획보다 첫 발을 떼는 용기가 더 크게 작동합니다. 낯설어도 가볍게 시도하면 예상 밖의 가능성이 따라와요.',
                tags: ['시작', '자유', '가능성'],
                guide: '망설이던 일은 아주 작은 버전으로 먼저 시작해보세요.',
                match: '행운 포인트: 흰색, 새로운 길',
                accent: '#9bb8cf'
            },
            {
                image: 'major-01-magician.jpg',
                title: 'The Magician · 마법사',
                subtitle: '있는 도구를 제대로 쓰는 카드',
                summary: '오늘은 새로 구하기보다 이미 가진 자원을 조합하는 날이에요. 말, 자료, 사람, 타이밍 중 하나만 잘 연결해도 판이 바뀝니다.',
                tags: ['실행', '아이디어', '연결'],
                guide: '복잡한 일은 20분만 타이머를 켜고 시작해보세요.',
                match: '행운 포인트: 흰색, 짧은 메시지',
                accent: '#a995bf'
            },
            {
                image: 'major-02-high-priestess.jpg',
                title: 'The High Priestess · 여사제',
                subtitle: '조용한 직감이 선명해지는 카드',
                summary: '겉으로 드러난 정보보다 마음 안쪽에서 반복되는 신호를 봐야 하는 날입니다. 답을 서두르지 않으면 더 정확한 단서가 떠올라요.',
                tags: ['직감', '침묵', '통찰'],
                guide: '오늘의 중요한 판단은 잠깐 시간을 두고 다시 확인하세요.',
                match: '행운 포인트: 보라색, 조용한 자리',
                accent: '#8572b8'
            },
            {
                image: 'major-03-empress.jpg',
                title: 'The Empress · 여황제',
                subtitle: '풍요와 돌봄이 살아나는 카드',
                summary: '오늘은 결과를 억지로 밀어내기보다 충분히 먹이고 돌보는 쪽이 좋습니다. 관계든 일상이든 여유를 주면 자연스럽게 자라나요.',
                tags: ['풍요', '돌봄', '감각'],
                guide: '좋은 음식이나 향처럼 몸이 먼저 편해지는 것을 챙겨보세요.',
                match: '행운 포인트: 초록색, 식물',
                accent: '#72aa8d'
            },
            {
                image: 'major-04-emperor.jpg',
                title: 'The Emperor · 황제',
                subtitle: '질서와 기준을 세우는 카드',
                summary: '흩어진 일을 한 줄로 세우면 힘이 생기는 날이에요. 감정보다 기준을 먼저 정하면 결정이 훨씬 가벼워집니다.',
                tags: ['기준', '책임', '정리'],
                guide: '오늘 해야 할 일의 우선순위를 세 개만 남겨보세요.',
                match: '행운 포인트: 진한 남색, 체크리스트',
                accent: '#66789d'
            },
            {
                image: 'major-05-hierophant.jpg',
                title: 'The Hierophant · 교황',
                subtitle: '배움과 조언이 길을 여는 카드',
                summary: '혼자 답을 만들기보다 검증된 방법과 믿을 만한 조언을 참고하면 좋은 날입니다. 기본기를 지키는 쪽이 멀리 갑니다.',
                tags: ['조언', '배움', '기본'],
                guide: '이미 잘하는 사람의 방식을 하나만 따라 해보세요.',
                match: '행운 포인트: 책, 차분한 대화',
                accent: '#9f927b'
            },
            {
                image: 'major-06-lovers.jpg',
                title: 'The Lovers · 연인',
                subtitle: '마음의 선택이 선명해지는 카드',
                summary: '오늘은 관계와 취향에서 중요한 선택이 보일 수 있어요. 남들이 좋아할 답보다 내가 계속 마음 쓰는 쪽을 보는 게 좋습니다.',
                tags: ['선택', '관계', '취향'],
                guide: '망설이는 답장은 너무 오래 묵히지 않는 편이 좋아요.',
                match: '행운 포인트: 분홍색, 디저트',
                accent: '#c986a0'
            },
            {
                image: 'major-07-chariot.jpg',
                title: 'The Chariot · 전차',
                subtitle: '방향을 잡고 움직이는 카드',
                summary: '오늘은 멈춰 생각하기보다 움직이며 길을 만드는 쪽에 힘이 있습니다. 목표가 선명하면 주변의 잡음도 덜 흔들려요.',
                tags: ['전진', '집중', '승부'],
                guide: '오늘의 첫 번째 이동 동선을 미리 정해두세요.',
                match: '행운 포인트: 이동, 검은색',
                accent: '#5f76a8'
            },
            {
                image: 'major-08-strength.jpg',
                title: 'Strength · 힘',
                subtitle: '부드럽게 버티는 카드',
                summary: '오늘의 힘은 세게 밀어붙이는 데서 나오지 않아요. 감정을 조절하고 오래 갈 수 있는 속도를 고르는 쪽이 더 강합니다.',
                tags: ['인내', '조율', '회복력'],
                guide: '불편한 대화는 목소리를 낮추는 순간 절반은 풀려요.',
                match: '행운 포인트: 따뜻한 차, 편한 신발',
                accent: '#bd7c82'
            },
            {
                image: 'major-09-hermit.jpg',
                title: 'The Hermit · 은둔자',
                subtitle: '혼자만의 답을 찾는 카드',
                summary: '잠깐 떨어져서 보면 보이지 않던 방향이 드러납니다. 오늘은 많은 말보다 조용한 정리가 더 큰 힌트가 돼요.',
                tags: ['성찰', '거리두기', '지혜'],
                guide: '혼자 걷는 시간을 10분만 만들어보세요.',
                match: '행운 포인트: 작은 조명, 메모',
                accent: '#6f7f86'
            },
            {
                image: 'major-10-wheel-of-fortune.jpg',
                title: 'Wheel of Fortune · 운명의 수레바퀴',
                subtitle: '흐름이 갑자기 바뀌는 카드',
                summary: '오늘은 예상 밖의 제안이나 변수가 들어올 수 있어요. 계획이 살짝 흔들려도 그 안에서 더 나은 길이 열릴 가능성이 큽니다.',
                tags: ['변화', '기회', '타이밍'],
                guide: '갑작스러운 변경을 바로 거절하기 전에 한 번만 더 확인해보세요.',
                match: '행운 포인트: 동그란 물건, 3시',
                accent: '#86a8b2'
            },
            {
                image: 'major-11-justice.jpg',
                title: 'Justice · 정의',
                subtitle: '균형 잡힌 판단이 필요한 카드',
                summary: '감정과 사실을 분리해서 보면 답이 가까워집니다. 오늘은 공정한 기준과 정확한 확인이 당신 편이 되어줘요.',
                tags: ['판단', '균형', '확인'],
                guide: '중요한 약속이나 숫자는 한 번 더 확인하세요.',
                match: '행운 포인트: 회색, 문서 정리',
                accent: '#85899d'
            },
            {
                image: 'major-12-hanged-man.jpg',
                title: 'The Hanged Man · 행맨',
                subtitle: '다른 시선으로 멈춰보는 카드',
                summary: '밀어붙여도 잘 풀리지 않는다면 잠깐 거꾸로 봐야 하는 날입니다. 기다림이 손해가 아니라 방향 전환의 시간이 될 수 있어요.',
                tags: ['관점', '멈춤', '전환'],
                guide: '바로 답하지 말고 “내일 다시 볼게요”라는 여지를 남겨보세요.',
                match: '행운 포인트: 느린 음악, 창밖',
                accent: '#8a9bb3'
            },
            {
                image: 'major-13-death.jpg',
                title: 'Death · 죽음',
                subtitle: '끝맺음 뒤 새 장면이 오는 카드',
                summary: '오래 끌어온 것을 정리하면 공간이 생깁니다. 오늘의 종료는 실패보다 새 흐름을 위한 정돈에 가까워요.',
                tags: ['정리', '변화', '재시작'],
                guide: '더 이상 쓰지 않는 약속이나 물건 하나를 비워보세요.',
                match: '행운 포인트: 검은색, 삭제 버튼',
                accent: '#5d6270'
            },
            {
                image: 'major-14-temperance.jpg',
                title: 'Temperance · 절제',
                subtitle: '속도를 맞추는 카드',
                summary: '오늘은 양쪽 사이에서 균형을 찾는 감각이 좋아요. 너무 빠른 선택보다 적당한 타협이 오래 가는 결과를 만듭니다.',
                tags: ['균형', '조화', '회복'],
                guide: '일정 사이에 15분의 빈칸을 남겨두세요.',
                match: '행운 포인트: 민트색, 산책',
                accent: '#b2a69f'
            },
            {
                image: 'major-15-devil.jpg',
                title: 'The Devil · 악마',
                subtitle: '집착의 고리를 알아차리는 카드',
                summary: '오늘은 끌리는 것과 필요한 것을 구분해야 합니다. 반복되는 습관을 알아차리면 선택권이 다시 돌아와요.',
                tags: ['욕망', '습관', '해방'],
                guide: '자꾸 손이 가는 것을 30분만 미뤄보세요.',
                match: '행운 포인트: 물 한 잔, 잠금화면',
                accent: '#755d85'
            },
            {
                image: 'major-16-tower.jpg',
                title: 'The Tower · 타워',
                subtitle: '갑작스러운 깨달음의 카드',
                summary: '예상 밖의 일이 기존 구조를 흔들 수 있지만, 덕분에 오래 버티던 불편함이 드러납니다. 무너지는 것보다 새로 세울 기준을 보세요.',
                tags: ['전환', '충격', '진실'],
                guide: '오늘의 변수는 바로 수습하기보다 원인을 먼저 보세요.',
                match: '행운 포인트: 번개 아이콘, 빠른 백업',
                accent: '#a66874'
            },
            {
                image: 'major-17-star.jpg',
                title: 'The Star · 별',
                subtitle: '작은 희망이 방향을 만드는 카드',
                summary: '오늘은 큰 성과보다 회복과 기대가 중요한 날이에요. 작아 보여도 나를 다시 움직이게 하는 약속을 하나 잡아두면 좋습니다.',
                tags: ['희망', '회복', '기대'],
                guide: '미래의 나에게 도움이 되는 작은 예약을 해보세요.',
                match: '행운 포인트: 파란색, 물 한 잔',
                accent: '#879dbc'
            },
            {
                image: 'major-18-moon.jpg',
                title: 'The Moon · 달',
                subtitle: '감정의 물결을 읽어야 하는 카드',
                summary: '오늘은 확답보다 관찰이 먼저예요. 헷갈리는 일은 바로 결론 내리지 말고, 마음이 반복해서 가리키는 곳을 천천히 확인하세요.',
                tags: ['직감', '감정', '관찰'],
                guide: '밤에 떠오른 생각은 메모해두면 내일 꽤 쓸모가 있어요.',
                match: '행운 포인트: 은색, 조용한 음악',
                accent: '#8d95a3'
            },
            {
                image: 'major-19-sun.jpg',
                title: 'The Sun · 태양',
                subtitle: '분위기가 환하게 열리는 카드',
                summary: '오늘은 숨겨둔 실력보다 드러나는 태도가 더 큰 힘을 냅니다. 어색해도 먼저 말하고, 밝은 쪽으로 선택하면 흐름이 빨리 풀려요.',
                tags: ['활력', '확신', '표현'],
                guide: '오전에 미뤄둔 연락 하나를 먼저 처리해보세요.',
                match: '행운 포인트: 노란색, 창가 자리',
                accent: '#d7a66f'
            },
            {
                image: 'major-20-judgement.jpg',
                title: 'Judgement · 심판',
                subtitle: '다시 부름을 듣는 카드',
                summary: '이전의 선택을 돌아보고 다음 단계로 넘어갈 때입니다. 오늘은 미뤄둔 결론이나 재도전의 신호가 선명해질 수 있어요.',
                tags: ['각성', '재도전', '결론'],
                guide: '과거의 실수보다 지금 바꿀 수 있는 한 가지를 보세요.',
                match: '행운 포인트: 알림음, 아침 공기',
                accent: '#9aa7c8'
            },
            {
                image: 'major-21-world.jpg',
                title: 'The World · 세계',
                subtitle: '한 사이클이 완성되는 카드',
                summary: '오늘은 흩어진 조각들이 하나로 맞춰지는 감각이 있습니다. 작게라도 마무리하면 다음 장면으로 넘어갈 힘이 생겨요.',
                tags: ['완성', '확장', '성취'],
                guide: '끝낸 일을 표시하고 스스로에게 작은 보상을 주세요.',
                match: '행운 포인트: 원형 패턴, 넓은 시야',
                accent: '#7faeae'
            }
        ];

        return major.concat(this.createMinorTarotDeck()).map((card: any, index: number) => this.hydrateTarotCard(card, index));
    }

    public createMinorTarotDeck() {
        let suits = [
            {
                id: 'wands',
                ko: '완드',
                en: 'Wands',
                tags: ['열정', '행동', '창조'],
                accent: '#d7865f',
                energy: '열정과 실행력이 살아나는 흐름입니다.',
                focus: '아이디어를 움직임으로 바꾸는 데'
            },
            {
                id: 'cups',
                ko: '컵',
                en: 'Cups',
                tags: ['감정', '관계', '직감'],
                accent: '#7db2c5',
                energy: '감정과 관계의 결이 선명해지는 흐름입니다.',
                focus: '마음이 움직이는 방향을 돌보는 데'
            },
            {
                id: 'swords',
                ko: '소드',
                en: 'Swords',
                tags: ['생각', '판단', '대화'],
                accent: '#7f8fb7',
                energy: '생각과 말의 힘이 커지는 흐름입니다.',
                focus: '사실을 정리하고 정확히 말하는 데'
            },
            {
                id: 'pentacles',
                ko: '펜타클',
                en: 'Pentacles',
                tags: ['현실', '돈', '몸'],
                accent: '#7fab8c',
                energy: '현실적인 기반을 다지는 흐름입니다.',
                focus: '생활의 리듬과 자원을 안정시키는 데'
            }
        ];
        let ranks = [
            { id: 'ace', ko: '에이스', en: 'Ace', subtitle: '새 씨앗이 들어오는 카드', flow: '아직 작지만 분명한 시작점이 보입니다.', guide: '처음 떠오른 아이디어를 바로 적어두세요.' },
            { id: '02', ko: '2', en: 'Two', subtitle: '두 선택지를 비교하는 카드', flow: '서로 다른 방향을 놓고 균형을 잡아야 합니다.', guide: '장단점을 눈에 보이게 나누어 적어보세요.' },
            { id: '03', ko: '3', en: 'Three', subtitle: '확장과 협업의 카드', flow: '혼자 품던 일이 바깥으로 넓어질 수 있습니다.', guide: '믿을 만한 사람에게 현재 상황을 공유해보세요.' },
            { id: '04', ko: '4', en: 'Four', subtitle: '기반을 정돈하는 카드', flow: '안정된 구조를 만들수록 다음 단계가 편해집니다.', guide: '공간이나 일정 중 하나를 단정하게 정리하세요.' },
            { id: '05', ko: '5', en: 'Five', subtitle: '작은 충돌을 통과하는 카드', flow: '불편한 지점이 드러나지만 덕분에 핵심을 볼 수 있습니다.', guide: '감정이 앞서기 전에 사실부터 확인하세요.' },
            { id: '06', ko: '6', en: 'Six', subtitle: '회복과 이동의 카드', flow: '어제보다 나은 쪽으로 천천히 이동하는 기운입니다.', guide: '부담을 하나 줄이는 선택을 해보세요.' },
            { id: '07', ko: '7', en: 'Seven', subtitle: '스스로를 지키는 카드', flow: '내 입장과 우선순위를 분명히 세워야 합니다.', guide: '오늘은 거절해야 하는 일을 부드럽게 거절하세요.' },
            { id: '08', ko: '8', en: 'Eight', subtitle: '반복과 집중의 카드', flow: '작은 반복이 실력을 만들고 흐름을 안정시킵니다.', guide: '30분만 한 가지 일에 깊게 집중해보세요.' },
            { id: '09', ko: '9', en: 'Nine', subtitle: '결실 직전의 카드', flow: '거의 다 온 만큼 마지막 정리가 중요합니다.', guide: '끝내기 전에 빠진 부분 하나를 점검하세요.' },
            { id: '10', ko: '10', en: 'Ten', subtitle: '한 흐름의 완성 카드', flow: '쌓인 것이 결과로 드러나지만 무게도 함께 느껴질 수 있습니다.', guide: '혼자 다 들지 말고 나눌 수 있는 몫을 찾으세요.' },
            { id: 'page', ko: '페이지', en: 'Page', subtitle: '호기심과 배움의 카드', flow: '서툴러도 배우려는 태도가 운을 엽니다.', guide: '모르는 것을 모른다고 말하고 질문해보세요.' },
            { id: 'knight', ko: '나이트', en: 'Knight', subtitle: '빠르게 움직이는 카드', flow: '에너지가 앞으로 쏠리니 방향 점검이 필요합니다.', guide: '속도를 내기 전에 목적지를 한 문장으로 정하세요.' },
            { id: 'queen', ko: '퀸', en: 'Queen', subtitle: '성숙하게 돌보는 카드', flow: '상황을 부드럽게 다루는 감각이 강해집니다.', guide: '나와 상대 모두 편해지는 방식을 골라보세요.' },
            { id: 'king', ko: '킹', en: 'King', subtitle: '책임 있게 이끄는 카드', flow: '큰 그림을 보고 기준을 세워야 하는 날입니다.', guide: '오늘 결정의 원칙을 먼저 정해두세요.' }
        ];
        let cards: any[] = [];
        for (let suit of suits) {
            for (let rank of ranks) {
                cards.push({
                    image: `${suit.id}-${rank.id}.jpg`,
                    title: `${rank.en} of ${suit.en} · ${suit.ko} ${rank.ko}`,
                    subtitle: rank.subtitle,
                    summary: `${suit.energy} ${rank.flow} 오늘은 ${suit.focus} 작은 힌트가 숨어 있어요.`,
                    tags: suit.tags,
                    guide: rank.guide,
                    match: this.tarotMatchText(suit.id, rank.id),
                    accent: suit.accent
                });
            }
        }
        return cards;
    }

    public hydrateTarotCard(card: any, index: number) {
        let accents = ['#879dbc', '#c986a0', '#86a8b2', '#b2a69f', '#a995bf', '#d7a66f', '#7fab8c', '#7f8fb7'];
        let image = card.image || this.resolveTarotImageName(card);
        return {
            ...card,
            image,
            imageUrl: image ? this.tarotAsset(image) : '',
            tags: card.tags || ['타로', '오늘', '메시지'],
            guide: card.guide || '오늘 마음에 남는 신호를 하나만 붙잡아보세요.',
            match: card.match || '행운 포인트: 별빛, 천천히 걷기',
            accent: card.accent || accents[index % accents.length]
        };
    }

    public tarotAsset(fileName: string) {
        return `/assets/tarot/${fileName}`;
    }

    public tarotResultImage(card: any) {
        if (!card) return '';
        if (card.imageUrl) return card.imageUrl;
        let image = card.image || this.resolveTarotImageName(card);
        return image ? this.tarotAsset(image) : '';
    }

    public resolveTarotImageName(card: any) {
        let title = `${card?.title || ''}`.toLowerCase();
        let majors = [
            { image: 'major-00-fool.jpg', keys: ['the fool', '바보'] },
            { image: 'major-01-magician.jpg', keys: ['the magician', '마법사'] },
            { image: 'major-02-high-priestess.jpg', keys: ['high priestess', '여사제'] },
            { image: 'major-03-empress.jpg', keys: ['the empress', '여황제'] },
            { image: 'major-04-emperor.jpg', keys: ['the emperor', '황제'] },
            { image: 'major-05-hierophant.jpg', keys: ['hierophant', '교황'] },
            { image: 'major-06-lovers.jpg', keys: ['lovers', '연인'] },
            { image: 'major-07-chariot.jpg', keys: ['chariot', '전차'] },
            { image: 'major-08-strength.jpg', keys: ['strength', '힘'] },
            { image: 'major-09-hermit.jpg', keys: ['hermit', '은둔자'] },
            { image: 'major-10-wheel-of-fortune.jpg', keys: ['wheel of fortune', '운명의 수레바퀴'] },
            { image: 'major-11-justice.jpg', keys: ['justice', '정의'] },
            { image: 'major-12-hanged-man.jpg', keys: ['hanged man', '행맨'] },
            { image: 'major-13-death.jpg', keys: ['death', '죽음'] },
            { image: 'major-14-temperance.jpg', keys: ['temperance', '절제'] },
            { image: 'major-15-devil.jpg', keys: ['devil', '악마'] },
            { image: 'major-16-tower.jpg', keys: ['tower', '타워'] },
            { image: 'major-17-star.jpg', keys: ['the star', '별'] },
            { image: 'major-18-moon.jpg', keys: ['the moon', '달'] },
            { image: 'major-19-sun.jpg', keys: ['the sun', '태양'] },
            { image: 'major-20-judgement.jpg', keys: ['judgement', 'judgment', '심판'] },
            { image: 'major-21-world.jpg', keys: ['world', '세계'] }
        ];
        for (let item of majors) {
            if (item.keys.some((key: string) => title.indexOf(key) >= 0)) {
                return item.image;
            }
        }
        return '';
    }

    public createTarotDrawResult(card: any, preferredOrientation: string = '') {
        let result = this.hydrateTarotCard({ ...card }, card?.fanIndex || 0);
        let reversed = preferredOrientation === 'reversed' ? true : preferredOrientation === 'upright' ? false : this.randomInt(2) === 1;
        let orientation = reversed ? 'reversed' : 'upright';
        let orientationLabel = reversed ? '역방향' : '정방향';
        let tags = (result.tags || []).filter((tag: string) => tag !== '정방향' && tag !== '역방향');
        let orientationSummary = reversed
            ? '역방향으로 나온 카드는 흐름이 안쪽으로 막히거나 과하게 쏠린 부분을 보여줘요.'
            : '정방향으로 나온 카드는 지금 흐름이 비교적 자연스럽게 열리고 있다는 신호예요.';
        return {
            ...result,
            orientation,
            orientationLabel,
            imageUrl: this.tarotResultImage(result),
            subtitle: `${result.subtitle} · ${orientationLabel}`,
            summary: `${orientationSummary} ${result.summary}`,
            tags: [orientationLabel, ...tags].slice(0, 5),
            guide: reversed ? `속도를 조금 늦추고 반대로 놓친 부분을 확인해보세요. ${result.guide}` : result.guide,
            shareResultIndex: Number.isInteger(card?.shareResultIndex) ? card.shareResultIndex : this.resultIndexForResult(this.selectedTest, card),
            shareFanIndex: Number.isInteger(card?.fanIndex) ? card.fanIndex : 0
        };
    }

    public tarotMatchText(suitId: string, rankId: string) {
        let suitLucky: any = {
            wands: '행운 포인트: 따뜻한 색, 빠른 실행',
            cups: '행운 포인트: 물빛, 진심 어린 말',
            swords: '행운 포인트: 파란색, 짧은 메모',
            pentacles: '행운 포인트: 초록색, 현실적인 정리'
        };
        let rankLucky: any = {
            ace: '새로운 시작',
            page: '배움',
            knight: '이동',
            queen: '돌봄',
            king: '기준'
        };
        return rankLucky[rankId] ? `${suitLucky[suitId]}, ${rankLucky[rankId]}` : suitLucky[suitId];
    }

    public validateQuestionTests() {
        let inputScoring = ['axes', 'photo', 'gift', 'tarot', 'pinball', 'saju', 'compatibility', 'daily', 'manse'];
        let problems: string[] = [];

        for (let test of this.tests) {
            if (inputScoring.indexOf(test.scoring) >= 0) continue;

            let resultKeys = Object.keys(test.results || {});
            let questionTexts = new Set<string>();
            if ((test.questions || []).length < 10) {
                problems.push(`${test.id}: 직접 작성된 문항이 10개보다 적습니다.`);
            }

            (test.questions || []).forEach((question: any, questionIndex: number) => {
                if (questionTexts.has(question.text)) {
                    problems.push(`${test.id}: 중복 질문 "${question.text}"`);
                }
                questionTexts.add(question.text);

                let optionTexts = new Set<string>();
                let optionResults = new Set<string>();
                for (let option of question.options || []) {
                    let optionText = `${option.label}|${option.detail}`;
                    if (optionTexts.has(optionText)) {
                        problems.push(`${test.id} Q${questionIndex + 1}: 중복 선택지 "${option.label}"`);
                    }
                    optionTexts.add(optionText);
                    optionResults.add(option.result);
                    if (resultKeys.indexOf(option.result) < 0) {
                        problems.push(`${test.id} Q${questionIndex + 1}: 결과 키 "${option.result}"가 없습니다.`);
                    }
                }

                for (let key of resultKeys) {
                    if (!optionResults.has(key)) {
                        problems.push(`${test.id} Q${questionIndex + 1}: "${key}" 선택지가 빠졌습니다.`);
                    }
                }
            });
        }

        if (problems.length) {
            console.warn('[패싯 테스트 문항 점검]\n' + problems.join('\n'));
        }
    }

    public get heroTest() {
        return this.tests.find((test: any) => test.id === 'mood-weather') || this.tests[0];
    }

    public get filteredTests() {
        let keyword = this.query.trim().toLowerCase();
        return this.tests.filter((test: any) => {
            let categoryMatched = this.testMatchesCategory(test, this.activeCategory);
            let text = `${test.title} ${test.subtitle} ${test.description} ${test.tags.join(' ')}`.toLowerCase();
            return categoryMatched && (!keyword || text.indexOf(keyword) >= 0);
        });
    }

    public testMatchesCategory(test: any, category: string) {
        if (category === 'all') return true;
        if (category === 'pick') return test.section === 'must';
        if (category === 'astrology') return test.category === 'astrology' || test.category === 'fortune';
        return test.category === category;
    }

    public get featuredTests() {
        return this.tests.filter((test: any) => test.section === 'must').slice(0, 3);
    }

    public get newTests() {
        return this.tests.filter((test: any) => test.section === 'new');
    }

    public get selfTests() {
        return this.tests.filter((test: any) => test.section === 'self');
    }

    public get progressPercent() {
        if (!this.selectedTest || !this.selectedTest.questions.length) return 0;
        return Math.round(((this.questionIndex + 1) / this.selectedTest.questions.length) * 100);
    }

    public get currentQuestion() {
        if (!this.selectedTest) return null;
        return this.selectedTest.questions[this.questionIndex];
    }

    public async selectCategory(category: string) {
        this.clearSharedResultUrl();
        this.activeCategory = category;
        if (category === 'attachment') {
            this.screen = 'attachment';
            await this.service.render();
            this.scrollPageToTop('smooth');
            return;
        }
        this.screen = 'home';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public categoryClass(category: string) {
        if (this.activeCategory === category) {
            return 'h-10 shrink-0 rounded-full bg-[#b76e79] px-4 text-[13px] font-bold text-white shadow-sm transition';
        }
        return 'h-10 shrink-0 rounded-full bg-white px-4 text-[13px] font-bold text-slate-600 ring-1 ring-[#eadfda] transition hover:text-[#7f4f5d] hover:ring-[#d8a4ae]';
    }

    public testMetaLabel(test: any) {
        if (test?.scoring === 'photo') return '사진 업로드';
        if (test?.scoring === 'gift') return '선물뽑기';
        if (test?.scoring === 'tarot') return '카드 선택';
        if (test?.scoring === 'pinball') return '핀볼 뽑기';
        if (test?.scoring === 'saju') return '사주 입력';
        if (test?.scoring === 'compatibility') return '궁합 입력';
        if (test?.scoring === 'daily') return '오늘 운세';
        if (test?.scoring === 'manse') return test?.precision ? '정밀 만세력' : '만세력';
        return `${test?.questions?.length || 0}문항`;
    }

    public get attachmentTotalSize() {
        return this.attachmentFiles.reduce((total: number, item: any) => total + (Number(item.size) || 0), 0);
    }

    public attachmentFileKey(file: any) {
        return `${file?.name || ''}|${file?.size || 0}|${file?.lastModified || 0}`;
    }

    public formatFileSize(bytes: any) {
        let size = Number(bytes) || 0;
        if (size < 1024) return `${size}B`;
        if (size < 1024 * 1024) return `${Math.round(size / 1024 * 10) / 10}KB`;
        return `${Math.round(size / 1024 / 1024 * 10) / 10}MB`;
    }

    public attachmentStatusLabel(item: any) {
        if (item?.status === 'uploading') return '첨부 중';
        if (item?.status === 'uploaded') return '첨부됨';
        if (item?.status === 'failed') return '실패';
        return '대기';
    }

    public attachmentIcon(item: any) {
        let type = `${item?.type || ''}`.toLowerCase();
        let name = `${item?.name || ''}`.toLowerCase();
        if (type.indexOf('image/') === 0) return 'IMG';
        if (type.indexOf('pdf') >= 0 || name.endsWith('.pdf')) return 'PDF';
        if (type.indexOf('zip') >= 0 || name.endsWith('.zip')) return 'ZIP';
        if (type.indexOf('text') >= 0 || name.endsWith('.txt') || name.endsWith('.md')) return 'TXT';
        return 'FILE';
    }

    public async chooseAttachmentFiles() {
        let files = await this.service.file.select({ multiple: true });
        await this.addAttachmentFiles(files);
    }

    public async handleAttachmentInput(event: any) {
        let input = event?.target as HTMLInputElement;
        await this.addAttachmentFiles(input?.files);
        if (input) input.value = '';
    }

    public async handleAttachmentDragOver(event: any) {
        event?.preventDefault();
    }

    public async handleAttachmentDrop(event: any) {
        event?.preventDefault();
        let files = await this.service.file.drop(event);
        await this.addAttachmentFiles(files);
    }

    public async addAttachmentFiles(files: any) {
        let selected = Array.from(files || []) as any[];
        if (!selected.length) return;

        let existing = new Set(this.attachmentFiles.map((item: any) => item.key));
        let entries = [];
        let skipped = 0;
        let oversized = 0;

        for (let file of selected) {
            if (!file) continue;
            if (file.size > this.attachmentMaxSize) {
                oversized++;
                continue;
            }

            let key = this.attachmentFileKey(file);
            if (existing.has(key)) {
                skipped++;
                continue;
            }

            existing.add(key);
            let entry = {
                id: `${Date.now()}-${Math.random()}`,
                key: key,
                file: file,
                name: file.name || '이름 없는 파일',
                size: file.size || 0,
                type: file.type || '',
                status: 'ready',
                progress: 0,
                server: null
            };
            this.attachmentFiles.push(entry);
            entries.push(entry);
        }

        if (!entries.length) {
            if (oversized) {
                this.attachmentMessage = `${this.formatFileSize(this.attachmentMaxSize)} 이하 파일만 첨부할 수 있어요`;
            } else if (skipped) {
                this.attachmentMessage = '이미 첨부한 파일이에요';
            }
            await this.service.render();
            return;
        }

        await this.uploadAttachmentEntries(entries, skipped, oversized);
    }

    public async uploadAttachmentEntries(entries: any[], skipped: number = 0, oversized: number = 0) {
        let formData = new FormData();
        entries.forEach((entry: any) => {
            entry.status = 'uploading';
            entry.progress = 0;
            formData.append('files', entry.file, entry.name);
        });

        this.attachmentUploading = true;
        this.attachmentProgress = 0;
        this.attachmentMessage = `${entries.length}개 파일을 첨부하는 중`;
        await this.service.render();

        try {
            let response: any = await this.service.file.upload(wiz.url('upload_attachment'), formData, async (percent: number) => {
                this.attachmentProgress = percent;
                entries.forEach((entry: any) => entry.progress = percent);
                await this.service.render();
            });

            if ((response?.code && response.code !== 200) || (response?.status && response.status !== 200)) {
                throw new Error(response?.data?.message || '파일 첨부에 실패했어요');
            }

            let uploaded = response?.data?.files || [];
            entries.forEach((entry: any, index: number) => {
                entry.status = 'uploaded';
                entry.progress = 100;
                entry.server = uploaded[index] || null;
            });

            let notices = [];
            if (skipped) notices.push(`중복 ${skipped}개 제외`);
            if (oversized) notices.push(`용량 초과 ${oversized}개 제외`);
            this.attachmentMessage = `${entries.length}개 파일을 첨부했어요${notices.length ? ' · ' + notices.join(' · ') : ''}`;
        } catch (error) {
            entries.forEach((entry: any) => {
                entry.status = 'failed';
                entry.progress = 0;
            });
            this.attachmentMessage = '파일 첨부에 실패했어요';
            await this.showNotice('파일 첨부에 실패했어요');
        }

        this.attachmentUploading = false;
        this.attachmentProgress = 0;
        await this.service.render();
    }

    public async deleteAttachmentServerFile(item: any) {
        if (item?.server?.path) {
            let response: any = await wiz.call('delete_attachment', { path: item.server.path });
            if (response?.code && response.code !== 200) {
                return false;
            }
        }
        return true;
    }

    public async removeAttachmentFile(index: number) {
        if (index < 0 || index >= this.attachmentFiles.length) return;
        let item = this.attachmentFiles[index];
        if (!await this.deleteAttachmentServerFile(item)) {
            await this.showNotice('첨부 파일을 삭제하지 못했어요');
            return;
        }
        this.attachmentFiles.splice(index, 1);
        this.attachmentMessage = this.attachmentFiles.length ? `${this.attachmentFiles.length}개 파일이 첨부되어 있어요` : '파일을 선택하거나 끌어다 놓으세요';
        await this.service.render();
    }

    public async clearAttachments() {
        for (let item of this.attachmentFiles) {
            await this.deleteAttachmentServerFile(item);
        }
        this.attachmentFiles = [];
        this.attachmentProgress = 0;
        this.attachmentUploading = false;
        this.attachmentMessage = '파일을 선택하거나 끌어다 놓으세요';
        await this.service.render();
    }

    public async openTest(test: any) {
        this.clearSharedResultUrl();
        this.selectedTest = test;
        this.questionIndex = 0;
        this.answers = [];
        this.result = null;
        this.screen = 'detail';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public async startTest(test: any = null) {
        this.clearSharedResultUrl();
        if (test) {
            this.selectedTest = test;
        }
        if (!this.selectedTest) {
            this.selectedTest = this.heroTest;
        }
        this.questionIndex = 0;
        this.answers = [];
        this.result = null;
        this.resultTransitionToken++;
        this.resetPhotoState();
        this.resetGiftState();
        this.resetPinballState();
        this.resetFortuneState();
        if (this.selectedTest.scoring === 'photo') {
            this.screen = 'photo';
            await this.service.render();
            this.scrollPageToTop('smooth');
            return;
        }
        if (this.selectedTest.scoring === 'gift') {
            this.screen = 'gift';
            await this.service.render();
            this.scrollPageToTop('smooth');
            return;
        }
        if (this.selectedTest.scoring === 'tarot') {
            this.prepareTarotChoices();
            this.screen = 'tarot';
            await this.service.render();
            this.scrollPageToTop('smooth');
            await this.playTarotShuffleIntro();
            return;
        }
        if (this.selectedTest.scoring === 'pinball') {
            this.screen = 'pinball';
            await this.service.render();
            this.queuePinballBoardDraw();
            this.scrollPageToTop('smooth');
            return;
        }
        if (['saju', 'compatibility', 'daily', 'manse'].indexOf(this.selectedTest.scoring) >= 0) {
            this.screen = this.selectedTest.scoring;
            await this.service.render();
            this.scrollPageToTop('smooth');
            return;
        }
        this.screen = 'play';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public async chooseOption(option: any) {
        this.answers[this.questionIndex] = option;
        if (this.questionIndex >= this.selectedTest.questions.length - 1) {
            await this.showResultWithLoading(this.calculateResult(), 'result');
            return;
        }
        this.questionIndex += 1;
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public async previousQuestion() {
        if (this.questionIndex <= 0) return;
        this.questionIndex -= 1;
        await this.service.render();
    }

    public resetPhotoState() {
        this.uploadedImage = '';
        this.uploadedFileName = '';
        this.uploadedFileMeta = null;
        this.photoAnalyzing = false;
    }

    public resetGiftState() {
        this.giftResult = null;
        this.giftDrawing = false;
        this.giftDeck = [];
    }

    public resetPinballState() {
        this.stopPinballLoop();
        this.stopPinballRecording();
        this.pinballRunning = false;
        this.pinballShuffling = false;
        this.pinballBalls = [];
        this.pinballResults = [];
        this.pinballWinner = null;
        this.pinballWinnerAnnouncedAt = 0;
        this.pinballWinnerBurstSeed = 0;
        this.pinballError = '';
        this.pinballMessage = '이름을 입력하고 셔플한 뒤 시작하세요';
        this.pinballWorld = null;
        this.pinballMotionElapsed = 0;
        this.pinballCurrentMotionScale = 1;
        this.resetPinballCamera();
        this.result = null;
        this.refreshPinballPreview();
    }

    public resetPinballCamera(focusBallId: string = '', scale: number = 1) {
        this.pinballCameraX = 0;
        this.pinballCameraTargetX = 0;
        this.pinballCameraVelocityX = 0;
        this.pinballCameraY = 0;
        this.pinballCameraTargetY = 0;
        this.pinballCameraVelocityY = 0;
        this.pinballCameraScale = scale;
        this.pinballCameraTargetScale = scale;
        this.pinballCameraBounceX = 0;
        this.pinballCameraBounceVelocityX = 0;
        this.pinballCameraBounce = 0;
        this.pinballCameraBounceVelocity = 0;
        this.pinballCameraFocusX = 0;
        this.pinballCameraFocusY = 0;
        this.pinballCameraFocusReady = false;
        this.pinballFocusBallId = focusBallId;
        this.pinballLastCameraImpactAt = 0;
    }

    public refreshPinballPreview() {
        let parsed = this.safePinballParticipants();
        this.pinballTotalBalls = parsed.items.length;
        this.pinballError = parsed.error;
    }

    public safePinballParticipants() {
        try {
            let parsed = this.parsePinballParticipants();
            if (!parsed || !Array.isArray(parsed.items)) {
                return { items: [], error: '입력값을 읽지 못했어요' };
            }
            return parsed;
        } catch (error) {
            return { items: [], error: '입력값을 읽지 못했어요' };
        }
    }

    public parsePinballParticipants() {
        let colors = this.pinballPastelPalette();
        let chunks = `${this.pinballParticipantsInput || ''}`
            .split(/[\n,]+/)
            .map((item: string) => item.trim())
            .filter((item: string) => item.length > 0);
        let items: any[] = [];
        let error = '';

        for (let chunk of chunks) {
            let source = chunk;
            let weight = 1;
            let count = 1;
            let weightMatch = source.match(/\/\s*(\d+(?:\.\d+)?)\s*$/);
            if (weightMatch) {
                weight = this.clamp(Number(weightMatch[1]) || 1, 1, 20);
                source = source.slice(0, weightMatch.index).trim();
            }

            let starMatch = source.match(/\*\s*(\d+)\s*$/);
            if (starMatch) {
                count = this.normalizedPinballBallCount(starMatch[1]);
                source = source.slice(0, starMatch.index).trim();
            } else if (!/^\d+$/.test(source)) {
                let countMatch = source.match(/^(.+?)(\d+)$/);
                if (countMatch && countMatch[1].trim()) {
                    source = countMatch[1].trim();
                    count = this.normalizedPinballBallCount(countMatch[2]);
                }
            }

            let label = this.normalizePinballParticipantLabel(source, `참가자 ${items.length + 1}`);
            for (let i = 0; i < count; i++) {
                items.push({
                    id: `${label}-${items.length}-${i}`,
                    label: label,
                    displayLabel: this.pinballDisplayLabel(label),
                    weight: weight,
                    color: colors[items.length % colors.length],
                    source: chunk
                });
            }
        }

        if (!items.length) {
            error = '이름이나 숫자를 하나 이상 입력해주세요';
        }

        return { items, error };
    }

    public normalizedPinballBallCount(value: any) {
        let count = parseInt(`${value || ''}`, 10);
        if (!Number.isFinite(count) || count < 1) return 1;
        return Math.floor(count);
    }

    public pinballPastelPalette() {
        return ['#ffb3c7', '#91d7ff', '#a7e8bd', '#ffe28a', '#cdb4ff', '#ffbf8f', '#8de7df', '#ffa5a5', '#d4f48f', '#f0a6df', '#a8c7ff', '#ffd0a6'];
    }

    public normalizePinballParticipantLabel(value: string, fallback: string = '') {
        let label = `${value || ''}`.trim();
        if (!label) return fallback || '';

        let withoutOrder = label.replace(/^\d+\s*(?:(?:번)|[.)\]:：_\-\/])?\s*/, '').trim();
        if (withoutOrder && /[^\d\s]/.test(withoutOrder)) {
            label = withoutOrder;
        }

        return label || fallback || '';
    }

    public pinballDisplayLabel(label: string) {
        let text = `${label || ''}`.trim();
        if (!text) return '?';
        return text.length > 6 ? text.slice(0, 6) : text;
    }

    public pinballColorRgb(color: string) {
        let hex = `${color || ''}`.trim().replace(/^#/, '');
        if (/^[0-9a-f]{3}$/i.test(hex)) {
            hex = hex.split('').map((part: string) => part + part).join('');
        }
        if (!/^[0-9a-f]{6}$/i.test(hex)) return null;
        return {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16)
        };
    }

    public pinballTextColor(color: string) {
        let rgb = this.pinballColorRgb(color);
        if (!rgb) return '#302c3d';
        let luminance = ((rgb.r * 0.299) + (rgb.g * 0.587) + (rgb.b * 0.114)) / 255;
        return luminance > 0.56 ? '#302c3d' : '#fffaf7';
    }

    public pinballSoftGlowColor(color: string, alpha: number = 0.52) {
        let rgb = this.pinballColorRgb(color);
        if (!rgb) return `rgba(255, 179, 199, ${alpha})`;
        return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
    }

    public pinballShadeColor(color: string, amount: number = 0) {
        let rgb = this.pinballColorRgb(color);
        if (!rgb) return color || '#ffb3c7';
        let ratio = this.clamp(Math.abs(amount), 0, 1);
        let target = amount >= 0 ? 255 : 0;
        let channel = (value: number) => Math.round(value + (target - value) * ratio);
        return `rgb(${channel(rgb.r)}, ${channel(rgb.g)}, ${channel(rgb.b)})`;
    }

    public pinballParticipantSummary() {
        let parsed = this.safePinballParticipants();
        if (parsed.error && !parsed.items.length) return parsed.error;
        return `${parsed.items.length}개의 공이 만들어져요`;
    }

    public pinballSelectedMap() {
        return this.pinballMaps.find((map: any) => map.id === this.pinballMap) || this.pinballMaps[0];
    }

    public pinballMapClass(mapId: string) {
        if (this.pinballMap === mapId) {
            return 'pinball-map-button is-active';
        }
        return 'pinball-map-button';
    }

    public pinballTargetRank(total: number = 0) {
        let size = total || this.pinballBalls.length || this.pinballTotalBalls || 1;
        if (this.pinballWinningRank === 'last') return size;
        let rank = parseInt(`${this.pinballWinningRank}`, 10);
        if (!Number.isFinite(rank) || rank < 1) rank = 1;
        return this.clamp(rank, 1, size);
    }

    public pinballTargetLabel() {
        if (this.pinballWinningRank === 'last') return '마지막';
        return `${this.pinballTargetRank()}번째`;
    }

    public async setPinballMap(mapId: string) {
        if (this.pinballRunning) return;
        this.pinballMap = mapId;
        this.pinballWorld = null;
        this.resetPinballCamera();
        await this.service.render();
        this.queuePinballBoardDraw();
    }

    public createPinballBalls(participants: any[]) {
        let shuffled = this.shuffleGifts(participants.slice());
        let total = Math.max(shuffled.length, 1);
        let radius = total > 86 ? 5.5 : total > 54 ? 6.5 : total > 28 ? 7.5 : 8.5;
        let branchLanes = Math.min(8, Math.max(4, Math.ceil(Math.sqrt(total) * 1.35)));
        let leftBranchStart = 128;
        let leftBranchEnd = 288;
        let rightBranchStart = this.pinballCanvasWidth - 288;
        let branchGap = (leftBranchEnd - leftBranchStart) / Math.max(branchLanes - 1, 1);

        return shuffled.map((participant: any, index: number) => {
            let branch = index % 2;
            let lane = Math.floor(index / 2) % branchLanes;
            let row = Math.floor(index / (branchLanes * 2));
            let branchStart = branch === 0 ? leftBranchStart : rightBranchStart;
            let branchSide = branch === 0 ? -1 : 1;
            let releaseDelay = Math.min(3.4, index * 0.038 + row * 0.22 + Math.random() * 0.11);
            return {
                ...participant,
                id: participant.id || `pinball-ball-${index}-${this.randomInt(99999)}`,
                x: branchStart + branchGap * lane + (Math.random() - 0.5) * 5,
                y: 104 + row * (radius * 2.55),
                vx: branchSide * (12 + Math.random() * 10) + (Math.random() - 0.5) * 4,
                vy: 0,
                r: radius,
                finished: false,
                released: releaseDelay <= 0.08,
                releaseDelay,
                rank: 0,
                skillTimer: 1.8 + Math.random() * 3.8,
                skillGlow: 0,
                lastProgressX: 0,
                lastProgressY: 0,
                stuckTimer: 0,
                rescueCount: 0
            };
        });
    }

    public async shufflePinball() {
        if (this.pinballRunning) return;
        this.clearSharedResultUrl();
        let parsed = this.safePinballParticipants();
        this.pinballError = parsed.error;
        this.pinballTotalBalls = parsed.items.length;
        if (parsed.error) {
            await this.showNotice(parsed.error);
            return;
        }
        this.pinballShuffling = true;
        this.pinballResults = [];
        this.pinballWinner = null;
        this.pinballWinnerAnnouncedAt = 0;
        this.pinballWinnerBurstSeed = 0;
        this.result = null;
        this.pinballWorld = this.createPinballWorld();
        this.pinballMotionElapsed = 0;
        this.pinballCurrentMotionScale = 1;
        this.pinballBalls = this.createPinballBalls(parsed.items);
        this.resetPinballCamera('', 1);
        this.pinballMessage = '공을 섞는 중';
        await this.service.render();
        this.drawPinballBoard();
        await this.wait(520);
        this.pinballShuffling = false;
        this.pinballMessage = `${this.pinballTotalBalls}개의 공이 준비됐어요`;
        await this.service.render();
        this.drawPinballBoard();
    }

    public async startPinballGame() {
        if (this.pinballRunning) return;
        this.clearSharedResultUrl();
        let parsed = this.safePinballParticipants();
        this.pinballError = parsed.error;
        this.pinballTotalBalls = parsed.items.length;
        if (parsed.error) {
            await this.showNotice(parsed.error);
            return;
        }

        this.stopPinballLoop();
        this.pinballWorld = this.createPinballWorld();
        this.pinballBalls = this.createPinballBalls(parsed.items);
        this.pinballResults = [];
        this.pinballWinner = null;
        this.pinballWinnerAnnouncedAt = 0;
        this.pinballWinnerBurstSeed = 0;
        this.result = null;
        this.pinballRunning = true;
        this.pinballShuffling = false;
        this.resetPinballCamera('', 1);
        this.pinballMessage = `${this.pinballTargetLabel()} 골인 공을 기다리는 중`;
        this.pinballLastFrameTime = 0;
        this.pinballLastPanelRenderAt = 0;
        this.pinballStartedAt = performance.now();
        this.pinballMotionElapsed = 0;
        this.pinballCurrentMotionScale = 1;
        await this.service.render();
        this.drawPinballBoard();
        setTimeout(() => this.drawPinballBoard(), 80);
        this.startPinballRecording();
        this.pinballFrameRequest = requestAnimationFrame((time: number) => this.stepPinball(time));
    }

    public async stopPinballGame() {
        if (!this.pinballRunning && !this.pinballShuffling) return;
        this.pinballRunning = false;
        this.pinballShuffling = false;
        this.pinballMessage = '게임을 멈췄어요';
        this.stopPinballLoop();
        this.stopPinballRecording();
        await this.service.render();
        this.drawPinballBoard();
    }

    public async resetPinballBoard() {
        this.clearSharedResultUrl();
        this.stopPinballLoop();
        this.stopPinballRecording();
        this.pinballRunning = false;
        this.pinballShuffling = false;
        this.pinballBalls = [];
        this.pinballResults = [];
        this.pinballWinner = null;
        this.pinballWinnerAnnouncedAt = 0;
        this.pinballWinnerBurstSeed = 0;
        this.result = null;
        this.pinballWorld = null;
        this.pinballMotionElapsed = 0;
        this.pinballCurrentMotionScale = 1;
        this.resetPinballCamera();
        this.pinballMessage = '초기화했어요';
        this.refreshPinballPreview();
        await this.service.render();
        this.drawPinballBoard();
    }

    public stopPinballLoop() {
        if (this.pinballFrameRequest) {
            cancelAnimationFrame(this.pinballFrameRequest);
            this.pinballFrameRequest = null;
        }
    }

    public stepPinball(time: number) {
        if (!this.pinballRunning) return;
        if (!this.pinballLastFrameTime) this.pinballLastFrameTime = time;
        let dt = Math.min((time - this.pinballLastFrameTime) / 1000, 0.033);
        this.pinballLastFrameTime = time;
        this.advancePinballWorld(dt || 0.016);
        this.updatePinballCamera(dt || 0.016);
        this.drawPinballBoard();

        if (this.pinballRunning) {
            this.pinballFrameRequest = requestAnimationFrame((nextTime: number) => this.stepPinball(nextTime));
        } else {
            this.pinballFrameRequest = null;
            this.stopPinballRecording();
            this.schedulePinballRender();
        }
    }

    public createPinballWorld() {
        let w = this.pinballCanvasWidth;
        let h = this.pinballWorldHeight;
        let pins: any[] = [];
        let bumpers: any[] = [];
        let wheelSpokes: any[] = [];
        let dropZones: any[] = [
            { x1: 88, y1: 132, x2: w - 88, y2: 680, force: 66, drift: 0, splitCenter: w * 0.5, splitForce: 148, neutralWidth: 72, swirl: 18 },
            { x1: 104, y1: 690, x2: w - 104, y2: 1010, force: 74, drift: 0, splitCenter: w * 0.5, splitForce: 74, neutralWidth: 86, swirl: 20 },
            { x1: 88, y1: 1060, x2: w - 88, y2: 1398, force: 86, drift: 0, splitCenter: w * 0.5, splitForce: 68, neutralWidth: 96, swirl: 26 },
            { x1: 104, y1: 1516, x2: w - 104, y2: 1796, force: 82, drift: 0, splitCenter: w * 0.5, splitForce: 58, neutralWidth: 102, swirl: 20 },
            { x1: 118, y1: h - 420, x2: w - 118, y2: h - 230, force: 62, drift: 0, splitCenter: w * 0.5, splitForce: 42, neutralWidth: 112, swirl: 14 }
        ];
        let decorBlocks: any[] = [
            { x: 174, y: 438, w: 16, h: 16, color: '#18f7ff', alpha: 0.42, angle: Math.PI * 0.25 },
            { x: 450, y: 438, w: 16, h: 16, color: '#18f7ff', alpha: 0.42, angle: Math.PI * 0.25 },
            { x: 302, y: 820, w: 18, h: 18, color: '#ff5ecf', alpha: 0.32, angle: Math.PI * 0.25 },
            { x: 170, y: 1292, w: 18, h: 18, color: '#18f7ff', alpha: 0.36, angle: Math.PI * 0.25 },
            { x: 452, y: 1518, w: 18, h: 18, color: '#18f7ff', alpha: 0.36, angle: Math.PI * 0.25 }
        ];
        let cyanDashes: any[] = [
            { y: 432, xs: [168, 224, 416, 472], length: 22, angle: 0.72 },
            { y: 812, xs: [188, 248, 392, 452], length: 24, angle: -0.68 },
            { y: 1128, xs: [142, 214, 426, 498], length: 24, angle: 0.64 },
            { y: 1470, xs: [214, 284, 356, 426], length: 25, angle: -0.62 },
            { y: 1818, xs: [176, 246, 394, 464], length: 26, angle: 0.62 }
        ];
        let funnelTop = h - 360;
        let funnelThroatY = h - 170;
        let pipeStartY = h - 118;
        let pipeBottomY = h - 22;
        let throatHalf = 138;
        let pipeHalf = 48;
        let funnelMouthInset = 92;
        let funnel = {
            topY: funnelTop,
            throatY: funnelThroatY,
            pipeStartY,
            bottomY: pipeBottomY,
            mouthLeft: funnelMouthInset,
            mouthRight: w - funnelMouthInset,
            throatLeft: w / 2 - throatHalf,
            throatRight: w / 2 + throatHalf,
            pipeLeft: w / 2 - pipeHalf,
            pipeRight: w / 2 + pipeHalf
        };
        let segments: any[] = [];

        let wallStyle = {
            bounce: 0.46,
            hitRadius: 5,
            wall: true,
            color: 'rgba(255,255,255,0.88)',
            glowColor: '#19f7ff',
            glowBlur: 16,
            visualWidth: 3
        };
        let cyanStyle = {
            ...wallStyle,
            color: 'rgba(25,247,255,0.86)',
            glowColor: '#19f7ff',
            glowBlur: 22,
            visualWidth: 4.2
        };

        let addSegment = (x1: number, y1: number, x2: number, y2: number, options: any = {}) => {
            segments.push({
                x1,
                y1,
                x2,
                y2,
                ...wallStyle,
                ...options
            });
        };
        let addRailPath = (points: any[], options: any = {}) => {
            for (let i = 0; i < points.length - 1; i++) {
                addSegment(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y, options);
            }
        };

        let addSlide = (x1: number, y1: number, x2: number, y2: number, kickback: boolean = false) => {
            addSegment(x1, y1, x2, y2, {
                ...cyanStyle,
                bounce: kickback ? 0.68 : 0.34,
                hitRadius: kickback ? 9 : 7,
                slide: true,
                slideForce: kickback ? 8 : 12,
                tangentImpulse: kickback ? 0.34 : 0.24,
                normalKick: kickback ? 12 : 3,
                upKick: kickback ? 42 : 0,
                kickback,
                visualWidth: kickback ? 7 : 5,
                glowBlur: kickback ? 30 : 24
            });
        };

        let leftWallPoints = [
            { x: 84, y: 34 },
            { x: 84, y: 190 },
            { x: 52, y: 318 },
            { x: 52, y: 520 },
            { x: 168, y: 664 },
            { x: 168, y: 842 },
            { x: 70, y: 1008 },
            { x: 70, y: 1190 },
            { x: 192, y: 1350 },
            { x: 192, y: 1524 },
            { x: 82, y: 1688 },
            { x: 82, y: 1886 },
            { x: 178, y: 2026 },
            { x: funnel.mouthLeft, y: funnelTop }
        ];
        let rightWallPoints = [
            { x: w - 84, y: 34 },
            { x: w - 84, y: 190 },
            { x: w - 52, y: 318 },
            { x: w - 52, y: 520 },
            { x: w - 168, y: 664 },
            { x: w - 168, y: 842 },
            { x: w - 70, y: 1008 },
            { x: w - 70, y: 1190 },
            { x: w - 192, y: 1350 },
            { x: w - 192, y: 1524 },
            { x: w - 82, y: 1688 },
            { x: w - 82, y: 1886 },
            { x: w - 178, y: 2026 },
            { x: funnel.mouthRight, y: funnelTop }
        ];
        addRailPath(leftWallPoints, { ...wallStyle, visualWidth: 4.4, hitRadius: 7, glowBlur: 18 });
        addRailPath(rightWallPoints, { ...wallStyle, visualWidth: 4.4, hitRadius: 7, glowBlur: 18 });

        let branchStyle = {
            ...cyanStyle,
            bounce: 0.58,
            hitRadius: 10,
            slide: true,
            slideForce: 9,
            tangentImpulse: 0.22,
            normalKick: 8,
            minOutwardVelocity: 46,
            visualWidth: 6.8,
            glowBlur: 28
        };
        addSegment(w * 0.5, 34, w * 0.5, 314, { ...cyanStyle, bounce: 0.64, hitRadius: 9, minOutwardVelocity: 48, visualWidth: 5.8, glowBlur: 28 });
        addSegment(132, 152, 266, 332, { ...branchStyle, bounce: 0.5, slideForce: 6, normalKick: 7, visualWidth: 5.8 });
        addSegment(w - 132, 152, w - 266, 332, { ...branchStyle, bounce: 0.5, slideForce: 6, normalKick: 7, visualWidth: 5.8 });
        addSegment(w * 0.5, 318, 178, 562, branchStyle);
        addSegment(w * 0.5, 318, w - 178, 562, branchStyle);
        addSegment(224, 604, 136, 806, { ...branchStyle, bounce: 0.46, slideForce: 7, visualWidth: 5.8 });
        addSegment(w - 224, 604, w - 136, 806, { ...branchStyle, bounce: 0.46, slideForce: 7, visualWidth: 5.8 });
        addSegment(w * 0.5, 638, w * 0.5, 932, { ...wallStyle, color: 'rgba(25,247,255,0.84)', glowColor: '#19f7ff', glowBlur: 24, bounce: 0.62, hitRadius: 10, visualWidth: 5.8, minOutwardVelocity: 46 });

        addSlide(156, 812, 282, 884, true);
        addSlide(w - 156, 812, w - 282, 884, true);
        addSlide(106, 1094, 250, 1192);
        addSlide(w - 106, 1094, w - 250, 1192);
        addSlide(248, 1314, 386, 1404, true);
        addSlide(w - 248, 1314, w - 386, 1404, true);
        addSlide(214, 1546, 330, 1636);
        addSlide(w - 214, 1546, w - 330, 1636);
        addSlide(132, 1836, 282, 1914, true);
        addSlide(w - 132, 1836, w - 282, 1914, true);
        addSegment(funnel.mouthLeft, funnelTop, funnel.throatLeft, funnelThroatY, { ...wallStyle, bounce: 0.52, funnel: true, hitRadius: 9, minOutwardVelocity: 30, visualWidth: 6.2 });
        addSegment(funnel.mouthRight, funnelTop, funnel.throatRight, funnelThroatY, { ...wallStyle, bounce: 0.52, funnel: true, hitRadius: 9, minOutwardVelocity: 30, visualWidth: 6.2 });
        addSegment(funnel.throatLeft, funnelThroatY, funnel.pipeLeft, pipeStartY, { ...wallStyle, bounce: 0.44, funnel: true, hitRadius: 8, minOutwardVelocity: 26, visualWidth: 5.6 });
        addSegment(funnel.throatRight, funnelThroatY, funnel.pipeRight, pipeStartY, { ...wallStyle, bounce: 0.44, funnel: true, hitRadius: 8, minOutwardVelocity: 26, visualWidth: 5.6 });
        addSegment(funnel.pipeLeft, pipeStartY, funnel.pipeLeft, pipeBottomY, { ...wallStyle, bounce: 0.4, funnel: true, hitRadius: 8, minOutwardVelocity: 24, visualWidth: 5.6 });
        addSegment(funnel.pipeRight, pipeStartY, funnel.pipeRight, pipeBottomY, { ...wallStyle, bounce: 0.4, funnel: true, hitRadius: 8, minOutwardVelocity: 24, visualWidth: 5.6 });

        segments.push(this.createPinballNeonBar(
            w * 0.5,
            h - 184,
            286,
            -0.2,
            1.76,
            {
                color: '#19f7ff',
                glowColor: '#19f7ff',
                startColor: '#16f7ff',
                midColor: '#ffffff',
                endColor: '#39ffcf',
                bounce: 0.84,
                hitRadius: 22,
                normalKick: 18,
                upKick: 92,
                sideKick: 24,
                tangentImpulse: 0.36,
                visualWidth: 22,
                glowWidth: 50,
                rotorField: true
            }
        ));
        segments.push(this.createPinballNeonBar(208, 1016, 92, 0.48, 1.9, {
            color: '#ff5ecf',
            glowColor: '#ff5ecf',
            startColor: '#ff5ecf',
            midColor: '#ffffff',
            endColor: '#9afcff',
            bounce: 0.68,
            hitRadius: 13,
            normalKick: 10,
            upKick: 28,
            sideKick: 14,
            tangentImpulse: 0.28,
            visualWidth: 9,
            glowWidth: 22,
            rotorField: true
        }));
        segments.push(this.createPinballNeonBar(w - 208, 1126, 94, -0.5, -1.75, {
            color: '#ffe28a',
            glowColor: '#ffe28a',
            startColor: '#ffe28a',
            midColor: '#ffffff',
            endColor: '#5cffef',
            bounce: 0.66,
            hitRadius: 13,
            normalKick: 10,
            upKick: 26,
            sideKick: 14,
            tangentImpulse: 0.28,
            visualWidth: 9,
            glowWidth: 22,
            rotorField: true
        }));
        segments.push(this.createPinballNeonBar(266, 1510, 96, -0.62, 1.58, {
            color: '#5cffef',
            glowColor: '#19f7ff',
            startColor: '#5cffef',
            midColor: '#ffffff',
            endColor: '#cdb4ff',
            bounce: 0.66,
            hitRadius: 13,
            normalKick: 10,
            upKick: 28,
            sideKick: 14,
            tangentImpulse: 0.27,
            visualWidth: 9,
            glowWidth: 22,
            rotorField: true
        }));
        segments.push(this.createPinballNeonBar(w - 272, 1714, 100, 0.58, -1.62, {
            color: '#d4f48f',
            glowColor: '#d4f48f',
            startColor: '#d4f48f',
            midColor: '#ffffff',
            endColor: '#ff5ecf',
            bounce: 0.66,
            hitRadius: 13,
            normalKick: 10,
            upKick: 28,
            sideKick: 14,
            tangentImpulse: 0.27,
            visualWidth: 9,
            glowWidth: 22,
            rotorField: true
        }));

        let corridorAt = (y: number, padding: number = 0) => {
            let leftX = this.pinballRailXAtY(leftWallPoints, y, 42);
            let rightX = this.pinballRailXAtY(rightWallPoints, y, w - 42);
            if (rightX < leftX) {
                let tmp = leftX;
                leftX = rightX;
                rightX = tmp;
            }
            return {
                left: leftX + padding,
                right: rightX - padding
            };
        };
        let addPin = (x: number, y: number, r: number = 4.8, color: string = 'rgba(25,247,255,0.86)') => {
            let bounds = corridorAt(y, r + 10);
            if (x < bounds.left || x > bounds.right) return;
            pins.push({ x, y, r, bounce: 0.56, color });
        };
        let addBumper = (x: number, y: number, r: number, color: string, options: any = {}) => {
            let bounds = corridorAt(y, r + 14);
            let clampedX = this.clamp(x, bounds.left, bounds.right);
            bumpers.push({
                x: clampedX,
                y,
                r,
                bounce: options.power ? 0.86 : 0.64,
                color,
                rimColor: options.rimColor || '#ffffff',
                powerBumper: !!options.power,
                normalKick: options.normalKick || (options.power ? 34 : 14),
                upKick: options.upKick || (options.power ? 24 : 4)
            });
        };

        let pinGrid = [
            { y: 438, xs: [146, 218, 422, 494], r: 4.8 },
            { y: 548, xs: [194, 266, 374, 446], r: 5 },
            { y: 716, xs: [178, 242, 398, 462], r: 4.8 },
            { y: 936, xs: [206, 286, 354, 434], r: 5 },
            { y: 1134, xs: [134, 206, 278, 362, 434, 506], r: 4.7 },
            { y: 1298, xs: [170, 248, 320, 392, 470], r: 4.9 },
            { y: 1508, xs: [232, 296, 344, 408], r: 5 },
            { y: 1708, xs: [142, 214, 286, 354, 426, 498], r: 4.8 },
            { y: 1906, xs: [166, 238, 320, 402, 474], r: 5 }
        ];
        for (let row of pinGrid) {
            for (let x of row.xs) addPin(x, row.y, row.r);
        }

        addBumper(210, 586, 18, '#ff5ecf', { power: true, rimColor: '#ffd8f5', upKick: 30 });
        addBumper(w - 210, 586, 18, '#5cffef', { power: true, rimColor: '#e5fffb', upKick: 30 });
        addBumper(w * 0.5, 792, 15, '#ffe28a', { rimColor: '#fff7cc' });
        addBumper(190, 1012, 16, '#91d7ff', { power: true, rimColor: '#def4ff', normalKick: 30 });
        addBumper(w - 190, 1018, 16, '#cdb4ff', { power: true, rimColor: '#f0e9ff', normalKick: 30 });
        addBumper(264, 1350, 14, '#ffbf8f', { rimColor: '#ffe8d4' });
        addBumper(w - 264, 1404, 14, '#a7e8bd', { rimColor: '#e2f8eb' });
        addBumper(218, 1688, 15, '#ffa5a5', { power: true, rimColor: '#ffe2e2', normalKick: 28 });
        addBumper(w - 218, 1712, 15, '#d4f48f', { power: true, rimColor: '#f0ffd5', normalKick: 28 });

        return {
            width: w,
            height: h,
            frame: {
                left: 12,
                right: w - 12,
                top: 12,
                bottom: h - 18
            },
            left: 30,
            right: w - 30,
            top: 28,
            goalY: h - 46,
            gravity: 218,
            maxSpeed: 500,
            funnel,
            leftWallPoints,
            rightWallPoints,
            dropZones,
            decorBlocks,
            cyanDashes,
            pins,
            bumpers,
            segments,
            wheelSpokes
        };
    }

    public createPinballSpinner(cx: number, cy: number, length: number, angle: number, spin: number, bounce: number = 0.52) {
        return { cx, cy, length, angle, spin, bounce, rotating: true };
    }

    public createPinballNeonBar(cx: number, cy: number, length: number, angle: number, spin: number, options: any = {}) {
        return {
            cx,
            cy,
            length,
            angle,
            spin,
            bounce: options.bounce || 0.62,
            rotating: true,
            neonBar: true,
            hitRadius: options.hitRadius || 19,
            tangentImpulse: options.tangentImpulse || 0.28,
            normalKick: options.normalKick || 16,
            upKick: options.upKick || 54,
            sideKick: options.sideKick || 16,
            color: options.color || '#ff55dc',
            glowColor: options.glowColor || '#b85cff',
            startColor: options.startColor || '#ff2fc7',
            midColor: options.midColor || '#ff78ef',
            endColor: options.endColor || '#8f5cff',
            visualWidth: options.visualWidth || 24,
            glowWidth: options.glowWidth || 42,
            rotorField: !!options.rotorField
        };
    }

    public addPinballWheelSpokes(spokes: any[], cx: number, cy: number, length: number) {
        let spin = 1000 / 760;
        for (let i = 0; i < 5; i++) {
            spokes.push({
                cx,
                cy,
                length,
                angle: i * Math.PI * 2 / 5,
                spin,
                bounce: 0.54,
                rotating: true,
                radial: true,
                hitRadius: 4,
                tangentImpulse: 0.24,
                normalKick: 5
            });
        }
    }

    public pinballSegmentEndpoints(segment: any) {
        if (!segment?.rotating) return segment;
        let elapsed = this.pinballMotionElapsed || 0;
        let angle = (segment.angle || 0) + elapsed * (segment.spin || 0);
        let half = (segment.length || 160) / 2;
        if (segment.radial) {
            let length = segment.length || 160;
            return {
                ...segment,
                x1: segment.cx,
                y1: segment.cy,
                x2: segment.cx + Math.cos(angle) * length,
                y2: segment.cy + Math.sin(angle) * length,
                currentAngle: angle
            };
        }
        let dx = Math.cos(angle) * half;
        let dy = Math.sin(angle) * half;
        return {
            ...segment,
            x1: segment.cx - dx,
            y1: segment.cy - dy,
            x2: segment.cx + dx,
            y2: segment.cy + dy,
            currentAngle: angle
        };
    }

    public pinballMotionScale(world: any) {
        let active = this.pinballBalls.filter((ball: any) => !ball.finished);
        if (!active.length) return 1;
        let leading = active.slice().sort((a: any, b: any) => {
            let aLead = a.y + Math.max(0, a.vy || 0) * 0.2;
            let bLead = b.y + Math.max(0, b.vy || 0) * 0.2;
            return bLead - aLead;
        })[0];
        let progress = this.clamp(((leading?.y || 0) - 180) / Math.max((world?.goalY || 1) - 180, 1), 0, 1);
        let finalSlow = this.clamp((progress - 0.78) / 0.22, 0, 1);
        let tensionSlow = finalSlow * finalSlow * (3 - 2 * finalSlow);
        let elapsed = Math.max(0, performance.now() - (this.pinballStartedAt || performance.now()));
        let total = Math.max(this.pinballBalls.length, active.length, 1);
        let remainingRatio = active.length / total;
        let scarcity = this.clamp((0.72 - remainingRatio) / 0.72, 0, 1);
        let scarcitySlow = scarcity * scarcity * (3 - 2 * scarcity);
        let rushPulse = this.clamp((progress - 0.24) / 0.38, 0, 1) * this.clamp((0.84 - progress) / 0.38, 0, 1);
        let tempo = 0.68 + Math.sin(elapsed * 0.0024) * 0.035 + rushPulse * 0.06;
        return this.clamp(tempo * (1 - tensionSlow * 0.3) * (1 - scarcitySlow * 0.24), 0.5, 0.88);
    }

    public advancePinballWorld(dt: number) {
        let world = this.pinballWorld || this.createPinballWorld();
        this.pinballWorld = world;
        let activeBalls = this.pinballBalls.filter((ball: any) => !ball.finished);
        let frameDt = dt || 0.016;
        let motionScale = this.pinballMotionScale(world);
        this.pinballCurrentMotionScale = motionScale;
        this.pinballMotionElapsed += frameDt * motionScale;
        dt = frameDt * motionScale;

        let elapsedMs = performance.now() - this.pinballStartedAt;
        if (elapsedMs > 90000 && activeBalls.length) {
            this.pushTimedOutPinballBalls(activeBalls, world);
        }

        for (let ball of activeBalls) {
            if ((ball.releaseDelay || 0) > 0) {
                ball.releaseDelay = Math.max(0, (ball.releaseDelay || 0) - frameDt);
                ball.vx *= 0.86;
                ball.vy = 0;
                ball.skillGlow = Math.max(ball.skillGlow || 0, 0.16);
                continue;
            }
            if (!ball.released) {
                ball.released = true;
                ball.vx += (Math.random() - 0.5) * 14;
                ball.vy = Math.max(ball.vy || 0, 16 + Math.random() * 14);
            }
            if (this.pinballSkillEnabled) {
                ball.skillTimer -= dt * (0.36 + ball.weight * 0.04);
                if (ball.skillTimer <= 0) {
                    this.pulsePinballSkill(ball);
                    ball.skillTimer = 4.2 + Math.random() * 4.2;
                }
            }
            ball.skillGlow = Math.max(0, ball.skillGlow - dt * 0.9);
            ball.vy += world.gravity * dt;
            this.applyPinballZoneForces(ball, world, dt);
            ball.vx *= 0.985;
            ball.vy *= 0.993;
            this.limitPinballVelocity(ball, world.maxSpeed);
            ball.x += ball.vx * dt;
            ball.y += ball.vy * dt;
            this.keepPinballBallInsideMap(ball, world);

            if (ball.x < world.left + ball.r) {
                ball.x = world.left + ball.r;
                ball.vx = Math.abs(ball.vx) * 0.44;
            }
            if (ball.x > world.right - ball.r) {
                ball.x = world.right - ball.r;
                ball.vx = -Math.abs(ball.vx) * 0.44;
            }
            if (ball.y < world.top + ball.r) {
                ball.y = world.top + ball.r;
                ball.vy = Math.abs(ball.vy) * 0.32;
            }

            for (let pin of world.pins) this.resolvePinballCircle(ball, pin);
            for (let bumper of world.bumpers) this.resolvePinballCircle(ball, bumper);
            for (let spoke of (world.wheelSpokes || [])) this.resolvePinballSegment(ball, spoke);
            for (let segment of world.segments) this.resolvePinballSegment(ball, segment);
            this.keepPinballBallInsideMap(ball, world);

            if (this.isPinballBallPastOutlet(ball, world)) {
                this.finishPinballBall(ball, true);
            }
        }

        this.resolvePinballBallPairs();

        for (let ball of activeBalls) {
            if (ball.finished) continue;
            if ((ball.releaseDelay || 0) > 0) continue;
            this.keepPinballBallInsideMap(ball, world);
            this.recoverPinballBallIfStuck(ball, dt, world);
            this.keepPinballBallInsideMap(ball, world);
            if (this.isPinballBallPastOutlet(ball, world)) {
                this.finishPinballBall(ball, true);
            }
        }

        if (this.pinballBalls.length && this.pinballResults.length >= this.pinballBalls.length) {
            this.pinballMessage = '모든 공이 골인했어요';
            if (
                !this.hasPinballExitAnimation()
                && Math.abs(this.pinballCameraBounce) < 0.4
                && Math.abs(this.pinballCameraBounceVelocity) < 8
                && Math.abs(this.pinballCameraBounceX) < 0.4
                && Math.abs(this.pinballCameraBounceVelocityX) < 7
            ) {
                this.pinballRunning = false;
            }
        }
    }

    public pinballOutletRange(world: any, radius: number = 0) {
        let funnel = world?.funnel || {};
        let center = Number.isFinite(funnel.pipeLeft) && Number.isFinite(funnel.pipeRight)
            ? (funnel.pipeLeft + funnel.pipeRight) * 0.5
            : (world?.width || this.pinballCanvasWidth) * 0.5;
        let pipeLeft = Number.isFinite(funnel.pipeLeft) ? funnel.pipeLeft : center - 28;
        let pipeRight = Number.isFinite(funnel.pipeRight) ? funnel.pipeRight : center + 28;
        let inset = Math.min(Math.max(radius * 0.55, 6), 14);
        return {
            left: pipeLeft + inset,
            right: pipeRight - inset,
            center
        };
    }

    public isPinballBallInsideOutlet(ball: any, world: any) {
        let range = this.pinballOutletRange(world, ball?.r || 12);
        return ball.x >= range.left && ball.x <= range.right;
    }

    public isPinballBallPastOutlet(ball: any, world: any) {
        if (!ball || ball.finished) return false;
        if (this.shouldDelayPinballFinish(ball, world)) return false;
        return ball.y > world.goalY && this.isPinballBallInsideOutlet(ball, world);
    }

    public pinballMinimumFirstFinishMs(total: number = 0) {
        let size = total || this.pinballBalls.length || this.pinballTotalBalls || 1;
        if (size >= 20) return 9200;
        if (size >= 12) return 7200;
        return 5200;
    }

    public pinballMinimumFinishMs(rank: number = 1, total: number = 0) {
        let size = total || this.pinballBalls.length || this.pinballTotalBalls || 1;
        let base = this.pinballMinimumFirstFinishMs(size);
        let rankDelay = Math.min(Math.max(rank - 1, 0), 18) * (size >= 20 ? 135 : 165);
        return base + rankDelay;
    }

    public shouldDelayPinballFinish(ball: any, world: any) {
        if (!ball || ball.finished) return false;
        if (!this.pinballStartedAt) return false;
        if (!this.isPinballBallInsideOutlet(ball, world)) return false;
        let elapsed = performance.now() - this.pinballStartedAt;
        let nextRank = this.pinballResults.length + 1;
        return elapsed < this.pinballMinimumFinishMs(nextRank, this.pinballBalls.length);
    }

    public pinballRailXAtY(points: any[] = [], y: number = 0, fallback: number = 0) {
        if (!points.length) return fallback;
        let sorted = points.slice().sort((a: any, b: any) => (a.y || 0) - (b.y || 0));
        if (y <= sorted[0].y) return sorted[0].x;
        for (let i = 0; i < sorted.length - 1; i++) {
            let a = sorted[i];
            let b = sorted[i + 1];
            let y1 = a.y || 0;
            let y2 = b.y || 0;
            if (y < y1 || y > y2) continue;
            let progress = this.clamp((y - y1) / Math.max(y2 - y1, 1), 0, 1);
            return (a.x || 0) + ((b.x || 0) - (a.x || 0)) * progress;
        }
        return sorted[sorted.length - 1].x;
    }

    public pinballCorridorBoundsAtY(world: any, y: number, radius: number = 0) {
        if (!world?.leftWallPoints?.length || !world?.rightWallPoints?.length) return null;
        let leftX = this.pinballRailXAtY(world.leftWallPoints, y, world.left || 0);
        let rightX = this.pinballRailXAtY(world.rightWallPoints, y, world.right || world.width || this.pinballCanvasWidth);
        if (!Number.isFinite(leftX) || !Number.isFinite(rightX)) return null;
        if (rightX < leftX) {
            let tmp = leftX;
            leftX = rightX;
            rightX = tmp;
        }
        let padding = radius + 4;
        if (rightX - leftX <= padding * 2) return null;
        return {
            left: leftX + padding,
            right: rightX - padding
        };
    }

    public keepPinballBallInsideMap(ball: any, world: any) {
        if (!ball || ball.finished) return;
        let radius = ball.r || 12;
        let frame = this.pinballWorldFrameBounds(world);
        let left = (world.left || 0) + radius;
        let right = (world.right || world.width || this.pinballCanvasWidth) - radius;
        let top = (world.top || 0) + radius;
        let bottom = frame.bottom - radius;

        if (ball.x < left) {
            ball.x = left;
            ball.vx = Math.abs(ball.vx || 0) * 0.42 + 8;
        } else if (ball.x > right) {
            ball.x = right;
            ball.vx = -Math.abs(ball.vx || 0) * 0.42 - 8;
        }

        if (ball.y < top) {
            ball.y = top;
            ball.vy = Math.abs(ball.vy || 0) * 0.3 + 6;
        }

        if (ball.y > bottom) {
            ball.y = bottom;
            ball.vy = -Math.abs(ball.vy || 0) * 0.3 - 12;
            ball.skillGlow = Math.max(ball.skillGlow || 0, 0.4);
        }

        let funnel = world.funnel || {};
        let corridor = this.pinballCorridorBoundsAtY(world, ball.y, radius);
        let beforeFunnel = !Number.isFinite(funnel.topY) || ball.y < funnel.topY - radius * 0.45;
        if (corridor && beforeFunnel) {
            if (ball.x < corridor.left) {
                ball.x = corridor.left;
                ball.vx = Math.abs(ball.vx || 0) * 0.46 + 16;
                ball.skillGlow = Math.max(ball.skillGlow || 0, 0.26);
            } else if (ball.x > corridor.right) {
                ball.x = corridor.right;
                ball.vx = -Math.abs(ball.vx || 0) * 0.46 - 16;
                ball.skillGlow = Math.max(ball.skillGlow || 0, 0.26);
            }
        }

        let pipeStartY = Number.isFinite(funnel.pipeStartY) ? funnel.pipeStartY : world.goalY - 380;
        let outletRange = this.pinballOutletRange(world, radius);
        let nearGoal = ball.y >= world.goalY - radius;
        let insideOutletBeforePipeClamp = this.isPinballBallInsideOutlet(ball, world);
        if (Number.isFinite(funnel.topY) && ball.y >= funnel.topY - radius * 0.35 && ball.y < pipeStartY) {
            let funnelProgress = this.clamp((ball.y - funnel.topY) / Math.max(pipeStartY - funnel.topY, 1), 0, 1);
            let leftEdge = funnel.mouthLeft + ((funnel.pipeLeft || outletRange.left) - funnel.mouthLeft) * funnelProgress;
            let rightEdge = funnel.mouthRight + ((funnel.pipeRight || outletRange.right) - funnel.mouthRight) * funnelProgress;
            let leftLimit = leftEdge + radius + 2;
            let rightLimit = rightEdge - radius - 2;
            if (ball.x < leftLimit) {
                ball.x = leftLimit;
                ball.vx = Math.abs(ball.vx || 0) * 0.24 + 8;
            } else if (ball.x > rightLimit) {
                ball.x = rightLimit;
                ball.vx = -Math.abs(ball.vx || 0) * 0.24 - 8;
            }
        }

        let delayFinish = this.shouldDelayPinballFinish(ball, world);
        if (nearGoal && (!insideOutletBeforePipeClamp || delayFinish)) {
            ball.y = world.goalY - radius - 1;
            ball.vy = -Math.abs(ball.vy || 0) * 0.28 - (delayFinish ? 22 : 30);
            ball.vx += this.clamp((outletRange.center - ball.x) * 0.08, -48, 48);
            ball.skillGlow = Math.max(ball.skillGlow || 0, delayFinish ? 0.52 : 0.46);
            this.limitPinballVelocity(ball, world.maxSpeed || 300);
            return;
        }

        if (ball.y >= pipeStartY - radius * 0.35 && ball.y < world.goalY + radius) {
            if (ball.x < outletRange.left) {
                ball.x = outletRange.left;
                ball.vx = Math.abs(ball.vx || 0) * 0.24;
            } else if (ball.x > outletRange.right) {
                ball.x = outletRange.right;
                ball.vx = -Math.abs(ball.vx || 0) * 0.24;
            }
        }

        this.limitPinballVelocity(ball, world.maxSpeed || 300);
    }

    public pinballWorldFrameBounds(world: any) {
        let width = world?.width || this.pinballCanvasWidth;
        let height = world?.height || this.pinballWorldHeight;
        return world?.frame || {
            left: 42,
            right: width - 42,
            top: 30,
            bottom: height - 58
        };
    }

    public hasPinballExitAnimation(now: number = performance.now()) {
        return this.pinballBalls.some((ball: any) => ball.exitStart && now - ball.exitStart < (ball.exitDuration || 900));
    }

    public limitPinballVelocity(ball: any, maxSpeed: number = 300) {
        let maxVx = maxSpeed * 0.72;
        let maxVy = maxSpeed;
        ball.vx = this.clamp(ball.vx || 0, -maxVx, maxVx);
        ball.vy = this.clamp(ball.vy || 0, -maxVy * 0.62, maxVy);
        let speed = Math.sqrt(ball.vx * ball.vx + ball.vy * ball.vy);
        if (speed <= maxSpeed || speed <= 0) return;
        let scale = maxSpeed / speed;
        ball.vx *= scale;
        ball.vy *= scale;
    }

    public applyPinballZoneForces(ball: any, world: any, dt: number) {
        for (let zone of (world.dropZones || [])) {
            if (ball.x < zone.x1 || ball.x > zone.x2 || ball.y < zone.y1 || ball.y > zone.y2) continue;
            let progress = this.clamp((ball.y - zone.y1) / Math.max(zone.y2 - zone.y1, 1), 0, 1);
            let pulse = Math.sin(progress * Math.PI);
            let drift = zone.drift || 0;
            if (Number.isFinite(zone.splitCenter)) {
                let distanceFromCenter = Math.abs(ball.x - zone.splitCenter);
                let neutralWidth = zone.neutralWidth || 56;
                let side = ball.x < zone.splitCenter ? -1 : 1;
                if (distanceFromCenter < neutralWidth * 0.5) {
                    side = this.hashText(`${ball.id || ball.label || ''}:${Math.floor(ball.y / 90)}`) % 2 === 0 ? -1 : 1;
                }
                let splitRange = Math.max(neutralWidth, (zone.x2 - zone.x1) * 0.46);
                let splitFalloff = this.clamp(1 - distanceFromCenter / splitRange, 0.22, 1);
                drift += side * (zone.splitForce || 0) * splitFalloff;
            }
            if (zone.swirl) {
                let seed = this.hashText(`${ball.id || ball.label || ''}`) % 360;
                drift += Math.sin((ball.y + seed) * 0.018) * zone.swirl;
            }
            ball.vy += (zone.force || 90) * dt * (0.58 + pulse * 0.22);
            ball.vx += drift * dt * (0.46 + pulse * 0.34);
            ball.skillGlow = Math.max(ball.skillGlow || 0, 0.18 + pulse * 0.18);
        }
    }

    public pinballBallGroupFocus(active: any[], world: any) {
        if (!active.length) return null;
        let focusBalls = active.filter((ball: any) => (ball.releaseDelay || 0) <= 0 || (ball.y || 0) > (world.top || 0) + 120);
        if (!focusBalls.length) focusBalls = active;
        let sumX = 0;
        let sumY = 0;
        let sumWeight = 0;
        let minY = Number.POSITIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        let leading: any = null;
        let leadingY = Number.NEGATIVE_INFINITY;

        for (let ball of focusBalls) {
            let speedLookahead = this.clamp(Math.max(0, ball.vy || 0) * 0.12, 0, 96);
            let weight = this.clamp(1 + Math.max(0, ball.vy || 0) / 1200, 1, 1.45);
            sumX += (ball.x || world.width * 0.5) * weight;
            sumY += ((ball.y || 0) + speedLookahead) * weight;
            sumWeight += weight;
            minY = Math.min(minY, ball.y || 0);
            maxY = Math.max(maxY, ball.y || 0);
            let projectedY = (ball.y || 0) + speedLookahead;
            if (projectedY > leadingY) {
                leadingY = projectedY;
                leading = ball;
            }
        }

        let averageX = sumX / Math.max(sumWeight, 1);
        let averageY = sumY / Math.max(sumWeight, 1);
        let leadBias = this.clamp((Math.max(0, maxY - minY) - 260) / 900, 0, 1);
        let x = averageX + (((leading?.x || averageX) - averageX) * leadBias * 0.42);
        let y = Math.max(averageY, leadingY - 120);
        return {
            id: 'pinball-group-focus',
            x: this.clamp(x, world.left || 0, world.right || world.width || this.pinballCanvasWidth),
            y: this.clamp(y, world.top || 0, world.goalY || world.height || this.pinballWorldHeight),
            spreadY: Math.max(0, maxY - minY),
            count: focusBalls.length
        };
    }

    public updatePinballCamera(dt: number = 0.016) {
        let world = this.pinballWorld || this.createPinballWorld();
        let active = this.pinballBalls.filter((ball: any) => !ball.finished);
        let winnerBall = this.pinballWinner?.ballId
            ? this.pinballBalls.find((ball: any) => ball.id === this.pinballWinner.ballId)
            : null;
        let groupFocus = this.pinballBallGroupFocus(active, world);
        this.pinballFocusBallId = active.length ? '' : (winnerBall?.id || this.pinballFocusBallId || '');
        let trackedFocus = this.pinballBalls.find((ball: any) => ball.id === this.pinballFocusBallId);
        let exitingFocus = this.pinballBalls
            .filter((ball: any) => ball.exitStart && performance.now() - ball.exitStart < (ball.exitDuration || 900))
            .sort((a: any, b: any) => (b.exitStart || 0) - (a.exitStart || 0))[0] || null;
        let winnerFocus = winnerBall
            ? { id: winnerBall.id, x: winnerBall.finishedFocusX || winnerBall.x, y: winnerBall.finishedFocusY || winnerBall.y }
            : null;
        let finishedFocus = trackedFocus?.finished
            ? { id: trackedFocus.id, x: trackedFocus.finishedFocusX || world.width * 0.5, y: trackedFocus.finishedFocusY || world.goalY }
            : null;
        let focus = groupFocus
            || winnerFocus
            || (trackedFocus && !trackedFocus.finished ? trackedFocus : null)
            || (exitingFocus ? { id: exitingFocus.id, x: exitingFocus.finishedFocusX || exitingFocus.x, y: exitingFocus.finishedFocusY || exitingFocus.y } : null)
            || finishedFocus
            || null;
        let desiredFocus = focus
            ? { id: focus.id, x: focus.x || world.width * 0.5, y: focus.y || 0 }
            : null;
        if (desiredFocus && !this.pinballCameraFocusReady) {
            this.pinballCameraFocusX = desiredFocus.x;
            this.pinballCameraFocusY = desiredFocus.y;
            this.pinballCameraFocusReady = true;
        }
        if (desiredFocus) {
            let focusEase = Math.min(1, 1 - Math.pow(0.018, dt));
            this.pinballCameraFocusX += (desiredFocus.x - this.pinballCameraFocusX) * focusEase;
            this.pinballCameraFocusY += (desiredFocus.y - this.pinballCameraFocusY) * focusEase;
        }
        let cameraFocus = desiredFocus
            ? { id: desiredFocus.id, x: this.pinballCameraFocusX, y: this.pinballCameraFocusY }
            : null;
        if (!active.length) {
            let finalScale = this.pinballWinner ? 1.16 : 1;
            this.pinballCameraTargetScale = finalScale;
            let visibleW = this.pinballCanvasWidth / finalScale;
            let visibleH = this.pinballCanvasHeight / finalScale;
            let finalX = cameraFocus ? (cameraFocus.x || world.width * 0.5) - visibleW * 0.5 : (world.width - visibleW) * 0.5;
            this.pinballCameraTargetX = this.clamp(finalX, 0, Math.max(0, world.width - visibleW));
            this.pinballCameraTargetY = this.pinballWinner
                ? this.clamp(cameraFocus ? (cameraFocus.y || world.goalY) - visibleH * 0.56 : world.goalY - visibleH * 0.62, 0, Math.max(0, world.height - visibleH))
                : 0;
        } else {
            if (!this.pinballFocusBallId && focus?.id) this.pinballFocusBallId = focus.id;
            let progress = this.clamp(((cameraFocus?.y || 0) - 140) / Math.max(world.goalY - 140, 1), 0, 1);
            let finishPull = this.clamp((progress - 0.48) / 0.52, 0, 1);
            let zoomProgress = finishPull * finishPull * (3 - 2 * finishPull);
            this.pinballCameraTargetScale = 1 + zoomProgress * 0.24;
            let visibleW = this.pinballCanvasWidth / this.pinballCameraTargetScale;
            let visibleH = this.pinballCanvasHeight / this.pinballCameraTargetScale;
            let followX = (cameraFocus?.x || world.width * 0.5) - visibleW * 0.5;
            let anchor = 0.38 + zoomProgress * 0.12;
            let elapsedSec = Math.max(0, (performance.now() - (this.pinballStartedAt || performance.now())) / 1000);
            let introScroll = this.clamp(
                elapsedSec * 42,
                0,
                Math.max(0, (cameraFocus?.y || 0) - visibleH * 0.24)
            );
            let followY = (cameraFocus?.y || 0) - visibleH * anchor;
            this.pinballCameraTargetX = this.clamp(followX, 0, Math.max(0, world.width - visibleW));
            this.pinballCameraTargetY = this.clamp(Math.max(followY, introScroll), 0, Math.max(0, world.height - visibleH));
        }
        let spring = 44;
        let damping = Math.exp(-9.8 * dt);
        this.pinballCameraVelocityX = (this.pinballCameraVelocityX + (this.pinballCameraTargetX - this.pinballCameraX) * spring * dt) * damping;
        this.pinballCameraVelocityY = (this.pinballCameraVelocityY + (this.pinballCameraTargetY - this.pinballCameraY) * spring * dt) * damping;
        let scaleEase = Math.min(1, 1 - Math.pow(0.055, dt));
        this.pinballCameraX += this.pinballCameraVelocityX * dt;
        this.pinballCameraY += this.pinballCameraVelocityY * dt;
        if (Math.abs(this.pinballCameraTargetX - this.pinballCameraX) < 0.12 && Math.abs(this.pinballCameraVelocityX) < 1.4) {
            this.pinballCameraX = this.pinballCameraTargetX;
            this.pinballCameraVelocityX = 0;
        }
        if (Math.abs(this.pinballCameraTargetY - this.pinballCameraY) < 0.12 && Math.abs(this.pinballCameraVelocityY) < 1.4) {
            this.pinballCameraY = this.pinballCameraTargetY;
            this.pinballCameraVelocityY = 0;
        }
        this.pinballCameraScale += (this.pinballCameraTargetScale - this.pinballCameraScale) * scaleEase;
        this.updatePinballCameraBounce(dt);
        let visibleW = this.pinballCanvasWidth / Math.max(this.pinballCameraScale, 0.001);
        let visibleH = this.pinballCanvasHeight / Math.max(this.pinballCameraScale, 0.001);
        let clampedX = this.clamp(this.pinballCameraX, 0, Math.max(0, world.width - visibleW));
        let clampedY = this.clamp(this.pinballCameraY, 0, Math.max(0, world.height - visibleH));
        if (clampedX !== this.pinballCameraX) this.pinballCameraVelocityX = 0;
        if (clampedY !== this.pinballCameraY) this.pinballCameraVelocityY = 0;
        this.pinballCameraX = clampedX;
        this.pinballCameraY = clampedY;
    }

    public updatePinballCameraBounce(dt: number) {
        if (!this.pinballCameraBounce && !this.pinballCameraBounceVelocity && !this.pinballCameraBounceX && !this.pinballCameraBounceVelocityX) return;
        let spring = -this.pinballCameraBounce * 30;
        let damping = -this.pinballCameraBounceVelocity * 8.4;
        let springX = -this.pinballCameraBounceX * 22;
        let dampingX = -this.pinballCameraBounceVelocityX * 7.2;
        this.pinballCameraBounceVelocityX += (springX + dampingX) * dt;
        this.pinballCameraBounceVelocity += (spring + damping) * dt;
        this.pinballCameraBounceX += this.pinballCameraBounceVelocityX * dt;
        this.pinballCameraBounce += this.pinballCameraBounceVelocity * dt;
        this.pinballCameraBounceX = this.clamp(this.pinballCameraBounceX, -10, 10);
        this.pinballCameraBounce = this.clamp(this.pinballCameraBounce, -18, 14);
        if (Math.abs(this.pinballCameraBounceX) < 0.08 && Math.abs(this.pinballCameraBounceVelocityX) < 2) {
            this.pinballCameraBounceX = 0;
            this.pinballCameraBounceVelocityX = 0;
        }
        if (Math.abs(this.pinballCameraBounce) < 0.08 && Math.abs(this.pinballCameraBounceVelocity) < 2) {
            this.pinballCameraBounce = 0;
            this.pinballCameraBounceVelocity = 0;
        }
    }

    public pulsePinballCameraImpact(strength: number = 0.35) {
        let now = performance.now();
        if (now - (this.pinballLastCameraImpactAt || 0) < 24) return;
        if (strength < 0.26) return;
        this.pinballLastCameraImpactAt = now;
        let amount = this.clamp(strength, 0.22, 0.78);
        this.pinballCameraBounceVelocity = this.clamp(this.pinballCameraBounceVelocity - (5 + amount * 15), -58, 38);
        this.pinballCameraBounceVelocityX = this.clamp(this.pinballCameraBounceVelocityX + (Math.random() - 0.5) * amount * 9, -18, 18);
    }

    public resolvePinballCircle(ball: any, obstacle: any) {
        let dx = ball.x - obstacle.x;
        let dy = ball.y - obstacle.y;
        let distance = Math.sqrt(dx * dx + dy * dy);
        let minDistance = ball.r + obstacle.r;
        if (distance >= minDistance) return;
        if (distance < 0.001) {
            dx = ball.vx || (ball.x < this.pinballCanvasWidth / 2 ? -1 : 1);
            dy = ball.vy || 1;
            let fallbackLength = Math.sqrt(dx * dx + dy * dy) || 1;
            dx /= fallbackLength;
            dy /= fallbackLength;
            distance = 1;
        }

        let nx = dx / distance;
        let ny = dy / distance;
        let overlap = minDistance - distance;
        ball.x += nx * overlap;
        ball.y += ny * overlap;
        let velocity = ball.vx * nx + ball.vy * ny;
        if (velocity < 0) {
            let bounce = obstacle.bounce || 0.5;
            ball.vx -= (1 + bounce) * velocity * nx;
            ball.vy -= (1 + bounce) * velocity * ny;
            this.pulsePinballCameraImpact(Math.abs(velocity) / 420);
        }
        if (obstacle.powerBumper) {
            let impact = this.clamp((Math.abs(velocity) + Math.sqrt(ball.vx * ball.vx + ball.vy * ball.vy)) / 420, 0.28, 1);
            let kick = (obstacle.normalKick || 24) * impact;
            ball.vx += nx * kick;
            ball.vy += ny * kick - (obstacle.upKick || 0) * impact;
            ball.skillGlow = Math.max(ball.skillGlow || 0, 0.62);
            obstacle.lastHitAt = performance.now();
        }
        ball.vx += nx * 2.4;
        ball.vy += ny * 2.4;
        this.limitPinballVelocity(ball, (this.pinballWorld?.maxSpeed || 300));
    }

    public resolvePinballSegment(ball: any, segment: any) {
        let current = this.pinballSegmentEndpoints(segment);
        let vx = current.x2 - current.x1;
        let vy = current.y2 - current.y1;
        let lengthSq = vx * vx + vy * vy || 1;
        let segmentLength = Math.sqrt(lengthSq) || 1;
        let t = ((ball.x - current.x1) * vx + (ball.y - current.y1) * vy) / lengthSq;
        t = this.clamp(t, 0, 1);
        let closestX = current.x1 + vx * t;
        let closestY = current.y1 + vy * t;
        let dx = ball.x - closestX;
        let dy = ball.y - closestY;
        let distance = Math.sqrt(dx * dx + dy * dy);
        let hitRadius = segment.hitRadius || 2;
        if (distance >= ball.r + hitRadius) return;
        if (distance < 0.001) {
            dx = -vy / segmentLength;
            dy = vx / segmentLength;
            if (dy < 0) {
                dx *= -1;
                dy *= -1;
            }
            distance = 1;
        }

        let nx = dx / distance;
        let ny = dy / distance;
        let overlap = ball.r + hitRadius - distance;
        ball.x += nx * overlap;
        ball.y += ny * overlap;
        let surfaceVx = 0;
        let surfaceVy = 0;
        if (segment.rotating) {
            let rx = closestX - segment.cx;
            let ry = closestY - segment.cy;
            let spinVelocity = (segment.spin || 0) * (this.pinballCurrentMotionScale || 1);
            surfaceVx = -ry * spinVelocity;
            surfaceVy = rx * spinVelocity;
        }
        let velocity = (ball.vx - surfaceVx) * nx + (ball.vy - surfaceVy) * ny;
        if (velocity < 0) {
            let bounce = segment.bounce || 0.46;
            ball.vx -= (1 + bounce) * velocity * nx;
            ball.vy -= (1 + bounce) * velocity * ny;
            this.pulsePinballCameraImpact(Math.abs(velocity) / 430);
        }

        let outwardVelocity = (ball.vx - surfaceVx) * nx + (ball.vy - surfaceVy) * ny;
        let minOutwardVelocity = segment.minOutwardVelocity;
        if (!Number.isFinite(minOutwardVelocity)) {
            minOutwardVelocity = segment.rotating ? 54 : segment.slide ? 42 : segment.funnel ? 24 : segment.wall ? 32 : 26;
        }
        if (overlap > Math.max(0.45, ball.r * 0.045) && outwardVelocity < minOutwardVelocity) {
            let unstickImpulse = (minOutwardVelocity - outwardVelocity) * (segment.rotating ? 0.72 : 1);
            ball.vx += nx * unstickImpulse;
            ball.vy += ny * unstickImpulse;
            this.pulsePinballCameraImpact(unstickImpulse / 520);
        }
        if (segment.rotating) {
            let impulse = segment.tangentImpulse || 0.24;
            let normalKick = segment.normalKick || 0;
            ball.vx += surfaceVx * impulse + nx * normalKick;
            ball.vy += surfaceVy * impulse + ny * normalKick;
            if (segment.neonBar) {
                let impact = this.clamp(Math.abs(velocity) / 300, 0.25, 0.9);
                let side = ball.x < (segment.cx || this.pinballCanvasWidth * 0.5) ? -1 : 1;
                ball.vy -= (segment.upKick || 0) * impact;
                ball.vx += side * (segment.sideKick || 0) * impact;
                ball.skillGlow = Math.max(ball.skillGlow || 0, 0.58);
            }
        }
        if (segment.slide) {
            let tx = vx / segmentLength;
            let ty = vy / segmentLength;
            if (ty < 0) {
                tx *= -1;
                ty *= -1;
            }
            let slideForce = segment.slideForce || 12;
            let slideBoost = slideForce + Math.max(0, ball.vy) * 0.008;
            ball.vx += tx * slideBoost;
            ball.vy += ty * slideBoost * 0.58;
            if (segment.kickback && Math.abs(velocity) > 28) {
                let side = ball.x < this.pinballCanvasWidth * 0.5 ? 1 : -1;
                ball.vy -= segment.upKick || 42;
                ball.vx += side * (18 + Math.min(34, Math.abs(velocity) * 0.1));
                ball.skillGlow = Math.max(ball.skillGlow || 0, 0.5);
            }
        }
        this.limitPinballVelocity(ball, (this.pinballWorld?.maxSpeed || 300));
    }

    public resolvePinballBallPairs() {
        let active = this.pinballBalls.filter((ball: any) => !ball.finished && (ball.releaseDelay || 0) <= 0);
        if (active.length < 2) return;

        let cellSize = active.reduce((size: number, ball: any) => Math.max(size, (ball.r || 10) * 2 + 6), 28);
        let buckets = new Map<string, any[]>();
        for (let ball of active) {
            let cellX = Math.floor(ball.x / cellSize);
            let cellY = Math.floor(ball.y / cellSize);
            let key = `${cellX}:${cellY}`;
            if (!buckets.has(key)) buckets.set(key, []);
            buckets.get(key)?.push(ball);
        }

        let checked = new Set<string>();
        for (let [key, bucket] of buckets) {
            let parts = key.split(':');
            let cellX = parseInt(parts[0], 10);
            let cellY = parseInt(parts[1], 10);
            for (let offsetY = -1; offsetY <= 1; offsetY++) {
                for (let offsetX = -1; offsetX <= 1; offsetX++) {
                    let other = buckets.get(`${cellX + offsetX}:${cellY + offsetY}`);
                    if (!other) continue;
                    for (let a of bucket) {
                        for (let b of other) {
                            if (a === b) continue;
                            let pairKey = a.id < b.id ? `${a.id}|${b.id}` : `${b.id}|${a.id}`;
                            if (checked.has(pairKey)) continue;
                            checked.add(pairKey);
                            this.resolvePinballBallPair(a, b);
                        }
                    }
                }
            }
        }
    }

    public resolvePinballBallPair(a: any, b: any) {
        let dx = b.x - a.x;
        let dy = b.y - a.y;
        let distance = Math.sqrt(dx * dx + dy * dy);
        let minDistance = a.r + b.r + 0.5;
        if (distance >= minDistance) return;
        if (distance < 0.001) {
            dx = a.id < b.id ? 1 : -1;
            dy = 0.5;
            let fallbackLength = Math.sqrt(dx * dx + dy * dy) || 1;
            dx /= fallbackLength;
            dy /= fallbackLength;
            distance = 1;
        }

        let nx = dx / distance;
        let ny = dy / distance;
        let overlap = (minDistance - distance) * 0.46;
        a.x -= nx * overlap;
        a.y -= ny * overlap;
        b.x += nx * overlap;
        b.y += ny * overlap;

        let tx = -ny;
        let ty = nx;
        let dpTanA = a.vx * tx + a.vy * ty;
        let dpTanB = b.vx * tx + b.vy * ty;
        let dpNormA = a.vx * nx + a.vy * ny;
        let dpNormB = b.vx * nx + b.vy * ny;
        let restitution = 0.52;
        a.vx = tx * dpTanA + nx * dpNormB * restitution;
        a.vy = ty * dpTanA + ny * dpNormB * restitution;
        b.vx = tx * dpTanB + nx * dpNormA * restitution;
        b.vy = ty * dpTanB + ny * dpNormA * restitution;
        let world = this.pinballWorld || this.createPinballWorld();
        this.limitPinballVelocity(a, (world.maxSpeed || 300) * 0.9);
        this.limitPinballVelocity(b, (world.maxSpeed || 300) * 0.9);
        this.keepPinballBallInsideMap(a, world);
        this.keepPinballBallInsideMap(b, world);
    }

    public recoverPinballBallIfStuck(ball: any, dt: number, world: any) {
        if (!ball || ball.finished) return;
        if ((ball.releaseDelay || 0) > 0 || performance.now() - this.pinballStartedAt < 2400) return;

        if (typeof ball.lastProgressX !== 'number' || typeof ball.lastProgressY !== 'number' || (!ball.lastProgressX && !ball.lastProgressY)) {
            ball.lastProgressX = ball.x;
            ball.lastProgressY = ball.y;
            ball.stuckTimer = 0;
            return;
        }

        let speed = Math.sqrt(ball.vx * ball.vx + ball.vy * ball.vy);
        let downProgress = ball.y - ball.lastProgressY;
        let progressThreshold = Math.max(18, ball.r * 1.4);

        if (downProgress > progressThreshold || ball.y < ball.lastProgressY - progressThreshold * 1.4 || ball.vy > 96 || speed > 150) {
            ball.lastProgressX = ball.x;
            ball.lastProgressY = ball.y;
            ball.stuckTimer = 0;
            return;
        }

        let trapped = speed < 46 || Math.abs(downProgress) < progressThreshold * 0.38 || ball.vy < 18;
        if (!trapped) {
            ball.stuckTimer = Math.max(0, (ball.stuckTimer || 0) - dt * 0.5);
            return;
        }

        ball.stuckTimer = (ball.stuckTimer || 0) + dt;
        let threshold = ball.rescueCount ? 1.25 : 1.8;
        if (ball.stuckTimer < threshold) return;

        this.rescuePinballBall(ball, world);
    }

    public rescuePinballBall(ball: any, world: any) {
        let rescueCount = (ball.rescueCount || 0) + 1;
        ball.rescueCount = rescueCount;

        let direction = ball.x < world.left + 92 ? 1 : ball.x > world.right - 92 ? -1 : (rescueCount % 2 === 0 ? -1 : 1);
        let spot = rescueCount >= 2 ? this.findPinballOpenSpot(ball, world, direction) : null;
        if (spot) {
            ball.x = spot.x;
            ball.y = spot.y;
        } else {
            ball.x = this.clamp(ball.x + direction * Math.max(12, ball.r + 7), world.left + ball.r + 2, world.right - ball.r - 2);
            ball.y = Math.min(world.goalY - ball.r - 8, ball.y + Math.min(44, 16 + rescueCount * 6));
        }

        let boost = Math.min(5, rescueCount);
        ball.vx = direction * (54 + Math.random() * 34 + boost * 10);
        ball.vy = Math.max(ball.vy, 96 + boost * 18);
        ball.skillGlow = Math.max(ball.skillGlow || 0, 0.58);
        ball.stuckTimer = 0;
        ball.lastProgressX = ball.x;
        ball.lastProgressY = ball.y;
        this.limitPinballVelocity(ball, world.maxSpeed || 360);
    }

    public pushTimedOutPinballBalls(activeBalls: any[], world: any) {
        let now = performance.now();
        let outletRange = this.pinballOutletRange(world, 12);
        for (let ball of activeBalls) {
            if (ball.finished) continue;
            if (!ball.timeoutBoostedAt || now - ball.timeoutBoostedAt > 1200) {
                this.rescuePinballBall(ball, world);
                ball.timeoutBoostedAt = now;
            }
            outletRange = this.pinballOutletRange(world, ball.r || 12);
            let centerPull = this.clamp((outletRange.center - ball.x) * 0.08, -44, 44);
            ball.vy = Math.max(ball.vy || 0, (world.maxSpeed || 300) * 0.58);
            ball.vx += centerPull;
            if (ball.y > (world.funnel?.throatY || world.goalY) - 260) {
                ball.vx += this.clamp((outletRange.center - ball.x) * 0.14, -70, 70);
            }
            ball.skillGlow = Math.max(ball.skillGlow || 0, 0.36);
            this.keepPinballBallInsideMap(ball, world);
        }
    }

    public findPinballOpenSpot(ball: any, world: any, direction: number) {
        let radius = ball.r || 12;
        let lateralOffsets = [0, direction * 38, -direction * 38, direction * 76, -direction * 76, direction * 118, -direction * 118];
        let verticalOffsets = [28, 58, 94, 136, 184];

        for (let dy of verticalOffsets) {
            for (let dx of lateralOffsets) {
                let x = this.clamp(ball.x + dx, world.left + radius + 4, world.right - radius - 4);
                let y = Math.min(world.goalY - radius - 12, ball.y + dy);
                if (this.isPinballSpotClear(x, y, radius, world, ball)) {
                    return { x, y };
                }
            }
        }
        return null;
    }

    public isPinballSpotClear(x: number, y: number, radius: number, world: any, ignoreBall: any = null) {
        if (x < world.left + radius || x > world.right - radius || y < world.top + radius || y > world.goalY - radius) return false;

        for (let obstacle of [...world.pins, ...world.bumpers]) {
            let dx = x - obstacle.x;
            let dy = y - obstacle.y;
            if (Math.sqrt(dx * dx + dy * dy) < radius + obstacle.r + 8) return false;
        }

        for (let segment of [...(world.wheelSpokes || []), ...world.segments]) {
            let distance = this.pinballPointToSegmentDistance(x, y, segment);
            if (distance < radius + (segment.hitRadius || 3) + 9) return false;
        }

        for (let other of this.pinballBalls) {
            if (other === ignoreBall || other.finished) continue;
            let dx = x - other.x;
            let dy = y - other.y;
            if (Math.sqrt(dx * dx + dy * dy) < radius + other.r + 5) return false;
        }

        return true;
    }

    public pinballPointToSegmentDistance(x: number, y: number, segment: any) {
        let current = this.pinballSegmentEndpoints(segment);
        let vx = current.x2 - current.x1;
        let vy = current.y2 - current.y1;
        let lengthSq = vx * vx + vy * vy || 1;
        let t = ((x - current.x1) * vx + (y - current.y1) * vy) / lengthSq;
        t = this.clamp(t, 0, 1);
        let closestX = current.x1 + vx * t;
        let closestY = current.y1 + vy * t;
        let dx = x - closestX;
        let dy = y - closestY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    public pulsePinballSkill(ball: any) {
        ball.skillGlow = 1;
        for (let other of this.pinballBalls) {
            if (other === ball || other.finished || (other.releaseDelay || 0) > 0) continue;
            let dx = other.x - ball.x;
            let dy = other.y - ball.y;
            let distance = Math.sqrt(dx * dx + dy * dy) || 0.001;
            if (distance > 74) continue;
            let force = (1 - distance / 74) * (18 + ball.weight * 2);
            other.vx += dx / distance * force;
            other.vy += dy / distance * force * 0.16;
            this.limitPinballVelocity(other, (this.pinballWorld?.maxSpeed || 300));
        }
    }

    public finishPinballBall(ball: any, fromOutlet: boolean = false) {
        if (ball.finished) return;
        let rank = this.pinballResults.length + 1;
        let world = this.pinballWorld || this.createPinballWorld();
        if (!fromOutlet && !this.isPinballBallPastOutlet(ball, world)) {
            this.keepPinballBallInsideMap(ball, world);
            return;
        }
        let outletRange = this.pinballOutletRange(world, ball.r || 12);
        let frame = this.pinballWorldFrameBounds(world);
        ball.finishedFocusX = this.clamp(ball.x, outletRange.left, outletRange.right);
        ball.finishedFocusY = this.clamp(ball.y, world.goalY - (ball.r || 12) * 0.3, frame.bottom - (ball.r || 12) - 18);
        ball.exitStart = performance.now();
        ball.exitDuration = 760;
        ball.exitVx = 0;
        ball.exitVy = this.clamp(frame.bottom - (ball.r || 12) - 10 - ball.finishedFocusY, 28, 72);
        ball.finished = true;
        ball.rank = rank;
        ball.vx = 0;
        ball.vy = 0;
        ball.x = ball.finishedFocusX;
        ball.y = ball.finishedFocusY;
        let sideKick = this.clamp((world.width * 0.5 - ball.finishedFocusX) / (world.width * 0.5), -1, 1);
        this.pinballCameraBounceVelocityX = this.clamp(this.pinballCameraBounceVelocityX + sideKick * 26, -76, 76);
        this.pinballCameraBounceVelocity = Math.max(this.pinballCameraBounceVelocity - 48, -130);
        this.pinballCameraBounceX = this.clamp(this.pinballCameraBounceX + sideKick * 0.9, -4, 4);
        this.pinballCameraBounce = Math.max(this.pinballCameraBounce - 1.4, -8);

        let resultRow = {
            ballId: ball.id,
            label: ball.label,
            displayLabel: ball.displayLabel,
            rank: rank,
            color: ball.color,
            weight: ball.weight
        };
        this.pinballResults.push(resultRow);

        let targetRank = this.pinballTargetRank(this.pinballBalls.length);
        if (!this.pinballWinner && rank >= targetRank) {
            this.pinballWinner = this.pinballResults[targetRank - 1] || resultRow;
            this.pinballWinnerAnnouncedAt = performance.now();
            this.pinballWinnerBurstSeed = this.randomInt(100000);
            this.result = this.createPinballSharedResult(this.selectedTest, this.pinballResults, this.pinballWinner.label, this.pinballWinner.rank);
            this.pinballMessage = `${this.pinballWinner.label} 당첨`;
            this.replaceCurrentUrlWithShareLink();
        }

        this.schedulePinballRender();
    }

    public finishRemainingPinballBalls() {
        let world = this.pinballWorld || this.createPinballWorld();
        let remaining = this.pinballBalls
            .filter((ball: any) => !ball.finished)
            .sort((a: any, b: any) => b.y - a.y);
        for (let index = 0; index < remaining.length; index++) {
            let ball = remaining[index];
            let outletRange = this.pinballOutletRange(world, ball.r || 12);
            let stagger = ((index % 3) - 1) * Math.min(8, Math.max(0, (outletRange.right - outletRange.left) * 0.28));
            let targetX = this.clamp(outletRange.center + stagger, outletRange.left, outletRange.right);
            ball.x = this.clamp(ball.x + this.clamp(targetX - ball.x, -42, 42), world.left + ball.r, world.right - ball.r);
            ball.vx = this.clamp((targetX - ball.x) * 0.3, -92, 92);
            ball.vy = Math.max(ball.vy || 0, (world.maxSpeed || 300) * 0.52);
            ball.skillGlow = Math.max(ball.skillGlow || 0, 0.5);
            this.keepPinballBallInsideMap(ball, world);
        }
        this.pinballMessage = '남은 공을 토출구로 유도하고 있어요';
    }

    public schedulePinballRender() {
        if (this.pinballRenderQueued) return;
        this.pinballRenderQueued = true;
        let now = performance.now();
        let delay = this.pinballRunning ? Math.max(0, 120 - (now - this.pinballLastPanelRenderAt)) : 0;
        setTimeout(async () => {
            this.pinballRenderQueued = false;
            this.pinballLastPanelRenderAt = performance.now();
            await this.service.render();
            this.drawPinballBoard();
        }, delay);
    }

    public drawPinballBoard() {
        let canvas = document.getElementById('pinball-canvas') as HTMLCanvasElement;
        if (!canvas) return;
        let ctx = canvas.getContext('2d');
        if (!ctx) return;
        let w = this.pinballCanvasWidth;
        let h = this.pinballCanvasHeight;
        if (canvas.width !== w) canvas.width = w;
        if (canvas.height !== h) canvas.height = h;
        let world = this.pinballWorld || this.createPinballWorld();
        let map = this.pinballSelectedMap();
        if (!this.pinballBalls.length && this.pinballResults.length) {
            this.restorePinballResultState(this.pinballResults);
            world = this.pinballWorld || world;
        }
        let cameraScale = Math.max(1, this.pinballCameraScale || 1);
        let cameraX = this.clamp(this.pinballCameraX || 0, 0, Math.max(0, world.width - w / cameraScale));
        let cameraY = this.clamp(this.pinballCameraY || 0, 0, Math.max(0, world.height - h / cameraScale));
        let viewPad = 140 / cameraScale;
        let visibleLeft = cameraX - viewPad;
        let visibleRight = cameraX + w / cameraScale + viewPad;
        let visibleTop = cameraY - viewPad;
        let visibleBottom = cameraY + h / cameraScale + viewPad;

        ctx.clearRect(0, 0, w, h);
        ctx.fillStyle = '#020205';
        ctx.fillRect(0, 0, w, h);

        ctx.save();
        ctx.translate(this.pinballCameraBounceX || 0, this.pinballCameraBounce || 0);

        ctx.save();
        ctx.globalAlpha = 0.06;
        ctx.strokeStyle = 'rgba(25,247,255,0.16)';
        ctx.lineWidth = 1;
        for (let x = -120; x < w + 160; x += 110) {
            ctx.beginPath();
            ctx.moveTo(x - cameraX * 0.04, 0);
            ctx.lineTo(x + 70 - cameraX * 0.04, h);
            ctx.stroke();
        }
        ctx.restore();

        ctx.save();
        ctx.shadowColor = map.accent;
        ctx.shadowBlur = 16;
        this.drawRoundedRect(ctx, 8, 8, w - 16, h - 16, 0, 'rgba(0,0,0,0.82)', 'rgba(25,247,255,0.24)', 1.2);
        ctx.shadowBlur = 0;
        ctx.restore();

        ctx.save();
        this.clipPinballMapFrame(ctx, w, h);
        this.applyPinballCameraTransform(ctx, cameraX, cameraY, cameraScale);
        ctx.globalAlpha = 0.5;
        this.drawRoundedRect(ctx, 12, 12, w - 24, world.height - 28, 0, 'rgba(255,255,255,0.015)', 'rgba(255,255,255,0.08)', 1.2);
        ctx.restore();

        ctx.save();
        this.clipPinballMapFrame(ctx, w, h);
        this.applyPinballCameraTransform(ctx, cameraX, cameraY, cameraScale);
        this.drawPinballTowerDepth(ctx, world, map, visibleTop, visibleBottom);
        this.drawPinballDropZones(ctx, world, map, visibleTop, visibleBottom);
        this.drawPinballFunnel(ctx, world, map, visibleTop, visibleBottom);

        ctx.lineCap = 'round';
        for (let segment of world.segments) {
            if (segment.hidden) continue;
            let current = this.pinballSegmentEndpoints(segment);
            let minX = Math.min(current.x1, current.x2);
            let maxX = Math.max(current.x1, current.x2);
            let minY = Math.min(current.y1, current.y2);
            let maxY = Math.max(current.y1, current.y2);
            if (maxY < visibleTop || minY > visibleBottom || maxX < visibleLeft || minX > visibleRight) continue;
            if (segment.neonBar) {
                this.drawPinballNeonBarSegment(ctx, current, segment);
                continue;
            }
            ctx.strokeStyle = segment.color || (segment.rotating
                ? 'rgba(255,255,255,0.84)'
                : segment.funnel ? 'rgba(255,255,255,0.94)' : 'rgba(255,255,255,0.68)');
            ctx.lineWidth = segment.visualWidth || (segment.slide ? (segment.kickback ? 5 : 3.5) : segment.rotating ? 4 : segment.funnel ? 3 : 2);
            if (segment.funnel || segment.slide || segment.wall) {
                ctx.shadowColor = segment.glowColor || map.accent;
                ctx.shadowBlur = segment.glowBlur || (segment.kickback ? 18 : 12);
            } else {
                ctx.shadowBlur = 0;
            }
            ctx.beginPath();
            ctx.moveTo(current.x1, current.y1);
            ctx.lineTo(current.x2, current.y2);
            ctx.stroke();
            ctx.shadowBlur = 0;
            if (segment.rotating) {
                ctx.beginPath();
                ctx.arc(segment.cx, segment.cy, 8, 0, Math.PI * 2);
                ctx.fillStyle = map.accent;
                ctx.fill();
                ctx.strokeStyle = 'rgba(255,255,255,0.72)';
                ctx.lineWidth = 2;
                ctx.stroke();
            }
        }
        ctx.lineCap = 'butt';

        for (let pin of world.pins) {
            if (pin.y + pin.r < visibleTop || pin.y - pin.r > visibleBottom || pin.x + pin.r < visibleLeft || pin.x - pin.r > visibleRight) continue;
            ctx.save();
            ctx.beginPath();
            ctx.arc(pin.x, pin.y, pin.r, 0, Math.PI * 2);
            let pinGradient = ctx.createRadialGradient(pin.x - pin.r * 0.28, pin.y - pin.r * 0.32, 1, pin.x, pin.y, pin.r);
            pinGradient.addColorStop(0, 'rgba(255,255,255,0.96)');
            pinGradient.addColorStop(0.62, pin.color);
            pinGradient.addColorStop(1, 'rgba(255,255,255,0.46)');
            ctx.shadowColor = 'rgba(255,255,255,0.22)';
            ctx.shadowBlur = 7;
            ctx.fillStyle = pinGradient;
            ctx.fill();
            ctx.shadowBlur = 0;
            ctx.strokeStyle = 'rgba(255,255,255,0.36)';
            ctx.lineWidth = 1.5;
            ctx.stroke();
            ctx.restore();
        }

        for (let bumper of world.bumpers) {
            if (bumper.y + bumper.r < visibleTop || bumper.y - bumper.r > visibleBottom || bumper.x + bumper.r < visibleLeft || bumper.x - bumper.r > visibleRight) continue;
            ctx.save();
            if (bumper.powerBumper) {
                let hitPulse = bumper.lastHitAt ? this.clamp(1 - (performance.now() - bumper.lastHitAt) / 420, 0, 1) : 0;
                ctx.save();
                ctx.globalCompositeOperation = 'lighter';
                ctx.globalAlpha = 0.46 + hitPulse * 0.34;
                ctx.strokeStyle = this.pinballSoftGlowColor(bumper.rimColor || bumper.color, 0.62);
                ctx.lineWidth = 9 + hitPulse * 5;
                ctx.shadowColor = bumper.rimColor || bumper.color;
                ctx.shadowBlur = 20 + hitPulse * 20;
                ctx.beginPath();
                ctx.arc(bumper.x, bumper.y, bumper.r + 10 + hitPulse * 12, 0, Math.PI * 2);
                ctx.stroke();
                ctx.restore();
            }
            ctx.beginPath();
            ctx.arc(bumper.x, bumper.y, bumper.r, 0, Math.PI * 2);
            let bumperGradient = ctx.createRadialGradient(bumper.x - bumper.r * 0.32, bumper.y - bumper.r * 0.38, bumper.r * 0.08, bumper.x, bumper.y, bumper.r);
            bumperGradient.addColorStop(0, 'rgba(255,255,255,0.72)');
            bumperGradient.addColorStop(0.42, bumper.color);
            bumperGradient.addColorStop(1, this.pinballShadeColor(bumper.color, -0.18));
            ctx.shadowColor = this.pinballSoftGlowColor(bumper.color, 0.22);
            ctx.shadowBlur = 18;
            ctx.fillStyle = bumperGradient;
            ctx.fill();
            ctx.shadowBlur = 0;
            ctx.strokeStyle = bumper.rimColor || 'rgba(255,255,255,0.72)';
            ctx.lineWidth = bumper.powerBumper ? 6 : 5;
            ctx.stroke();
            if (bumper.powerBumper) {
                ctx.beginPath();
                ctx.arc(bumper.x, bumper.y, bumper.r * 0.56, 0, Math.PI * 2);
                ctx.strokeStyle = 'rgba(255,255,255,0.34)';
                ctx.lineWidth = 2.5;
                ctx.stroke();
            }
            ctx.beginPath();
            ctx.arc(bumper.x - bumper.r * 0.25, bumper.y - bumper.r * 0.25, bumper.r * 0.18, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(255,255,255,0.52)';
            ctx.fill();
            ctx.restore();
        }

        if (this.pinballMap === 'wheel') {
            for (let spoke of (world.wheelSpokes || [])) {
                let current = this.pinballSegmentEndpoints(spoke);
                let minX = Math.min(current.x1, current.x2);
                let maxX = Math.max(current.x1, current.x2);
                let minY = Math.min(current.y1, current.y2);
                let maxY = Math.max(current.y1, current.y2);
                if (maxY < visibleTop || minY > visibleBottom || maxX < visibleLeft || minX > visibleRight) continue;
                ctx.save();
                ctx.strokeStyle = 'rgba(255,255,255,0.58)';
                ctx.lineWidth = 2.4;
                ctx.lineCap = 'round';
                ctx.beginPath();
                ctx.moveTo(current.x1, current.y1);
                ctx.lineTo(current.x2, current.y2);
                ctx.stroke();
                ctx.restore();
            }
        }

        ctx.restore();

        ctx.save();
        this.clipPinballMapFrame(ctx, w, h);
        this.applyPinballCameraTransform(ctx, cameraX, cameraY, cameraScale);
        let now = performance.now();
        let renderedBallLabels: any[] = [];
        let frame = this.pinballWorldFrameBounds(world);
        for (let ball of this.pinballBalls) {
            let exitProgress = ball.exitStart ? this.clamp((now - ball.exitStart) / (ball.exitDuration || 900), 0, 1) : 0;
            if (ball.finished && !ball.exitStart) continue;
            if (ball.finished && exitProgress >= 1) continue;
            let renderR = ball.r * (ball.finished ? (1 - exitProgress * 0.28) : 1);
            let renderX = ball.finished
                ? this.clamp(ball.x + (ball.exitVx || 0) * exitProgress, frame.left + renderR, frame.right - renderR)
                : ball.x;
            let renderY = ball.finished
                ? this.clamp(ball.y + (ball.exitVy || 0) * exitProgress, frame.top + renderR, frame.bottom - renderR)
                : ball.y;
            if (renderY + renderR < visibleTop || renderY - renderR > visibleBottom || renderX + renderR < visibleLeft || renderX - renderR > visibleRight) continue;
            ctx.save();
            let baseAlpha = 1;
            if (ball.finished) {
                baseAlpha = Math.max(0, 1 - this.clamp((exitProgress - 0.48) / 0.52, 0, 1));
                ctx.globalAlpha = baseAlpha;
            }
            let glow = this.clamp(0.2 + (ball.skillGlow || 0) * 0.36, 0.18, 0.56);
            let glowRadius = renderR * (2.05 + (ball.skillGlow || 0) * 0.7);
            ctx.save();
            ctx.globalCompositeOperation = 'lighter';
            ctx.globalAlpha = baseAlpha;
            let glowGradient = ctx.createRadialGradient(renderX, renderY, renderR * 0.62, renderX, renderY, glowRadius);
            glowGradient.addColorStop(0, this.pinballSoftGlowColor(ball.color, glow * 0.28));
            glowGradient.addColorStop(0.5, this.pinballSoftGlowColor(ball.color, glow * 0.12));
            glowGradient.addColorStop(1, this.pinballSoftGlowColor(ball.color, 0));
            ctx.fillStyle = glowGradient;
            ctx.fillRect(renderX - glowRadius, renderY - glowRadius, glowRadius * 2, glowRadius * 2);
            ctx.restore();
            ctx.beginPath();
            ctx.arc(renderX, renderY, renderR, 0, Math.PI * 2);
            ctx.shadowColor = this.pinballSoftGlowColor(ball.color, 0.22 + (ball.skillGlow || 0) * 0.16);
            ctx.shadowBlur = 6 + (ball.skillGlow || 0) * 9;
            ctx.fillStyle = ball.color;
            ctx.fill();
            ctx.shadowBlur = 0;
            renderedBallLabels.push({
                label: `${ball.displayLabel || ball.label || ''}`.trim(),
                x: renderX,
                y: renderY,
                r: renderR,
                color: ball.color,
                alpha: baseAlpha
            });
            ctx.restore();
        }
        for (let labelInfo of renderedBallLabels) {
            if (!labelInfo.label) continue;
            ctx.save();
            ctx.globalAlpha = labelInfo.alpha * 0.92;
            let fontSize = Math.max(7, Math.min(10, labelInfo.r * 0.95));
            ctx.font = `900 ${fontSize}px SUIT, Arial, sans-serif`;
            let frameBounds = this.pinballWorldFrameBounds(world);
            let labelX = this.clamp(labelInfo.x, frameBounds.left + 18, frameBounds.right - 18);
            let labelY = this.clamp(labelInfo.y + labelInfo.r + fontSize + 2, frameBounds.top + fontSize, frameBounds.bottom - 4);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgba(0,0,0,0.82)';
            ctx.strokeText(labelInfo.label, labelX, labelY);
            ctx.fillStyle = '#ffffff';
            ctx.fillText(labelInfo.label, labelX, labelY);
            ctx.restore();
        }
        ctx.restore();

        ctx.restore();

        this.drawPinballMiniMapCanvas(world, map, cameraX, cameraY, cameraScale);

        if (this.pinballWinner && !this.pinballRunning) {
            ctx.save();
            ctx.translate(this.pinballCameraBounceX || 0, this.pinballCameraBounce || 0);
            this.drawPinballWinnerCelebration(ctx, w, h, map, true);
            ctx.restore();
        }
    }

    public drawPinballNeonBarSegment(ctx: CanvasRenderingContext2D, current: any, segment: any) {
        let color = segment.color || '#ff55dc';
        let glowColor = segment.glowColor || '#b85cff';
        let gradient = ctx.createLinearGradient(current.x1, current.y1, current.x2, current.y2);
        gradient.addColorStop(0, segment.startColor || color);
        gradient.addColorStop(0.42, segment.midColor || color);
        gradient.addColorStop(1, segment.endColor || color);

        ctx.save();
        ctx.lineCap = segment.rotorField ? 'round' : 'butt';
        ctx.shadowColor = glowColor;
        ctx.shadowBlur = segment.rotorField ? 26 : 52;
        ctx.strokeStyle = this.pinballSoftGlowColor(glowColor, segment.rotorField ? 0.34 : 0.48);
        ctx.lineWidth = segment.glowWidth || 42;
        ctx.beginPath();
        ctx.moveTo(current.x1, current.y1);
        ctx.lineTo(current.x2, current.y2);
        ctx.stroke();

        ctx.shadowColor = color;
        ctx.shadowBlur = segment.rotorField ? 14 : 28;
        ctx.strokeStyle = gradient;
        ctx.lineWidth = segment.visualWidth || 24;
        ctx.beginPath();
        ctx.moveTo(current.x1, current.y1);
        ctx.lineTo(current.x2, current.y2);
        ctx.stroke();
        ctx.restore();
    }

    public applyPinballCameraTransform(ctx: CanvasRenderingContext2D, cameraX: number, cameraY: number, cameraScale: number) {
        ctx.scale(cameraScale, cameraScale);
        ctx.translate(-cameraX, -cameraY);
    }

    public drawPinballTowerDepth(ctx: CanvasRenderingContext2D, world: any, map: any, visibleTop: number, visibleBottom: number) {
        let floorGap = 420;
        let first = Math.max(0, Math.floor((visibleTop - 220) / floorGap));
        let last = Math.ceil((visibleBottom + 220) / floorGap);

        ctx.save();
        for (let floor = first; floor <= last; floor++) {
            let y = 180 + floor * floorGap;
            if (y < visibleTop - 80 || y > visibleBottom + 80) continue;

            ctx.strokeStyle = floor % 4 === 0 ? 'rgba(25,247,255,0.12)' : 'rgba(255,255,255,0.045)';
            ctx.lineWidth = floor % 4 === 0 ? 1.3 : 1;
            ctx.beginPath();
            ctx.moveTo(86, y);
            ctx.lineTo(world.width - 86, y);
            ctx.stroke();
        }

        ctx.globalCompositeOperation = 'lighter';
        for (let block of (world.decorBlocks || [])) {
            if (block.y + block.h < visibleTop || block.y > visibleBottom) continue;
            let blockBounds = this.pinballCorridorBoundsAtY(world, block.y + block.h * 0.5, block.w * 0.5);
            if (blockBounds && (block.x < blockBounds.left || block.x + block.w > blockBounds.right)) continue;
            ctx.save();
            ctx.translate(block.x + block.w * 0.5, block.y + block.h * 0.5);
            ctx.rotate(block.angle || 0);
            ctx.shadowColor = block.color || map.accent;
            ctx.shadowBlur = 18;
            this.drawRoundedRect(
                ctx,
                -block.w * 0.5,
                -block.h * 0.5,
                block.w,
                block.h,
                4,
                this.pinballSoftGlowColor(block.color || map.accent, block.alpha || 0.18),
                this.pinballSoftGlowColor(block.color || map.accent, 0.28),
                1.4
            );
            ctx.restore();
        }

        ctx.lineCap = 'round';
        for (let row of (world.cyanDashes || [])) {
            if (row.y < visibleTop - 80 || row.y > visibleBottom + 80) continue;
            let length = row.length || 42;
            let angle = row.angle || 0;
            let dx = Math.cos(angle) * length * 0.5;
            let dy = Math.sin(angle) * length * 0.5;
            ctx.save();
            ctx.strokeStyle = 'rgba(25,247,255,0.82)';
            ctx.shadowColor = map.accent;
            ctx.shadowBlur = 15;
            ctx.lineWidth = 5;
            let rowBounds = this.pinballCorridorBoundsAtY(world, row.y, length * 0.5);
            for (let x of row.xs || []) {
                if (rowBounds && (x < rowBounds.left || x > rowBounds.right)) continue;
                ctx.beginPath();
                ctx.moveTo(x - dx, row.y - dy);
                ctx.lineTo(x + dx, row.y + dy);
                ctx.stroke();
            }
            ctx.restore();
        }
        ctx.restore();
    }

    public drawPinballDropZones(ctx: CanvasRenderingContext2D, world: any, map: any, visibleTop: number, visibleBottom: number) {
        void ctx;
        void world;
        void map;
        void visibleTop;
        void visibleBottom;
        return;
    }

    public drawPinballFunnel(ctx: CanvasRenderingContext2D, world: any, map: any, visibleTop: number, visibleBottom: number) {
        let funnel = world?.funnel;
        if (!funnel || funnel.bottomY < visibleTop || funnel.topY > visibleBottom) return;
        let pipeTop = funnel.pipeStartY || funnel.throatY;
        if (funnel.bottomY <= pipeTop) return;

        ctx.save();
        let center = world.width * 0.5;
        let railGradient = ctx.createLinearGradient(0, funnel.topY, 0, funnel.bottomY);
        railGradient.addColorStop(0, 'rgba(255,255,255,0.96)');
        railGradient.addColorStop(0.62, this.pinballSoftGlowColor(map.accent, 0.82));
        railGradient.addColorStop(1, 'rgba(255,255,255,0.78)');
        let drawRail = (points: any[], width: number, alpha: number = 1) => {
            ctx.save();
            ctx.globalAlpha = alpha;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            ctx.shadowColor = map.accent;
            ctx.shadowBlur = 24;
            ctx.strokeStyle = this.pinballSoftGlowColor(map.accent, 0.36);
            ctx.lineWidth = width + 12;
            ctx.beginPath();
            ctx.moveTo(points[0].x, points[0].y);
            for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y);
            ctx.stroke();
            ctx.shadowBlur = 10;
            ctx.strokeStyle = railGradient as any;
            ctx.lineWidth = width;
            ctx.beginPath();
            ctx.moveTo(points[0].x, points[0].y);
            for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y);
            ctx.stroke();
            ctx.restore();
        };

        drawRail([
            { x: funnel.mouthLeft, y: funnel.topY },
            { x: funnel.throatLeft, y: funnel.throatY },
            { x: funnel.pipeLeft, y: pipeTop },
            { x: funnel.pipeLeft, y: funnel.bottomY }
        ], 7);
        drawRail([
            { x: funnel.mouthRight, y: funnel.topY },
            { x: funnel.throatRight, y: funnel.throatY },
            { x: funnel.pipeRight, y: pipeTop },
            { x: funnel.pipeRight, y: funnel.bottomY }
        ], 7);

        ctx.save();
        ctx.globalAlpha = 0.34;
        ctx.strokeStyle = this.pinballSoftGlowColor(map.accent, 0.5);
        ctx.lineWidth = 2;
        ctx.setLineDash([12, 18]);
        ctx.beginPath();
        ctx.moveTo(center, funnel.topY + 34);
        ctx.lineTo(center, funnel.bottomY - 18);
        ctx.stroke();
        ctx.restore();

        if (world.goalY >= visibleTop && world.goalY <= visibleBottom + 120) {
            ctx.save();
            ctx.lineCap = 'round';
            ctx.shadowColor = map.accent;
            ctx.shadowBlur = 18;
            ctx.strokeStyle = this.pinballSoftGlowColor(map.accent, 0.64);
            ctx.lineWidth = 5;
            let finishLineY = Math.min(world.goalY + 18, funnel.bottomY - 6);
            ctx.beginPath();
            ctx.moveTo(funnel.pipeLeft + 10, finishLineY);
            ctx.lineTo(funnel.pipeRight - 10, finishLineY);
            ctx.stroke();
            ctx.restore();
        }
        ctx.restore();
    }

    public drawPinballMiniMapCanvas(world: any, map: any, cameraX: number, cameraY: number, cameraScale: number) {
        let canvas = document.getElementById('pinball-minimap-canvas') as HTMLCanvasElement;
        if (!canvas) return;
        let ctx = canvas.getContext('2d');
        if (!ctx) return;
        let miniW = 132;
        let miniH = 220;
        if (canvas.width !== miniW) canvas.width = miniW;
        if (canvas.height !== miniH) canvas.height = miniH;
        ctx.clearRect(0, 0, miniW, miniH);
        this.drawPinballMiniMap(ctx, world, map, cameraX, cameraY, cameraScale, { x: 0, y: 0, width: miniW, height: miniH });
    }

    public drawPinballMiniMap(ctx: CanvasRenderingContext2D, world: any, map: any, cameraX: number, cameraY: number, cameraScale: number, bounds: any = null) {
        let miniW = bounds?.width || 132;
        let miniH = bounds?.height || 220;
        let x = bounds?.x || 0;
        let y = bounds?.y || 0;
        let innerX = x + 7;
        let innerY = y + 7;
        let innerW = miniW - 14;
        let innerH = miniH - 14;
        let sx = innerW / world.width;
        let sy = innerH / world.height;

        ctx.save();
        this.drawRoundedRect(ctx, x, y, miniW, miniH, 0, 'rgba(36,36,36,0.88)', 'rgba(0,116,20,0.95)', 2.4);
        ctx.save();
        ctx.beginPath();
        ctx.rect(innerX, innerY, innerW, innerH);
        ctx.clip();

        ctx.fillStyle = 'rgba(48,48,48,0.82)';
        ctx.fillRect(innerX, innerY, innerW, innerH);

        ctx.strokeStyle = 'rgba(255,255,255,0.42)';
        ctx.lineWidth = 1.5;
        for (let segment of (world.segments || [])) {
            if (segment.hidden || (!segment.slide && !segment.neonBar && !segment.color)) continue;
            let current = this.pinballSegmentEndpoints(segment);
            ctx.strokeStyle = segment.neonBar ? (segment.color || map.accent) : segment.slide ? 'rgba(255,255,255,0.48)' : 'rgba(255,255,255,0.26)';
            ctx.lineWidth = segment.neonBar ? 3 : segment.slide ? 1.5 : 1;
            ctx.beginPath();
            ctx.moveTo(innerX + current.x1 * sx, innerY + current.y1 * sy);
            ctx.lineTo(innerX + current.x2 * sx, innerY + current.y2 * sy);
            ctx.stroke();
        }

        for (let bumper of (world.bumpers || [])) {
            if (!bumper.powerBumper) continue;
            ctx.beginPath();
            ctx.arc(innerX + bumper.x * sx, innerY + bumper.y * sy, Math.max(2.4, bumper.r * sx), 0, Math.PI * 2);
            ctx.fillStyle = bumper.color || map.accent;
            ctx.globalAlpha = 0.76;
            ctx.fill();
            ctx.globalAlpha = 1;
        }

        if (world.funnel) {
            let funnel = world.funnel;
            ctx.strokeStyle = 'rgba(255,255,255,0.28)';
            ctx.globalAlpha = 0.52;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(innerX + funnel.mouthLeft * sx, innerY + funnel.topY * sy);
            ctx.lineTo(innerX + funnel.throatLeft * sx, innerY + funnel.throatY * sy);
            ctx.moveTo(innerX + funnel.pipeLeft * sx, innerY + (funnel.pipeStartY || funnel.throatY) * sy);
            ctx.lineTo(innerX + funnel.pipeLeft * sx, innerY + funnel.bottomY * sy);
            ctx.moveTo(innerX + funnel.mouthRight * sx, innerY + funnel.topY * sy);
            ctx.lineTo(innerX + funnel.throatRight * sx, innerY + funnel.throatY * sy);
            ctx.moveTo(innerX + funnel.pipeRight * sx, innerY + (funnel.pipeStartY || funnel.throatY) * sy);
            ctx.lineTo(innerX + funnel.pipeRight * sx, innerY + funnel.bottomY * sy);
            ctx.stroke();
            ctx.globalAlpha = 1;
        }

        for (let ball of this.pinballBalls) {
            if (ball.finished && !ball.exitStart) continue;
            let exitProgress = ball.exitStart ? this.clamp((performance.now() - ball.exitStart) / (ball.exitDuration || 900), 0, 1) : 0;
            if (ball.finished && exitProgress >= 1) continue;
            let frame = this.pinballWorldFrameBounds(world);
            let bx = ball.finished
                ? this.clamp(ball.x + (ball.exitVx || 0) * exitProgress, frame.left + ball.r, frame.right - ball.r)
                : ball.x;
            let by = ball.finished
                ? this.clamp(ball.y + (ball.exitVy || 0) * exitProgress, frame.top + ball.r, frame.bottom - ball.r)
                : ball.y;
            ctx.beginPath();
            let miniBallRadius = this.pinballBalls.length > 90 ? 1.6 : this.pinballBalls.length > 46 ? 2 : 2.4;
            ctx.arc(innerX + bx * sx, innerY + by * sy, ball.id === this.pinballFocusBallId ? miniBallRadius + 1.4 : miniBallRadius, 0, Math.PI * 2);
            ctx.fillStyle = ball.id === this.pinballFocusBallId ? '#ffffff' : (ball.color || map.accent);
            ctx.fill();
        }

        let viewW = this.pinballCanvasWidth / cameraScale;
        let viewH = this.pinballCanvasHeight / cameraScale;
        ctx.fillStyle = 'rgba(255,255,255,0.08)';
        ctx.fillRect(innerX + cameraX * sx, innerY + cameraY * sy, viewW * sx, viewH * sy);
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.strokeRect(innerX + cameraX * sx, innerY + cameraY * sy, viewW * sx, viewH * sy);
        if (this.pinballCameraFocusReady) {
            let focusX = innerX + this.pinballCameraFocusX * sx;
            let focusY = innerY + this.pinballCameraFocusY * sy;
            ctx.beginPath();
            ctx.arc(focusX, focusY, 4.2, 0, Math.PI * 2);
            ctx.strokeStyle = map.accent || '#19f7ff';
            ctx.lineWidth = 1.8;
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(focusX, focusY, 1.8, 0, Math.PI * 2);
            ctx.fillStyle = '#ffffff';
            ctx.fill();
        }
        ctx.restore();
        ctx.restore();
    }

    public drawPinballWinnerCelebration(ctx: CanvasRenderingContext2D, w: number, h: number, map: any, settled: boolean = false) {
        if (!this.pinballWinner) return;
        let now = performance.now();
        if (!this.pinballWinnerAnnouncedAt) this.pinballWinnerAnnouncedAt = now;
        let elapsed = Math.max(0, (now - this.pinballWinnerAnnouncedAt) / 1000);
        let pulse = Math.sin(elapsed * 4.2) * 0.5 + 0.5;
        let accent = this.pinballWinner.color || map.accent || '#5cffef';
        let panelW = Math.min(w - 92, settled ? 520 : 560);
        let panelH = settled ? 166 : 156;
        let panelX = w - panelW - 42;
        let panelY = h - panelH - 44;

        this.drawPinballFireworks(ctx, w, h, map, elapsed);

        ctx.save();
        ctx.translate(0, Math.sin(elapsed * 2.8) * 2.4);
        ctx.shadowColor = this.pinballSoftGlowColor(accent, 0.3);
        ctx.shadowBlur = 28;
        ctx.shadowOffsetY = 0;
        this.drawRoundedRect(ctx, panelX, panelY, panelW, panelH, 20, 'rgba(2,6,12,0.58)', this.pinballSoftGlowColor(accent, 0.7), 2);
        ctx.shadowBlur = 0;

        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = accent;
        ctx.font = '900 32px SUIT, Arial, sans-serif';
        ctx.fillText('Winner', panelX + panelW - 28, panelY + 42);

        let name = `${this.pinballWinner.label || '당첨'}`;
        let fontSize = name.length > 9 ? 48 : name.length > 5 ? 60 : 78;
        fontSize += pulse * 2.6;
        ctx.font = `900 ${fontSize}px SUIT, Arial, sans-serif`;
        while (ctx.measureText(name).width > panelW - 56 && fontSize > 34) {
            fontSize -= 2;
            ctx.font = `900 ${fontSize}px SUIT, Arial, sans-serif`;
        }
        ctx.shadowColor = this.pinballSoftGlowColor(accent, 0.45);
        ctx.shadowBlur = 14;
        ctx.fillStyle = '#ffffff';
        ctx.fillText(name, panelX + panelW - 28, panelY + 102);
        ctx.shadowBlur = 0;

        ctx.font = '800 18px SUIT, Arial, sans-serif';
        ctx.fillStyle = 'rgba(255,255,255,0.72)';
        ctx.fillText(`${this.pinballTargetLabel()} 골인`, panelX + panelW - 30, panelY + panelH - 28);
        ctx.restore();
    }

    public drawPinballFireworks(ctx: CanvasRenderingContext2D, w: number, h: number, map: any, elapsed: number) {
        let colors = [map.accent || this.pinballPastelPalette()[0], ...this.pinballPastelPalette().slice(1, 6), '#ffffff'];
        let seed = this.pinballWinnerBurstSeed || 37;
        let positions = [
            { x: 0.22, y: 0.24 },
            { x: 0.5, y: 0.18 },
            { x: 0.78, y: 0.25 },
            { x: 0.34, y: 0.43 },
            { x: 0.66, y: 0.42 }
        ];

        ctx.save();
        ctx.globalCompositeOperation = 'lighter';
        for (let b = 0; b < positions.length; b++) {
            let cycle = (elapsed + b * 0.24) % 2.05;
            let t = this.clamp(cycle / 1.12, 0, 1);
            if (cycle > 1.12) continue;
            let alpha = (1 - t) * (0.72 + b * 0.04);
            let cx = w * positions[b].x + Math.sin(seed + b * 1.7) * 26;
            let cy = h * positions[b].y + Math.cos(seed * 0.3 + b) * 16;
            let particles = 18 + (b % 2) * 6;
            for (let i = 0; i < particles; i++) {
                let angle = (i / particles) * Math.PI * 2 + (seed % 17) * 0.03 + b * 0.18;
                let distance = 22 + 108 * t;
                let inner = Math.max(10, distance - 24);
                let x1 = cx + Math.cos(angle) * inner;
                let y1 = cy + Math.sin(angle) * inner;
                let x2 = cx + Math.cos(angle) * distance;
                let y2 = cy + Math.sin(angle) * distance;
                ctx.strokeStyle = colors[(i + b) % colors.length];
                ctx.globalAlpha = alpha;
                ctx.lineWidth = 2.2;
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();

                ctx.fillStyle = colors[(i + b + 2) % colors.length];
                ctx.globalAlpha = alpha * 0.9;
                ctx.beginPath();
                ctx.arc(x2, y2, 2.4 + (i % 3), 0, Math.PI * 2);
                ctx.fill();
            }
        }
        ctx.globalAlpha = 1;
        ctx.restore();
    }

    public clipPinballMapFrame(ctx: CanvasRenderingContext2D, w: number = this.pinballCanvasWidth, h: number = this.pinballCanvasHeight) {
        this.pinballRoundedRectPath(ctx, 8, 8, w - 16, h - 16, 0);
        ctx.clip();
    }

    public pinballRoundedRectPath(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
        let radius = Math.max(0, Math.min(r, w / 2, h / 2));
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + w - radius, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
        ctx.lineTo(x + w, y + h - radius);
        ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
        ctx.lineTo(x + radius, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
    }

    public drawRoundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, fill: string, stroke: string = '', lineWidth: number = 1) {
        this.pinballRoundedRectPath(ctx, x, y, w, h, r);
        ctx.fillStyle = fill;
        ctx.fill();
        if (stroke) {
            ctx.strokeStyle = stroke;
            ctx.lineWidth = lineWidth;
            ctx.stroke();
        }
    }

    public startPinballRecording() {
        if (!this.pinballRecordEnabled) return;
        let canvas = document.getElementById('pinball-canvas') as HTMLCanvasElement;
        let Recorder = (window as any).MediaRecorder;
        if (!canvas?.captureStream || !Recorder) {
            this.showNotice('이 브라우저는 녹화를 지원하지 않아요');
            return;
        }
        if (this.pinballDownloadUrl) {
            URL.revokeObjectURL(this.pinballDownloadUrl);
            this.pinballDownloadUrl = '';
        }
        try {
            this.pinballRecordedChunks = [];
            let stream = canvas.captureStream(50);
            this.pinballRecorder = new Recorder(stream, { mimeType: 'video/webm' });
            this.pinballRecorder.ondataavailable = (event: any) => {
                if (event.data?.size) this.pinballRecordedChunks.push(event.data);
            };
            this.pinballRecorder.onstop = async () => {
                if (!this.pinballRecordedChunks.length) return;
                let blob = new Blob(this.pinballRecordedChunks, { type: 'video/webm' });
                this.pinballDownloadUrl = URL.createObjectURL(blob);
                this.pinballDownloadName = `facet-pinball-${Date.now()}.webm`;
                await this.service.render();
            };
            this.pinballRecorder.start();
        } catch (error) {
            this.pinballRecorder = null;
            this.showNotice('녹화를 시작하지 못했어요');
        }
    }

    public stopPinballRecording() {
        if (!this.pinballRecorder) return;
        try {
            if (this.pinballRecorder.state !== 'inactive') {
                this.pinballRecorder.stop();
            }
        } catch (error) {
        }
        this.pinballRecorder = null;
    }

    public resetFortuneState() {
        this.tarotChoices = [];
        this.tarotReading = false;
        this.tarotShuffling = false;
        this.tarotOpening = false;
        this.pickedTarotIndex = null;
    }

    public async showResultWithLoading(result: any, targetScreen: string = 'result', delay: number = this.resultLoadingDelayMs) {
        let token = ++this.resultTransitionToken;
        this.result = null;
        this.screen = 'loading';
        await this.service.render();
        this.scrollPageToTop('smooth');
        await this.wait(delay);
        if (token !== this.resultTransitionToken) return;
        this.result = result;
        this.screen = targetScreen;
        this.replaceCurrentUrlWithShareLink();
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public async handlePhotoUpload(event: any) {
        let input = event?.target as HTMLInputElement;
        let file = input?.files?.[0];
        if (!file) return;
        if (file.type && file.type.indexOf('image/') !== 0) {
            await this.showNotice('이미지 파일만 올릴 수 있어요');
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            await this.showNotice('10MB 이하 사진으로 올려주세요');
            return;
        }

        this.uploadedFileName = file.name;
        this.uploadedFileMeta = {
            name: file.name,
            size: file.size,
            lastModified: file.lastModified,
            type: file.type
        };
        this.photoAnalyzing = false;

        await new Promise<void>((resolve) => {
            let reader = new FileReader();
            reader.onload = async () => {
                this.uploadedImage = String(reader.result || '');
                await this.service.render();
                resolve();
            };
            reader.onerror = async () => {
                this.uploadedImage = '';
                await this.showNotice('사진을 불러오지 못했어요');
                resolve();
            };
            reader.readAsDataURL(file);
        });
    }

    public async analyzePhoto() {
        if (!this.uploadedImage) {
            await this.showNotice('먼저 사진을 올려주세요');
            return;
        }
        let token = ++this.resultTransitionToken;
        this.photoAnalyzing = true;
        await this.service.render();
        await this.wait(this.photoAnalyzeDelayMs);
        if (token !== this.resultTransitionToken) return;
        this.photoAnalyzing = false;
        await this.showResultWithLoading(this.generatePhotoResult(), 'photoResult');
    }

    public generatePhotoResult() {
        let results = this.selectedTest?.results || [];
        let seed = this.photoSeed();
        let base = this.pickPhotoResult(results, seed);
        let tones = this.photoResultTones();
        let resultIndex = results.indexOf(base);
        let toneIndex = seed % tones.length;

        return {
            ...base,
            summary: `${base.summary || ''} ${tones[toneIndex]}`.trim(),
            tags: base.tags || ['전생', '인물상'],
            guide: base.guide || '오늘의 선택에 전생 캐릭터의 장점을 살짝 빌려보세요.',
            match: base.match || '추천 테스트: 생활 MBTI 성향 테스트',
            shareResultIndex: resultIndex,
            sharePhotoToneIndex: toneIndex
        };
    }

    public photoResultTones() {
        return [
            '첫인상은 또렷하고 차분한 쪽으로 기울어 있어요.',
            '표정의 리듬은 부드럽지만 결정적인 순간에는 선명해지는 편이에요.',
            '전체 분위기에서 낯선 곳에도 금방 적응하는 감각이 보여요.',
            '시선의 결은 조용히 관찰하다가 핵심을 잡는 쪽에 가까워요.'
        ];
    }

    public pickPhotoResult(results: any[], seed: number) {
        if (!results.length) return {};
        let totalWeight = results.reduce((total: number, item: any) => total + this.photoResultWeight(item), 0);
        if (totalWeight <= 0) return results[seed % results.length] || {};

        let cursor = seed % totalWeight;
        for (let item of results) {
            cursor -= this.photoResultWeight(item);
            if (cursor < 0) return item;
        }

        return results[results.length - 1] || {};
    }

    public photoResultWeight(result: any) {
        let weight = Number(result?.photoWeight ?? 50);
        if (!Number.isFinite(weight) || weight < 1) return 1;
        return Math.floor(weight);
    }

    public photoSeed() {
        let meta = this.uploadedFileMeta || {};
        let source = `${meta.name || ''}|${meta.size || 0}|${meta.lastModified || 0}|${this.uploadedImage.length}`;
        let hash = 17;
        for (let i = 0; i < source.length; i++) {
            hash = ((hash << 5) - hash) + source.charCodeAt(i);
            hash = hash & hash;
        }
        return Math.abs(hash);
    }

    public async restartPhotoTest() {
        this.clearSharedResultUrl();
        this.resultTransitionToken++;
        this.resetPhotoState();
        this.result = null;
        this.screen = 'photo';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public wait(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public appScrollContainer() {
        return document.querySelector('app-root') as HTMLElement;
    }

    public scrollPageToTop(behavior: ScrollBehavior = 'smooth') {
        let container = this.appScrollContainer();
        if (container?.scrollTo) {
            container.scrollTo({ top: 0, left: 0, behavior });
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior });
    }

    public scrollPinballBoardIntoView(behavior: ScrollBehavior = 'smooth') {
        let board = document.querySelector('.pinball-machine-card') as HTMLElement;
        if (!board) return;
        board.scrollIntoView({ block: 'start', behavior });
    }

    public async drawGift() {
        if (!this.selectedTest?.results?.length || this.giftDrawing) return;
        this.clearSharedResultUrl();
        let token = ++this.resultTransitionToken;
        this.giftDrawing = true;
        this.giftResult = null;
        this.result = null;
        await this.service.render();
        await this.wait(this.giftDrawDelayMs);
        if (token !== this.resultTransitionToken) return;

        if (!this.giftDeck.length) {
            this.giftDeck = this.shuffleGifts(this.selectedTest.results.slice());
        }

        let gift = this.giftDeck.pop();
        if (!gift) {
            this.giftDrawing = false;
            await this.service.render();
            return;
        }

        let resultIndex = this.selectedTest.results.indexOf(gift);
        this.giftResult = {
            ...gift,
            drawNumber: resultIndex + 1,
            shareResultIndex: resultIndex
        };
        this.result = this.giftResult;
        this.giftDrawing = false;
        this.replaceCurrentUrlWithShareLink();
        await this.service.render();
    }

    public shuffleGifts(items: any[]) {
        for (let i = items.length - 1; i > 0; i--) {
            let j = this.randomInt(i + 1);
            let temp = items[i];
            items[i] = items[j];
            items[j] = temp;
        }
        return items;
    }

    public randomInt(max: number) {
        if (max <= 0) return 0;
        let cryptoApi = (window as any).crypto;
        if (cryptoApi?.getRandomValues) {
            let values = new Uint32Array(1);
            cryptoApi.getRandomValues(values);
            return values[0] % max;
        }
        return Math.floor(Math.random() * max);
    }

    public async restartGiftTest() {
        this.clearSharedResultUrl();
        this.resetGiftState();
        this.result = null;
        this.screen = 'gift';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public get pinballParticipantCount() {
        return this.pinballExpandedTotal();
    }

    public pinballExpandedTotal() {
        return this.parseSimplePinballParticipants().reduce((total: number, item: any) => total + item.count, 0);
    }

    public parseSimplePinballParticipants() {
        let tokens = `${this.pinballParticipantsInput || ''}`.split(/[\n,]+/).map((item: string) => item.trim()).filter(Boolean);
        return tokens.map((token: string) => this.parsePinballParticipantToken(token)).filter((item: any) => item.label);
    }

    public parsePinballParticipantToken(token: string) {
        let label = `${token || ''}`.trim();
        let count = 1;
        let weight = 1;

        let weightMatch = label.match(/\/(\d+)$/);
        if (weightMatch) {
            weight = this.clamp(parseInt(weightMatch[1], 10) || 1, 1, 9);
            label = label.slice(0, weightMatch.index).trim();
        }

        let starCountMatch = label.match(/\*(\d+)$/);
        if (starCountMatch) {
            count = this.normalizedPinballBallCount(starCountMatch[1]);
            label = label.slice(0, starCountMatch.index).trim();
        } else {
            let inlineCountMatch = label.match(/^(.+?)(\d+)$/);
            if (inlineCountMatch && /\D/.test(inlineCountMatch[1])) {
                count = this.normalizedPinballBallCount(inlineCountMatch[2]);
                label = inlineCountMatch[1].trim();
            }
        }

        label = this.normalizePinballParticipantLabel(label, token);

        return {
            label: label || token,
            count: count,
            weight: weight,
            source: token
        };
    }

    public expandPinballParticipants(limit: number = 0) {
        let expanded: any[] = [];
        let participants = this.parseSimplePinballParticipants();
        for (let participant of participants) {
            for (let i = 0; i < participant.count; i++) {
                if (limit > 0 && expanded.length >= limit) return expanded;
                expanded.push({
                    id: `${expanded.length}-${participant.label}-${i}`,
                    label: participant.label,
                    copyIndex: i + 1,
                    count: participant.count,
                    weight: participant.weight,
                    source: participant.source,
                    index: expanded.length
                });
            }
        }
        return expanded;
    }

    public async shufflePinballInput() {
        if (this.pinballRunning || this.pinballShuffling) return;
        let tokens = `${this.pinballParticipantsInput || ''}`.split(/[\n,]+/).map((item: string) => item.trim()).filter(Boolean);
        if (tokens.length < 2) {
            await this.showNotice('섞을 공을 2개 이상 입력해주세요');
            return;
        }
        this.pinballShuffling = true;
        await this.service.render();
        for (let i = tokens.length - 1; i > 0; i--) {
            let j = this.randomInt(i + 1);
            let temp = tokens[i];
            tokens[i] = tokens[j];
            tokens[j] = temp;
        }
        await this.wait(360);
        this.pinballParticipantsInput = tokens.join('\n');
        this.pinballShuffling = false;
        this.resetPinballState();
        await this.service.render();
    }

    public async startPinballDraw() {
        if (this.pinballRunning) return;
        this.clearSharedResultUrl();
        let total = this.pinballExpandedTotal();
        if (total < 1) {
            await this.showNotice('공 이름이나 숫자를 입력해주세요');
            return;
        }
        let participants = this.expandPinballParticipants();

        let token = ++this.resultTransitionToken;
        this.pinballRunning = true;
        this.pinballResults = [];
        this.result = null;
        this.pinballBalls = this.createPinballRace(participants);
        await this.service.render();
        await this.wait(this.pinballDrawDelayMs);
        if (token !== this.resultTransitionToken || this.screen !== 'pinball') return;

        this.pinballResults = this.pinballBalls
            .map((ball: any) => ({
                id: ball.id,
                label: ball.label,
                shortLabel: ball.shortLabel,
                rank: ball.rank,
                color: ball.color,
                weight: ball.weight,
                copyIndex: ball.copyIndex,
                count: ball.count
            }))
            .sort((a: any, b: any) => a.rank - b.rank);

        let winner = this.pinballWinnerFromRanking(this.pinballResults);
        for (let ball of this.pinballBalls) {
            ball.isWinner = ball.id === winner?.id;
        }
        for (let item of this.pinballResults) {
            item.isWinner = item.id === winner?.id;
        }
        this.result = this.createPinballResult(winner, this.pinballResults);
        this.pinballRunning = false;
        this.replaceCurrentUrlWithShareLink();
        await this.service.render();
    }

    public createPinballRace(participants: any[]) {
        let map = this.pinballMapConfig(this.pinballMap);
        let palette = this.pinballPastelPalette();
        let scored = participants.map((participant: any, index: number) => {
            let skillBoost = this.pinballSkillEnabled ? (participant.weight - 1) * this.randomInt(52000) : 0;
            let mapShake = this.pinballMap === 'bubble' ? this.randomInt(72000) : this.pinballMap === 'jar' ? this.randomInt(56000) : this.randomInt(64000);
            return {
                ...participant,
                orderIndex: index,
                score: this.randomInt(1000000) + mapShake - skillBoost + index
            };
        }).sort((a: any, b: any) => a.score - b.score);

        let finishLanes = [12, 24, 36, 48, 60, 72, 84];
        return scored.map((participant: any, rankIndex: number) => {
            let color = palette[participant.orderIndex % palette.length];
            let start = this.clamp(10 + ((participant.orderIndex % 9) * 10) + this.randomInt(5) - 2, 8, 92);
            let finishBase = finishLanes[rankIndex % finishLanes.length];
            let finish = this.clamp(finishBase + this.randomInt(7) - 3, 8, 92);
            let duration = 2300 + (rankIndex * 145) + this.randomInt(420);
            let delay = (participant.orderIndex % 8) * 46;
            let middle = this.pinballMiddleStops(start, finish, rankIndex);
            return {
                ...participant,
                id: `pinball-${participant.orderIndex}-${rankIndex}-${this.randomInt(99999)}`,
                rank: rankIndex + 1,
                color: color,
                shortLabel: this.pinballShortLabel(participant.label),
                style: [
                    `--pinball-start: ${start}%`,
                    `--pinball-mid-a: ${middle[0]}%`,
                    `--pinball-mid-b: ${middle[1]}%`,
                    `--pinball-mid-c: ${middle[2]}%`,
                    `--pinball-end: ${finish}%`,
                    `--pinball-color: ${color}`,
                    `--pinball-accent: ${map.accent}`,
                    `--pinball-duration: ${duration}ms`,
                    `--pinball-delay: ${delay}ms`
                ].join('; ')
            };
        });
    }

    public pinballMiddleStops(start: number, finish: number, rankIndex: number) {
        let drift = (finish - start) / 4;
        let swing = this.pinballMap === 'wheel' ? 18 : this.pinballMap === 'bubble' ? 12 : 16;
        return [
            this.clamp(start + drift + this.randomInt(swing) - swing / 2, 8, 92),
            this.clamp(start + drift * 2 + this.randomInt(swing + 8) - (swing + 8) / 2 + (rankIndex % 2 ? 5 : -5), 8, 92),
            this.clamp(start + drift * 3 + this.randomInt(swing) - swing / 2, 8, 92)
        ];
    }

    public pinballWinnerFromRanking(ranking: any[]) {
        if (!ranking.length) return null;
        if (this.pinballWinningRank === 'last') return ranking[ranking.length - 1];
        let rank = parseInt(`${this.pinballWinningRank}`, 10);
        if (!Number.isFinite(rank) || rank < 1) rank = 1;
        return ranking[this.clamp(rank - 1, 0, ranking.length - 1)];
    }

    public createPinballResult(winner: any, ranking: any[]) {
        let winnerLabel = winner?.label || '결과 없음';
        let targetLabel = this.pinballWinningRankLabel();
        return {
            title: `${winnerLabel} 당첨`,
            subtitle: `${targetLabel} 골인 공`,
            summary: `${this.pinballMapLabel(this.pinballMap)} 맵에서 총 ${ranking.length}개 공을 굴렸고, 규칙으로 정한 ${targetLabel} 공이 ${winnerLabel}으로 결정됐어요.`,
            tags: ['핀볼', '랜덤뽑기', `${ranking.length}개 공`],
            guide: this.pinballSkillEnabled ? '스킬 옵션을 켜서 가중치가 높은 공이 살짝 더 유리하게 움직였어요.' : '스킬 옵션 없이 모든 공을 같은 조건으로 굴렸어요.',
            match: '입력 예시: 1 지원*10, 2 희진*10, 보미/2',
            ranking: ranking,
            winnerLabel: winnerLabel
        };
    }

    public createSimplePinballSharedResult(test: any, ranking: any[], winnerLabelValue: any = '') {
        let colors = this.pinballPastelPalette();
        let normalized = ranking.map((item: any, index: number) => ({
            id: `shared-${index}`,
            label: item.label || `공 ${index + 1}`,
            shortLabel: this.pinballShortLabel(item.label || `${index + 1}`),
            rank: index + 1,
            color: item.color || colors[index % colors.length],
            isWinner: `${item.label || ''}` === `${winnerLabelValue || ''}`
        }));
        let winner = normalized.find((item: any) => item.isWinner) || normalized[0];
        normalized.forEach((item: any) => item.isWinner = item.id === winner.id);
        return {
            title: `${winner.label} 당첨`,
            subtitle: '공유된 핀볼 결과',
            summary: `${test.title}에서 저장된 결과예요. 전체 순위 중 당첨 공은 ${winner.label}입니다.`,
            tags: ['핀볼', '공유결과', `${normalized.length}개 공`],
            guide: '새로 뽑기를 누르면 현재 입력값으로 다시 굴릴 수 있어요.',
            match: '공유 링크로 복원된 결과입니다.',
            ranking: normalized,
            winnerLabel: winner.label
        };
    }

    public pinballWinningRankLabel() {
        if (this.pinballWinningRank === 'last') return '마지막';
        let option = this.pinballRankOptions.find((item: any) => item.value === this.pinballWinningRank || `${item.value}` === `${this.pinballWinningRank}`);
        return option?.label || `${this.pinballWinningRank}번째`;
    }

    public pinballShortLabel(label: string) {
        let text = this.normalizePinballParticipantLabel(`${label || ''}`.trim());
        if (!text) return '?';
        if (/^\d+$/.test(text)) return text.slice(-2);
        return text.slice(0, 2);
    }

    public pinballMapConfig(id: string) {
        return this.pinballMaps.find((map: any) => map.id === id) || this.pinballMaps[0];
    }

    public pinballMapLabel(id: string) {
        return this.pinballMapConfig(id).label;
    }

    public pinballSimpleMapClass(id: string) {
        if (this.pinballMap === id) {
            return 'h-11 rounded-full bg-[#b76e79] px-4 text-[13px] font-black text-white shadow-sm transition';
        }
        return 'h-11 rounded-full bg-white px-4 text-[13px] font-black text-slate-600 ring-1 ring-slate-200 transition hover:text-[#7f4f5d]';
    }

    public async selectPinballMap(id: string) {
        if (this.pinballRunning) return;
        this.pinballMap = id;
        this.resetPinballState();
        this.result = null;
        await this.service.render();
    }

    public async restartPinballTest() {
        this.clearSharedResultUrl();
        this.resultTransitionToken++;
        this.resetPinballState();
        this.result = null;
        this.screen = 'pinball';
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public prepareTarotChoices() {
        let deck = this.shuffleGifts((this.selectedTest?.results || []).slice());
        let fanCount = 13;
        this.tarotChoices = [];
        for (let i = 0; i < fanCount && deck.length; i++) {
            let card = deck[i % deck.length];
            this.tarotChoices.push({ ...card, fanIndex: i, shareResultIndex: (this.selectedTest?.results || []).indexOf(card) });
        }
        this.tarotReading = false;
        this.tarotShuffling = true;
        this.tarotOpening = false;
        this.pickedTarotIndex = null;
    }

    public async playTarotShuffleIntro() {
        let token = this.resultTransitionToken;
        this.tarotShuffling = true;
        await this.service.render();
        await this.wait(this.tarotShuffleDelayMs);
        if (token !== this.resultTransitionToken || this.screen !== 'tarot' || this.result) return;
        this.tarotShuffling = false;
        this.tarotOpening = true;
        await this.service.render();
        await this.wait(this.tarotOpenDelayMs);
        if (token !== this.resultTransitionToken || this.screen !== 'tarot' || this.result) return;
        this.tarotOpening = false;
        await this.service.render();
    }

    public async reshuffleTarot() {
        this.clearSharedResultUrl();
        this.resultTransitionToken++;
        this.result = null;
        this.prepareTarotChoices();
        this.screen = 'tarot';
        await this.service.render();
        await this.playTarotShuffleIntro();
    }

    public async chooseTarot(card: any, index: number = -1) {
        if (!card || this.tarotReading || this.tarotShuffling || this.tarotOpening) return;
        this.tarotReading = true;
        this.pickedTarotIndex = index;
        await this.service.render();
        await this.wait(520);
        await this.showResultWithLoading(this.createTarotDrawResult(card), 'tarot');
        this.tarotReading = false;
        this.pickedTarotIndex = null;
        await this.service.render();
    }

    public async submitSaju() {
        let birthDate = this.parseBirthDate(this.fortuneProfile.birthDate, this.fortuneProfile.calendarType);
        if (!birthDate) {
            await this.showNotice('생년월일을 입력해주세요');
            return;
        }
        await this.showResultWithLoading(this.buildSajuResult(this.fortuneProfile), 'saju');
    }

    public async submitCompatibility() {
        let aDate = this.parseBirthDate(this.compatibilityForm.aBirthDate);
        let bDate = this.parseBirthDate(this.compatibilityForm.bBirthDate);
        if (!aDate || !bDate) {
            await this.showNotice('두 사람의 생년월일을 모두 입력해주세요');
            return;
        }
        await this.showResultWithLoading(this.buildCompatibilityResult(this.compatibilityForm), 'compatibility');
    }

    public async submitDailyFortune() {
        let birthDate = this.parseBirthDate(this.dailyForm.birthDate);
        if (!birthDate) {
            await this.showNotice('생년월일을 입력해주세요');
            return;
        }
        await this.showResultWithLoading(this.buildDailyFortuneResult(this.dailyForm), 'daily');
    }

    public async submitManse() {
        let birthDate = this.parseBirthDate(this.manseForm.birthDate, this.manseForm.calendarType);
        if (!birthDate) {
            await this.showNotice('생년월일을 입력해주세요');
            return;
        }
        this.resetManseAccordion();
        this.manseValidationOpen = false;
        this.manseForm.targetYear = this.normalTargetYear(this.manseForm.targetYear);
        let calculation = this.calculateSaju({ ...this.manseForm, targetYear: this.manseForm.targetYear });
        await this.showResultWithLoading(this.buildManseResult(calculation), 'manse');
    }

    public buildSajuResult(profile: any) {
        let calculation = this.calculateSaju(profile);
        let reportData = this.buildManseReportData(calculation, false);
        let chart = reportData.chart;
        let pillars = reportData.pillars;
        let elements = reportData.rawElements;
        let weightedElements = reportData.elements;
        let tenGods = reportData.tenGods;
        let personality = reportData.personality;
        let displayPillars = reportData.displayPillars;
        let interactionSections = reportData.interactionSections;
        let detailedReading = this.buildDetailedReading(reportData);
        let validation = this.normalizeManseValidation(reportData.validation, reportData);
        let dominant = elements[0];
        let lacking = elements[elements.length - 1];
        let name = profile.name?.trim() || '당신';
        let tone = this.elementTone(dominant.label);

        return {
            title: `${name}의 ${pillars[2].label} 일주 사주`,
            subtitle: `${pillars.map((pillar: any) => pillar.label).join(' · ')} 네 기둥`,
            summary: detailedReading?.dayProfile?.keywordSummary || `${name}님은 ${tone.core} 흐름이 강하게 잡히는 타입이에요.`,
            tags: ['사주', `${dominant.label} 강세`, `${lacking.label} 보완`],
            guide: `${lacking.label} 기운을 보완하는 색, 장소, 루틴을 하나만 정해두면 하루 리듬이 안정됩니다.`,
            match: `오늘의 활용법: ${tone.action}`,
            pillars: pillars,
            displayPillars: displayPillars,
            elements: elements,
            tenGods: tenGods,
            personality: personality,
            interactionSections: interactionSections,
            detailedReading: detailedReading,
            calcMeta: { ...chart.meta, calendarLabel: reportData.calendarLabel },
            validation: validation
        };
    }

    public buildCompatibilityResult(form: any) {
        let aName = form.aName?.trim() || '나';
        let bName = form.bName?.trim() || '상대';
        let aDate = this.parseBirthDate(form.aBirthDate) || new Date();
        let bDate = this.parseBirthDate(form.bBirthDate) || new Date();
        let aPillars = this.buildChart(aDate, form.aBirthTime, form).pillars;
        let bPillars = this.buildChart(bDate, form.bBirthTime, form).pillars;
        let seed = this.hashText(`${form.aBirthDate}|${form.aBirthTime}|${form.bBirthDate}|${form.bBirthTime}`);
        let sameElement = aPillars[2].stem.element === bPillars[2].stem.element ? 8 : 0;
        let branchGap = Math.abs(aPillars[0].branch.index - bPillars[0].branch.index);
        let score = this.clamp(52 + (seed % 34) + sameElement - Math.min(branchGap, 6), 34, 98);
        let style = score >= 82 ? '서로의 장점을 빠르게 알아보는 고득점 궁합' : score >= 65 ? '다른 리듬을 맞추면 안정되는 현실형 궁합' : '천천히 규칙을 정해야 편해지는 조율형 궁합';
        let conversation = this.clamp(48 + ((seed >> 2) % 45), 35, 99);
        let affection = this.clamp(50 + ((seed >> 4) % 44), 35, 99);
        let rhythm = this.clamp(45 + ((seed >> 6) % 48), 35, 99);

        return {
            title: `${aName} × ${bName} 궁합 ${score}점`,
            subtitle: style,
            summary: `${aName}님과 ${bName}님은 ${aPillars[2].label} 일주와 ${bPillars[2].label} 일주의 만남이에요. 관계가 좋아지는 포인트는 대화 속도를 맞추고, 서운함을 오래 묵히지 않는 데 있습니다.`,
            tags: ['궁합', `${score}점`, score >= 70 ? '호흡좋음' : '조율필요'],
            guide: score >= 75 ? '좋은 흐름을 믿되 약속 시간과 돈 문제처럼 현실적인 기준은 분명히 해두세요.' : '호감만으로 밀어붙이기보다 연락 빈도와 표현 방식을 먼저 맞추면 편해져요.',
            match: `관계 키워드: ${this.pickBySeed(['속도 조절', '솔직한 표현', '생활 리듬', '작은 약속', '취향 공유'], seed)}`,
            score: score,
            sections: [
                { label: '대화', value: conversation },
                { label: '애정', value: affection },
                { label: '생활리듬', value: rhythm }
            ],
            pillars: [
                { label: aName, value: aPillars[2].label },
                { label: bName, value: bPillars[2].label }
            ]
        };
    }

    public buildDailyFortuneResult(form: any, targetDate: Date = new Date()) {
        let today = targetDate;
        let seed = this.hashText(`${form.birthDate}|${form.focus}|${this.formatInputDate(today)}`);
        let score = this.clamp(46 + (seed % 52), 30, 99);
        let focusLabels: any = { overall: '총운', love: '애정운', money: '재물운', work: '일운' };
        let luckyColors = ['코랄', '네이비', '라임', '실버', '화이트', '민트', '블랙'];
        let luckyItems = ['작은 메모지', '따뜻한 커피', '이어폰', '손수건', '편한 신발', '물 한 잔', '동전'];
        let luckyTimes = ['오전 9시', '오전 11시', '오후 2시', '오후 4시', '저녁 7시', '밤 10시'];

        return {
            title: `${this.formatKoreanDate(today)} 일일운세 ${score}점`,
            subtitle: `${focusLabels[form.focus] || '총운'} 중심으로 보는 오늘의 흐름`,
            summary: score >= 80 ? '오늘은 먼저 움직이는 사람이 흐름을 가져가는 날이에요. 작게 시작한 일이 생각보다 좋은 반응을 만들 수 있습니다.' : score >= 60 ? '오늘은 큰 승부보다 균형감이 중요해요. 할 일의 순서를 정리하면 무난하게 좋은 하루가 됩니다.' : '오늘은 속도를 낮추고 실수를 줄이는 쪽이 좋아요. 답답한 일은 잠깐 미뤄두면 다른 길이 보입니다.',
            tags: ['일일운세', `${score}점`, focusLabels[form.focus] || '총운'],
            guide: `행운 컬러는 ${this.pickBySeed(luckyColors, seed)}, 행운 아이템은 ${this.pickBySeed(luckyItems, seed >> 3)}입니다.`,
            match: `움직이기 좋은 시간: ${this.pickBySeed(luckyTimes, seed >> 5)}`,
            score: score,
            shareDate: this.formatInputDate(today),
            sections: [
                { label: '애정', value: this.clamp(42 + ((seed >> 1) % 58), 20, 99) },
                { label: '재물', value: this.clamp(42 + ((seed >> 3) % 58), 20, 99) },
                { label: '일/공부', value: this.clamp(42 + ((seed >> 5) % 58), 20, 99) },
                { label: '컨디션', value: this.clamp(42 + ((seed >> 7) % 58), 20, 99) }
            ]
        };
    }

    public buildManseResult(calculation: SajuCalculationResult, precisionMode: boolean = this.isPrecisionManseMode()) {
        let reportData = this.buildManseReportData(calculation, precisionMode);
        let targetYear = reportData.targetYear;
        let pillars = reportData.pillars;
        let displayPillars = reportData.displayPillars;
        let elements = reportData.elements;
        let tenGods = reportData.tenGods;
        let nobleStars = reportData.nobleStars;
        let specialStars = reportData.specialStars;
        let emptyBranches = reportData.emptyBranches;
        let personality = reportData.personality;
        let luckInfo = reportData.luckInfo;
        let interactionSections = reportData.interactionSections;
        let detailedReading = this.buildDetailedReading(reportData);
        let sajuKidSections = this.buildSajuKidSections(reportData);
        let luckFlow = reportData.luckFlow;
        let annualLuck = reportData.annualLuck;
        let monthlyLuck = precisionMode ? reportData.monthlyLuck : [];
        let precision = precisionMode ? this.buildMansePrecisionReport(reportData) : null;
        let validation = this.normalizeManseValidation(reportData.validation, reportData);
        let resultLabel = precisionMode ? '정밀' : '간편';
        let resultName = String(calculation.input?.name || '').trim() || '나';

        return {
            title: `${resultName}의 ${resultLabel} 만세력`,
            subtitle: precisionMode ? `${targetYear}년 흐름까지 함께 읽는 개인 리포트` : displayPillars.map((pillar: any) => pillar.label).join(' · '),
            summary: personality.summary,
            tags: precisionMode ? ['정밀 리포트', '개인화 해석', `${targetYear}년 흐름`] : ['만세력', `${pillars[2].label} 일주`, personality.strengthLabel],
            guide: personality.usefulGuide,
            match: personality.keyword,
            pillars: pillars,
            displayPillars: displayPillars,
            elements: elements,
            tenGods: tenGods,
            nobleStars: nobleStars,
            specialStars: specialStars,
            emptyBranches: emptyBranches,
            personality: personality,
            interactionSections: interactionSections,
            detailedReading: detailedReading,
            sajuKidSections: sajuKidSections,
            reportChapters: sajuKidSections,
            luckFlow: luckFlow,
            annualLuck: annualLuck,
            monthlyLuck: monthlyLuck,
            precision: precision,
            interpretationSignals: reportData.interpretationSignals,
            calcMeta: { ...reportData.chart.meta, calendarLabel: reportData.calendarLabel },
            luckInfo: luckInfo,
            validation: validation,
            shareYear: targetYear
        };
    }

    private calculateSaju(input: SajuInput) {
        return this.sajuCalculator.calculate(input);
    }

    private buildManseReportData(calculation: SajuCalculationResult, precisionMode: boolean = false): ManseReportData {
        let targetYear = this.normalTargetYear(calculation.calculationOptions?.targetYear || calculation.input?.targetYear || new Date().getFullYear());
        let chart = calculation.chart;
        let pillars = calculation.pillars || chart.pillars;
        let displayPillars = this.decoratePillarsForManse(pillars, calculation.pillarDetails);
        let rawElements = calculation.rawElements?.length ? calculation.rawElements : calculation.elements;
        let elements = calculation.elements || rawElements;
        let tenGods = calculation.tenGods || [];
        let elementRelations = calculation.elementRelations || {};
        let personality = this.buildSajuPersonality(pillars, elements, tenGods, elementRelations);
        let reportData: ManseReportData = {
            calculation: calculation,
            targetYear: targetYear,
            ownerName: this.readingOwnerName(calculation.input?.name),
            calendarLabel: this.calendarTypeLabel(calculation.calculationOptions?.calendarType || calculation.input?.calendarType),
            chart: chart,
            pillars: pillars,
            displayPillars: displayPillars,
            rawElements: rawElements,
            elements: elements,
            tenGods: tenGods,
            elementRelations: elementRelations,
            personality: personality,
            nobleStars: calculation.nobleStars || [],
            specialStars: calculation.specialStars || [],
            emptyBranches: calculation.emptyBranches || [],
            luckInfo: calculation.luckInfo,
            luckFlow: calculation.luckFlow || [],
            annualLuck: calculation.annualLuck || [],
            monthlyLuck: calculation.monthlyLuck || [],
            interactionSections: calculation.interactions || [],
            interpretationSignals: calculation.interpretationSignals || calculation.validation?.interpretationSignals || [],
            validation: calculation.validation,
            reading: {},
            precision: null
        };
        reportData.reading = this.buildManseReadingContext(reportData);
        reportData.precision = precisionMode ? this.buildMansePrecisionData(reportData) : null;
        return reportData;
    }

    private buildManseReadingContext(reportData: ManseReportData): ManseReadingContext {
        let owner = reportData.ownerName;
        let topic = this.topicName(owner);
        let possessive = this.possessiveName(owner);
        let pillars = reportData.pillars;
        let yearPillar = pillars[0];
        let monthPillar = pillars[1];
        let dayPillar = pillars[2];
        let hourPillar = pillars[3];
        let rawElements = reportData.rawElements?.length ? reportData.rawElements : reportData.elements;
        let dominantElement = rawElements[0] || reportData.elements[0] || { label: dayPillar.stem.element, value: 0 };
        let lackingElement = rawElements[rawElements.length - 1] || reportData.elements[reportData.elements.length - 1] || dominantElement;
        let elementText = rawElements.map((item: any) => `${item.label}${this.cleanCountValue(item.value)}`).join(', ');
        let dayTheory = this.dayPillarTheoryFromDetails(dayPillar, reportData.displayPillars);
        let stemProfile = this.dayStemProfile(dayPillar.stem.name);
        let branchProfile = this.dayBranchProfile(dayPillar.branch.name);
        let seasonProfile = this.monthBranchProfile(monthPillar.branch.name);
        let dayTheoryTenGodProfile = this.tenGodReadingProfile(dayTheory.tenGod);
        let dayProfile = this.dayPillarProfile(dayPillar, stemProfile, branchProfile, dayTheoryTenGodProfile, seasonProfile, reportData.personality, dayTheory.tenGod);
        dayProfile = this.applyBirthSeasonToDayProfile(dayProfile, dayPillar, seasonProfile, dayTheory, stemProfile, branchProfile);
        let dominantTenGod = reportData.tenGods.find((item: any) => item.label !== '일간') || reportData.tenGods[0] || { label: dayTheory.tenGod, value: 0, tone: this.tenGodTone(dayTheory.tenGod) };
        let dominantTenGodProfile = this.tenGodReadingProfile(dominantTenGod.label);
        let outputElement = reportData.elementRelations?.outputElement || '';
        let wealthElement = reportData.elementRelations?.wealthElement || '';
        let resourceElement = reportData.elementRelations?.resourceElement || '';
        let officerElement = reportData.elementRelations?.officerElement || '';
        let usefulElements = reportData.personality?.usefulElements?.length ? reportData.personality.usefulElements : [lackingElement.label];
        let usefulText = usefulElements.join('·');
        let activeInteractions = (reportData.interactionSections || []).filter((section: any) => section.active && section.label !== '궁성' && section.items?.length).slice(0, 3);
        let activeInteractionText = this.interactionReadingText(activeInteractions);
        let noble = (reportData.nobleStars || [])[0];
        let special = (reportData.specialStars || []).find((star: any) => star.name !== '공망') || (reportData.specialStars || [])[0];
        let timeUnknown = this.isManseTimeUnknown(reportData);
        let nobleText = noble
            ? `${noble.name}은 ${noble.description} 위치는 ${noble.location}입니다.`
            : `뚜렷하게 앞에 나서는 귀인성보다 ${dayPillar.label} 일주 자체의 ${stemProfile.keyword}과 월지 ${seasonProfile.keyword}이 도움의 통로가 됩니다.`;
        let specialText = special
            ? `${special.name}(${special.location})은 ${special.description}`
            : '특별히 강한 신살보다 일간과 월지, 오행 균형을 먼저 보는 명식입니다.';
        if (timeUnknown) {
            nobleText += ' 생시 미정이라 시지 기준 귀인성은 계산하지 않았습니다.';
            specialText += ' 시주와 시지에서만 잡히는 신살은 생시 미정으로 제외했습니다.';
        }
        let placeProfile = this.elementPlaceProfile(lackingElement.label);
        let wealthCount = this.elementValue(rawElements, wealthElement);
        let wealthText = this.wealthFlowText(wealthCount, wealthElement);
        let hourText = timeUnknown ? '시주는 생시 미정으로 해석에서 제외' : `시주는 ${hourPillar.label}`;
        let pillarEvidenceText = timeUnknown
            ? `년주 ${yearPillar.label}, 월주 ${monthPillar.label}, 일주 ${dayPillar.label}를 기준으로 보았습니다. 시주·시지·시주 십성/신살은 생시 미정으로 제외했습니다.`
            : `년주 ${yearPillar.label}, 월주 ${monthPillar.label}, 일주 ${dayPillar.label}, ${hourText}를 기준으로 보았습니다.`;
        let titles = this.sajuKidSectionTitles(dayPillar, dominantElement, lackingElement, dominantTenGod, reportData.personality, {
            dayProfile: dayProfile,
            branchProfile: branchProfile,
            seasonProfile: seasonProfile,
            dayTheory: dayTheory,
            dominantTenGodProfile: dominantTenGodProfile,
            noble: noble,
            activeInteractions: activeInteractions,
            wealthElement: wealthElement,
            wealthCount: wealthCount,
            resourceElement: resourceElement,
            officerElement: officerElement,
            special: special,
            luckInfo: reportData.luckInfo,
            stemProfile: stemProfile
        });

        return {
            owner: owner,
            topic: topic,
            possessive: possessive,
            yearPillar: yearPillar,
            monthPillar: monthPillar,
            dayPillar: dayPillar,
            hourPillar: hourPillar,
            rawElements: rawElements,
            dominantElement: dominantElement,
            lackingElement: lackingElement,
            elementText: elementText,
            dayTheory: dayTheory,
            stemProfile: stemProfile,
            branchProfile: branchProfile,
            seasonProfile: seasonProfile,
            dayTheoryTenGodProfile: dayTheoryTenGodProfile,
            dayProfile: dayProfile,
            dominantTenGod: dominantTenGod,
            dominantTenGodProfile: dominantTenGodProfile,
            outputElement: outputElement,
            wealthElement: wealthElement,
            resourceElement: resourceElement,
            officerElement: officerElement,
            usefulElements: usefulElements,
            usefulText: usefulText,
            activeInteractions: activeInteractions,
            activeInteractionText: activeInteractionText,
            noble: noble,
            special: special,
            nobleText: nobleText,
            specialText: specialText,
            placeProfile: placeProfile,
            wealthCount: wealthCount,
            wealthText: wealthText,
            hourText: hourText,
            timeUnknown: timeUnknown,
            pillarEvidenceText: pillarEvidenceText,
            titles: titles
        };
    }

    private dayPillarTheoryFromDetails(dayPillar: any, displayPillars: any[]) {
        let detail = (displayPillars || []).find((pillar: any) => pillar.part === dayPillar.part) || {};
        let tenGod = detail.branchTenGod || detail.branchTenGods?.[0]?.tenGod || '일간';
        let stage = detail.twelveStage || '미정';
        return {
            tenGod: tenGod,
            stage: stage,
            stemText: `천간 ${dayPillar.stem.name}${dayPillar.stem.hanja}(${dayPillar.stem.element})`,
            branchText: `지지 ${dayPillar.branch.name}${dayPillar.branch.hanja}(${dayPillar.branch.element})`,
            structureText: `천간 ${dayPillar.stem.name}${dayPillar.stem.hanja}와 지지 ${dayPillar.branch.name}${dayPillar.branch.hanja}가 만나고, 십이운성은 ${stage}, 일지 육친은 ${tenGod}으로 읽습니다.`,
            stageTone: this.twelveStageTone(stage)
        };
    }

    private buildMansePrecisionData(reportData: ManseReportData) {
        let chart = reportData.chart;
        return {
            ipchun: this.solarTermDate(chart.adjusted.getFullYear(), 2),
            annualStart: reportData.annualLuck[0] || null,
            boundaries: this.solarTermBoundaryItems(chart),
            solarTerms: this.solarTermTimeline(chart.adjusted.getFullYear())
        };
    }

    public isPrecisionManseMode() {
        return !!(this.selectedTest?.precision || this.selectedTest?.id === 'manse-precision');
    }

    public resetManseAccordion() {
        this.expandedManseSection = 0;
        this.expandedManseSectionId = 'manse-chapter-core';
    }

    public manseSectionId(section: any, index: number = 0) {
        return String(section?.id || section?.chapterId || (section?.key ? `manse-chapter-${section.key}` : `manse-chapter-${index}`));
    }

    public trackByManseSection(index: number, section: any) {
        return String(section?.id || section?.chapterId || (section?.key ? `manse-chapter-${section.key}` : `manse-chapter-${index}`));
    }

    public toggleManseSection(section: any, index: number) {
        let sectionId = this.manseSectionId(section, index);
        if (this.expandedManseSectionId === sectionId) {
            this.expandedManseSectionId = '';
            this.expandedManseSection = -1;
            return;
        }
        this.expandedManseSectionId = sectionId;
        this.expandedManseSection = index;
    }

    public isManseSectionExpanded(section: any, index: number) {
        let sectionId = this.manseSectionId(section, index);
        if (this.expandedManseSectionId) return this.expandedManseSectionId === sectionId;
        return this.expandedManseSection === index;
    }

    public toggleManseValidation() {
        this.manseValidationOpen = !this.manseValidationOpen;
    }

    public validationRows(value: any) {
        return Object.keys(value || {}).map((key: string) => ({
            key: key,
            label: this.validationLabel(key),
            value: this.validationValue(value[key])
        }));
    }

    public normalizeManseValidation(validation: any, reportData: ManseReportData) {
        let source = validation || {};
        let elementDistribution = this.nonEmptyArray(source.elementDistribution || source.elements, reportData.elements || reportData.rawElements);
        let tenGods = this.nonEmptyArray(source.tenGods, reportData.tenGods);
        let nobleStars = this.nonEmptyArray(source.nobleStars, reportData.nobleStars);
        let specialStars = this.nonEmptyArray(source.specialStars, reportData.specialStars);
        let stars = this.nonEmptyArray(source.stars, [...nobleStars, ...specialStars]);
        let emptyBranches = this.nonEmptyArray(source.emptyBranches || source.voidBranches, reportData.emptyBranches);
        let yearLuck = this.nonEmptyArray(source.yearLuck || source.annualLuck, reportData.annualLuck);
        let monthLuck = this.nonEmptyArray(source.monthLuck || source.monthlyLuck, reportData.monthlyLuck);
        return {
            ...source,
            rawInput: source.rawInput || reportData.calculation?.validation?.rawInput || {},
            normalizedInput: source.normalizedInput || reportData.calculation?.normalizedInput || {},
            calculationOptions: source.calculationOptions || reportData.calculation?.calculationOptions || {},
            warnings: Array.isArray(source.warnings) ? source.warnings : (reportData.calculation?.warnings || []),
            confidence: typeof source.confidence === 'number' ? source.confidence : Number(reportData.calculation?.confidence || 0),
            trace: source.trace || reportData.calculation?.trace || { steps: [] },
            pillars: this.nonEmptyArray(source.pillars, this.validationPillarsFromDisplay(reportData.displayPillars)),
            tenGods: tenGods,
            hiddenStems: this.nonEmptyArray(source.hiddenStems, this.validationHiddenStemsFromDisplay(reportData.displayPillars)),
            twelveStages: this.nonEmptyArray(source.twelveStages, this.validationTwelveStagesFromDisplay(reportData.displayPillars)),
            elements: elementDistribution,
            elementDistribution: elementDistribution,
            interactions: this.nonEmptyArray(source.interactions, reportData.interactionSections),
            nobleStars: nobleStars,
            specialStars: specialStars,
            stars: stars,
            emptyBranches: emptyBranches,
            voidBranches: emptyBranches,
            majorLuck: source.majorLuck || reportData.luckInfo || null,
            yearLuck: yearLuck,
            monthLuck: monthLuck,
            annualLuck: yearLuck,
            monthlyLuck: monthLuck,
            interpretationSignals: this.nonEmptyArray(source.interpretationSignals, reportData.interpretationSignals),
            chartSignature: source.chartSignature || reportData.calculation?.chartSignature || null,
            todos: Array.isArray(source.todos) ? source.todos : []
        };
    }

    public nonEmptyArray(value: any, fallback: any[] = []) {
        let array = this.displayArray(value);
        if (array.length) return array;
        return this.displayArray(fallback);
    }

    public displayArray(value: any) {
        if (Array.isArray(value)) return value.filter((item: any) => item !== null && item !== undefined);
        if (value && typeof value === 'object') {
            return Object.keys(value).map((key: string) => {
                let item = value[key];
                if (item && typeof item === 'object' && !Array.isArray(item)) {
                    return { label: item.label || this.validationLabel(key), key: key, ...item };
                }
                return { label: this.validationLabel(key), key: key, value: item };
            });
        }
        return [];
    }

    public validationPillarsFromDisplay(displayPillars: any[]) {
        return (displayPillars || []).map((pillar: any) => ({
            part: pillar.part || '',
            label: pillar.label || '-',
            stem: pillar.stemTenGod === '미정' || pillar.unknown ? '미정' : `${pillar.stem?.name || ''}${pillar.stem?.hanja || ''}` || '-',
            branch: pillar.branchTenGod === '미정' || pillar.unknown ? '미정' : `${pillar.branch?.name || ''}${pillar.branch?.hanja || ''}` || '-',
            stemTenGod: pillar.stemTenGod || '-',
            branchTenGod: pillar.branchTenGod || '-',
            hiddenText: pillar.hiddenText || '-',
            twelveStage: pillar.twelveStage || '-',
            starText: pillar.starText || '-',
            unknown: !!pillar.unknown
        }));
    }

    public validationHiddenStemsFromDisplay(displayPillars: any[]) {
        return (displayPillars || []).map((pillar: any) => ({
            part: pillar.part || '',
            branch: pillar.unknown ? '미정' : `${pillar.branch?.name || ''}${pillar.branch?.hanja || ''}` || '-',
            items: pillar.branchTenGods || []
        }));
    }

    public validationTwelveStagesFromDisplay(displayPillars: any[]) {
        return (displayPillars || []).map((pillar: any) => ({
            part: pillar.part || '',
            branch: pillar.unknown ? '미정' : `${pillar.branch?.name || ''}${pillar.branch?.hanja || ''}` || '-',
            stage: pillar.twelveStage || '-'
        }));
    }

    public validationLabel(key: string) {
        let labels: any = {
            name: '이름',
            birthDate: '생년월일',
            birthTime: '출생시간',
            timeUnknown: '생시 미정',
            calendarType: '달력',
            birthPlace: '출생지/보정',
            gender: '성별',
            targetYear: '세운 기준연도',
            rawBirthDate: '원본 생년월일',
            solarDate: '양력 환산일',
            originalDateTime: '원본 일시',
            adjustedDateTime: '보정 일시',
            timeCorrectionMinutes: '시간 보정',
            birthPlaceLabel: '보정 기준',
            timezone: '시간대',
            dayMaster: '일간',
            dayPillar: '일주',
            monthBranch: '월지',
            centerTenGods: '중심 십성',
            excessiveElements: '오행 과다',
            deficientElements: '오행 부족',
            strength: '신강/신약',
            coreInteractions: '핵심 합충',
            majorStars: '주요 신살',
            majorLuck: '대운 기준'
        };
        return labels[key] || key;
    }

    public validationValue(value: any) {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'boolean') return value ? '예' : '아니오';
        if (Array.isArray(value)) {
            if (!value.length) return '-';
            return value.map((item: any) => typeof item === 'object' ? JSON.stringify(item) : String(item)).join(' · ');
        }
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
    }

    public validationElements(validation: any) {
        return this.nonEmptyArray(validation?.elementDistribution || validation?.elements);
    }

    public validationTenGods(validation: any) {
        return this.nonEmptyArray(validation?.tenGods);
    }

    public validationNobleStars(validation: any) {
        return this.nonEmptyArray(validation?.nobleStars);
    }

    public validationSpecialStars(validation: any) {
        return this.nonEmptyArray(validation?.specialStars);
    }

    public validationStars(validation: any) {
        return this.nonEmptyArray(validation?.stars, [
            ...this.validationNobleStars(validation),
            ...this.validationSpecialStars(validation)
        ]);
    }

    public validationVoidBranches(validation: any) {
        return this.nonEmptyArray(validation?.voidBranches || validation?.emptyBranches);
    }

    public validationYearLuck(validation: any) {
        return this.nonEmptyArray(validation?.yearLuck || validation?.annualLuck);
    }

    public validationMonthLuck(validation: any) {
        return this.nonEmptyArray(validation?.monthLuck || validation?.monthlyLuck);
    }

    public resultElements(result: any) {
        return this.nonEmptyArray(result?.elements, result?.validation?.elements || result?.validation?.elementDistribution);
    }

    public resultTenGods(result: any) {
        return this.nonEmptyArray(result?.tenGods, result?.validation?.tenGods);
    }

    public resultNobleStars(result: any) {
        return this.nonEmptyArray(result?.nobleStars, result?.validation?.nobleStars);
    }

    public resultSpecialStars(result: any) {
        return this.nonEmptyArray(result?.specialStars, result?.validation?.specialStars);
    }

    public resultEmptyBranches(result: any) {
        return this.nonEmptyArray(result?.emptyBranches, result?.validation?.voidBranches || result?.validation?.emptyBranches);
    }

    public resultLuckFlow(result: any) {
        return this.nonEmptyArray(result?.luckFlow);
    }

    public resultAnnualLuck(result: any) {
        return this.nonEmptyArray(result?.annualLuck, result?.validation?.yearLuck || result?.validation?.annualLuck);
    }

    public resultMonthlyLuck(result: any) {
        return this.nonEmptyArray(result?.monthlyLuck, result?.validation?.monthLuck || result?.validation?.monthlyLuck);
    }

    public detailText(value: any) {
        if (Array.isArray(value)) return value.map((item: any) => String(item || '').trim()).filter(Boolean).join('\n');
        return String(value || '').trim();
    }

    public detailedReadingSectionBody(section: any) {
        return this.detailText(section?.body || section?.detail || section?.content || section?.summary);
    }

    public validationConfidencePercent(validation: any) {
        return Math.round(Number(validation?.confidence || 0) * 100);
    }

    public signalPercent(value: any) {
        return Math.round(Number(value || 0) * 100);
    }

    public limitationConfidencePercent(limitation: any) {
        return Math.round(Number(limitation?.confidence || 0) * 100);
    }

    public sectionConfidencePercent(confidence: any) {
        return Math.round(Number(confidence?.score ?? confidence?.confidence ?? 0) * 100);
    }

    public sectionConfidenceClass(confidence: any) {
        if (confidence?.referenceOnly || confidence?.level === 'low') return 'rounded-full bg-[#fff7ed] px-2.5 py-1 text-[10px] font-black text-[#b45309] ring-1 ring-[#fed7aa]';
        if (confidence?.level === 'medium') return 'rounded-full bg-[#eff6ff] px-2.5 py-1 text-[10px] font-black text-[#1d4ed8] ring-1 ring-[#bfdbfe]';
        return 'rounded-full bg-[#ecfdf3] px-2.5 py-1 text-[10px] font-black text-[#027a48] ring-1 ring-[#a6f4c5]';
    }

    public warningClass(severity: string) {
        if (severity === 'error') return 'rounded-[8px] bg-[#fff1f0] p-3 text-[12px] font-bold leading-5 text-[#b42318] ring-1 ring-[#f5b5ad]';
        if (severity === 'warning') return 'rounded-[8px] bg-[#fff7ed] p-3 text-[12px] font-bold leading-5 text-[#b45309] ring-1 ring-[#fed7aa]';
        return 'rounded-[8px] bg-[#eff6ff] p-3 text-[12px] font-bold leading-5 text-[#1d4ed8] ring-1 ring-[#bfdbfe]';
    }

    public manseSectionSummary(section: any) {
        if (section?.summary) return section.summary;
        if (section?.subtitle) return section.subtitle;
        let paragraph = this.chapterParagraphs(section)[0] || '';
        return this.firstSentence(paragraph).replace(/[.!?。！？]$/, '');
    }

    public chapterParagraphs(section: any) {
        if (Array.isArray(section?.paragraphs) && section.paragraphs.length) {
            return section.paragraphs.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        if (Array.isArray(section?.body)) {
            return section.body.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        if (Array.isArray(section?.detail)) {
            return section.detail.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        if (Array.isArray(section?.content)) {
            return section.content.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        let body = String(section?.body || section?.detail || section?.content || '').trim();
        return body ? [body] : [];
    }

    public chapterEvidencePoints(section: any) {
        if (Array.isArray(section?.points) && section.points.length) {
            return section.points.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        if (Array.isArray(section?.evidenceTags) && section.evidenceTags.length) {
            return section.evidenceTags.map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        if (Array.isArray(section?.evidence) && section.evidence.length) {
            return section.evidence.map((item: any) => {
                let label = item?.label || item?.evidenceId || '';
                let value = item?.value ? `: ${item.value}` : '';
                return `${label}${value}`.trim();
            }).filter(Boolean);
        }
        if (Array.isArray(section?.evidenceIds) && section.evidenceIds.length) {
            return section.evidenceIds.slice(0, 8).map((item: any) => String(item || '').trim()).filter(Boolean);
        }
        return [];
    }

    public elementCarePhrase(element: string) {
        let data: any = {
            목: '새로 시작할 여지',
            화: '표현하고 데워낼 시간',
            토: '몸과 일정의 안정감',
            금: '정리하고 덜어낼 기준',
            수: '생각을 흘려보낼 여백'
        };
        return data[element] || '생활의 균형';
    }

    public tenGodLifePhrase(label: string) {
        let data: any = {
            비견: '자기 기준을 지키는 방식',
            겁재: '판을 흔들고 밀고 나가는 감각',
            식신: '꾸준히 만들어내는 방식',
            상관: '새롭게 표현하고 바꾸는 방식',
            편재: '기회를 빨리 알아보는 방식',
            정재: '현실을 차곡차곡 관리하는 방식',
            편관: '긴장 속에서도 실행하는 방식',
            정관: '약속과 책임을 지키는 방식',
            편인: '보이지 않는 신호를 읽는 방식',
            정인: '배우고 정리해 안정시키는 방식',
            일간: '내 기준으로 세상을 고르는 방식'
        };
        return data[label] || data.일간;
    }

    public dayLifeTitle(dayProfile: any, tenGodLabel: string) {
        let keywordText = (dayProfile?.keywords || []).join(' ');
        if (/감각|미감|정성|섬세|완성|선택/.test(keywordText)) return '작은 차이를 빨리 알아보는 사람';
        if (/성장|개척|도전|생명력|확장/.test(keywordText)) return '먼저 길을 열어보는 사람';
        if (/책임|신뢰|관리|성실|축적/.test(keywordText)) return '맡은 일을 오래 붙잡는 사람';
        if (/직관|통찰|상상|지혜|관찰/.test(keywordText)) return '보이지 않는 흐름을 먼저 읽는 사람';
        if (/표현|존재감|매력|활력|열정/.test(keywordText)) return '분위기를 바꾸는 반응이 빠른 사람';
        return this.tenGodLifePhrase(tenGodLabel);
    }

    public coreLifeChapterTitle(dayProfile: any, dayTheory: any, branchProfile: any, seasonProfile: any) {
        let text = `${(dayProfile?.keywords || []).join(' ')} ${dayProfile?.theme || ''} ${branchProfile?.short || ''} ${seasonProfile?.keyword || ''}`;
        if (/감각|미감|정성|섬세|완성|선택/.test(text)) return '섬세한 기준을 편하게 쓰는 법';
        if (/성장|개척|도전|생명력|확장|시작/.test(text)) return '먼저 움직이는 힘을 오래 쓰는 법';
        if (/책임|신뢰|관리|성실|축적|현실/.test(text)) return '기준을 생활의 구조로 바꾸는 법';
        if (/직관|통찰|상상|지혜|관찰|생각/.test(text)) return '보이지 않는 흐름을 현실로 옮기는 법';
        if (/표현|존재감|매력|활력|열정/.test(text)) return '반응의 온도를 내 편으로 쓰는 법';
        return `${this.tenGodLifePhrase(dayTheory?.tenGod || '일간')}을 내 방식으로 쓰는 법`;
    }

    public moneyLifeTitle(count: number) {
        if (count >= 2) return '돈은 키우는 방식이 더 잘 맞습니다';
        if (count > 0) return '돈은 작게 잡아 오래 남기는 편이 맞습니다';
        return '돈은 신뢰가 쌓인 뒤 따라옵니다';
    }

    public interactionLifeTitle(activeInteractions: any[], strengthLabel: string = '중화') {
        if (activeInteractions?.length) return '관계 속에서 긴장을 푸는 법';
        if (strengthLabel === '신강') return '힘을 오래 쓰려면 쉬는 구조가 필요합니다';
        if (strengthLabel === '신약') return '흔들릴 때 나를 받쳐주는 순서';
        return '무리하지 않고 오래 가는 법';
    }

    public specialLifeTitle(noble: any, special: any) {
        if (noble) return '도움은 사람과 배움의 형태로 들어옵니다';
        if (special) return '내 안에 반복되는 특별한 기질';
        return '특별함은 기본기를 오래 쓰는 데 있습니다';
    }

    public elementBalanceLifeTitle(dominantElement: any, lackingElement: any) {
        let dominantMap: any = {
            목: '앞으로 나아가려는 힘',
            화: '표현하고 반응하는 힘',
            토: '흔들리는 것을 붙잡는 힘',
            금: '작은 차이를 골라내는 힘',
            수: '흐름을 읽고 생각을 잇는 힘'
        };
        let gap = Number(dominantElement?.value || 0) - Number(lackingElement?.value || 0);
        if (gap >= 2) return `${dominantMap[dominantElement?.label] || '잘 쓰는 힘'}은 충분하고, 쉬어갈 여백이 필요합니다`;
        if (gap >= 1) return `${dominantMap[dominantElement?.label] || '잘 쓰는 힘'}이 먼저 움직입니다`;
        return '한쪽으로 몰기보다 균형을 맞출 때 편합니다';
    }

    public elementBalanceSummary(lackingElement: any) {
        return `${this.elementCarePhrase(lackingElement?.label)}을 생활에 넣으면 마음의 속도가 안정됩니다`;
    }

    public careerEnvironmentTitle(dominantTenGodProfile: any, stemProfile: any) {
        let field = `${dominantTenGodProfile?.field || ''} ${dominantTenGodProfile?.work || ''} ${stemProfile?.work || ''}`;
        if (/디자인|검수|분석|기술|법무|재무|데이터|구조/.test(field)) return '작은 차이가 결과를 바꾸는 일이 잘 맞습니다';
        if (/영업|투자|사업|유통|스타트업|협상|네트워킹/.test(field)) return '움직임이 있는 판에서 감각이 살아납니다';
        if (/교육|연구|문서|상담|리서치|자격/.test(field)) return '깊게 배우고 정리하는 환경이 잘 맞습니다';
        if (/관리|운영|행정|조직|공공|인사/.test(field)) return '역할과 기준이 분명한 자리에서 안정됩니다';
        if (/콘텐츠|마케팅|창작|발표|브랜딩/.test(field)) return '표현이 결과로 이어지는 일이 잘 맞습니다';
        return '잘 맞는 환경을 고르면 실력이 오래 갑니다';
    }

    public relationshipLifeTitle(dayProfile: any, branchProfile: any) {
        let text = `${dayProfile?.relationshipStyle || ''} ${branchProfile?.relationship || ''}`;
        if (/진심|신뢰|말의 온도|태도/.test(text)) return '마음이 열리는 데는 온도가 필요합니다';
        if (/자유|거리|지적|교류/.test(text)) return '편한 거리가 있어야 관계가 오래 갑니다';
        if (/성장|함께|활력/.test(text)) return '함께 자라는 관계에서 힘이 납니다';
        if (/책임|약속|안정/.test(text)) return '약속이 쌓일수록 마음이 놓입니다';
        return '가까운 관계에서는 기준과 온도가 중요합니다';
    }

    public loveLifeTitle(dayProfile: any, branchProfile: any, tenGodLabel: string) {
        let text = `${dayProfile?.loveStyle || ''} ${branchProfile?.relationship || ''} ${tenGodLabel || ''}`;
        if (/천천|오래|깊|안전/.test(text)) return '천천히 가까워질수록 깊어지는 사랑';
        if (/표현|솔직|열정|애정/.test(text)) return '표현의 온도를 맞출 때 사랑이 안정됩니다';
        if (/자유|거리|교류/.test(text)) return '좋아해도 숨 쉴 거리가 필요합니다';
        if (/약속|책임|안정/.test(text)) return '사랑은 약속이 쌓일 때 편해집니다';
        return '친밀감의 속도를 맞출 때 오래 갑니다';
    }

    public relationshipStyleFallback(branchName: string, branchProfile: any, tenGodLabel: string, stemProfile: any) {
        let branchText = this.socialRelationshipBranchText(branchName);
        let tenGodText = this.socialRelationshipTenGodText(tenGodLabel);
        let stemText = this.firstSentence(stemProfile?.relationship || branchProfile?.relationship || '');
        return `${branchText} ${tenGodText} ${stemText}`;
    }

    public loveStyleFallback(branchName: string, tenGodLabel: string, stemProfile: any) {
        let branchText = this.loveBranchText(branchName);
        let tenGodText = this.loveTenGodText(tenGodLabel);
        let stemText = this.loveStemText(stemProfile?.keyword || '');
        return `${branchText} ${tenGodText} ${stemText}`;
    }

    public socialRelationshipBranchText(branchName: string) {
        let data: any = {
            자: '친구나 동료 사이에서는 말보다 분위기와 신뢰의 흐름을 먼저 봅니다.',
            축: '사람을 천천히 확인하고, 책임 있게 행동하는 사람에게 마음이 놓입니다.',
            인: '같이 성장하거나 새 일을 시작할 수 있는 관계에서 활력이 납니다.',
            묘: '상대의 표정과 반응을 빨리 읽어 분위기를 부드럽게 맞춥니다.',
            진: '관계 안에서 역할과 책임이 흐려지면 먼저 기준을 정리하려 합니다.',
            사: '대화의 열기와 현실 조건이 함께 맞을 때 사람을 편하게 대합니다.',
            오: '솔직한 표현을 좋아하지만, 자존심이 부딪히면 거리가 생길 수 있습니다.',
            미: '챙김이 자연스럽지만 부담이 한쪽으로 몰리면 피로가 쌓입니다.',
            신: '지적 교류와 자유로운 호흡이 있어야 오래 편하게 지냅니다.',
            유: '예의, 약속, 취향의 기준이 맞는 사람에게 신뢰가 빨리 생깁니다.',
            술: '의리와 약속을 중요하게 보고, 방어적인 사람에게는 천천히 다가갑니다.',
            해: '정서적 안정과 각자의 자유가 함께 있을 때 관계가 오래 갑니다.'
        };
        return data[branchName] || '관계에서는 서로의 속도와 기준을 확인할 때 편해집니다.';
    }

    public socialRelationshipTenGodText(label: string) {
        let data: any = {
            비견: '대등한 동료감이 중요하고 간섭이 많으면 피로가 커집니다.',
            겁재: '호흡이 빠른 사람과 쉽게 가까워지지만 경쟁 구도는 조심해야 합니다.',
            식신: '편안한 반복과 생활감 있는 대화가 신뢰를 만듭니다.',
            상관: '솔직한 말맛이 장점이지만 비판처럼 들리지 않게 온도를 조절해야 합니다.',
            편재: '넓은 네트워크에서 기회를 잘 잡지만 약속 관리는 따로 챙겨야 합니다.',
            정재: '성실하고 예측 가능한 사람과 오래 안정됩니다.',
            편관: '책임감 있는 사람에게 끌리지만 통제처럼 느껴지는 방식은 불편합니다.',
            정관: '예의와 규칙을 지키는 관계에서 마음이 놓입니다.',
            편인: '혼자 생각할 틈과 깊은 대화가 함께 있어야 편합니다.',
            정인: '배려와 안정감이 있는 관계에서 회복이 빠릅니다.',
            일간: '내 기준을 존중받을 때 관계도 자연스럽게 풀립니다.'
        };
        return data[label] || data.일간;
    }

    public loveBranchText(branchName: string) {
        let data: any = {
            자: '연애에서는 말보다 감정의 안전감이 먼저 확인되어야 마음이 깊어집니다.',
            축: '천천히 쌓이는 신뢰와 현실적인 책임감에 오래 끌립니다.',
            인: '같이 새로운 것을 해보는 사람에게 설렘이 살아납니다.',
            묘: '다정한 말, 취향 공유, 섬세한 반응에서 마음이 열립니다.',
            진: '애정이 깊어질수록 관계의 방향과 역할을 분명히 하고 싶어집니다.',
            사: '표현의 열기와 실제 행동이 함께 맞을 때 끌림이 커집니다.',
            오: '솔직한 애정 표현에 반응하지만 자존심을 건드리는 말에는 예민해집니다.',
            미: '챙겨주고 싶은 마음이 사랑으로 이어지지만 혼자 부담을 안지 않아야 합니다.',
            신: '대화가 통하고 각자의 자유를 존중하는 사람에게 오래 끌립니다.',
            유: '예의 있는 표현, 취향의 선명함, 약속을 지키는 태도를 중요하게 봅니다.',
            술: '의리와 보호감이 있는 사랑에서 안정되고, 불확실한 관계에는 신중해집니다.',
            해: '정서적으로 편하고 상상력을 나눌 수 있는 사람에게 마음이 깊어집니다.'
        };
        return data[branchName] || '연애에서는 친밀감의 속도와 마음의 안전감을 함께 봅니다.';
    }

    public loveTenGodText(label: string) {
        let data: any = {
            비견: '대등한 연애를 원해서 간섭보다 존중이 오래 갑니다.',
            겁재: '강한 끌림이 빨리 올 수 있어 속도 조절이 관계의 질을 바꿉니다.',
            식신: '편안한 애정 표현과 일상의 안정감이 사랑을 키웁니다.',
            상관: '매력과 솔직함이 살아나지만 말의 날을 부드럽게 다듬어야 합니다.',
            편재: '활동적인 사람에게 끌리지만 관계의 약속을 구체화해야 오래 갑니다.',
            정재: '성실하고 안정적인 사람에게 마음이 놓입니다.',
            편관: '보호받고 함께 책임지는 감각에 끌리지만 통제는 경계합니다.',
            정관: '예의, 약속, 미래의 기준이 맞을 때 마음을 깊게 줍니다.',
            편인: '정신적으로 통하는 사람에게 끌리고 혼자만의 시간이 필요합니다.',
            정인: '따뜻한 돌봄과 안정감이 애정 표현의 중심이 됩니다.',
            일간: '좋아할수록 내 속도와 기준을 잃지 않는 것이 중요합니다.'
        };
        return data[label] || data.일간;
    }

    public loveStemText(keyword: string) {
        if (/표현|온기|존재감|열/.test(keyword)) return '좋아하는 마음도 말과 행동의 온도로 드러나는 편입니다.';
        if (/정교|완성|결단|기준/.test(keyword)) return '사소한 무심함보다 세심한 존중을 오래 기억합니다.';
        if (/유연|감수|통찰|사고/.test(keyword)) return '감정이 편안히 흐를 때 깊은 이야기를 나누고 싶어집니다.';
        if (/현실|포용|중심|책임/.test(keyword)) return '사랑도 생활의 안정감과 함께 놓일 때 편합니다.';
        return '관계가 가까워질수록 표현보다 지속적인 태도를 더 봅니다.';
    }

    public isManseTimeUnknown(reportData: any) {
        return !!(
            reportData?.validation?.normalizedInput?.timeUnknown ||
            reportData?.calculation?.normalizedInput?.timeUnknown ||
            reportData?.calculation?.calculationOptions?.timeUnknown ||
            reportData?.pillars?.[3]?.unknown
        );
    }

    public applyTimeUnknownSectionConfidence<T extends { key?: string; confidence?: any }>(sections: T[], reportData: ManseReportData): T[] {
        if (!this.isManseTimeUnknown(reportData)) return sections;
        let payloadConfidence = Number(reportData.validation?.confidence || reportData.calculation?.confidence || 0.85);
        let note = '생시 미정으로 시주·시지·시주 기반 십성/신살/합충 근거를 제외했습니다.';
        let configs: any = {
            core: { level: 'medium', score: 0.78, label: '시주 제외', reason: `${note} 핵심 성향은 년주·월주·일주 중심으로만 읽습니다.` },
            elements: { level: 'medium', score: 0.7, label: '참고용', reason: `${note} 오행 분포는 전체 8글자가 아닌 확인 가능한 6글자 기준입니다.`, referenceOnly: true },
            day: { level: 'medium', score: 0.82, label: '일주 중심', reason: '일주와 월지는 유지되지만, 시주가 보태는 반응 방식은 제외했습니다.' },
            relationship: { level: 'medium', score: 0.78, label: '일지 중심', reason: '관계 해석은 일지와 인성·관성 중심으로만 보며 시지 기반 가족/자녀 신호는 제외했습니다.' },
            love: { level: 'medium', score: 0.78, label: '일지 중심', reason: '연애 해석은 일지와 일지 육친 중심으로만 보며 시지 기반 배우자/자녀 확장 신호는 제외했습니다.' },
            career: { level: 'low', score: 0.6, label: '참고용', reason: '직업 해석 중 시주가 보조하는 결실, 산출물, 후반부 역할 신호는 확인할 수 없습니다.', referenceOnly: true },
            money: { level: 'medium', score: 0.68, label: '참고용', reason: '재성 흐름은 일간 기준으로 읽지만 시주 십성 누락으로 분포 해석은 낮춰 봅니다.', referenceOnly: true },
            caution: { level: 'low', score: 0.65, label: '참고용', reason: '합충형파해는 년주·월주·일주 사이만 확정하고 시주 포함 긴장은 판단하지 않습니다.', referenceOnly: true },
            value: { level: 'low', score: 0.65, label: '참고용', reason: '신살과 귀인성은 확인 가능한 기둥만 사용하며 시지 기준 신살은 제외했습니다.', referenceOnly: true },
            place: { level: 'medium', score: 0.7, label: '참고용', reason: '보완 기운은 시주 제외 분포에서 나온 후보라 생활 조언 수준으로만 봅니다.', referenceOnly: true },
            cycle: { level: 'medium', score: 0.72, label: '참고용', reason: '대운 방향은 유지하지만 시작 세부시점은 정오 기준 약식 계산입니다.', referenceOnly: true },
            closing: { level: 'medium', score: 0.75, label: '시주 제외', reason: `${note} 마지막 조언은 확정 가능한 원국 근거만 요약합니다.` }
        };

        return (sections || []).map((section: any) => {
            let config = configs[section.key] || { level: 'medium', score: 0.7, label: '시주 제외', reason: note };
            return {
                ...section,
                confidence: {
                    ...config,
                    score: Math.round(Math.min(payloadConfidence, config.score) * 100) / 100
                }
            };
        }) as T[];
    }

    public normalizeManseReportChapter(section: any, reportData: ManseReportData): ReportChapter {
        let key = String(section?.key || section?.chapterId || section?.id || 'custom').replace(/^manse-chapter-/, '');
        let paragraphs = (section?.paragraphs || [])
            .map((paragraph: any) => String(paragraph || '').trim())
            .filter(Boolean);
        let evidenceIds = this.manseReportChapterEvidenceIds(key, reportData);
        let cautions = this.manseReportChapterCautions(key, reportData, section);
        let confidence = section?.confidence || this.manseReportChapterConfidence(key, evidenceIds, reportData);
        return {
            ...section,
            id: section?.id || `manse-chapter-${key}`,
            chapterId: section?.chapterId || key,
            key: key,
            theme: this.manseReportChapterTheme(key),
            role: section?.role || this.manseReportChapterTheme(key),
            title: String(section?.title || ''),
            subtitle: String(section?.subtitle || ''),
            summary: String(section?.summary || this.manseSectionSummary(section)),
            body: paragraphs,
            paragraphs: paragraphs,
            evidenceIds: evidenceIds,
            confidence: confidence,
            advice: section?.advice || this.manseReportChapterAdvice(key, reportData, section),
            caution: section?.caution || cautions[0],
            cautions: cautions
        };
    }

    public manseReportChapterTheme(key: string): ReportChapterTheme {
        let themes: any = {
            core: 'core_image',
            elements: 'element_balance',
            day: 'day_pillar',
            relationship: 'friends',
            love: 'love',
            career: 'work',
            money: 'money',
            caution: 'strength',
            value: 'stars',
            place: 'place_routine',
            cycle: 'cycle',
            closing: 'advice'
        };
        return themes[key] || 'custom';
    }

    public manseReportChapterEvidenceIds(key: string, reportData: ManseReportData): string[] {
        let context = reportData.reading;
        let dayPillar = context.dayPillar || {};
        let monthPillar = context.monthPillar || {};
        let yearPillar = context.yearPillar || {};
        let hourPillar = context.hourPillar || {};
        let dominantElement = context.dominantElement || {};
        let lackingElement = context.lackingElement || {};
        let dayTheory = context.dayTheory || {};
        let dominantTenGod = context.dominantTenGod || {};
        let chartSignature = reportData.validation?.chartSignature || reportData.calculation?.chartSignature;
        let base = [
            ...(chartSignature?.evidenceIds || []),
            chartSignature?.key ? `chartSignature:${chartSignature.key}` : '',
            `pillar:year:${yearPillar.label || '-'}`,
            `pillar:month:${monthPillar.label || '-'}`,
            `pillar:day:${dayPillar.label || '-'}`,
            hourPillar?.unknown ? 'pillar:hour:unknown' : `pillar:hour:${hourPillar.label || '-'}`,
            context.timeUnknown ? 'timeUnknown:true' : 'timeUnknown:false'
        ];
        let activeInteractions = context.activeInteractions || [];
        let rawElements = context.rawElements || [];
        let byKey: any = {
            core: [
                `dayMaster:${dayPillar.stem?.name || '-'}`,
                `dayPillar:${dayPillar.label || '-'}`,
                `monthBranch:${monthPillar.branch?.name || '-'}`,
                `tenGod:dayBranch:${dayTheory.tenGod || '-'}`
            ],
            elements: [
                ...rawElements.map((item: any) => `element:${item.label}:value:${item.value}:percent:${item.percent || 0}`),
                `element:dominant:${dominantElement.label || '-'}`,
                `element:lacking:${lackingElement.label || '-'}`,
                `usefulElements:${(context.usefulElements || []).join('|') || '-'}`
            ],
            day: [
                `dayPillar:${dayPillar.label || '-'}`,
                `dayBranch:${dayPillar.branch?.name || '-'}`,
                `tenGod:dayBranch:${dayTheory.tenGod || '-'}`,
                `twelveStage:${dayTheory.stage || '-'}`
            ],
            relationship: [
                `dayBranch:${dayPillar.branch?.name || '-'}`,
                `element:resource:${context.resourceElement || '-'}`,
                `element:officer:${context.officerElement || '-'}`
            ],
            love: [
                `dayBranch:${dayPillar.branch?.name || '-'}`,
                `tenGod:dayBranch:${dayTheory.tenGod || '-'}`,
                `role:love`
            ],
            career: [
                `tenGod:dominant:${dominantTenGod.label || '-'}`,
                `element:output:${context.outputElement || '-'}`,
                `dayMaster:${dayPillar.stem?.name || '-'}`
            ],
            money: [
                `element:wealth:${context.wealthElement || '-'}`,
                `wealthCount:${context.wealthCount ?? '-'}`,
                `tenGod:dominant:${dominantTenGod.label || '-'}`
            ],
            caution: activeInteractions.length
                ? activeInteractions.flatMap((section: any) => (section.items || []).map((item: any) => `interaction:${section.label}:${item}`))
                : [`strength:${reportData.personality?.strengthLabel || '-'}`, `tenGod:dayBranch:${dayTheory.tenGod || '-'}`, `twelveStage:${dayTheory.stage || '-'}`],
            value: [
                context.noble ? `star:noble:${context.noble.name}:${context.noble.location}` : '',
                context.special ? `star:special:${context.special.name}:${context.special.location}` : '',
                `tenGod:dominant:${dominantTenGod.label || '-'}`
            ],
            place: [
                `element:lacking:${lackingElement.label || '-'}`,
                `usefulElements:${(context.usefulElements || []).join('|') || '-'}`,
                `placeRoutine:${context.placeProfile?.label || '-'}`
            ],
            cycle: [
                `luck:direction:${reportData.luckInfo?.direction || '-'}`,
                `luck:startAge:${reportData.luckInfo?.startAgeLabel || reportData.luckInfo?.startAge || '-'}`,
                `luck:basis:${reportData.luckInfo?.basisTerm || '-'}`
            ],
            closing: [
                `dayPillar:${dayPillar.label || '-'}`,
                `monthBranch:${monthPillar.branch?.name || '-'}`,
                `tenGod:dominant:${dominantTenGod.label || '-'}`,
                `usefulElements:${(context.usefulElements || []).join('|') || '-'}`
            ]
        };
        return this.uniqueTexts([...base, ...(byKey[key] || [])]);
    }

    public manseReportChapterConfidence(key: string, evidenceIds: string[], reportData: ManseReportData) {
        let score = this.clamp(Number(reportData.validation?.confidence || reportData.calculation?.confidence || 0.9), 0, 1);
        let level = score >= 0.9 && evidenceIds.length >= 2 ? 'high' : score >= 0.72 ? 'medium' : 'low';
        return {
            level: level,
            score: Math.round(score * 100) / 100,
            label: level === 'high' ? '근거 충분' : level === 'medium' ? '근거 보통' : '참고용',
            reason: `${this.manseReportChapterTheme(key)} 챕터는 계산 payload의 확정 근거 ${evidenceIds.length}개를 참조합니다.`
        };
    }

    public manseReportChapterAdvice(key: string, reportData: ManseReportData, section: any) {
        let paragraphs = section?.paragraphs || [];
        let explicitAdvice = paragraphs.find((paragraph: string) => /현실 조언|현실적으로|마지막 조언|결정 전/.test(paragraph));
        if (explicitAdvice) return this.firstSentence(explicitAdvice);
        let data: any = {
            core: '결정해야 할 때 기준을 세 가지로 줄이고, 마지막 하나는 몸이 편해지는 쪽으로 남겨두세요.',
            elements: `${(reportData.reading.usefulElements || []).join(', ')} 중 하나를 매일 같은 시간에 반복해보세요.`,
            day: '결정 전에는 지금 중요한 기준을 먼저 적고, 나머지는 다음 선택으로 넘기면 편합니다.',
            relationship: '역할, 약속, 싫은 지점을 작게 나누어 확인하는 편이 좋습니다.',
            love: '호감은 인정하되, 친밀감은 대화와 행동이 반복되는지를 보고 천천히 깊게 두세요.',
            career: '평가 기준, 마감, 권한이 보이는 환경을 고르는 편이 좋습니다.',
            money: '수입을 늘리는 계획과 새어 나가는 돈을 막는 규칙을 따로 두세요.',
            caution: '피곤한 날의 기준을 따로 정해두면 평소의 높은 기준에 덜 소모됩니다.',
            value: '배움과 소개가 오가는 자리에 꾸준히 얼굴을 비추는 편이 좋습니다.',
            place: '책상, 산책길, 카페, 운동 시간 중 가장 쉽게 반복할 수 있는 곳부터 정하세요.',
            cycle: '한 해 계획은 크게 세우되 실제 행동은 분기마다 하나씩만 바꾸세요.',
            closing: '잘하는 방식과 쉬는 장치를 같은 일정 안에 넣어두세요.'
        };
        return data[key] || this.firstSentence(paragraphs[paragraphs.length - 1] || '');
    }

    public manseReportChapterCautions(key: string, reportData: ManseReportData, section: any): string[] {
        let context = reportData.reading;
        let data: any = {
            core: '마음이 따라오지 않은 결정을 오래 밀어붙이면 피로가 커질 수 있습니다.',
            elements: `${context.lackingElement?.label || '보완 기운'} 부족을 성격 결함으로 단정하지 않고 생활 리듬의 빈자리로만 봅니다.`,
            day: `${context.dayTheory?.tenGod || '일지 육친'} 해석만으로 전체 성격을 단정하지 않습니다.`,
            relationship: '사회적 관계의 거리감과 연애의 친밀감은 같은 문장으로 섞지 않습니다.',
            love: '끌림의 속도를 결혼, 이별, 만남 시기 같은 단정 예언으로 확장하지 않습니다.',
            career: '직업명 확정이 아니라 잘 맞는 역할과 환경 조건으로만 읽습니다.',
            money: '돈복을 단정하지 않고 재성 흐름과 관리 습관을 분리해 봅니다.',
            caution: '긴장 신호는 공포 조장이 아니라 반복 패턴을 알아차리는 참고 근거입니다.',
            value: '귀인과 신살은 자동 행운처럼 단정하지 않고 도움을 받기 쉬운 태도로 번역합니다.',
            place: '장소와 루틴 조언은 미신적 지시가 아니라 보완 기운을 생활 행동으로 낮춘 것입니다.',
            cycle: '대운 문장은 사건 예언이 아니라 계획 단위를 조절하는 참고 흐름입니다.',
            closing: '마지막 조언은 앞 챕터의 근거를 요약한 것이며 새로운 계산 주장을 추가하지 않습니다.'
        };
        let cautions = [section?.caution, data[key]].filter(Boolean);
        return this.uniqueTexts(cautions);
    }

    public buildSajuKidSections(reportData: ManseReportData): ReportChapter[] {
        let context = reportData.reading;
        let personality = reportData.personality;
        let luckInfo = reportData.luckInfo;
        let topic = context.topic;
        let possessive = context.possessive;
        let yearPillar = context.yearPillar;
        let monthPillar = context.monthPillar;
        let dayPillar = context.dayPillar;
        let dominantElement = context.dominantElement;
        let lackingElement = context.lackingElement;
        let elementText = context.elementText;
        let dayTheory = context.dayTheory;
        let stemProfile = context.stemProfile;
        let branchProfile = context.branchProfile;
        let seasonProfile = context.seasonProfile;
        let dayTheoryTenGodProfile = context.dayTheoryTenGodProfile;
        let dayProfile = context.dayProfile;
        let dominantTenGod = context.dominantTenGod;
        let dominantTenGodProfile = context.dominantTenGodProfile;
        let outputElement = context.outputElement;
        let wealthElement = context.wealthElement;
        let resourceElement = context.resourceElement;
        let officerElement = context.officerElement;
        let usefulElements = context.usefulElements;
        let usefulText = context.usefulText;
        let activeInteractions = context.activeInteractions;
        let activeInteractionText = context.activeInteractionText;
        let noble = context.noble;
        let nobleText = context.nobleText;
        let specialText = context.specialText;
        let placeProfile = context.placeProfile;
        let wealthCount = context.wealthCount;
        let wealthText = context.wealthText;
        let titles = context.titles;
        let coreIdentity = dayProfile.traitTitle || dayProfile.subtitle || '자기만의 기준을 가진 사람';
        let usefulActions = usefulElements.map((element: string) => this.elementTone(element).action).join(', ');
        let relationshipSentence = this.firstSentence(dayProfile.relationshipStyle || this.relationshipStyleFallback(dayPillar.branch.name, branchProfile, dayTheory.tenGod, stemProfile));
        let relationshipSocialText = this.socialRelationshipBranchText(dayPillar.branch.name);
        let loveSentence = this.firstSentence(dayProfile.loveStyle || this.loveStyleFallback(dayPillar.branch.name, dayTheory.tenGod, stemProfile));
        let loveTenGodText = this.loveTenGodText(dayTheory.tenGod);
        let decisionSentence = this.firstSentence(dayProfile.decisionStyle || dayProfile.traitBody);
        let careerSentence = this.firstSentence(dominantTenGodProfile.work || stemProfile.work);
        let moneyAdvice = wealthCount >= 2
            ? '기회를 발견하는 속도는 장점으로 두되, 들어온 돈이 머무를 규칙을 먼저 세우면 좋습니다.'
            : wealthCount > 0
                ? '작게 시작해 반복 가능한 단위로 키울 때 돈의 흐름이 안정됩니다.'
                : '돈 자체를 바로 좇기보다 실력, 신뢰, 소개의 통로를 먼저 넓히는 편이 좋습니다.';

        let sections = [
            {
                key: 'core',
                icon: '✦',
                kicker: '나는 어떤 사람인가',
                title: titles.core,
                subtitle: `${coreIdentity}으로 읽힙니다`,
                summary: '작은 선택에서도 자기 기준이 먼저 움직입니다',
                paragraphs: [
                    `${topic} 작은 선택을 대충 넘기기보다, 마음에 걸리는 차이를 오래 살피는 편입니다. ${dayProfile.oneLine}`,
                    `중요한 일일수록 속도보다 납득이 먼저입니다. 충분히 보고 고른 선택은 오래 지키지만, 마음이 따라오지 않은 결정은 쉽게 피로해질 수 있습니다.`,
                    `현실 조언은 간단합니다. 결정해야 할 때 기준을 세 가지로 줄이고, 마지막 하나는 몸이 편해지는 쪽으로 남겨두세요.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `${context.pillarEvidenceText} 태어난 계절의 ${seasonProfile.keyword}이 같은 성향의 속도와 온도를 바꿉니다.`,
                points: [`일간 ${dayPillar.stem.name}${dayPillar.stem.hanja} · ${stemProfile.keyword}`, `월지 ${monthPillar.branch.name}${monthPillar.branch.hanja} · ${seasonProfile.keyword}`, `${dayTheory.tenGod} · ${dayTheory.stage}`]
            },
            {
                key: 'elements',
                icon: '▱',
                kicker: '내 안의 기운 균형',
                title: titles.elements,
                subtitle: `잘 쓰는 힘과 비어 있는 리듬을 나눠 봅니다`,
                summary: this.elementBalanceSummary(lackingElement),
                paragraphs: [
                    `${possessive} 에너지는 이미 잘 굴러가는 방향이 있습니다. 그 힘을 계속 밀기만 하면 성과는 빨라져도 마음의 숨이 좁아질 수 있습니다.`,
                    `비어 있는 리듬은 성격의 문제가 아니라 생활에서 채워야 할 자리입니다. 특히 ${this.elementCarePhrase(lackingElement.label)}이 생기면 판단이 덜 조급해집니다.`,
                    `현실적으로는 ${usefulActions} 중 하나를 매일 같은 시간에 반복해보세요. 작게 반복되는 행동이 균형을 오래 잡아줍니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `오행 분포 ${elementText}를 비교했습니다. ${this.elementBalanceTone(dominantElement, lackingElement)}`,
                points: [`강한 기운: ${dominantElement.label}${this.cleanCountValue(dominantElement.value)}`, `보완 기운: ${lackingElement.label}${this.cleanCountValue(lackingElement.value)}`, `용신 후보: ${usefulText}`]
            },
            {
                key: 'day',
                icon: '◎',
                kicker: '내가 세상을 받아들이는 방식',
                title: titles.day,
                subtitle: `상황을 판단하기 전에 먼저 살피는 것이 있습니다`,
                summary: `${this.tenGodLifePhrase(dayTheory.tenGod)}으로 상황을 걸러 봅니다`,
                paragraphs: [
                    `${topic} 상황을 즉시 결론내기보다, 작은 차이와 분위기를 먼저 살핀 뒤 마음이 납득하는 쪽을 고릅니다. ${dayProfile.traitBody}`,
                    `이 방식은 신중함을 만들지만, 선택지가 많아지면 오래 망설이게 할 수도 있습니다. ${decisionSentence}`,
                    `결정 전에는 "지금 중요한 기준은 무엇인가"를 먼저 적고, 나머지는 다음 선택으로 넘기면 편합니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `일지 ${dayPillar.branch.name}${dayPillar.branch.hanja}, ${dayTheory.tenGod}, 십이운성 ${dayTheory.stage}를 함께 보았습니다. 이 조합은 ${dayTheory.stageTone}으로 읽습니다.`,
                points: [stemProfile.keyword, branchProfile.short, `${dayTheory.tenGod}: ${dayTheoryTenGodProfile.field}`]
            },
            {
                key: 'relationship',
                icon: '⌂',
                kicker: '관계에서 드러나는 모습',
                title: titles.relationship,
                subtitle: `친구와 동료 사이에서 편한 거리와 신뢰 방식을 봅니다`,
                summary: `가까워지는 속도보다 오래 편한 기준이 중요합니다`,
                paragraphs: [
                    `친구나 동료 관계에서는 친해지는 속도보다 서로의 기준을 확인하는 과정이 더 중요합니다. ${relationshipSocialText}`,
                    `${relationshipSentence} 불편한 사람 앞에서는 ${this.firstSentence(branchProfile.caution)}`,
                    `현실 조언으로는 역할, 약속, 싫은 지점을 작게 나누어 확인하는 편이 좋습니다. 그렇게 해야 호의가 부담으로 쌓이지 않습니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `관계 해석은 일지 ${dayPillar.branch.name}${dayPillar.branch.hanja}, ${resourceElement} 인성, ${officerElement} 관성을 함께 본 것입니다.`,
                points: [`일지: ${branchProfile.short}`, `인성: ${resourceElement}`, `관성: ${officerElement}`]
            },
            {
                key: 'love',
                icon: '♥',
                kicker: '연애에서 가까워지는 방식',
                title: titles.love,
                subtitle: `끌리는 사람, 애정 표현, 친밀감의 속도를 따로 봅니다`,
                summary: `좋아하는 마음도 안전한 리듬이 있을 때 깊어집니다`,
                paragraphs: [
                    `연애에서는 사회적 관계보다 훨씬 가까운 거리에서 마음의 안전감을 확인합니다. ${loveSentence}`,
                    `${loveTenGodText} 반복되는 패턴은 좋아질수록 상대에게 맞추려는 부분과 끝까지 지키고 싶은 내 기준이 동시에 커지는 데서 생깁니다.`,
                    `현실 조언으로는 설렘의 속도와 생활의 약속을 분리해보는 것입니다. 호감은 빠르게 인정하되, 친밀감은 대화와 행동이 반복되는지를 보고 천천히 깊게 두는 편이 안정됩니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `연애 해석은 일지 ${dayPillar.branch.name}${dayPillar.branch.hanja}, 일지 육친 ${dayTheory.tenGod}, 일간 ${dayPillar.stem.name}${dayPillar.stem.hanja}의 표현 방식을 분리해 본 것입니다.`,
                points: [`끌리는 사람: ${this.stripSentenceEnd(this.loveBranchText(dayPillar.branch.name))}`, `애정 표현: ${this.stripSentenceEnd(loveTenGodText)}`, `내 기준: ${stemProfile.keyword}`]
            },
            {
                key: 'career',
                icon: '▣',
                kicker: '일과 직업에서 잘 맞는 환경',
                title: titles.career,
                subtitle: `잘하는 일을 오래 쓰려면 환경의 조건이 중요합니다`,
                summary: `역할과 결과 기준이 보일 때 실력이 살아납니다`,
                paragraphs: [
                    `${possessive} 일은 감각만 믿고 던지는 방식보다, 역할과 마감선이 분명한 환경에서 더 안정적으로 풀립니다. 작은 차이를 알아보는 눈이 결과물의 질을 높이는 쪽으로 쓰입니다.`,
                    `${careerSentence} 결과물을 밖으로 내놓을 때는 ${this.elementTone(outputElement).action} 방식이 실력으로 남습니다.`,
                    `현실적으로는 평가 기준, 마감, 권한이 흐릿한 자리보다 무엇을 잘하면 인정받는지 보이는 곳을 고르는 편이 좋습니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `일의 방향은 중심 십신 ${dominantTenGod.label}, 식상 ${outputElement}, 일간의 처리 방식을 함께 보았습니다.${context.timeUnknown ? ' 생시가 필요한 결실·후반 역할·자녀/제자 관련 직업 신호는 참고용으로만 봅니다.' : ''}`,
                points: [dominantTenGodProfile.field, `식상: ${outputElement}`, `일 처리: ${stemProfile.keyword}`]
            },
            {
                key: 'money',
                icon: '◌',
                kicker: '돈을 벌고 쓰고 모으는 방식',
                title: titles.money,
                subtitle: `기회와 관리의 속도를 나눠두면 돈이 덜 새어 나갑니다`,
                summary: `돈은 성향을 거스르기보다 맞는 방식으로 키울 때 안정됩니다`,
                paragraphs: [
                    `${wealthText} 그래서 돈을 다룰 때도 한 번에 크게 바꾸기보다, 자신이 잘 보는 기회와 꾸준히 관리할 수 있는 범위를 구분하는 편이 좋습니다.`,
                    `${moneyAdvice} ${dominantTenGod.label === '편재' || dominantTenGod.label === '정재' ? dominantTenGodProfile.talent : `먼저 ${dominantTenGodProfile.field}에서 신뢰를 만들고, 그 다음 돈의 통로를 넓히는 순서가 편합니다.`}`,
                    `현실 조언은 수입을 늘리는 계획과 새어 나가는 돈을 막는 규칙을 따로 두는 것입니다. 두 장부를 나누면 판단이 훨씬 선명해집니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `재물 해석은 일간 ${dayPillar.stem.name}${dayPillar.stem.hanja}이 다루는 ${wealthElement} 재성과 중심 십신 ${dominantTenGod.label}을 근거로 보았습니다.`,
                points: [`재성: ${wealthElement}${this.cleanCountValue(wealthCount)}`, `관리 방식: ${this.elementTone(wealthElement).action}`, `중심 십신: ${dominantTenGod.label}`]
            },
            {
                key: 'caution',
                icon: '⌁',
                kicker: '반복되는 고민과 약점',
                title: titles.caution,
                subtitle: activeInteractions.length ? `긴장이 생기는 패턴을 알면 선택이 가벼워집니다` : `무리하기 쉬운 지점을 미리 알면 에너지를 덜 씁니다`,
                summary: activeInteractions.length ? `같은 문제를 반복하기 전에 신호를 알아차리는 편이 좋습니다` : `잘하던 방식이 피곤한 날에도 계속될 때 고민이 생깁니다`,
                paragraphs: [
                    `반복되는 고민은 성향이 나빠서가 아니라, 잘 쓰던 방식이 피곤한 날에도 그대로 작동할 때 생깁니다. 기준이 높아질수록 선택은 정교해지지만 마음의 여백은 줄어들 수 있습니다.`,
                    `살펴볼 점은 ${this.firstSentence(dayTheoryTenGodProfile.caution)} ${this.firstSentence(branchProfile.caution)}`,
                    `현실 조언으로는 피곤한 날의 기준을 따로 정해두는 것이 좋습니다. 평소의 높은 기준을 그대로 적용하지 않아도 흐름이 무너지지 않습니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `긴장 지점은 ${activeInteractions.length ? activeInteractionText : `${personality?.strengthLabel || '중화'} 흐름과 ${dayTheory.tenGod}·${dayTheory.stage} 리듬`}을 근거로 보았습니다. ${specialText}`,
                points: activeInteractions.length ? activeInteractions.map((section: any) => `${section.label}: ${section.items[0]}`) : [`${dayTheory.tenGod} 조율`, `${dayTheory.stage} 리듬`, `${lackingElement.label} 보완`]
            },
            {
                key: 'value',
                icon: '♡',
                kicker: '내 사주의 특별한 기질',
                title: titles.value,
                subtitle: noble ? `도움은 우연보다 준비된 태도와 좋은 연결에서 들어옵니다` : `특별한 표식보다 오래 쓰는 장점이 더 중요합니다`,
                summary: noble ? `사람과 배움의 통로를 만들 때 도움을 받기 쉽습니다` : `반복해서 쓰는 장점이 특별함으로 남습니다`,
                paragraphs: [
                    `도움은 가만히 있어도 자동으로 들어오는 행운이라기보다, ${topic} 어떤 태도로 사람과 기회를 만나야 힘이 나는지를 보여주는 신호에 가깝습니다.`,
                    `${dominantTenGodProfile.talent} ${stemProfile.relationship} 이 결을 사람을 돕는 방식으로 쓰면 시간이 지나 신뢰와 평판으로 남습니다.`,
                    `현실적으로는 좋은 연결을 기다리기보다, 배움과 소개가 오가는 자리에 꾸준히 얼굴을 비추는 편이 좋습니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: nobleText,
                points: noble ? [`귀인: ${noble.name}`, `위치: ${noble.location}`, dominantTenGodProfile.field] : [dominantTenGod.label, stemProfile.keyword, seasonProfile.keyword]
            },
            {
                key: 'place',
                icon: '⌖',
                kicker: '나를 편하게 해주는 장소와 루틴',
                title: titles.place,
                subtitle: `막힐 때는 성격을 고치기보다 공간과 리듬을 먼저 바꾸는 편이 빠릅니다`,
                summary: `공간을 바꾸면 막힌 생각이 먼저 풀립니다`,
                paragraphs: [
                    `생각이 막힐 때는 더 몰아붙이기보다, 몸이 편해지는 장소를 먼저 정하는 편이 좋습니다. ${placeProfile.body}`,
                    `생활에서는 ${usefulActions}을 루틴으로 작게 반복해보세요. 장소와 행동을 함께 묶어두면 마음이 막혔을 때 돌아올 지점이 생깁니다.`,
                    `현실 조언은 하나만 고르는 것입니다. 책상, 산책길, 카페, 운동 시간 중 가장 쉽게 반복할 수 있는 곳부터 정하세요.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `환경 조언은 부족하게 잡힌 ${lackingElement.label} 기운과 용신 후보 ${usefulText}를 기준으로 잡았습니다.`,
                points: [`보완 장소: ${placeProfile.label}`, `보완 기운: ${lackingElement.label}`, `용신 후보: ${usefulText}`]
            },
            {
                key: 'cycle',
                icon: '↗',
                kicker: '앞으로의 흐름을 쓰는 법',
                title: titles.cycle,
                subtitle: `운의 흐름은 크게 뒤집기보다 생활 리듬에 맞춰 쓰는 쪽이 좋습니다`,
                summary: `큰 운보다 반복 가능한 계획 단위가 흐름을 살립니다`,
                paragraphs: [
                    `앞으로의 흐름은 한 번에 바뀌기보다 10년 단위의 생활 리듬으로 들어옵니다. 지금 잘 쓰는 힘과 보완할 환경을 구분해두면 변화가 와도 덜 흔들립니다.`,
                    `새 흐름이 들어올 때는 ${usefulActions}을 먼저 생활에 배치해보세요. 큰 목표보다 반복 가능한 환경을 바꾸는 쪽이 오래 갑니다.`,
                    `현실 조언은 한 해의 계획을 크게 세우되, 실제 행동은 분기마다 하나씩만 바꾸는 것입니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `대운 방향은 ${luckInfo?.direction || '순행'}, 시작 시점은 ${luckInfo?.startAgeLabel || '대운 시작 시점'}, 기준 절기는 ${luckInfo?.basisTerm || '절입'}으로 계산했습니다.${context.timeUnknown ? ' 생시 미정이라 시작 세부시점은 정오 기준 약식값입니다.' : ''}`,
                points: [`대운: ${luckInfo?.direction || '-'}`, `시작: ${luckInfo?.startAgeLabel || '-'}`, `기준 절기: ${luckInfo?.basisTerm || '-'}`]
            },
            {
                key: 'closing',
                icon: '✓',
                kicker: '마지막 조언',
                title: titles.closing,
                subtitle: `타고난 결을 고치기보다 편하게 쓰는 방향을 기억하면 됩니다`,
                summary: `잘하는 방식과 쉬는 장치를 함께 둘 때 오래 갑니다`,
                paragraphs: [
                    `${dayProfile.growthMessage} ${possessive} 장점은 ${stemProfile.keyword}과 ${branchProfile.short}이 만날 때 가장 자연스럽게 살아납니다.`,
                    `이 장점을 억지로 고치기보다 편하게 쓰는 방향을 찾는 것이 중요합니다. 잘하는 방식을 지키되, 지치는 순간에는 쉬어갈 장치를 먼저 만들어두세요.`,
                    `마지막 조언은 하나입니다. 나답게 잘하는 일과 나를 편하게 해주는 루틴을 같은 일정 안에 넣어두면, 같은 성향도 훨씬 부드럽게 쓰입니다.`
                ],
                evidenceLabel: '왜 이렇게 봤는지',
                evidenceNote: `마지막 조언은 ${dayPillar.label} 일주, ${seasonProfile.keyword}, ${dominantTenGod.label} 중심 흐름과 ${usefulText} 보완 방향을 함께 본 것입니다.`,
                points: [dayPillar.label, seasonProfile.keyword, `${usefulText} 보완`]
            }
        ];
        let chapters = sections.map((section: any) => this.normalizeManseReportChapter(section, reportData));
        return this.applyTimeUnknownSectionConfidence(chapters, reportData);
    }

    public cleanCountValue(value: any) {
        let number = Number(value || 0);
        if (Number.isInteger(number)) return String(number);
        return number.toFixed(1).replace(/\.0$/, '');
    }

    public elementValue(items: any[], label: string) {
        let item = (items || []).find((entry: any) => entry.label === label);
        return Number(item?.value || 0);
    }

    public elementBalanceTone(dominantElement: any, lackingElement: any) {
        let gap = Number(dominantElement?.value || 0) - Number(lackingElement?.value || 0);
        if (gap >= 3) return `${dominantElement.label} 쏠림이 뚜렷해서 장점도 선명하지만, ${lackingElement.label}이 비어 보이는 순간에는 속도가 한쪽으로 몰릴 수 있습니다.`;
        if (gap >= 1.5) return `${dominantElement.label}이 살짝 앞서고 ${lackingElement.label}이 뒤에서 균형을 맞추는 구조입니다.`;
        return '오행 차이가 크지 않아 특정 기운 하나보다 전체 조율력이 더 중요합니다.';
    }

    public interactionReadingText(activeInteractions: any[]) {
        if (!activeInteractions?.length) return '두드러진 합충형파보다 일간의 힘, 월지 계절감, 오행 분포를 먼저 보는 명식입니다.';
        return activeInteractions.map((section: any) => `${section.label}: ${section.items.slice(0, 2).join(', ')}`).join(' / ');
    }

    public wealthFlowText(count: number, wealthElement: string) {
        if (count >= 2) return `돈, 기회, 현실 성과를 직접 다루는 감각이 비교적 살아납니다.`;
        if (count > 0) return `큰 승부보다 관리 가능한 기회부터 잡을 때 돈의 흐름이 안정됩니다.`;
        return `돈 자체를 바로 좇기보다 실력, 신뢰, 관계의 통로를 먼저 만드는 편이 좋습니다.`;
    }

    public elementPlaceProfile(element: string) {
        let data: any = {
            목: { label: '초록과 새 출발이 있는 곳', body: '나무가 보이는 길, 식물 가까운 책상, 아침 산책처럼 성장감을 느끼는 환경이 좋습니다.' },
            화: { label: '햇빛과 표현이 살아나는 곳', body: '밝은 조명, 따뜻한 햇빛, 운동이나 발표처럼 몸과 마음의 온도가 올라가는 환경이 좋습니다.' },
            토: { label: '몸의 리듬을 안정시키는 곳', body: '정돈된 방, 흙길, 규칙적인 식사와 수면처럼 중심을 다시 잡아주는 환경이 좋습니다.' },
            금: { label: '정리와 집중이 쉬운 곳', body: '깨끗한 책상, 조용한 작업실, 체크리스트가 보이는 공간처럼 선택과 마무리가 쉬운 환경이 좋습니다.' },
            수: { label: '흐름과 기록이 생기는 곳', body: '물가, 조용한 카페, 이동 중 메모처럼 생각을 흘려보내고 다시 정리할 수 있는 환경이 좋습니다.' }
        };
        return data[element] || data.토;
    }

    public stripSentenceEnd(text: string) {
        return String(text || '').trim().replace(/[.!?。！？]+$/, '');
    }

    public subjectParticle(text: string) {
        let value = String(text || '').trim();
        if (!value) return '';
        let last = value.charAt(value.length - 1);
        let code = last.charCodeAt(0);
        if (code >= 0xac00 && code <= 0xd7a3) return `${value}${(code - 0xac00) % 28 ? '은' : '는'}`;
        return `${value}은`;
    }

    public sajuKidSectionTitles(dayPillar: any, dominantElement: any, lackingElement: any, dominantTenGod: any, personality: any, context: any = {}) {
        let dayProfile = context.dayProfile || {};
        let branchProfile = context.branchProfile || this.dayBranchProfile(dayPillar.branch.name);
        let seasonProfile = context.seasonProfile || this.monthBranchProfile(dayPillar.branch.name);
        let dayTheory = context.dayTheory || this.dayPillarTheoryProfile(dayPillar);
        let dominantTenGodProfile = context.dominantTenGodProfile || this.tenGodReadingProfile(dominantTenGod.label);
        let activeInteractions = context.activeInteractions || [];
        let noble = context.noble;
        return {
            core: this.coreLifeChapterTitle(dayProfile, dayTheory, branchProfile, seasonProfile),
            elements: this.elementBalanceLifeTitle(dominantElement, lackingElement),
            day: this.dayLifeTitle(dayProfile, dayTheory.tenGod),
            caution: this.interactionLifeTitle(activeInteractions, personality?.strengthLabel || '중화'),
            value: this.specialLifeTitle(noble, context.special),
            career: this.careerEnvironmentTitle(dominantTenGodProfile, context.stemProfile),
            money: this.moneyLifeTitle(Number(context.wealthCount || 0)),
            relationship: this.relationshipLifeTitle(dayProfile, branchProfile),
            love: this.loveLifeTitle(dayProfile, branchProfile, dayTheory.tenGod),
            place: '막힌 생각을 풀어주는 장소들',
            cycle: '앞으로의 흐름을 내 편으로 쓰는 법',
            closing: '마지막으로 기억하면 좋은 말'
        };
    }

    public normalTargetYear(value: any) {
        let year = parseInt(String(value || ''), 10);
        if (Number.isNaN(year)) year = new Date().getFullYear();
        return this.clamp(year, 1900, 2100);
    }

    public buildMansePrecisionReport(reportData: ManseReportData) {
        let chart = reportData.chart;
        let pillars = reportData.pillars;
        let targetYear = reportData.targetYear;
        let luckInfo = reportData.luckInfo;
        let precision = reportData.precision || {};
        let ipchun = precision.ipchun;
        let annualStart = precision.annualStart;
        let timeUnknown = this.isManseTimeUnknown(reportData);
        return {
            cards: [
                { label: '입력 시각', value: timeUnknown ? '생시 미정' : chart.meta.originalDateTime, note: timeUnknown ? '절기·날짜 보정용 정오 기준, 시주는 미정' : '양력 환산 후 사용한 출생 시각' },
                { label: '사주 시각', value: chart.meta.adjustedDateTime, note: this.timeCorrectionLabel(chart) },
                { label: '년주 기준', value: pillars[0].label, note: `입춘 ${this.formatDateTime(ipchun)} 기준` },
                { label: '월주 절입', value: `${pillars[1].label} · ${chart.monthTerm.name}`, note: this.formatDateTime(chart.monthTerm.date) },
                { label: '대운 시작', value: luckInfo.preciseStartLabel || luckInfo.startAgeLabel, note: `${luckInfo.direction} · 기준 절기까지 ${luckInfo.gapLabel}${timeUnknown ? ' · 생시 미정 약식' : ''}` },
                { label: '세운 기준', value: `${targetYear}년 ${annualStart?.pillar || ''}`, note: `${targetYear}년부터 8년 흐름 표시` }
            ],
            boundaries: precision.boundaries || [],
            solarTerms: precision.solarTerms || [],
            notes: [
                '년주는 입춘, 월주는 절입을 기준으로 산정합니다.',
                '대운 시작은 기준 절기까지의 시간 차를 3일=1년으로 환산한 값입니다.',
                '생시 미정이면 정오 기준으로 원국을 만들고 시주는 미정 처리합니다.'
            ],
            accuracy: this.manseAccuracyChecklist()
        };
    }

    public manseAccuracyChecklist() {
        return {
            summary: '샘플 사주는 정답 그 자체가 아니라 계산 엔진을 검증하는 기준값입니다. 먼저 원국 계산값을 확정하고, 해석은 그 다음 단계에서 붙여야 결과가 흔들리지 않습니다.',
            items: [
                {
                    label: '입력 표준화',
                    body: '양력·음력·윤달, 생시 모름, 출생지, 성별, 기준 연도처럼 결과를 바꾸는 값을 빠짐없이 받습니다.'
                },
                {
                    label: '달력 변환',
                    body: '음력 생일은 한국식 음력/윤달 변환표를 기준으로 양력 날짜를 먼저 확정해야 합니다.'
                },
                {
                    label: '절기 엔진',
                    body: '년주는 입춘, 월주는 절입 시각을 기준으로 분 단위 경계값을 계산해야 합니다.'
                },
                {
                    label: '시간 보정',
                    body: '기본은 한국 표준시로 계산하고, 사용자가 선택할 때만 출생지 경도·서머타임·자시 기준을 적용해야 합니다.'
                },
                {
                    label: '검증 샘플',
                    body: '다른 만세력에서 확인한 원국·대운 시작·신살 값을 회귀 테스트로 쌓아 변경 때마다 비교합니다.'
                },
                {
                    label: '해석 분리',
                    body: '사주팔자 계산 결과와 스토리형 풀이를 분리해야, 문장이 바뀌어도 원국 값은 정확하게 유지됩니다.'
                }
            ]
        };
    }

    public timeCorrectionLabel(chart: any) {
        if (chart.meta?.timeUnknown) return '생시 미정: 정오 기준, 시주 제외';
        let minutes = chart.meta?.timeCorrectionMinutes || 0;
        if (!minutes) return '한국 표준시 기준, 별도 보정 없음';
        return `지역 경도·서머타임 보정 ${minutes > 0 ? '+' : ''}${minutes}분`;
    }

    public solarTermBoundaryItems(chart: any) {
        let previous = this.previousSolarTerm(chart.adjusted);
        let next = this.nextSolarTerm(chart.adjusted);
        let current = chart.monthTerm;
        let items: any[] = [];
        if (previous) {
            items.push({
                label: '직전 절기',
                name: previous.name,
                branch: this.solarTermBranchLabel(previous),
                dateText: this.formatDateTime(previous.date),
                gap: `출생 ${this.dateTimeGapLabel(previous.date, chart.adjusted)} 전`
            });
        }
        if (current) {
            items.push({
                label: '월주 절입',
                name: current.name,
                branch: this.solarTermBranchLabel(current),
                dateText: this.formatDateTime(current.date),
                gap: `월지 ${this.solarTermBranchLabel(current)} 적용`
            });
        }
        if (next) {
            items.push({
                label: '다음 절기',
                name: next.name,
                branch: this.solarTermBranchLabel(next),
                dateText: this.formatDateTime(next.date),
                gap: `출생 ${this.dateTimeGapLabel(chart.adjusted, next.date)} 후`
            });
        }
        return items;
    }

    public buildPillars(date: Date, time: string = '12:00') { return this.sajuCalculator.buildPillars(date, time); }
    public buildChart(date: Date, time: string = '12:00', options: any = {}) { return this.sajuCalculator.buildChart(date, time, options); }
    public pillar(part: string, stemIndex: number, branchIndex: number) { return this.sajuCalculator.pillar(part, stemIndex, branchIndex); }
    public ganjiFromIndex(index: number) { return this.sajuCalculator.ganjiFromIndex(index); }
    public unknownHourPillar() { return this.sajuCalculator.unknownHourPillar(); }
    public adjustBirthDateTime(date: Date, time: string = '12:00', options: any = {}) { return this.sajuCalculator.adjustBirthDateTime(date, time, options); }
    public birthPlaceCorrectionMinutes(place: string = 'none') { return this.sajuCalculator.birthPlaceCorrectionMinutes(place); }
    public birthPlaceLabel(place: string = 'none') { return this.sajuCalculator.birthPlaceLabel(place); }
    public timeParts(time: string) { return this.sajuCalculator.timeParts(time); }
    public isKoreanLocalStandardPeriod(date: Date) { return this.sajuCalculator.isKoreanLocalStandardPeriod(date); }
    public isKoreanDaylightSavingPeriod(date: Date) { return this.sajuCalculator.isKoreanDaylightSavingPeriod(date); }
    public dateNumber(date: Date) { return this.sajuCalculator.dateNumber(date); }
    public isDateNumberBetween(value: number, start: number, end: number) { return this.sajuCalculator.isDateNumberBetween(value, start, end); }
    public yearGanjiIndex(date: Date) { return this.sajuCalculator.yearGanjiIndex(date); }
    public solarTermInfo() { return this.sajuCalculator.solarTermInfo(); }
    public solarTermDate(year: number, termIndex: number) { return this.sajuCalculator.solarTermDate(year, termIndex); }
    public solarMonthTerms(year: number) { return this.sajuCalculator.solarMonthTerms(year); }
    public solarTermTimeline(year: number) { return this.sajuCalculator.solarTermTimeline(year); }
    public findSolarMonthTerm(date: Date) { return this.sajuCalculator.findSolarMonthTerm(date); }
    public nextSolarMonthTerm(date: Date) { return this.sajuCalculator.nextSolarMonthTerm(date); }
    public previousSolarMonthTerm(date: Date) { return this.sajuCalculator.previousSolarMonthTerm(date); }
    public nextSolarTerm(date: Date) { return this.sajuCalculator.nextSolarTerm(date); }
    public previousSolarTerm(date: Date) { return this.sajuCalculator.previousSolarTerm(date); }
    public solarTermBranchLabel(term: any) { return this.sajuCalculator.solarTermBranchLabel(term); }
    public dateTimeGapLabel(start: Date, end: Date) { return this.sajuCalculator.dateTimeGapLabel(start, end); }
    public monthStemIndex(yearStemIndex: number, monthBranchIndex: number) { return this.sajuCalculator.monthStemIndex(yearStemIndex, monthBranchIndex); }
    public dayGanjiIndex(date: Date) { return this.sajuCalculator.dayGanjiIndex(date); }
    public hourBranchIndex(hour: number, minute: number = 0) { return this.sajuCalculator.hourBranchIndex(hour, minute); }
    public hourStemIndex(dayStemIndex: number, hourBranchIndex: number) { return this.sajuCalculator.hourStemIndex(dayStemIndex, hourBranchIndex); }
    public cycleIndex(stemIndex: number, branchIndex: number) { return this.sajuCalculator.cycleIndex(stemIndex, branchIndex); }
    public majorLuckInfo(chart: any, gender: string = 'none') { return this.sajuCalculator.majorLuckInfo(chart, gender); }

    public decoratePillarsForManse(pillars: any[], pillarDetails: any[] | null = null) {
        let details = pillarDetails?.length ? pillarDetails : this.sajuCalculator.pillarDetails(pillars);
        return details.map((pillar: any) => {
            let palace = this.palaceInfo(pillar.part);
            let stemVisual = this.elementVisual(pillar?.stem?.element);
            let branchVisual = this.elementVisual(pillar?.branch?.element);
            if (pillar?.unknown) {
                return {
                    ...pillar,
                    palaceTitle: palace.title,
                    palaceNote: palace.note,
                    stemRole: palace.stemRole,
                    branchRole: palace.branchRole,
                    stemTenGod: '미정',
                    branchTenGod: '미정',
                    branchTenGods: [],
                    hiddenText: '미정',
                    dayShinsal: '미정',
                    yearShinsal: '미정',
                    starText: '생시 미정',
                    twelveStage: '',
                    nayin: '',
                    empty: false,
                    stemBg: '#f1f5f9',
                    stemText: '#64748b',
                    branchBg: '#f1f5f9',
                    branchText: '#64748b'
                };
            }
            return {
                ...pillar,
                palaceTitle: palace.title,
                palaceNote: palace.note,
                stemRole: palace.stemRole,
                branchRole: palace.branchRole,
                stemBg: stemVisual.bg,
                stemText: stemVisual.text,
                branchBg: branchVisual.bg,
                branchText: branchVisual.text
            };
        });
    }

    public elementVisual(element: string) {
        let data: any = {
            목: { bg: '#cfe86a', text: '#255c2e' },
            화: { bg: '#ef7f83', text: '#ffffff' },
            토: { bg: '#f8c85d', text: '#4b5563' },
            금: { bg: '#f6f4e8', text: '#4b4b45' },
            수: { bg: '#b9dbe5', text: '#163247' }
        };
        return data[element] || { bg: '#f8fafc', text: '#475569' };
    }

    public palaceInfo(part: string) {
        let data: any = {
            시주: { title: '말년운', note: '자녀운, 결실', stemRole: '아들', branchRole: '딸' },
            일주: { title: '중년운', note: '정체성, 자아', stemRole: '자신', branchRole: '배우자' },
            월주: { title: '청년운', note: '부모, 사회상', stemRole: '부친', branchRole: '모친' },
            년주: { title: '초년운', note: '조상, 시대상', stemRole: '조부', branchRole: '조모' }
        };
        return data[part] || { title: '', note: '', stemRole: '', branchRole: '' };
    }

    public weightedElementDistribution(pillars: any[]) {
        return this.sajuCalculator.weightedElementDistribution(pillars);
    }

    public tenGodDistribution(pillars: any[]) {
        return this.sajuCalculator.tenGodDistribution(pillars);
    }

    public buildSajuPersonality(pillars: any[], elements: any[], tenGods: any[], elementRelations: any = {}) {
        let dayStem = pillars[2].stem;
        let dayElement = dayStem.element;
        let resourceElement = elementRelations.resourceElement || this.producerOf(dayElement);
        let outputElement = elementRelations.outputElement || this.producesElement(dayElement);
        let wealthElement = elementRelations.wealthElement || this.controlsElement(dayElement);
        let officerElement = elementRelations.officerElement || this.controlledByElement(dayElement);
        let byElement: any = {};
        elements.forEach((item: any) => byElement[item.label] = item.value);
        let seasonalBonus = pillars[1].branch.element === dayElement ? 1.2 : pillars[1].branch.element === resourceElement ? 0.8 : 0;
        let support = (byElement[dayElement] || 0) + (byElement[resourceElement] || 0) * 0.85 + seasonalBonus;
        let pressure = (byElement[outputElement] || 0) * 0.65 + (byElement[wealthElement] || 0) * 0.8 + (byElement[officerElement] || 0) * 0.9;
        let strengthScore = this.clamp(Math.round(50 + (support - pressure) * 8), 5, 95);
        let strengthLabel = strengthScore >= 65 ? '신강' : strengthScore <= 43 ? '신약' : '중화';
        let usefulElements = strengthLabel === '신강'
            ? [outputElement, wealthElement, officerElement]
            : [dayElement, resourceElement];
        let dominantTenGod = tenGods.find((item: any) => item.label !== '일간') || tenGods[0];
        let dayTone = this.elementTone(dayElement);
        let strengthText = strengthLabel === '신강'
            ? '밖으로 쓰는 힘이 많은 편'
            : strengthLabel === '신약'
                ? '나를 받쳐주는 순서가 먼저인 편'
                : '상황에 맞춰 조율하는 편';
        let usefulActionText = usefulElements.map((element: string) => this.elementCarePhrase(element)).join(' · ');

        return {
            dayMaster: `${dayStem.name}${dayStem.yinYang}${dayElement}`,
            strengthScore: strengthScore,
            strengthLabel: strengthLabel,
            keyword: `${dayTone.core} · ${this.tenGodLifePhrase(dominantTenGod?.label || '일간')}`,
            usefulElements: usefulElements,
            usefulGuide: `균형 힌트는 ${usefulActionText} 쪽에 있습니다. 과한 힘을 더 밀기보다 ${usefulElements.map((element: string) => this.elementTone(element).action).join(', ')} 흐름을 먼저 보세요.`,
            summary: `${dayTone.core}을 바탕으로 움직입니다. 지금은 ${strengthText}이라서 ${strengthLabel === '신강' ? '바깥으로 쓰는 일과 회복 루틴을 함께 둘 때 균형이 납니다.' : strengthLabel === '신약' ? '나를 받쳐주는 생활 리듬과 안정적인 사람을 먼저 둘 때 편해집니다.' : '상황에 따라 속도와 역할을 조절할 때 장점이 살아납니다.'}`,
            cards: [
                { label: '기본 기질', value: dayTone.core, note: dayTone.strength },
                { label: '에너지 사용', value: strengthText, note: `내부 기준 점수 ${strengthScore}` },
                { label: '드러나는 방식', value: this.tenGodLifePhrase(dominantTenGod?.label || '일간'), note: dominantTenGod?.tone || '자기 기준이 또렷한 편' },
                { label: '균형 힌트', value: usefulActionText, note: '편해지는 생활 행동' }
            ]
        };
    }

    public buildDetailedReading(reportData: ManseReportData) {
        let context = reportData.reading;
        let owner = context.owner;
        let topic = context.topic;
        let possessive = context.possessive;
        let dayPillar = context.dayPillar;
        let monthPillar = context.monthPillar;
        let dayStem = dayPillar.stem;
        let dayBranch = dayPillar.branch;
        let dominantElement = context.dominantElement || { label: dayStem.element, tone: '' };
        let lackingElement = context.lackingElement || dominantElement;
        let personality = reportData.personality;
        let stemProfile = context.stemProfile;
        let seasonProfile = context.seasonProfile;
        let dayBranchProfile = context.branchProfile;
        let dayTheory = context.dayTheory;
        let tenGodProfile = context.dayTheoryTenGodProfile;
        let dayProfile = context.dayProfile;
        let coreKeywords = this.buildCoreKeywords(dayProfile, personality, { label: dayTheory.tenGod }, dominantElement, tenGodProfile);
        let introMessage = this.birthSeasonMessage(monthPillar.branch.name);
        let activeInteractions = (reportData.interactionSections || [])
            .filter((section: any) => section.active && section.label !== '궁성')
            .slice(0, 5);
        let usefulElements = context.usefulElements || [lackingElement.label];
        let usefulActions = usefulElements.map((element: string) => this.elementTone(element).action).join(' · ');
        let timeUnknown = this.isManseTimeUnknown(reportData);
        let heroQuote = this.buildManseHeroQuote(topic, dayProfile, stemProfile, dayBranchProfile, seasonProfile);
        let firstImpression = this.buildFirstImpressionCopy(dayProfile, stemProfile, dayBranchProfile, seasonProfile, dayTheory);

        let reading = {
            intro: {
                preface: introMessage,
                quote: heroQuote,
                note: `${seasonProfile.short} 그래서 같은 기질도 계절과 생활 장면에 따라 드러나는 속도가 달라집니다.`,
                theme: `삶의 문장: ${this.shortThemeText(dayProfile.theme)}`
            },
            firstImpression: firstImpression,
            dayProfile: dayProfile,
            coreKeywords: coreKeywords,
            natureProfile: {
                title: dayProfile.natureTitle,
                subtitle: dayProfile.natureSubtitle,
                statement: dayProfile.natureStatement,
                quote: dayProfile.natureQuote,
                season: seasonProfile.natureSeason,
                time: dayProfile.natureTime,
                scenery: dayProfile.natureScenery,
                energy: dayProfile.natureEnergy,
                growth: dayProfile.growthMessage
            },
            headline: '나를 이해하는 첫 장',
            lead: `${topic} 작은 차이와 분위기를 먼저 읽고, 마음이 납득하는 선택을 오래 기억하는 편입니다. 계산 근거는 아래 확인 포인트에 따로 두고, 여기서는 그 근거가 생활에서 어떻게 드러나는지 먼저 읽습니다.${timeUnknown ? ' 생시 미정으로 시주·시지·말년운·자녀운 근거는 제외하고 읽습니다.' : ''}`,
            cards: [
                { label: '기본 기질', value: stemProfile.keyword, note: stemProfile.short },
                { label: '태어난 계절', value: seasonProfile.natureSeason, note: seasonProfile.short },
                { label: '가까운 관계', value: dayBranchProfile.short, note: '마음이 편해지는 자리의 힌트' },
                { label: '성장 리듬', value: dayTheory.stageTone, note: '반응 속도와 회복 방식을 읽는 기준' },
                { label: '균형 힌트', value: usefulActions, note: `${this.elementCarePhrase(lackingElement.label)}이 필요할 때 참고합니다.` }
            ],
            sections: [
                {
                    title: '내가 자주 쓰는 방식',
                    body: `${possessive} 기본 반응은 ${stemProfile.keyword}에서 출발합니다. 여기에 ${dayBranchProfile.short} 흐름이 더해져 사람과 일을 대할 때 세부의 결을 오래 살피는 편입니다.`,
                    evidenceLabel: '근거 확인',
                    points: [
                        `일주론 구조: ${dayTheory.stemText} · ${dayTheory.branchText}`,
                        `${dayTheory.tenGod}: ${this.firstSentence(tenGodProfile.talent)}`,
                        `십이운성 ${dayTheory.stage}: ${dayTheory.stageTone}`,
                        `계절감: ${seasonProfile.short}`
                    ]
                },
                {
                    title: '일과 돈이 움직이는 순서',
                    body: `${this.firstSentence(tenGodProfile.work)} ${personality.strengthLabel === '신강' ? '품은 에너지를 바깥으로 흘려보낼 때 결과가 맑아집니다.' : personality.strengthLabel === '신약' ? '생활의 리듬과 함께하는 사람이 먼저 안정될 때 길이 부드럽게 열립니다.' : '상황에 맞춰 역할을 바꾸는 감각이 삶의 균형을 잡아줍니다.'}`,
                    evidenceLabel: '근거 확인',
                    points: [
                        `추천 방향: ${tenGodProfile.field}`,
                        `일 처리: ${this.firstSentence(stemProfile.work)}`,
                        `살펴볼 점: ${this.firstSentence(tenGodProfile.caution)}`
                    ]
                },
                {
                    title: '가까운 사람 앞에서 드러나는 모습',
                    body: `가까운 관계에서는 말의 내용만큼 태도와 온도를 오래 기억합니다. ${dayBranchProfile.relationship} 오래 이어가려면 기대를 작게 나누어 자주 확인하는 편이 좋습니다.`,
                    evidenceLabel: '관계 근거',
                    points: [
                        `배우자 자리: ${dayBranch.name}${dayBranch.hanja} · ${dayBranchProfile.short}`,
                        `장점: ${this.firstSentence(stemProfile.relationship)}`,
                        `살펴볼 점: ${this.firstSentence(dayBranchProfile.caution)}`
                    ]
                },
                {
                    title: '균형을 찾는 방식',
                    body: `보완의 실마리는 성격을 고치는 데 있지 않고, 매일 반복되는 작은 리듬을 바꾸는 데 있습니다. 삶을 크게 뒤집기보다 한두 가지 행동을 일정하게 얹을 때 오래 갑니다.`,
                    evidenceLabel: '균형 근거',
                    points: usefulElements.map((element: string) => `${element}: ${this.elementTone(element).action}`)
                },
                {
                    title: '반복되는 긴장을 푸는 힌트',
                    body: activeInteractions.length ? '반복해서 부딪히는 지점은 고쳐야 할 결함보다 조율해야 할 리듬으로 보는 편이 좋습니다. 긴장이 생기는 상황을 미리 알면 선택의 폭이 넓어집니다.' : '큰 충돌 신호보다 기본 성향과 생활 균형을 먼저 살피는 편이 맞습니다. 무리한 해석보다 지금 반복되는 생활 패턴을 기준으로 조절하면 좋습니다.',
                    evidenceLabel: '흐름 근거',
                    points: activeInteractions.length ? activeInteractions.map((section: any) => `${section.label} 흐름이 ${section.items.length}곳에서 보입니다.`) : ['원국의 기본 결을 먼저 보고, 대운·세운에서 들어오는 충합을 함께 살펴보면 좋습니다.']
                }
            ],
            pillarReadings: reportData.displayPillars.map((pillar: any) => this.detailedPillarReading(pillar))
        };
        return this.polishDetailedReading(reading);
    }

    public buildManseHeroQuote(topic: string, dayProfile: any, stemProfile: any, branchProfile: any, seasonProfile: any) {
        if (dayProfile?.natureQuote) {
            let quote = this.firstSentence(dayProfile.natureQuote);
            return topic && topic !== '당신' ? quote.replace(/^당신은/, topic) : quote;
        }
        let stemKeyword = stemProfile?.keyword || '자기 기준';
        let branchShort = branchProfile?.short || '상황을 살피는 감각';
        let seasonKeyword = seasonProfile?.keyword || '태어난 계절의 흐름';
        return `${topic} ${seasonKeyword} 속에서 ${stemKeyword}을 ${branchShort}으로 현실에 맞추는 사람입니다.`;
    }

    public buildFirstImpressionCopy(dayProfile: any, stemProfile: any, branchProfile: any, seasonProfile: any, dayTheory: any) {
        let title = dayProfile?.title || `${stemProfile?.keyword || '자기 기준'}과 ${branchProfile?.short || '생활 감각'}이 먼저 보이는 사람`;
        let subtitle = dayProfile?.subtitle || `${seasonProfile?.short || '태어난 계절의 흐름'} 위에 ${dayTheory?.stageTone || '자기 리듬'}이 더해집니다`;
        let body = dayProfile?.traitBody || `${stemProfile?.detail || '기본 기질'} ${branchProfile?.detail || '가까운 자리에서 드러나는 반응'} 그래서 첫인상은 한 문장보다 판단 방식과 생활 리듬을 함께 봐야 정확합니다.`;
        return {
            title: this.softenReadingText(this.stripSentenceEnd(title)),
            subtitle: this.softenReadingText(this.firstSentence(subtitle)),
            body: this.softenReadingText(this.firstTwoSentences(body))
        };
    }

    public dayPillarTheoryProfile(dayPillar: any) {
        let hidden = this.hiddenStems(dayPillar.branch.name);
        let mainHidden = hidden[0]?.stem || dayPillar.stem;
        let tenGod = this.tenGod(dayPillar.stem, mainHidden) || '일간';
        let stage = this.twelveStage(dayPillar.stem, dayPillar.branch.name) || '미정';
        return {
            tenGod: tenGod,
            stage: stage,
            stemText: `천간 ${dayPillar.stem.name}${dayPillar.stem.hanja}(${dayPillar.stem.element})`,
            branchText: `지지 ${dayPillar.branch.name}${dayPillar.branch.hanja}(${dayPillar.branch.element})`,
            structureText: `천간 ${dayPillar.stem.name}${dayPillar.stem.hanja}와 지지 ${dayPillar.branch.name}${dayPillar.branch.hanja}가 만나고, 십이운성은 ${stage}, 일지 육친은 ${tenGod}으로 읽습니다.`,
            stageTone: this.twelveStageTone(stage)
        };
    }

    public applyBirthSeasonToDayProfile(profile: any, dayPillar: any, seasonProfile: any, theory: any, stemProfile: any, branchProfile: any) {
        let stemSymbol = this.stemSeasonSymbol(dayPillar.stem.name);
        return {
            ...profile,
            title: profile.traitTitle || profile.subtitle || `${stemProfile.keyword}을 자기 방식으로 쓰는 사람`,
            subtitle: `${seasonProfile.natureSeason}의 분위기 속에서 ${stemProfile.keyword}이 살아나는 사람`,
            oneLine: `${this.firstSentence(profile.oneLine || '')} ${seasonProfile.short}`,
            traitTitle: profile.traitTitle || profile.subtitle || `${stemProfile.keyword}을 자기 방식으로 쓰는 사람`,
            natureTitle: '태어난 계절이 만든 생활 리듬',
            natureSubtitle: `${seasonProfile.natureSeason}에서 읽는 반응 속도와 회복 방식`,
            natureStatement: `${seasonProfile.natureSeason}의 분위기 속에서 ${stemProfile.keyword}이 더 뚜렷해집니다. ${branchProfile.detail}`,
            natureQuote: `${stemProfile.keyword}은 삶의 장면 속에서 선택과 태도로 드러납니다.`,
            natureTime: seasonProfile.natureTime,
            natureScenery: seasonProfile.natureScenery,
            natureEnergy: `${seasonProfile.keyword} 속에서 ${stemProfile.keyword}을 쓰는 방식`,
            growthMessage: `${seasonProfile.short} ${stemSymbol.growth}`
        };
    }

    public stemSeasonSymbol(stemName: string) {
        let data: any = {
            갑: { noun: '큰 나무', statement: '크게 방향을 세우고 앞으로 뻗으려는 결이 있습니다.', growth: '당신의 성장은 스스로 세운 방향을 오래 키울 때 깊어집니다.' },
            을: { noun: '부드러운 풀잎', statement: '상황에 맞춰 휘어지면서도 자기 생명력을 잃지 않는 결이 있습니다.', growth: '당신의 성장은 부드러운 연결 속에서 조용히 넓어집니다.' },
            병: { noun: '밝은 태양', statement: '사람과 장면을 환하게 비추며 존재감을 드러내는 결이 있습니다.', growth: '당신의 성장은 숨기지 않고 따뜻하게 표현할 때 선명해집니다.' },
            정: { noun: '작은 등불', statement: '가까운 곳을 오래 밝히는 섬세한 온기가 있습니다.', growth: '당신의 성장은 작은 정성을 꾸준히 지킬 때 깊어집니다.' },
            무: { noun: '너른 산', statement: '흔들리는 것을 받아내고 큰 틀을 지키려는 결이 있습니다.', growth: '당신의 성장은 책임을 품되 몸의 리듬도 함께 돌볼 때 단단해집니다.' },
            기: { noun: '따뜻한 흙', statement: '사람과 일을 현실적으로 품고 가꾸는 결이 있습니다.', growth: '당신의 성장은 작은 조건을 정성껏 돌볼 때 결실로 이어집니다.' },
            경: { noun: '벼려진 금속', statement: '복잡한 것을 덜어내고 핵심을 남기는 결이 있습니다.', growth: '당신의 성장은 선명한 판단에 여백을 더할 때 더 깊어집니다.' },
            신: { noun: '맑은 보석', statement: '작은 차이와 품격을 알아보는 섬세한 결이 있습니다.', growth: '당신의 성장은 높은 기준을 아름다운 선택으로 다듬을 때 빛납니다.' },
            임: { noun: '넓은 물길', statement: '흐름을 크게 보고 여러 가능성을 품는 결이 있습니다.', growth: '당신의 성장은 자유로운 이동과 배움 속에서 넓어집니다.' },
            계: { noun: '고요한 이슬', statement: '보이지 않는 흐름을 조용히 읽고 마음의 결을 살피는 힘이 있습니다.', growth: '당신의 성장은 직감을 기록하고 천천히 현실로 옮길 때 맑아집니다.' }
        };
        return data[stemName] || data.무;
    }

    public twelveStageTone(stage: string) {
        let data: any = {
            장생: '새롭게 배우고 자라나는 리듬',
            목욕: '감각과 표현이 살아나는 리듬',
            관대: '자기 색을 세상에 드러내는 리듬',
            건록: '기반과 실력을 세우는 리듬',
            제왕: '기운이 가장 뚜렷하게 솟는 리듬',
            쇠: '성숙한 판단과 조율의 리듬',
            병: '민감하게 살피며 회복을 배우는 리듬',
            사: '한 흐름을 마무리하고 깊이 이해하는 리듬',
            묘: '안쪽에 쌓아두고 때를 기다리는 리듬',
            절: '낡은 흐름을 끊고 새 방향을 찾는 리듬',
            태: '가능성을 품고 준비하는 리듬',
            양: '천천히 보호받으며 자라는 리듬'
        };
        return data[stage] || '일주의 흐름을 읽는 기준';
    }

    public readingOwnerName(name: string = '') {
        let clean = String(name || '').trim();
        return clean || '당신';
    }

    public possessiveName(name: string) {
        if (name === '당신') return '당신의';
        if (name.endsWith('님')) return `${name}의`;
        return `${name}님의`;
    }

    public topicName(name: string) {
        if (name === '당신') return '당신은';
        let last = name.charAt(name.length - 1);
        let code = last.charCodeAt(0);
        if (code >= 0xac00 && code <= 0xd7a3) {
            return `${name}${(code - 0xac00) % 28 ? '은' : '는'}`;
        }
        return `${name}은`;
    }

    public birthSeasonMessage(branchName: string) {
        let data: any = {
            인: '새싹이 돋아나는 이 시기, 당신 안의 새로운 에너지도 싹트고 있습니다.',
            묘: '봄빛이 번지는 이 시기, 당신 안의 감각도 부드럽게 깨어납니다.',
            진: '봄이 땅속으로 스며드는 이 시기, 흩어진 가능성이 형태를 찾습니다.',
            사: '초여름의 열기가 오르는 이 시기, 당신 안의 표현력도 선명해집니다.',
            오: '햇빛이 가장 강한 이 시기, 당신의 존재감도 자연스럽게 드러납니다.',
            미: '여름의 열기가 여물어가는 이 시기, 당신 안의 현실감도 단단해집니다.',
            신: '가을바람이 시작되는 이 시기, 당신의 판단력도 한층 또렷해집니다.',
            유: '가을빛이 맑아지는 이 시기, 당신 안의 기준과 취향도 선명해집니다.',
            술: '늦가을의 기운이 깊어지는 이 시기, 지켜야 할 가치가 분명해집니다.',
            해: '초겨울의 물길이 깊어지는 이 시기, 당신 안의 생각도 넓어집니다.',
            자: '한겨울의 기운이 고이는 이 시기, 당신 안의 직감도 조용히 깊어집니다.',
            축: '겨울 끝의 땅이 씨앗을 품는 이 시기, 당신의 가능성도 천천히 준비됩니다.'
        };
        return data[branchName] || data.진;
    }

    public firstSentence(text: string) {
        let value = String(text || '').trim();
        if (!value) return '';
        let match = value.match(/^.*?[.!?。！？]/);
        return (match ? match[0] : value).trim();
    }

    public firstTwoSentences(text: string) {
        let value = String(text || '').trim();
        if (!value) return '';
        let matches = value.match(/[^.!?。！？]+[.!?。！？]/g);
        if (!matches || matches.length <= 1) return this.firstSentence(value);
        return matches.slice(0, 2).join(' ').replace(/\s+/g, ' ').trim();
    }

    public shortThemeText(text: string) {
        let value = String(text || '').trim();
        if (!value) return '나답게 균형을 세우는 삶';
        return value.replace(/하는 삶$/, '하기').replace(/는 삶$/, '기');
    }

    public polishDetailedReading(reading: any) {
        let polish = (value: any): any => {
            if (typeof value === 'string') return this.softenReadingText(value);
            if (Array.isArray(value)) return value.map((item: any) => polish(item));
            if (value && typeof value === 'object') {
                let result: any = {};
                Object.keys(value).forEach((key: string) => {
                    result[key] = key === 'color' ? value[key] : polish(value[key]);
                });
                return result;
            }
            return value;
        };
        return polish(reading);
    }

    public softenReadingText(text: string) {
        let value = String(text || '').trim();
        if (!value) return '';
        let replacements: any[] = [
            [/완벽하지 않아도/g, '모든 장면이 완성되지 않아도'],
            [/완벽하지 못한/g, '마음에 덜 찬'],
            [/완벽한/g, '충분히 아름다운'],
            [/완벽주의자/g, '정성의 기준을 지닌 사람'],
            [/완벽주의/g, '정성스러운 기준'],
            [/완벽추구/g, '정성의 기준'],
            [/완벽성/g, '정제된 감각'],
            [/완벽과/g, '정제미와'],
            [/완벽을/g, '정제미를'],
            [/완벽의/g, '정제미의'],
            [/완벽/g, '정제미'],
            [/예민한/g, '섬세한'],
            [/예민함/g, '섬세함'],
            [/비판적 태도/g, '날카로운 안목'],
            [/까다로운 기준/g, '높은 기준'],
            [/스트레스를 받습니다/g, '마음이 쉽게 지칠 수 있습니다'],
            [/스트레스/g, '마음의 압력'],
            [/약점/g, '살펴볼 결'],
            [/주의:/g, '살펴볼 점:'],
            [/주의/g, '살펴볼 점'],
            [/조심하세요/g, '천천히 살펴보면 좋습니다'],
            [/필요합니다/g, '도움이 됩니다'],
            [/강하게 보입니다/g, '선명하게 드러납니다'],
            [/강하게/g, '선명하게'],
            [/강한/g, '선명한'],
            [/강합니다/g, '선명하게 살아납니다'],
            [/힘이 있습니다/g, '기운이 흐릅니다'],
            [/힘이 좋습니다/g, '결이 안정적입니다'],
            [/중심입니다/g, '중심에 놓여 있습니다'],
            [/두드러집니다/g, '은은하게 드러납니다'],
            [/가짜/g, '겉치레'],
            [/고통/g, '시간'],
            [/검열/g, '살핌'],
            [/통제처럼/g, '무겁게'],
            [/손해를 볼 수 있습니다/g, '흐름이 거칠어질 수 있습니다']
        ];
        replacements.forEach((item: any) => {
            value = value.replace(item[0], item[1]);
        });
        return value.replace(/\s+/g, ' ').trim();
    }

    public softenTagText(text: string) {
        let value = String(text || '').trim();
        let exact: any = {
            완벽추구: '정성의 기준',
            완벽: '정제미',
            예민함: '섬세한 감각',
            '비판적 태도': '날카로운 안목',
            '까다로운 기준': '높은 기준',
            냉철함: '맑은 판단',
            고독: '내면의 깊이',
            경쟁력: '실력의 윤곽',
            승부감각: '승부의 감각',
            돌파력: '길을 여는 힘'
        };
        if (exact[value]) return exact[value];
        return this.softenReadingText(value).replace(/[.!?。！？]$/, '');
    }

    public buildCoreKeywords(dayProfile: any, personality: any, dominantTenGod: any, dominantElement: any, tenGodProfile: any) {
        let keywordItems = this.uniqueTexts([
            ...(dayProfile.keywords || []),
            this.tenGodKeyword(dominantTenGod?.label || '일간'),
            this.elementKeyword(dominantElement?.label || ''),
            this.strengthKeyword(personality?.strengthLabel || '중화')
        ]).slice(0, 3);
        while (keywordItems.length < 3) {
            keywordItems.push(['자기이해', '균형감', '성장성'][keywordItems.length]);
        }

        return {
            title: '핵심 키워드',
            keywords: keywordItems.map((keyword: string, index: number) => ({
                label: this.softenTagText(keyword),
                color: ['bg-[#9d8f84] text-white', 'bg-[#c8ab87] text-white', 'bg-[#729987] text-white'][index] || 'bg-[#9d8f84] text-white'
            })),
            summary: `이 세 단어가 이 리포트의 첫인상입니다. ${dayProfile.keywordSummary} 겉으로 드러나는 방식은 ${this.tenGodLifePhrase(dominantTenGod?.label || '일간')}에 가깝습니다.`,
            cards: [
                { label: '첫인상', value: this.softenTagText(keywordItems[0]), note: '처음 드러나는 성향' },
                { label: '드러나는 방식', value: this.softenTagText(keywordItems[1]), note: '상황을 받아들이는 습관' },
                { label: '균형 방향', value: this.softenTagText(keywordItems[2]), note: '편해지는 생활 힌트' }
            ]
        };
    }

    public dayPillarProfile(dayPillar: any, stemProfile: any, branchProfile: any, tenGodProfile: any, seasonProfile: any, personality: any, tenGodLabel: string = '일간') {
        let poeticData: any = this.dayPillarPoeticData();
        let data = poeticData[dayPillar.label] || {};
        let keywords = (data.keywords || this.uniqueTexts([stemProfile.keyword, branchProfile.short, tenGodProfile.field]).slice(0, 3)).map((item: string) => this.softenTagText(item));
        let theme = data.theme || `${keywords[0]}을 중심으로 자기만의 기준을 만들고, ${keywords[1]}을 삶의 방식으로 다듬는 사람`;
        let strengths = data.strengths || [stemProfile.keyword, branchProfile.short, tenGodProfile.talent];
        let weaknesses = data.weaknesses || [tenGodProfile.caution, branchProfile.caution, '혼자서 너무 오래 버티지 않기'];

        return {
            ganji: dayPillar.label,
            title: data.title || `${stemProfile.keyword}과 ${branchProfile.short}`,
            subtitle: data.subtitle || `${stemProfile.short} ${branchProfile.short}`,
            symbol: data.symbol || `${dayPillar.stem.name}${dayPillar.stem.hanja} · ${dayPillar.branch.name}${dayPillar.branch.hanja}`,
            oneLine: this.softenReadingText(this.firstSentence(data.oneLine || `${stemProfile.detail} ${branchProfile.detail}`)),
            theme: this.softenReadingText(theme),
            keywordSummary: this.softenReadingText(data.keywordSummary || `${keywords.join(', ')}의 기질이 선명하게 살아납니다.`),
            keywords: keywords,
            strengths: strengths.slice(0, 3).map((item: string) => this.softenTagText(item)),
            weaknesses: weaknesses.slice(0, 3).map((item: string) => this.softenTagText(item)),
            traitTitle: this.softenReadingText(data.traitTitle || `${stemProfile.keyword}을 삶의 언어로 다듬는 사람`),
            traitBody: this.softenReadingText(this.firstTwoSentences(data.traitBody || `${dayPillar.label} 일주는 ${stemProfile.detail} 일지의 ${branchProfile.short}이 더해져 감정과 현실을 함께 살피는 편입니다.`)),
            decisionStyle: this.softenReadingText(this.firstTwoSentences(data.decisionStyle || `${stemProfile.work} 다만 결정을 내리기 전에는 ${branchProfile.caution}`)),
            relationshipStyle: this.softenReadingText(this.firstTwoSentences(data.relationshipStyle || this.relationshipStyleFallback(dayPillar.branch.name, branchProfile, tenGodLabel, stemProfile))),
            workStyle: this.softenReadingText(this.firstTwoSentences(data.workStyle || `${tenGodProfile.work} ${stemProfile.work}`)),
            loveStyle: this.softenReadingText(this.firstTwoSentences(data.loveStyle || this.loveStyleFallback(dayPillar.branch.name, tenGodLabel, stemProfile))),
            stress: this.softenReadingText(this.firstTwoSentences(data.stress || `${tenGodProfile.caution} 특히 ${personality?.strengthLabel || '중화'} 흐름에서는 스스로에게 요구하는 기준이 높아질 수 있습니다.`)),
            advice: this.softenReadingText(this.firstTwoSentences(data.advice || `${personality?.usefulGuide || '한쪽 기운에 치우치지 않고 생활 리듬을 맞추는 것이 좋습니다.'}`)),
            natureTitle: data.natureTitle || data.title || `${stemProfile.keyword}과 ${branchProfile.short}`,
            natureSubtitle: data.natureSubtitle || `${stemProfile.short} ${branchProfile.short}`,
            natureStatement: this.softenReadingText(this.firstSentence(data.natureStatement || `${dayPillar.label} 일주는 ${data.title || stemProfile.keyword}처럼 자기 안의 기준을 천천히 현실로 드러냅니다.`)),
            natureQuote: this.softenReadingText(this.firstSentence(data.natureQuote || `당신은 ${stemProfile.keyword}을 바탕으로 세상을 읽고, ${branchProfile.short}을 통해 관계와 일의 온도를 조절합니다.`)),
            natureTime: data.natureTime || seasonProfile.natureTime,
            natureScenery: data.natureScenery || seasonProfile.natureScenery,
            natureEnergy: data.natureEnergy || `${this.elementTone(dayPillar.stem.element).core}과 ${this.elementTone(dayPillar.branch.element).core}`,
            growthMessage: this.softenReadingText(this.firstSentence(data.growthMessage || `${strengths[0]}을 장점으로 쓰되, ${weaknesses[0]}를 의식하면 더 단단해집니다.`))
        };
    }

    public uniqueTexts(items: string[]) {
        let seen: any = {};
        return (items || []).filter((item: string) => {
            let value = String(item || '').trim();
            if (!value || seen[value]) return false;
            seen[value] = true;
            return true;
        });
    }

    public tenGodKeyword(label: string) {
        let data: any = {
            비견: '자기주도',
            겁재: '승부감각',
            식신: '생산성',
            상관: '표현력',
            편재: '기회포착',
            정재: '현실관리',
            편관: '돌파력',
            정관: '책임감',
            편인: '직관',
            정인: '학구열',
            일간: '자기기준'
        };
        return data[label] || data.일간;
    }

    public elementKeyword(element: string) {
        let data: any = { 목: '성장성', 화: '존재감', 토: '안정감', 금: '완성도', 수: '지혜' };
        return data[element] || '균형감';
    }

    public strengthKeyword(label: string) {
        let data: any = { 신강: '자기확신', 신약: '회복력', 중화: '조율력' };
        return data[label] || data.중화;
    }

    public dayPillarPoeticData() {
        return {
            갑자: { title: '깊은 샘에서 자라는 큰 나무', subtitle: '배움과 개척심이 함께 있는 사람', keywords: ['개척', '학습', '생명력'], theme: '지식을 뿌리 삼아 자기만의 숲을 키우는 삶', oneLine: '머릿속에 큰 그림이 있고, 새 흐름을 발견하면 먼저 뿌리를 내려보려는 사람입니다.', keywordSummary: '개척심과 학습력이 삶의 첫 인상으로 드러납니다.' },
            을축: { title: '겨울 밭을 붙잡는 풀잎', subtitle: '부드럽지만 쉽게 꺾이지 않는 사람', keywords: ['인내', '현실감', '회복력'], theme: '느리더라도 끝내 살아남아 결실을 만드는 삶', oneLine: '겉으로는 조용해도 안쪽에는 오래 버티는 힘과 현실 감각이 단단합니다.', keywordSummary: '인내와 회복력이 중심축입니다.' },
            병인: { title: '숲 위로 떠오르는 태양', subtitle: '시작을 밝히고 사람을 움직이는 사람', keywords: ['표현력', '리더십', '시작'], theme: '자기 빛으로 주변의 가능성을 깨우는 삶', oneLine: '분위기를 열고 앞장서는 힘이 있어, 정체된 곳에 활기를 넣습니다.', keywordSummary: '표현력과 리더십이 강하게 보입니다.' },
            정묘: { title: '봄뜰을 밝히는 등불', subtitle: '다정한 감각으로 분위기를 살리는 사람', keywords: ['섬세함', '감성', '창의'], theme: '작은 온기로 아름다운 관계와 작품을 만드는 삶', oneLine: '예민한 감각을 부드럽게 쓰며, 사람의 마음과 분위기를 세밀하게 읽습니다.', keywordSummary: '섬세함과 창의성이 돋보입니다.' },
            무진: { title: '넓은 대지를 품은 산', subtitle: '큰 틀을 잡고 사람을 품는 사람', keywords: ['책임', '포용', '축적'], theme: '흔들리는 것을 받아내며 자기 기반을 넓히는 삶', oneLine: '쉽게 움직이지 않지만 한번 마음먹으면 책임 있게 판을 지켜냅니다.', keywordSummary: '책임감과 포용력이 중심입니다.' },
            기사: { title: '따뜻한 흙 위의 작은 불씨', subtitle: '실용성과 집중력이 살아 있는 사람', keywords: ['실용', '집중', '보살핌'], theme: '생활 속에서 쓸모와 온기를 함께 만드는 삶', oneLine: '현실을 잘 살피면서도 마음을 담아 오래 챙기는 방식이 강합니다.', keywordSummary: '실용성과 집중력이 함께 움직입니다.' },
            경오: { title: '한낮에 빛나는 단단한 칼', subtitle: '결단과 명예감이 분명한 사람', keywords: ['결단', '명예', '추진'], theme: '분명한 기준으로 길을 뚫고 결과를 증명하는 삶', oneLine: '판단이 빠르고 자존감이 강해, 맡은 일에서는 선명한 결과를 원합니다.', keywordSummary: '결단력과 추진력이 두드러집니다.' },
            신미: { title: '여름 끝 보석 같은 흙', subtitle: '감각과 완성도를 지키는 사람', keywords: ['정교함', '감각', '완성'], theme: '아름다움과 현실감을 함께 다듬는 삶', oneLine: '부드러워 보여도 기준은 높고, 결과물의 질을 끝까지 신경 씁니다.', keywordSummary: '정교함과 감각이 강합니다.' },
            임신: { title: '가을 물길을 여는 큰 강', subtitle: '전략과 변화 감각이 빠른 사람', keywords: ['전략', '변화', '지성'], theme: '넓게 보고 빠르게 방향을 바꾸며 흐름을 여는 삶', oneLine: '정보를 읽고 판을 바꾸는 능력이 좋아, 변화가 많은 환경에서 강합니다.', keywordSummary: '전략성과 변화 감각이 중심입니다.' },
            계유: { title: '맑은 그릇에 고인 이슬', subtitle: '통찰과 절제미가 있는 사람', keywords: ['통찰', '미감', '절제'], theme: '맑은 판단으로 불필요한 것을 덜어내는 삶', oneLine: '조용히 관찰하다가 중요한 부분을 정확히 짚는 섬세한 사람입니다.', keywordSummary: '통찰력과 미감이 두드러집니다.' },
            갑술: { title: '마른 산을 지키는 큰 나무', subtitle: '신념과 보호 본능이 강한 사람', keywords: ['신념', '보호', '지구력'], theme: '오래 지킬 가치를 세우고 책임지는 삶', oneLine: '한번 정한 기준과 사람을 쉽게 놓지 않고, 긴 호흡으로 버팁니다.', keywordSummary: '신념과 지구력이 강합니다.' },
            을해: { title: '겨울 강가의 부드러운 풀', subtitle: '상상력과 생존력이 깊은 사람', keywords: ['유연성', '상상력', '회복'], theme: '흐름을 따라가며 자기만의 가능성을 되살리는 삶', oneLine: '부드럽게 적응하지만 안쪽에는 생각과 상상력이 깊게 흐릅니다.', keywordSummary: '유연성과 회복력이 중심입니다.' },
            병자: { title: '한밤 물 위에 비친 태양', subtitle: '밝음과 직관이 공존하는 사람', keywords: ['직관', '표현', '반전'], theme: '어둠 속에서도 자기 빛을 발견해내는 삶', oneLine: '겉은 밝고 활동적이지만 속으로는 흐름을 예민하게 계산합니다.', keywordSummary: '직관과 표현력이 함께 나타납니다.' },
            정축: { title: '겨울 흙 속 오래 타는 불', subtitle: '성실한 온기를 오래 지키는 사람', keywords: ['성실', '인내', '온기'], theme: '천천히 쌓은 정성으로 신뢰를 만드는 삶', oneLine: '드러나는 속도는 느려도 끝까지 챙기는 힘이 깊습니다.', keywordSummary: '성실함과 인내가 강합니다.' },
            무인: { title: '초봄 숲을 받치는 산', subtitle: '확장과 책임을 함께 가진 사람', keywords: ['확장', '책임', '개척'], theme: '큰 기반 위에서 새 길을 열어가는 삶', oneLine: '새로운 일을 벌이는 힘과 그것을 책임지려는 중심감이 함께 있습니다.', keywordSummary: '확장성과 책임감이 두드러집니다.' },
            기묘: { title: '봄 정원을 가꾸는 흙', subtitle: '섬세하게 돌보고 조율하는 사람', keywords: ['돌봄', '조율', '섬세'], theme: '사람과 환경을 부드럽게 가꾸는 삶', oneLine: '상대의 반응을 잘 살피며, 작은 조건을 맞춰 전체 분위기를 안정시킵니다.', keywordSummary: '돌봄과 조율력이 중심입니다.' },
            경진: { title: '흙 속에서 벼려지는 금속', subtitle: '분석과 실력으로 증명하는 사람', keywords: ['분석', '실력', '정리'], theme: '복잡한 현실을 정리해 쓸모 있는 구조로 만드는 삶', oneLine: '속으로 갈고닦는 힘이 있어 시간이 지날수록 실력이 드러납니다.', keywordSummary: '분석력과 실력주의가 강합니다.' },
            신사: { title: '불빛 속 세공되는 보석', subtitle: '완성도와 매력을 동시에 가진 사람', keywords: ['완성도', '매력', '집중'], theme: '뜨거운 경험 속에서 자기 품격을 세공하는 삶', oneLine: '예민한 기준과 강한 집중력이 있어 빛나는 결과물을 만들려 합니다.', keywordSummary: '완성도와 집중력이 중심입니다.' },
            임오: { title: '태양 아래 흐르는 큰 물', subtitle: '활동성과 포용력이 넓은 사람', keywords: ['활동성', '포용', '변화'], theme: '움직임 속에서 사람과 기회를 넓히는 삶', oneLine: '열정적인 환경에서도 유연하게 흐르며 판을 크게 봅니다.', keywordSummary: '활동성과 포용력이 두드러집니다.' },
            계미: { title: '들판에 스며드는 단비', subtitle: '감수성과 균형감이 있는 사람', keywords: ['감수성', '봉사', '균형'], theme: '조용한 배려로 메마른 곳을 적시는 삶', oneLine: '말보다 분위기로 마음을 전하고, 주변의 필요를 섬세하게 알아차립니다.', keywordSummary: '감수성과 균형감이 중심입니다.' },
            갑신: { title: '바위 틈을 뚫는 큰 나무', subtitle: '도전과 기술 감각이 강한 사람', keywords: ['도전', '기술', '생존력'], theme: '어려운 조건을 돌파하며 자기 길을 만드는 삶', oneLine: '제약이 있을수록 방법을 찾고, 강한 문제 해결력으로 길을 냅니다.', keywordSummary: '도전성과 생존력이 강합니다.' },
            을유: { title: '가을 바람의 가는 풀', subtitle: '미감과 선택 기준이 예민한 사람', keywords: ['미감', '조율', '선택'], theme: '섬세한 감각으로 관계와 취향을 정리하는 삶', oneLine: '부드럽게 보이지만 취향과 기준이 분명해 쉽게 타협하지 않습니다.', keywordSummary: '미감과 선택력이 두드러집니다.' },
            병술: { title: '마른 산 위의 저녁 태양', subtitle: '명예와 책임을 의식하는 사람', keywords: ['명예', '책임', '표현'], theme: '자기 빛으로 책임의 자리를 밝히는 삶', oneLine: '인정받고 싶은 마음과 맡은 것을 지키려는 의지가 함께 큽니다.', keywordSummary: '명예감과 책임감이 중심입니다.' },
            정해: { title: '겨울 바다의 작은 등불', subtitle: '직관과 따뜻함이 깊은 사람', keywords: ['직관', '따뜻함', '예술'], theme: '깊은 감정 속에서도 꺼지지 않는 불빛을 지키는 삶', oneLine: '마음이 깊고 상상력이 풍부해, 보이지 않는 분위기를 잘 읽습니다.', keywordSummary: '직관과 예술성이 두드러집니다.' },
            무자: { title: '깊은 물을 품은 큰 산', subtitle: '전략과 중심감이 묵직한 사람', keywords: ['저장', '전략', '중심'], theme: '속에 쌓은 생각으로 큰 결정을 준비하는 삶', oneLine: '겉은 안정적이지만 안쪽에서는 많은 계산과 계획이 흐릅니다.', keywordSummary: '전략성과 중심감이 강합니다.' },
            기축: { title: '겨울 창고의 비옥한 흙', subtitle: '축적과 관리에 강한 사람', keywords: ['축적', '성실', '관리'], theme: '작은 것을 오래 쌓아 현실의 힘으로 바꾸는 삶', oneLine: '꾸준함과 실무 감각이 좋아 시간이 갈수록 안정적인 결과를 만듭니다.', keywordSummary: '축적과 관리력이 중심입니다.' },
            경인: { title: '숲을 가르는 날카로운 금', subtitle: '개척과 정의감이 분명한 사람', keywords: ['결단', '개척', '정의'], theme: '분명한 판단으로 새 길을 열고 책임지는 삶', oneLine: '낯선 영역에도 과감히 들어가며, 옳고 그름에 대한 기준이 선명합니다.', keywordSummary: '결단력과 개척성이 강합니다.' },
            신묘: { title: '봄날의 은빛 이슬', subtitle: '맑은 감각으로 아름다움을 알아보는 사람', keywords: ['정성의 기준', '섬세한 감각', '미적 감각'], strengths: ['맑은 미감', '정교한 손길', '깊은 관찰력'], weaknesses: ['섬세한 마음결', '날카로운 안목', '높은 기준'], theme: '섬세한 감성으로 아름다움을 빚고, 순수한 기준을 지켜가는 삶', oneLine: '작은 빛의 차이를 알아보고, 마음에 닿은 것을 오래 곱씹어 자기만의 아름다움으로 다듬는 사람입니다.', keywordSummary: '정교한 감각과 맑은 미감이 중심에 놓여 있습니다.', traitTitle: '맑은 기준을 가진 섬세한 사람', traitBody: '보석처럼 빛나는 장면을 알아보는 눈이 있습니다. 쉽게 지나칠 수 있는 결까지 살피기 때문에, 당신의 선택에는 조용한 품격이 남습니다.', decisionStyle: '좋은 선택을 위해 충분히 바라보고 오래 고릅니다. 서두르기보다 마음이 납득하는 순간을 기다릴 때 편안해집니다.', relationshipStyle: '진심이 느껴지는 관계에서 마음이 열립니다. 겉치레보다 말의 온도와 태도의 결을 더 오래 기억합니다.', workStyle: '세부의 완성도와 감각이 필요한 일에서 빛납니다. 디자인, 검수, 분석, 기획처럼 작은 차이가 결과를 바꾸는 분야와 잘 맞습니다.', loveStyle: '사랑에서도 마음의 깊이와 결을 중요하게 봅니다. 한번 마음을 열면 오래 아끼지만, 무심한 말에는 생각보다 깊이 흔들릴 수 있습니다.', stress: '마음에 덜 찬 결과를 억지로 받아들여야 할 때 지치기 쉽습니다. 스스로를 너무 오래 살피면 마음의 숨이 좁아질 수 있습니다.', advice: '모든 장면이 완성되지 않아도 괜찮습니다. 때로는 덜 다듬어진 순간에도 당신다운 아름다움이 이미 머물러 있습니다.', natureTitle: '세공된 보석과 맑은 거울', natureSubtitle: '진실을 조용히 비추는 투명한 결정체', natureStatement: '당신은 오래 다듬어진 보석처럼, 작은 흠과 빛의 차이를 함께 알아보는 사람입니다.', natureQuote: '섬세함은 약함이 아니라 세상을 더 정교하게 사랑하는 감각입니다.', natureTime: '달빛 비치는 밤', natureScenery: '수정 동굴, 고요한 호수 위', natureEnergy: '정제와 완성의 에너지', growthMessage: '삶이 당신을 천천히 다듬을수록, 그 안의 빛은 더 맑고 단단하게 남습니다.' },
            임진: { title: '용이 머무는 넓은 물길', subtitle: '스케일과 기획력이 큰 사람', keywords: ['스케일', '기획', '변화'], theme: '큰 흐름을 설계하고 변화를 이끄는 삶', oneLine: '생각의 폭이 넓고 가능성을 크게 보며, 판을 키우는 감각이 있습니다.', keywordSummary: '스케일과 기획력이 두드러집니다.' },
            계사: { title: '불 곁에서 반짝이는 물방울', subtitle: '통찰과 매력이 공존하는 사람', keywords: ['통찰', '표현', '매력'], theme: '섬세한 직관을 매력적인 표현으로 바꾸는 삶', oneLine: '조용히 흐름을 읽다가 필요한 순간에는 선명하게 자신을 드러냅니다.', keywordSummary: '통찰과 표현력이 함께 움직입니다.' },
            갑오: { title: '태양을 향해 솟는 큰 나무', subtitle: '열정과 성장 욕구가 강한 사람', keywords: ['열정', '성장', '리더십'], theme: '자기 확신으로 높이 뻗어가는 삶', oneLine: '하고 싶은 것이 분명하고 속도가 빨라, 목표가 생기면 강하게 밀고 갑니다.', keywordSummary: '열정과 성장성이 강합니다.' },
            을미: { title: '여름 들판의 부드러운 덩굴', subtitle: '돌봄과 예술성이 살아 있는 사람', keywords: ['돌봄', '예술', '인내'], theme: '부드러운 감성으로 오래 남는 결실을 만드는 삶', oneLine: '사람과 분위기를 살피는 감각이 좋고, 느리지만 깊게 완성합니다.', keywordSummary: '돌봄과 예술성이 중심입니다.' },
            병신: { title: '가을 금속 위의 태양', subtitle: '재능과 판단력이 빛나는 사람', keywords: ['재능', '판단', '표현'], theme: '명확한 판단으로 자기 재능을 드러내는 삶', oneLine: '밝은 표현력과 냉정한 판단이 함께 있어 결과를 빠르게 보여주려 합니다.', keywordSummary: '재능과 판단력이 강합니다.' },
            정유: { title: '보석에 비친 촛불', subtitle: '미감과 집중력이 섬세한 사람', keywords: ['미감', '집중', '완성'], theme: '작은 빛으로 깊은 아름다움을 완성하는 삶', oneLine: '말과 행동이 섬세하며, 작은 차이를 끝까지 다듬는 힘이 있습니다.', keywordSummary: '미감과 집중력이 중심입니다.' },
            무술: { title: '산맥처럼 버티는 대지', subtitle: '신뢰와 책임감이 묵직한 사람', keywords: ['책임', '신뢰', '보존'], theme: '끝까지 지킬 것을 선택하고 기반을 세우는 삶', oneLine: '쉽게 흔들리지 않고, 한번 맡은 일은 오래 책임지려 합니다.', keywordSummary: '책임감과 신뢰가 강합니다.' },
            기해: { title: '겨울 물가의 깊은 흙', subtitle: '포용과 학습력이 깊은 사람', keywords: ['포용', '학습', '회복'], theme: '깊이 받아들이고 천천히 회복시키는 삶', oneLine: '마음의 폭이 넓고 배움이 깊어, 사람과 상황을 오래 이해하려 합니다.', keywordSummary: '포용력과 학습력이 중심입니다.' },
            경자: { title: '찬물에 씻긴 날카로운 금', subtitle: '냉철한 분석과 절제가 있는 사람', keywords: ['냉철함', '분석', '절제'], theme: '감정을 정리해 명확한 판단으로 나아가는 삶', oneLine: '판단이 맑고 빠르며, 복잡한 것을 단순한 기준으로 정리합니다.', keywordSummary: '냉철함과 분석력이 강합니다.' },
            신축: { title: '겨울 흙 속 세공된 보석', subtitle: '인내로 품격을 만드는 사람', keywords: ['완성', '인내', '품격'], theme: '시간을 견뎌 자기 가치를 증명하는 삶', oneLine: '쉽게 드러나지 않지만 오래 쌓인 실력과 품격이 단단합니다.', keywordSummary: '완성도와 인내가 중심입니다.' },
            임인: { title: '숲을 적시는 큰 강', subtitle: '배움과 자유가 넓은 사람', keywords: ['확장', '배움', '자유'], theme: '넓은 세계를 배우며 자기 흐름을 키우는 삶', oneLine: '이동과 배움 속에서 가능성을 키우며, 한곳에 오래 갇히면 답답해집니다.', keywordSummary: '확장성과 자유로움이 강합니다.' },
            계묘: { title: '봄비에 젖은 어린 풀', subtitle: '공감과 창의성이 섬세한 사람', keywords: ['감수성', '공감', '창의'], theme: '부드러운 감정으로 새 가능성을 틔우는 삶', oneLine: '마음의 결이 섬세하고, 조용한 방식으로 주변에 생기를 줍니다.', keywordSummary: '감수성과 공감력이 중심입니다.' },
            갑진: { title: '구름 낀 대지의 큰 나무', subtitle: '전환을 품고 성장하는 사람', keywords: ['성장', '전환', '포용'], theme: '복잡한 가능성을 품고 큰 성장으로 나아가는 삶', oneLine: '한 가지 가능성에 머물지 않고 여러 흐름을 모아 현실화하려 합니다.', keywordSummary: '성장성과 전환력이 강합니다.' },
            을사: { title: '따뜻한 바람 속의 꽃줄기', subtitle: '매력과 표현력이 유연한 사람', keywords: ['매력', '유연성', '표현'], theme: '부드러운 방식으로 자기 존재감을 드러내는 삶', oneLine: '사람의 마음을 읽는 감각과 보여주는 감각이 함께 살아납니다.', keywordSummary: '매력과 표현력이 중심입니다.' },
            병오: { title: '한낮의 태양', subtitle: '존재감과 자신감이 강한 사람', keywords: ['존재감', '열정', '자신감'], theme: '자기 빛을 숨기지 않고 세상을 밝히는 삶', oneLine: '에너지가 크고 표현이 분명해, 어디서든 존재감이 쉽게 드러납니다.', keywordSummary: '존재감과 열정이 강합니다.' },
            정미: { title: '여름 흙을 데우는 작은 불', subtitle: '헌신과 감성이 깊은 사람', keywords: ['헌신', '감성', '완성'], theme: '따뜻한 정성으로 사람과 결과를 익혀내는 삶', oneLine: '작은 것에도 마음을 담고, 시간이 필요한 일을 묵묵히 완성합니다.', keywordSummary: '헌신과 감성이 중심입니다.' },
            무신: { title: '가을 들판의 큰 산', subtitle: '실무와 판단력이 강한 사람', keywords: ['실무', '판단', '자립'], theme: '현실의 판을 읽고 자기 기반을 세우는 삶', oneLine: '실속을 따지고 대응이 빠르며, 혼자서도 판을 정리하는 힘이 있습니다.', keywordSummary: '실무 감각과 자립심이 강합니다.' },
            기유: { title: '가을 곡식을 고르는 흙', subtitle: '관리와 정확성이 살아 있는 사람', keywords: ['관리', '미감', '정확성'], theme: '쓸모와 아름다움을 골라내 현실에 남기는 삶', oneLine: '세부 조건을 잘 살피고, 정돈된 결과를 만들 때 안정감을 느낍니다.', keywordSummary: '관리력과 정확성이 중심입니다.' },
            경술: { title: '마른 산의 단단한 광석', subtitle: '원칙과 책임을 중시하는 사람', keywords: ['원칙', '책임', '결단'], theme: '쉽게 흔들리지 않는 기준으로 삶을 지탱하는 삶', oneLine: '기준이 선명하고 책임감이 강해, 부당한 것을 오래 넘기지 못합니다.', keywordSummary: '원칙과 결단력이 강합니다.' },
            신해: { title: '깊은 물가의 투명한 보석', subtitle: '통찰과 예술성이 깊은 사람', keywords: ['통찰', '예술', '고독'], theme: '깊은 내면에서 맑은 아름다움을 길어 올리는 삶', oneLine: '감각이 섬세하고 생각이 깊어, 혼자 있는 시간에 힘을 회복합니다.', keywordSummary: '통찰과 예술성이 중심입니다.' },
            임자: { title: '한겨울의 큰 바다', subtitle: '지혜와 확장성이 거대한 사람', keywords: ['지혜', '확장', '유동성'], theme: '큰 흐름을 타고 넓은 세계로 나아가는 삶', oneLine: '생각과 감정의 폭이 커서, 변화가 많은 곳에서 진짜 역량이 나옵니다.', keywordSummary: '지혜와 확장성이 강합니다.' },
            계축: { title: '얼어붙은 땅의 맑은 샘', subtitle: '관찰과 회복력이 깊은 사람', keywords: ['인내', '관찰', '회복'], theme: '차가운 시간을 견디며 맑은 해답을 찾는 삶', oneLine: '느리게 보일 수 있지만 상황을 깊이 관찰하고 정확한 때를 기다립니다.', keywordSummary: '인내와 관찰력이 중심입니다.' },
            갑인: { title: '초봄 숲의 큰 기둥', subtitle: '자존과 개척심이 강한 사람', keywords: ['개척', '자존', '성장'], theme: '스스로 길을 열며 크게 성장하는 삶', oneLine: '자기 방향이 분명하고, 시작해야 할 때 망설임보다 행동이 앞섭니다.', keywordSummary: '개척심과 자존감이 강합니다.' },
            을묘: { title: '봄바람 속 푸른 덩굴', subtitle: '관계와 생명력이 유연한 사람', keywords: ['유연성', '관계', '생명력'], theme: '부드럽게 연결되며 자기 세계를 넓히는 삶', oneLine: '사람의 반응을 잘 읽고, 적절한 거리와 방향을 찾아 성장합니다.', keywordSummary: '유연성과 관계 감각이 중심입니다.' },
            병진: { title: '구름 사이로 비치는 태양', subtitle: '활력과 기획력이 함께 있는 사람', keywords: ['활력', '기획', '변화'], theme: '흐린 상황에서도 가능성을 밝히는 삶', oneLine: '밝은 에너지와 현실적인 계산이 함께 있어 판을 새로 짜는 데 강합니다.', keywordSummary: '활력과 기획력이 강합니다.' },
            정사: { title: '초여름의 선명한 불꽃', subtitle: '집중과 감각이 뜨거운 사람', keywords: ['집중', '열정', '감각'], theme: '한 가지에 깊이 몰입해 자기 빛을 만드는 삶', oneLine: '마음이 꽂히면 매우 깊게 파고들며, 감정과 집중력이 강하게 타오릅니다.', keywordSummary: '집중력과 열정이 중심입니다.' },
            무오: { title: '한낮을 품은 너른 대지', subtitle: '중심감과 활동성이 큰 사람', keywords: ['중심', '활동', '책임'], theme: '뜨거운 에너지를 현실의 기반으로 바꾸는 삶', oneLine: '존재감이 크고 책임감도 강해, 사람과 일을 넓게 끌어안으려 합니다.', keywordSummary: '중심감과 활동성이 강합니다.' },
            기미: { title: '여름 들판의 따뜻한 흙', subtitle: '포용과 실속을 함께 가진 사람', keywords: ['포용', '실속', '성실'], theme: '사람을 품고 현실적인 결실을 만드는 삶', oneLine: '부드럽고 성실하며, 주변을 안정시키는 생활형 지혜가 있습니다.', keywordSummary: '포용력과 실속 감각이 중심입니다.' },
            경신: { title: '가을의 벼려진 칼', subtitle: '실력과 경쟁력이 선명한 사람', keywords: ['실력', '결단', '경쟁력'], theme: '갈고닦은 능력으로 자기 위치를 증명하는 삶', oneLine: '판단과 행동이 빠르고, 실력으로 인정받고 싶은 마음이 강합니다.', keywordSummary: '실력과 결단력이 강합니다.' },
            신유: { title: '가을 거울 같은 보석', subtitle: '완벽과 품격을 추구하는 사람', keywords: ['완벽', '품격', '선택'], theme: '정제된 기준으로 진짜 가치를 가려내는 삶', oneLine: '아름다움과 기준이 매우 분명하고, 불필요한 것을 덜어낼수록 빛납니다.', keywordSummary: '완벽성과 품격이 중심입니다.' },
            임술: { title: '마른 대지를 적시는 큰 물', subtitle: '구조와 전략을 함께 보는 사람', keywords: ['구조', '전략', '책임'], theme: '흐름을 설계해 현실의 책임을 해결하는 삶', oneLine: '큰 생각을 현실 구조 안에 넣어 움직이게 만드는 능력이 있습니다.', keywordSummary: '구조화와 전략성이 강합니다.' },
            계해: { title: '깊은 바다의 맑은 물', subtitle: '직관과 상상력이 깊은 사람', keywords: ['직관', '상상력', '지혜'], theme: '보이지 않는 세계를 읽고 자기 지혜로 정리하는 삶', oneLine: '감정과 생각이 깊고, 혼자만의 내면에서 중요한 답을 길어 올립니다.', keywordSummary: '직관과 지혜가 중심입니다.' }
        };
    }

    public detailedPillarReading(pillar: any) {
        if (pillar?.unknown) {
            return {
                title: '시주 미정',
                subtitle: '생시가 없어 말년운과 자녀운은 확정하지 않았습니다.',
                body: '생시를 모르면 시주, 말년운, 자녀운, 시지 기준 신살 일부가 달라질 수 있습니다. 현재 풀이는 년주·월주·일주 중심으로 보는 것이 맞습니다.',
                confidence: {
                    level: 'low',
                    score: 0.3,
                    label: '참고용',
                    reason: '시주가 확정되지 않아 말년운·자녀운·결실의 자리는 해석하지 않습니다.',
                    referenceOnly: true
                }
            };
        }
        let palace = this.palaceInfo(pillar.part);
        let stemTenGod = pillar.stemTenGod || (pillar.part === '일주' ? '일간' : '');
        let tenProfile = this.tenGodReadingProfile(stemTenGod);
        let branchProfile = this.dayBranchProfile(pillar.branch.name);
        return {
            title: `${pillar.part} ${pillar.label}`,
            subtitle: `${palace.title} · ${palace.note}`,
            body: `${pillar.part}는 ${palace.note}을 보는 자리입니다. 천간 ${pillar.stem.name}${pillar.stem.hanja}은 ${stemTenGod}으로 작용해 ${tenProfile.short} 지지 ${pillar.branch.name}${pillar.branch.hanja}은 ${branchProfile.short} 흐름을 더합니다. 지장간은 ${pillar.hiddenText || '뚜렷한 지장간 없음'}으로 보며, 12운성은 ${pillar.twelveStage || '미정'}입니다.`
        };
    }

    public dayStemProfile(name: string) {
        let data: any = {
            갑: { keyword: '곧게 뻗는 추진력', short: '시작과 성장의 감각이 빠릅니다.', detail: '큰 방향을 먼저 세우고 앞으로 나아가려는 힘이 강합니다.', work: '초기 기획, 리더십, 개척 업무에 강점이 있습니다.', relationship: '솔직하고 보호하려는 마음이 분명합니다.' },
            을: { keyword: '유연한 생존력', short: '상황에 맞춰 길을 찾는 감각이 좋습니다.', detail: '부드럽지만 쉽게 꺾이지 않는 끈기가 있습니다.', work: '조율, 디자인, 관계 기반 업무에 강점이 있습니다.', relationship: '섬세하게 살피고 천천히 마음을 여는 편입니다.' },
            병: { keyword: '드러나는 표현력', short: '존재감과 전달력이 강합니다.', detail: '분위기를 밝히고 사람을 움직이게 하는 힘이 있습니다.', work: '홍보, 교육, 콘텐츠, 발표 업무에 강점이 있습니다.', relationship: '따뜻하게 표현하지만 감정 온도가 빨리 오를 수 있습니다.' },
            정: { keyword: '집중된 온기', short: '작은 것에 깊게 몰입하는 힘이 있습니다.', detail: '섬세한 관찰과 꾸준한 정성으로 결과를 만듭니다.', work: '연구, 돌봄, 기획 보완, 세밀한 제작에 강점이 있습니다.', relationship: '속정이 깊고 오래 챙기는 방식으로 애정을 보입니다.' },
            무: { keyword: '버티는 중심감', short: '큰 틀과 기준을 잡는 힘이 있습니다.', detail: '쉽게 흔들리지 않고 책임을 지려는 성향이 강합니다.', work: '관리, 운영, 부동산, 조직 안정화에 강점이 있습니다.', relationship: '신뢰를 중시하고 한번 정하면 오래 지키려 합니다.' },
            기: { keyword: '현실적인 포용력', short: '사람과 일을 실용적으로 품는 힘이 있습니다.', detail: '세부 조건을 살피며 차분히 정리하는 능력이 좋습니다.', work: '실무 관리, 회계, 교육, 생활 밀착형 업무에 강점이 있습니다.', relationship: '상대의 사정을 잘 살피지만 혼자 부담을 떠안을 수 있습니다.' },
            경: { keyword: '분명한 결단력', short: '정리와 판단이 빠릅니다.', detail: '복잡한 것을 덜어내고 핵심을 잡는 힘이 있습니다.', work: '기술, 법무, 분석, 구조화 업무에 강점이 있습니다.', relationship: '말은 직선적이어도 기준이 분명한 신뢰를 줍니다.' },
            신: { keyword: '정교한 완성도', short: '디테일과 품질 감각이 좋습니다.', detail: '작은 차이를 놓치지 않고 결과물을 다듬는 힘이 있습니다.', work: '브랜딩, 재무, 디자인, 검수 업무에 강점이 있습니다.', relationship: '품격과 예의를 중시하며 쉽게 마음을 열지 않습니다.' },
            임: { keyword: '넓은 사고와 유연성', short: '흐름을 크게 보고 움직입니다.', detail: '변화에 강하고 여러 가능성을 동시에 봅니다.', work: '기획, 유통, 연구, 이동이 많은 일에 강점이 있습니다.', relationship: '자유와 신뢰가 함께 있어야 편안해집니다.' },
            계: { keyword: '깊은 감수성과 통찰', short: '보이지 않는 흐름을 잘 읽습니다.', detail: '조용히 관찰하다가 정확한 포인트를 짚는 힘이 있습니다.', work: '분석, 상담, 글쓰기, 데이터와 리서치에 강점이 있습니다.', relationship: '섬세하지만 속마음을 오래 숨길 수 있습니다.' }
        };
        return data[name] || data.무;
    }

    public monthBranchProfile(name: string) {
        let data: any = {
            인: { keyword: '초봄의 시작', short: '새 판을 열고 움직이는 힘이 강합니다.', natureSeason: '초봄의 숲', natureTime: '새벽이 밝아오는 시간', natureScenery: '새싹이 올라오는 산길' },
            묘: { keyword: '봄의 확장', short: '관계, 성장, 감각이 살아납니다.', natureSeason: '완연한 봄', natureTime: '부드러운 아침', natureScenery: '꽃잎이 흔들리는 정원' },
            진: { keyword: '봄의 정리', short: '성장한 것을 현실 구조로 옮기는 흐름입니다.', natureSeason: '봄 끝의 습한 대지', natureTime: '구름 낀 오전', natureScenery: '물이 고인 넓은 들판' },
            사: { keyword: '초여름의 발산', short: '표현과 활동성이 강해집니다.', natureSeason: '초여름의 열기', natureTime: '햇살이 강해지는 오전', natureScenery: '빛이 번지는 길목' },
            오: { keyword: '한여름의 확산', short: '존재감과 속도가 크게 드러납니다.', natureSeason: '한여름의 태양', natureTime: '정오의 빛', natureScenery: '뜨겁게 열린 광장' },
            미: { keyword: '여름의 수렴', short: '열기를 정리하고 현실 감각을 더합니다.', natureSeason: '여름 끝 들판', natureTime: '느린 오후', natureScenery: '열기가 남은 황토밭' },
            신: { keyword: '초가을의 정리', short: '판단력과 실무 감각이 살아납니다.', natureSeason: '초가을의 바람', natureTime: '선선한 오후', natureScenery: '금속빛이 도는 들판' },
            유: { keyword: '가을의 완성', short: '품질, 기준, 선택의 힘이 강합니다.', natureSeason: '청명한 가을', natureTime: '달이 오르는 저녁', natureScenery: '맑은 거울 같은 하늘' },
            술: { keyword: '가을의 저장', short: '성과를 정리하고 책임을 점검합니다.', natureSeason: '늦가을의 산', natureTime: '해가 낮아진 오후', natureScenery: '마른 바람이 부는 언덕' },
            해: { keyword: '초겨울의 내면화', short: '생각과 이동, 공부의 흐름이 깊어집니다.', natureSeason: '초겨울의 강', natureTime: '깊어지는 밤', natureScenery: '어둠 속을 흐르는 물길' },
            자: { keyword: '한겨울의 응축', short: '감정과 지성이 깊게 모입니다.', natureSeason: '한겨울의 물', natureTime: '자정의 고요', natureScenery: '얼음 아래 흐르는 샘' },
            축: { keyword: '겨울의 마무리', short: '인내와 축적, 현실 준비가 중요합니다.', natureSeason: '겨울 끝의 땅', natureTime: '동트기 전 새벽', natureScenery: '씨앗을 품은 차가운 흙' }
        };
        return data[name] || data.진;
    }

    public dayBranchProfile(name: string) {
        let data: any = {
            자: { short: '감정과 생각이 깊은 자리', detail: '속으로 많은 것을 계산하고 흐름을 살피는 힘이 있습니다.', relationship: '말보다 분위기와 신뢰를 중요하게 봅니다.', caution: '서운함을 오래 품지 않도록 표현이 필요합니다.' },
            축: { short: '인내와 축적의 자리', detail: '천천히 쌓아 안정으로 만드는 힘이 있습니다.', relationship: '현실적인 책임감이 관계의 기반이 됩니다.', caution: '고집과 침묵이 길어지지 않게 해야 합니다.' },
            인: { short: '시작과 확장의 자리', detail: '새로운 목표를 향해 먼저 움직이는 힘이 있습니다.', relationship: '함께 성장하는 관계에서 활력이 납니다.', caution: '상대 속도를 기다리는 여유가 필요합니다.' },
            묘: { short: '감각과 조율의 자리', detail: '사람의 반응과 분위기를 섬세하게 읽습니다.', relationship: '다정한 소통과 취향 공유가 중요합니다.', caution: '눈치를 보느라 본심을 미루지 않는 편이 좋습니다.' },
            진: { short: '변화와 저장의 자리', detail: '여러 가능성을 품고 현실화하는 힘이 있습니다.', relationship: '관계 안에서 역할과 책임을 분명히 해야 편합니다.', caution: '생각이 복잡할수록 기준을 단순화해야 합니다.' },
            사: { short: '열정과 표현의 자리', detail: '집중하면 빠르게 결과를 내는 힘이 있습니다.', relationship: '애정 표현과 현실 조건을 함께 봅니다.', caution: '감정 온도가 높아질 때 말의 속도를 낮추면 좋습니다.' },
            오: { short: '존재감과 직진의 자리', detail: '자기 표현이 분명하고 활력이 강합니다.', relationship: '솔직한 표현이 장점이지만 자존심도 함께 봐야 합니다.', caution: '감정의 기복을 일정한 루틴으로 식히는 편이 좋습니다.' },
            미: { short: '돌봄과 정리의 자리', detail: '사람과 일을 품고 조율하는 힘이 있습니다.', relationship: '챙김이 깊지만 부담을 혼자 안을 수 있습니다.', caution: '거절과 부탁을 명확히 나누는 연습이 필요합니다.' },
            신: { short: '판단과 변화의 자리', detail: '상황 대응과 문제 해결 감각이 빠릅니다.', relationship: '지적 교류와 자유로운 호흡이 중요합니다.', caution: '관계가 계산적으로 보이지 않게 온도를 더하면 좋습니다.' },
            유: { short: '완성도와 선택의 자리', detail: '취향과 기준이 분명하고 결과물을 다듬습니다.', relationship: '예의와 신뢰, 품격 있는 표현을 중시합니다.', caution: '완벽 기준이 높아 상대를 평가하게 될 수 있습니다.' },
            술: { short: '책임과 보존의 자리', detail: '한번 맡은 것을 오래 지키는 힘이 있습니다.', relationship: '의리와 약속이 관계의 중심입니다.', caution: '방어적 태도가 길어지면 거리감이 생길 수 있습니다.' },
            해: { short: '감수성과 이동의 자리', detail: '생각이 깊고 낯선 가능성을 잘 받아들입니다.', relationship: '자유와 정서적 안정이 함께 필요합니다.', caution: '마음이 멀어지기 전에 말을 꺼내는 것이 좋습니다.' }
        };
        return data[name] || data.진;
    }

    public tenGodReadingProfile(label: string) {
        let data: any = {
            비견: { short: '자기 기준과 독립성이 강합니다.', talent: '동료와 어깨를 나란히 하며 버티는 힘이 좋습니다.', work: '독립성, 공동 창업, 자기 브랜드처럼 주도권이 있는 일에서 힘이 납니다.', field: '자기주도 업무, 협업 리더, 전문직', relationship: '대등한 관계를 원하고 간섭을 싫어합니다.', caution: '고집과 경쟁심이 과하면 손해를 볼 수 있습니다.' },
            겁재: { short: '경쟁과 판을 흔드는 힘이 있습니다.', talent: '위기 대응과 승부 감각이 빠르게 살아납니다.', work: '영업, 협상, 사업, 빠른 판단이 필요한 현장에서 강합니다.', field: '영업, 투자, 스타트업, 프로젝트 리딩', relationship: '강한 끌림과 빠른 결정을 보이지만 속도 조절이 필요합니다.', caution: '무리한 베팅과 인간관계 소모를 조심하세요.' },
            식신: { short: '꾸준히 만들고 표현하는 힘입니다.', talent: '실제로 손에 잡히는 결과물을 만드는 데 강합니다.', work: '콘텐츠, 교육, 요리, 제품, 서비스처럼 생산성이 보이는 일에 좋습니다.', field: '콘텐츠, 교육, 제품 기획, 서비스 운영', relationship: '편안하고 안정적인 애정 표현을 선호합니다.', caution: '안정에 머물러 변화 타이밍을 놓치지 않게 하세요.' },
            상관: { short: '개성과 말, 표현력이 강합니다.', talent: '틀을 깨고 새 관점을 제시하는 감각이 있습니다.', work: '기획, 마케팅, 창작, 발표, 브랜딩처럼 차별화가 필요한 일에 좋습니다.', field: '마케팅, 크리에이티브, 기획, 강의', relationship: '솔직하고 매력적이지만 말이 날카로워질 수 있습니다.', caution: '비판이 앞서면 좋은 기회를 스스로 닫을 수 있습니다.' },
            편재: { short: '기회 포착과 활동 반경이 넓습니다.', talent: '사람, 돈, 정보의 흐름을 빠르게 잡습니다.', work: '사업, 유통, 영업, 투자처럼 움직임이 큰 일에서 강점이 납니다.', field: '사업, 유통, 영업, 투자, 네트워킹', relationship: '매력과 활동성이 살아나지만 약속 관리가 중요합니다.', caution: '분산과 과소비를 조심하고 기준을 세워야 합니다.' },
            정재: { short: '현실감과 관리력이 좋습니다.', talent: '돈과 시간을 계획적으로 쌓는 힘이 있습니다.', work: '재무, 행정, 운영, 관리처럼 신뢰와 반복이 중요한 일에 좋습니다.', field: '재무, 운영관리, 행정, 데이터 관리', relationship: '안정과 책임을 중요하게 보며 성실한 관계를 선호합니다.', caution: '지나친 계산과 걱정이 기회를 늦출 수 있습니다.' },
            편관: { short: '압박 속 실행력과 승부근성이 있습니다.', talent: '어려운 상황에서 책임지고 돌파하는 힘이 있습니다.', work: '조직, 관리, 위기 대응, 규율이 있는 분야에서 실력이 드러납니다.', field: '관리직, 보안, 법무, 스포츠, 위기대응', relationship: '보호하려는 마음이 강하지만 통제처럼 느껴질 수 있습니다.', caution: '긴장과 압박을 오래 품지 않게 쉬는 구조가 필요합니다.' },
            정관: { short: '규칙, 신뢰, 사회적 균형을 중시합니다.', talent: '정돈된 태도와 책임감으로 평가받기 쉽습니다.', work: '공공성, 조직, 자격, 전문직처럼 기준이 분명한 일에 좋습니다.', field: '공무, 법무, 인사, 전문직, 조직관리', relationship: '예의와 약속을 중시하고 관계를 안정적으로 이끕니다.', caution: '남의 기대에 맞추느라 자기 욕구를 늦추지 마세요.' },
            편인: { short: '직관과 낯선 지식 흡수가 빠릅니다.', talent: '남들이 놓치는 신호와 구조를 읽는 힘이 있습니다.', work: '연구, 상담, 기획, 비정형 문제 해결에 강점이 있습니다.', field: '연구, 상담, 전략, 리서치, 예술', relationship: '거리감이 있어야 편하고 정신적 교류를 중시합니다.', caution: '생각만 많아지고 실행이 늦어지지 않게 해야 합니다.' },
            정인: { short: '학습, 보호, 안정적 회복의 힘입니다.', talent: '차분히 배우고 정리해 신뢰를 쌓습니다.', work: '교육, 문서, 자격, 연구, 돌봄처럼 깊게 축적하는 일에 좋습니다.', field: '교육, 연구, 문서, 상담, 공공 서비스', relationship: '따뜻한 보호와 안정감을 주지만 의존을 조심해야 합니다.', caution: '준비가 길어져 시작이 늦어지지 않게 하세요.' },
            일간: { short: '자기 중심과 기본 에너지가 핵심입니다.', talent: '자기 기준을 세우는 힘이 중요합니다.', work: '일간의 오행과 월지를 함께 보며 방향을 정해야 합니다.', field: '자기 기준이 살아나는 전문 분야', relationship: '내가 편안해야 관계도 안정됩니다.', caution: '한쪽 기운만 과하게 쓰지 않도록 균형이 필요합니다.' }
        };
        return data[label] || data.일간;
    }

    public hiddenStems(branchName: string) {
        return this.sajuCalculator.hiddenStems(branchName);
    }

    public tenGod(dayStem: any, targetStem: any) {
        return this.sajuCalculator.tenGod(dayStem, targetStem);
    }

    public producesElement(element: string) {
        return this.sajuCalculator.producesElement(element);
    }

    public producerOf(element: string) {
        return this.sajuCalculator.producerOf(element);
    }

    public controlsElement(element: string) {
        return this.sajuCalculator.controlsElement(element);
    }

    public controlledByElement(element: string) {
        return this.sajuCalculator.controlledByElement(element);
    }

    public twelveStage(dayStem: any, branchName: string) {
        return this.sajuCalculator.twelveStage(dayStem, branchName);
    }

    public stemByName(name: string) {
        return this.sajuCalculator.stemByName(name);
    }

    public branchByName(name: string) {
        return this.sajuCalculator.branchByName(name);
    }

    public tenGodTone(label: string) {
        return this.sajuCalculator.tenGodTone(label);
    }

    public stemData() {
        return this.sajuCalculator.stemData();
    }

    public branchData() {
        return this.sajuCalculator.branchData();
    }

    public elementCounts(pillars: any[]) {
        return this.sajuCalculator.elementCounts(pillars);
    }

    public elementTone(element: string) {
        return this.sajuCalculator.elementTone(element);
    }

    public parseBirthDate(value: string, calendarType: string = 'solar') {
        return this.sajuCalculator.parseBirthDate(value, calendarType);
    }

    public lunarToSolarDate(value: string, leapMonth: boolean = false) {
        return this.sajuCalculator.lunarToSolarDate(value, leapMonth);
    }

    public lunarDateInfo(date: Date) {
        return this.sajuCalculator.lunarDateInfo(date);
    }

    public firstNumber(text: string) {
        return this.sajuCalculator.firstNumber(text);
    }

    public calendarTypeLabel(calendarType: string = 'solar') {
        return this.sajuCalculator.calendarTypeLabel(calendarType);
    }

    public hourFromTime(time: string) {
        if (!time) return 12;
        let hour = parseInt(String(time).split(':')[0], 10);
        return Number.isNaN(hour) ? 12 : this.clamp(hour, 0, 23);
    }

    public daysSinceBase(date: Date) {
        return this.sajuCalculator.daysSinceBase(date);
    }

    public formatInputDate(date: Date) {
        return this.sajuCalculator.formatInputDate(date);
    }

    public formatKoreanDate(date: Date) {
        return `${date.getMonth() + 1}월 ${date.getDate()}일`;
    }

    public formatDateTime(date: Date) {
        return this.sajuCalculator.formatDateTime(date);
    }

    public hashText(text: string) {
        let hash = 2166136261;
        for (let i = 0; i < text.length; i++) {
            hash ^= text.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return Math.abs(hash >>> 0);
    }

    public pickBySeed(items: any[], seed: number) {
        if (!items.length) return '';
        return items[Math.abs(seed) % items.length];
    }

    public clamp(value: number, min: number, max: number) {
        return this.sajuCalculator.clamp(value, min, max);
    }

    public mod(value: number, size: number) {
        return this.sajuCalculator.mod(value, size);
    }

    public calculateResult() {
        if (this.selectedTest?.scoring === 'axes') {
            return this.calculateAxisResult();
        }

        let scores: any = {};
        for (let answer of this.answers) {
            if (!answer) continue;
            scores[answer.result] = (scores[answer.result] || 0) + answer.score;
        }
        let topKey = Object.keys(this.selectedTest.results)[0];
        let topScore = -1;
        for (let key of Object.keys(this.selectedTest.results)) {
            let score = scores[key] || 0;
            if (score > topScore) {
                topScore = score;
                topKey = key;
            }
        }
        return { ...this.selectedTest.results[topKey], shareResultKey: topKey };
    }

    public calculateAxisResult() {
        let scores: any = { E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 };
        for (let answer of this.answers) {
            if (!answer?.scores) continue;
            for (let key of Object.keys(answer.scores)) {
                scores[key] = (scores[key] || 0) + answer.scores[key];
            }
        }

        let code = `${scores.E >= scores.I ? 'E' : 'I'}${scores.S >= scores.N ? 'S' : 'N'}${scores.T >= scores.F ? 'T' : 'F'}${scores.J >= scores.P ? 'J' : 'P'}`;
        return this.axisProfile(code, scores);
    }

    public axisProfile(code: string, scores: any) {
        let names: any = {
            ISTJ: '차분한 루틴 설계자',
            ISFJ: '다정한 생활 관리자',
            INFJ: '조용한 의미 탐색가',
            INTJ: '멀리 보는 전략가',
            ISTP: '침착한 문제 해결러',
            ISFP: '감각적인 평화주의자',
            INFP: '상상 많은 가치 수집가',
            INTP: '궁금증 많은 구조 분석가',
            ESTP: '현장형 에너지 플레이어',
            ESFP: '분위기를 깨우는 순간파',
            ENFP: '가능성을 여는 아이디어러',
            ENTP: '유쾌한 발상 실험가',
            ESTJ: '실행력 있는 정리 리더',
            ESFJ: '사람을 챙기는 연결자',
            ENFJ: '흐름을 이끄는 응원가',
            ENTJ: '목표를 밀어붙이는 지휘자'
        };

        let energy = code[0] === 'E' ? '사람과 대화 속에서 에너지를 얻고' : '혼자만의 시간에서 에너지를 회복하고';
        let info = code[1] === 'S' ? '구체적인 경험과 현실 조건을 잘 살피며' : '가능성과 맥락, 큰 그림을 먼저 떠올리며';
        let decision = code[2] === 'T' ? '판단할 때 기준과 논리를 중요하게 보고' : '결정할 때 마음과 관계의 온도를 함께 봅니다';
        let rhythm = code[3] === 'J' ? '계획이 잡혀 있을 때 가장 편안해지는 편이에요' : '상황에 맞춰 유연하게 바꿀 때 더 살아나는 편이에요';

        return {
            title: `${code} · ${names[code] || '나만의 생활 타입'}`,
            subtitle: '내 일상 선택으로 조합된 4축 성향',
            summary: `당신은 ${energy}, ${info}, ${decision}. 그래서 ${rhythm}.`,
            tags: [code, code[0] === 'E' ? '외향 에너지' : '내향 에너지', code[1] === 'S' ? '현실 감각' : '직관 상상', code[2] === 'T' ? '논리 판단' : '가치 공감', code[3] === 'J' ? '계획 리듬' : '유연 리듬'],
            guide: code[3] === 'J' ? '계획이 틀어져도 한 칸의 여백을 남기면 더 가볍게 움직일 수 있어요.' : '자유로운 흐름을 즐기되, 꼭 지킬 기준 하나만 정하면 결과가 더 단단해져요.',
            match: code[0] === 'E' ? '추천 테스트: 연애 신호등 테스트' : '추천 테스트: 비밀 서랍 테스트',
            scores: scores,
            shareResultKey: code
        };
    }

    public async retake() {
        await this.startTest();
    }

    public async goHome() {
        this.clearSharedResultUrl();
        this.screen = 'home';
        if (this.activeCategory === 'attachment') {
            this.activeCategory = 'all';
        }
        this.selectedTest = this.heroTest;
        this.questionIndex = 0;
        this.answers = [];
        this.result = null;
        this.resultTransitionToken++;
        this.resetPhotoState();
        this.resetGiftState();
        this.resetPinballState();
        this.resetFortuneState();
        await this.service.render();
        this.scrollPageToTop('smooth');
    }

    public async randomTest() {
        let index = Math.floor(Math.random() * this.tests.length);
        await this.startTest(this.tests[index]);
    }

    public async shareResult() {
        if (!this.result || !this.selectedTest) return;
        let url = this.createResultShareUrl();
        if (!url) {
            await this.showNotice('공유 링크를 만들지 못했어요');
            return;
        }

        this.replaceCurrentUrlWithShareLink();
        try {
            await (navigator as any).clipboard.writeText(url);
            await this.showNotice('결과 링크를 복사했어요');
        } catch (error) {
            await this.showNotice('주소창의 결과 링크를 복사해주세요');
        }
    }

    public async showNotice(message: string) {
        this.notice = message;
        await this.service.render();
        setTimeout(async () => {
            this.notice = '';
            await this.service.render();
        }, 1800);
    }
}

export default PageDashboardComponent;